import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { useQuery, useMutation } from '@/core/plugins/api/composable';
import type { Context } from '@/core/plugins/api/api';
/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/naming-convention */
export function useTownSuggestionQuery(variables: TownSuggestionQueryVariables, context?: Context) {return useQuery<TownSuggestionQuery, TownSuggestionQueryVariables>(TownSuggestion, variables, context)}
export function useCurrencyListQuery(variables: CurrencyListQueryVariables, context?: Context) {return useQuery<CurrencyListQuery, CurrencyListQueryVariables>(CurrencyList, variables, context)}
export function useMeQuery(variables: MeQueryVariables, context?: Context) {return useQuery<MeQuery, MeQueryVariables>(Me, variables, context)}
export function useUpdateUserProfileMutation(variables: UpdateUserProfileMutationVariables) {return useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfile, variables)}
export function useIsLegalFreeQuery(variables: IsLegalFreeQueryVariables, context?: Context) {return useQuery<IsLegalFreeQuery, IsLegalFreeQueryVariables>(IsLegalFree, variables, context)}
export function useJoinToSupplierMutation(variables: JoinToSupplierMutationVariables) {return useMutation<JoinToSupplierMutation, JoinToSupplierMutationVariables>(JoinToSupplier, variables)}
export function useSendSupplierQuestionnaireMutation(variables: SendSupplierQuestionnaireMutationVariables) {return useMutation<SendSupplierQuestionnaireMutation, SendSupplierQuestionnaireMutationVariables>(SendSupplierQuestionnaire, variables)}
export function useUpdateSupplierQuestionnaireMutation(variables: UpdateSupplierQuestionnaireMutationVariables) {return useMutation<UpdateSupplierQuestionnaireMutation, UpdateSupplierQuestionnaireMutationVariables>(UpdateSupplierQuestionnaire, variables)}
export function useCreateSupplierMutation(variables: CreateSupplierMutationVariables) {return useMutation<CreateSupplierMutation, CreateSupplierMutationVariables>(CreateSupplier, variables)}
export function useRegisterKsbAccountMutation(variables: RegisterKsbAccountMutationVariables) {return useMutation<RegisterKsbAccountMutation, RegisterKsbAccountMutationVariables>(RegisterKsbAccount, variables)}
export function useQuotaOrderQuery(variables: QuotaOrderQueryVariables, context?: Context) {return useQuery<QuotaOrderQuery, QuotaOrderQueryVariables>(QuotaOrder, variables, context)}
export function useQuotaOrdersQuery(variables: QuotaOrdersQueryVariables, context?: Context) {return useQuery<QuotaOrdersQuery, QuotaOrdersQueryVariables>(QuotaOrders, variables, context)}
export function useAvoidOrderMutation(variables: AvoidOrderMutationVariables) {return useMutation<AvoidOrderMutation, AvoidOrderMutationVariables>(AvoidOrder, variables)}
export function useConfirmOrderMutation(variables: ConfirmOrderMutationVariables) {return useMutation<ConfirmOrderMutation, ConfirmOrderMutationVariables>(ConfirmOrder, variables)}
export function useSendOrderToSupplierMutation(variables: SendOrderToSupplierMutationVariables) {return useMutation<SendOrderToSupplierMutation, SendOrderToSupplierMutationVariables>(SendOrderToSupplier, variables)}
export function useContentServiceDictionariesQuery(variables: ContentServiceDictionariesQueryVariables, context?: Context) {return useQuery<ContentServiceDictionariesQuery, ContentServiceDictionariesQueryVariables>(ContentServiceDictionaries, variables, context)}
export function useContentServiceQuestionnaireAnswersQuery(variables: ContentServiceQuestionnaireAnswersQueryVariables, context?: Context) {return useQuery<ContentServiceQuestionnaireAnswersQuery, ContentServiceQuestionnaireAnswersQueryVariables>(ContentServiceQuestionnaireAnswers, variables, context)}
export function useContentServiceQuestionnaireAnswersValidationsByIdQuery(variables: ContentServiceQuestionnaireAnswersValidationsByIdQueryVariables, context?: Context) {return useQuery<ContentServiceQuestionnaireAnswersValidationsByIdQuery, ContentServiceQuestionnaireAnswersValidationsByIdQueryVariables>(ContentServiceQuestionnaireAnswersValidationsById, variables, context)}
export function useContentServiceQuestionnaireQuery(variables: ContentServiceQuestionnaireQueryVariables, context?: Context) {return useQuery<ContentServiceQuestionnaireQuery, ContentServiceQuestionnaireQueryVariables>(ContentServiceQuestionnaire, variables, context)}
export function useContentServiceQuestionnaireSaveMutation(variables: ContentServiceQuestionnaireSaveMutationVariables) {return useMutation<ContentServiceQuestionnaireSaveMutation, ContentServiceQuestionnaireSaveMutationVariables>(ContentServiceQuestionnaireSave, variables)}
export function useContentServiceQuestionnaireCreateMutation(variables: ContentServiceQuestionnaireCreateMutationVariables) {return useMutation<ContentServiceQuestionnaireCreateMutation, ContentServiceQuestionnaireCreateMutationVariables>(ContentServiceQuestionnaireCreate, variables)}
export function useContentServiceQuestionnaireMoveToNextStepMutation(variables: ContentServiceQuestionnaireMoveToNextStepMutationVariables) {return useMutation<ContentServiceQuestionnaireMoveToNextStepMutation, ContentServiceQuestionnaireMoveToNextStepMutationVariables>(ContentServiceQuestionnaireMoveToNextStep, variables)}
export function useContentServiceQuestionnaireFinalizeMutation(variables: ContentServiceQuestionnaireFinalizeMutationVariables) {return useMutation<ContentServiceQuestionnaireFinalizeMutation, ContentServiceQuestionnaireFinalizeMutationVariables>(ContentServiceQuestionnaireFinalize, variables)}
export function useContentServiceQuestionnaireEditMutation(variables: ContentServiceQuestionnaireEditMutationVariables) {return useMutation<ContentServiceQuestionnaireEditMutation, ContentServiceQuestionnaireEditMutationVariables>(ContentServiceQuestionnaireEdit, variables)}
export function useContentServiceQuestionnaireCancelEditMutation(variables: ContentServiceQuestionnaireCancelEditMutationVariables) {return useMutation<ContentServiceQuestionnaireCancelEditMutation, ContentServiceQuestionnaireCancelEditMutationVariables>(ContentServiceQuestionnaireCancelEdit, variables)}
export function useGetDocumentsQuery(variables: GetDocumentsQueryVariables, context?: Context) {return useQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocuments, variables, context)}
export function useGetDocumentToSignQuery(variables: GetDocumentToSignQueryVariables, context?: Context) {return useQuery<GetDocumentToSignQuery, GetDocumentToSignQueryVariables>(GetDocumentToSign, variables, context)}
export function useSaveDocumentSignatureMutation(variables: SaveDocumentSignatureMutationVariables) {return useMutation<SaveDocumentSignatureMutation, SaveDocumentSignatureMutationVariables>(SaveDocumentSignature, variables)}
export function useGetLegalsQuery(variables: GetLegalsQueryVariables, context?: Context) {return useQuery<GetLegalsQuery, GetLegalsQueryVariables>(GetLegals, variables, context)}
export function useGetLegalQuery(variables: GetLegalQueryVariables, context?: Context) {return useQuery<GetLegalQuery, GetLegalQueryVariables>(GetLegal, variables, context)}
export function useGetIsLegalFreeQuery(variables: GetIsLegalFreeQueryVariables, context?: Context) {return useQuery<GetIsLegalFreeQuery, GetIsLegalFreeQueryVariables>(GetIsLegalFree, variables, context)}
export function useFindFreeLegalQuery(variables: FindFreeLegalQueryVariables, context?: Context) {return useQuery<FindFreeLegalQuery, FindFreeLegalQueryVariables>(FindFreeLegal, variables, context)}
export function useAddLegalMutation(variables: AddLegalMutationVariables) {return useMutation<AddLegalMutation, AddLegalMutationVariables>(AddLegal, variables)}
export function useAddLegalExistingMutation(variables: AddLegalExistingMutationVariables) {return useMutation<AddLegalExistingMutation, AddLegalExistingMutationVariables>(AddLegalExisting, variables)}
export function useRemoveLegalMutation(variables: RemoveLegalMutationVariables) {return useMutation<RemoveLegalMutation, RemoveLegalMutationVariables>(RemoveLegal, variables)}
export function useSaveLegalEdiTypeMutation(variables: SaveLegalEdiTypeMutationVariables) {return useMutation<SaveLegalEdiTypeMutation, SaveLegalEdiTypeMutationVariables>(SaveLegalEdiType, variables)}
export function useAccommodationObjects2Query(variables: AccommodationObjects2QueryVariables, context?: Context) {return useQuery<AccommodationObjects2Query, AccommodationObjects2QueryVariables>(AccommodationObjects2, variables, context)}
export function useAccomodationObjectDashboardInfoQuery(variables: AccomodationObjectDashboardInfoQueryVariables, context?: Context) {return useQuery<AccomodationObjectDashboardInfoQuery, AccomodationObjectDashboardInfoQueryVariables>(AccomodationObjectDashboardInfo, variables, context)}
export function useAccommodationObject2Query(variables: AccommodationObject2QueryVariables, context?: Context) {return useQuery<AccommodationObject2Query, AccommodationObject2QueryVariables>(AccommodationObject2, variables, context)}
export function useHotelCategorySuggestionsQuery(variables: HotelCategorySuggestionsQueryVariables, context?: Context) {return useQuery<HotelCategorySuggestionsQuery, HotelCategorySuggestionsQueryVariables>(HotelCategorySuggestions, variables, context)}
export function useHotelTypeSuggestionsQuery(variables: HotelTypeSuggestionsQueryVariables, context?: Context) {return useQuery<HotelTypeSuggestionsQuery, HotelTypeSuggestionsQueryVariables>(HotelTypeSuggestions, variables, context)}
export function useRoomTypeSuggestionsQuery(variables: RoomTypeSuggestionsQueryVariables, context?: Context) {return useQuery<RoomTypeSuggestionsQuery, RoomTypeSuggestionsQueryVariables>(RoomTypeSuggestions, variables, context)}
export function useAddAccommodationObjectRoomCategoryMutation(variables: AddAccommodationObjectRoomCategoryMutationVariables) {return useMutation<AddAccommodationObjectRoomCategoryMutation, AddAccommodationObjectRoomCategoryMutationVariables>(AddAccommodationObjectRoomCategory, variables)}
export function useEditAccommodationObjectRoomCategoryMutation(variables: EditAccommodationObjectRoomCategoryMutationVariables) {return useMutation<EditAccommodationObjectRoomCategoryMutation, EditAccommodationObjectRoomCategoryMutationVariables>(EditAccommodationObjectRoomCategory, variables)}
export function useCancelEditAccommodationObjectRoomCategoryMutation(variables: CancelEditAccommodationObjectRoomCategoryMutationVariables) {return useMutation<CancelEditAccommodationObjectRoomCategoryMutation, CancelEditAccommodationObjectRoomCategoryMutationVariables>(CancelEditAccommodationObjectRoomCategory, variables)}
export function useAddAccommodationObjectServiceMutation(variables: AddAccommodationObjectServiceMutationVariables) {return useMutation<AddAccommodationObjectServiceMutation, AddAccommodationObjectServiceMutationVariables>(AddAccommodationObjectService, variables)}
export function useUpdateAccommodationObjectRoomCategoryMutation(variables: UpdateAccommodationObjectRoomCategoryMutationVariables) {return useMutation<UpdateAccommodationObjectRoomCategoryMutation, UpdateAccommodationObjectRoomCategoryMutationVariables>(UpdateAccommodationObjectRoomCategory, variables)}
export function useRemoveAccommodationObjectRoomCategoryMutation(variables: RemoveAccommodationObjectRoomCategoryMutationVariables) {return useMutation<RemoveAccommodationObjectRoomCategoryMutation, RemoveAccommodationObjectRoomCategoryMutationVariables>(RemoveAccommodationObjectRoomCategory, variables)}
export function useAddContractMutation(variables: AddContractMutationVariables) {return useMutation<AddContractMutation, AddContractMutationVariables>(AddContract, variables)}
export function useAddAccommodationObjectMutation(variables: AddAccommodationObjectMutationVariables) {return useMutation<AddAccommodationObjectMutation, AddAccommodationObjectMutationVariables>(AddAccommodationObject, variables)}
export function useGetOrdersReconciliationQuery(variables: GetOrdersReconciliationQueryVariables, context?: Context) {return useQuery<GetOrdersReconciliationQuery, GetOrdersReconciliationQueryVariables>(GetOrdersReconciliation, variables, context)}
export function useGetOrdersReconciliationFiltersQuery(variables: GetOrdersReconciliationFiltersQueryVariables, context?: Context) {return useQuery<GetOrdersReconciliationFiltersQuery, GetOrdersReconciliationFiltersQueryVariables>(GetOrdersReconciliationFilters, variables, context)}
export function useReconcileContractForPeriodMutation(variables: ReconcileContractForPeriodMutationVariables) {return useMutation<ReconcileContractForPeriodMutation, ReconcileContractForPeriodMutationVariables>(ReconcileContractForPeriod, variables)}
export function useReconcileOrdersReconciliationMutation(variables: ReconcileOrdersReconciliationMutationVariables) {return useMutation<ReconcileOrdersReconciliationMutation, ReconcileOrdersReconciliationMutationVariables>(ReconcileOrdersReconciliation, variables)}
export function useMismatchOrderReconciliationMutation(variables: MismatchOrderReconciliationMutationVariables) {return useMutation<MismatchOrderReconciliationMutation, MismatchOrderReconciliationMutationVariables>(MismatchOrderReconciliation, variables)}
export function useGetOrderReconciliationQuery(variables: GetOrderReconciliationQueryVariables, context?: Context) {return useQuery<GetOrderReconciliationQuery, GetOrderReconciliationQueryVariables>(GetOrderReconciliation, variables, context)}
export function useGetContractReconciliationAvailableForPeriodQuery(variables: GetContractReconciliationAvailableForPeriodQueryVariables, context?: Context) {return useQuery<GetContractReconciliationAvailableForPeriodQuery, GetContractReconciliationAvailableForPeriodQueryVariables>(GetContractReconciliationAvailableForPeriod, variables, context)}
export function useGetRoomCategoriesQuery(variables: GetRoomCategoriesQueryVariables, context?: Context) {return useQuery<GetRoomCategoriesQuery, GetRoomCategoriesQueryVariables>(GetRoomCategories, variables, context)}
export function useAddRoomCategoryMutation(variables: AddRoomCategoryMutationVariables) {return useMutation<AddRoomCategoryMutation, AddRoomCategoryMutationVariables>(AddRoomCategory, variables)}
export function useEditRoomCategoryStartMutation(variables: EditRoomCategoryStartMutationVariables) {return useMutation<EditRoomCategoryStartMutation, EditRoomCategoryStartMutationVariables>(EditRoomCategoryStart, variables)}
export function useEditRoomCategoryKeepAliveMutation(variables: EditRoomCategoryKeepAliveMutationVariables) {return useMutation<EditRoomCategoryKeepAliveMutation, EditRoomCategoryKeepAliveMutationVariables>(EditRoomCategoryKeepAlive, variables)}
export function useEditRoomCategoryCancelMutation(variables: EditRoomCategoryCancelMutationVariables) {return useMutation<EditRoomCategoryCancelMutation, EditRoomCategoryCancelMutationVariables>(EditRoomCategoryCancel, variables)}
export function useEditRoomCategoryUpdateMutation(variables: EditRoomCategoryUpdateMutationVariables) {return useMutation<EditRoomCategoryUpdateMutation, EditRoomCategoryUpdateMutationVariables>(EditRoomCategoryUpdate, variables)}
export function useRemoveRoomCategoryMutation(variables: RemoveRoomCategoryMutationVariables) {return useMutation<RemoveRoomCategoryMutation, RemoveRoomCategoryMutationVariables>(RemoveRoomCategory, variables)}
export function useReverseStartIntegrationMutation(variables: ReverseStartIntegrationMutationVariables) {return useMutation<ReverseStartIntegrationMutation, ReverseStartIntegrationMutationVariables>(ReverseStartIntegration, variables)}
export function useReverseIntegrationQuery(variables: ReverseIntegrationQueryVariables, context?: Context) {return useQuery<ReverseIntegrationQuery, ReverseIntegrationQueryVariables>(ReverseIntegration, variables, context)}
export function useUncompletedReverseInteractionQuery(variables: UncompletedReverseInteractionQueryVariables, context?: Context) {return useQuery<UncompletedReverseInteractionQuery, UncompletedReverseInteractionQueryVariables>(UncompletedReverseInteraction, variables, context)}
export function useCheckIsNotStartedReverseInteractionQuery(variables: CheckIsNotStartedReverseInteractionQueryVariables, context?: Context) {return useQuery<CheckIsNotStartedReverseInteractionQuery, CheckIsNotStartedReverseInteractionQueryVariables>(CheckIsNotStartedReverseInteraction, variables, context)}
export function useUpdateReverseRoomCategoriesMutation(variables: UpdateReverseRoomCategoriesMutationVariables) {return useMutation<UpdateReverseRoomCategoriesMutation, UpdateReverseRoomCategoriesMutationVariables>(UpdateReverseRoomCategories, variables)}
export function useUpdateReverseServiceGroupsMutation(variables: UpdateReverseServiceGroupsMutationVariables) {return useMutation<UpdateReverseServiceGroupsMutation, UpdateReverseServiceGroupsMutationVariables>(UpdateReverseServiceGroups, variables)}
export function useUpdateReverseTouristTypesMutation(variables: UpdateReverseTouristTypesMutationVariables) {return useMutation<UpdateReverseTouristTypesMutation, UpdateReverseTouristTypesMutationVariables>(UpdateReverseTouristTypes, variables)}
export function useGetReversePlacingVariantsQuery(variables: GetReversePlacingVariantsQueryVariables, context?: Context) {return useQuery<GetReversePlacingVariantsQuery, GetReversePlacingVariantsQueryVariables>(GetReversePlacingVariants, variables, context)}
export function useUpdateReversePlacingVariantsMutation(variables: UpdateReversePlacingVariantsMutationVariables) {return useMutation<UpdateReversePlacingVariantsMutation, UpdateReversePlacingVariantsMutationVariables>(UpdateReversePlacingVariants, variables)}
export function useReverseRestartIntegrationMutation(variables: ReverseRestartIntegrationMutationVariables) {return useMutation<ReverseRestartIntegrationMutation, ReverseRestartIntegrationMutationVariables>(ReverseRestartIntegration, variables)}
export function useTravelLineExternalHotelSuggestionsQuery(variables: TravelLineExternalHotelSuggestionsQueryVariables, context?: Context) {return useQuery<TravelLineExternalHotelSuggestionsQuery, TravelLineExternalHotelSuggestionsQueryVariables>(TravelLineExternalHotelSuggestions, variables, context)}
export function useTravelLineRefreshTouristTypesMutation(variables: TravelLineRefreshTouristTypesMutationVariables) {return useMutation<TravelLineRefreshTouristTypesMutation, TravelLineRefreshTouristTypesMutationVariables>(TravelLineRefreshTouristTypes, variables)}
export function useGetTravelLineRestartIntegrationMutation(variables: GetTravelLineRestartIntegrationMutationVariables) {return useMutation<GetTravelLineRestartIntegrationMutation, GetTravelLineRestartIntegrationMutationVariables>(GetTravelLineRestartIntegration, variables)}
export function useTravelLineIntegrationQuery(variables: TravelLineIntegrationQueryVariables, context?: Context) {return useQuery<TravelLineIntegrationQuery, TravelLineIntegrationQueryVariables>(TravelLineIntegration, variables, context)}
export function useUncompletedIntegrationInfoQuery(variables: UncompletedIntegrationInfoQueryVariables, context?: Context) {return useQuery<UncompletedIntegrationInfoQuery, UncompletedIntegrationInfoQueryVariables>(UncompletedIntegrationInfo, variables, context)}
export function useGetTravelLinePlacingVariantsQuery(variables: GetTravelLinePlacingVariantsQueryVariables, context?: Context) {return useQuery<GetTravelLinePlacingVariantsQuery, GetTravelLinePlacingVariantsQueryVariables>(GetTravelLinePlacingVariants, variables, context)}
export function useTravelLineStartIntegrationMutation(variables: TravelLineStartIntegrationMutationVariables) {return useMutation<TravelLineStartIntegrationMutation, TravelLineStartIntegrationMutationVariables>(TravelLineStartIntegration, variables)}
export function useTravelLineUpdateIntegrationSettingsMutation(variables: TravelLineUpdateIntegrationSettingsMutationVariables) {return useMutation<TravelLineUpdateIntegrationSettingsMutation, TravelLineUpdateIntegrationSettingsMutationVariables>(TravelLineUpdateIntegrationSettings, variables)}
export function useTravelLineSaveRoomCategoriesMappingMutation(variables: TravelLineSaveRoomCategoriesMappingMutationVariables) {return useMutation<TravelLineSaveRoomCategoriesMappingMutation, TravelLineSaveRoomCategoriesMappingMutationVariables>(TravelLineSaveRoomCategoriesMapping, variables)}
export function useTravelLineSaveServiceGroupsMappingMutation(variables: TravelLineSaveServiceGroupsMappingMutationVariables) {return useMutation<TravelLineSaveServiceGroupsMappingMutation, TravelLineSaveServiceGroupsMappingMutationVariables>(TravelLineSaveServiceGroupsMapping, variables)}
export function useTravelLineUpdateServiceGroupsMutation(variables: TravelLineUpdateServiceGroupsMutationVariables) {return useMutation<TravelLineUpdateServiceGroupsMutation, TravelLineUpdateServiceGroupsMutationVariables>(TravelLineUpdateServiceGroups, variables)}
export function useTravelLineUpdateRoomCategoriesMutation(variables: TravelLineUpdateRoomCategoriesMutationVariables) {return useMutation<TravelLineUpdateRoomCategoriesMutation, TravelLineUpdateRoomCategoriesMutationVariables>(TravelLineUpdateRoomCategories, variables)}
export function useTravelLineUpdateTouristTypesMutation(variables: TravelLineUpdateTouristTypesMutationVariables) {return useMutation<TravelLineUpdateTouristTypesMutation, TravelLineUpdateTouristTypesMutationVariables>(TravelLineUpdateTouristTypes, variables)}
export function useTravelLineUpdatePlacingVariantsMutation(variables: TravelLineUpdatePlacingVariantsMutationVariables) {return useMutation<TravelLineUpdatePlacingVariantsMutation, TravelLineUpdatePlacingVariantsMutationVariables>(TravelLineUpdatePlacingVariants, variables)}
export function useStartTariffGridEditMutation(variables: StartTariffGridEditMutationVariables) {return useMutation<StartTariffGridEditMutation, StartTariffGridEditMutationVariables>(StartTariffGridEdit, variables)}
export function useKeepAliveTariffGridEditMutation(variables: KeepAliveTariffGridEditMutationVariables) {return useMutation<KeepAliveTariffGridEditMutation, KeepAliveTariffGridEditMutationVariables>(KeepAliveTariffGridEdit, variables)}
export function useCancelTariffGridEditMutation(variables: CancelTariffGridEditMutationVariables) {return useMutation<CancelTariffGridEditMutation, CancelTariffGridEditMutationVariables>(CancelTariffGridEdit, variables)}
export function useUpdateTariffGridMutation(variables: UpdateTariffGridMutationVariables) {return useMutation<UpdateTariffGridMutation, UpdateTariffGridMutationVariables>(UpdateTariffGrid, variables)}
export function useGetQuotaQuery(variables: GetQuotaQueryVariables, context?: Context) {return useQuery<GetQuotaQuery, GetQuotaQueryVariables>(GetQuota, variables, context)}
export function useEditQuotaInitialValuesStartMutation(variables: EditQuotaInitialValuesStartMutationVariables) {return useMutation<EditQuotaInitialValuesStartMutation, EditQuotaInitialValuesStartMutationVariables>(EditQuotaInitialValuesStart, variables)}
export function useEditQuotaInitialValuesKeepAliveMutation(variables: EditQuotaInitialValuesKeepAliveMutationVariables) {return useMutation<EditQuotaInitialValuesKeepAliveMutation, EditQuotaInitialValuesKeepAliveMutationVariables>(EditQuotaInitialValuesKeepAlive, variables)}
export function useEditQuotaInitialValuesCancelMutation(variables: EditQuotaInitialValuesCancelMutationVariables) {return useMutation<EditQuotaInitialValuesCancelMutation, EditQuotaInitialValuesCancelMutationVariables>(EditQuotaInitialValuesCancel, variables)}
export function useEditQuotaInitialValuesUpdateMutation(variables: EditQuotaInitialValuesUpdateMutationVariables) {return useMutation<EditQuotaInitialValuesUpdateMutation, EditQuotaInitialValuesUpdateMutationVariables>(EditQuotaInitialValuesUpdate, variables)}
export function useEditQuotaReservesStartMutation(variables: EditQuotaReservesStartMutationVariables) {return useMutation<EditQuotaReservesStartMutation, EditQuotaReservesStartMutationVariables>(EditQuotaReservesStart, variables)}
export function useEditQuotaReservesKeepAliveMutation(variables: EditQuotaReservesKeepAliveMutationVariables) {return useMutation<EditQuotaReservesKeepAliveMutation, EditQuotaReservesKeepAliveMutationVariables>(EditQuotaReservesKeepAlive, variables)}
export function useEditQuotaReservesCancelMutation(variables: EditQuotaReservesCancelMutationVariables) {return useMutation<EditQuotaReservesCancelMutation, EditQuotaReservesCancelMutationVariables>(EditQuotaReservesCancel, variables)}
export function useEditQuotaReservesUpdateMutation(variables: EditQuotaReservesUpdateMutationVariables) {return useMutation<EditQuotaReservesUpdateMutation, EditQuotaReservesUpdateMutationVariables>(EditQuotaReservesUpdate, variables)}
export function useGetCheckInOutRestrictionsQuery(variables: GetCheckInOutRestrictionsQueryVariables, context?: Context) {return useQuery<GetCheckInOutRestrictionsQuery, GetCheckInOutRestrictionsQueryVariables>(GetCheckInOutRestrictions, variables, context)}
export function useAddCheckInOutRestrictionMutation(variables: AddCheckInOutRestrictionMutationVariables) {return useMutation<AddCheckInOutRestrictionMutation, AddCheckInOutRestrictionMutationVariables>(AddCheckInOutRestriction, variables)}
export function useUpdateCheckInOutRestrictionMutation(variables: UpdateCheckInOutRestrictionMutationVariables) {return useMutation<UpdateCheckInOutRestrictionMutation, UpdateCheckInOutRestrictionMutationVariables>(UpdateCheckInOutRestriction, variables)}
export function useRemoveCheckInOutRestrictionMutation(variables: RemoveCheckInOutRestrictionMutationVariables) {return useMutation<RemoveCheckInOutRestrictionMutation, RemoveCheckInOutRestrictionMutationVariables>(RemoveCheckInOutRestriction, variables)}
export function useGetPlacingVariantsRestrictionsQuery(variables: GetPlacingVariantsRestrictionsQueryVariables, context?: Context) {return useQuery<GetPlacingVariantsRestrictionsQuery, GetPlacingVariantsRestrictionsQueryVariables>(GetPlacingVariantsRestrictions, variables, context)}
export function useAddPlacingVariantsRestrictionMutation(variables: AddPlacingVariantsRestrictionMutationVariables) {return useMutation<AddPlacingVariantsRestrictionMutation, AddPlacingVariantsRestrictionMutationVariables>(AddPlacingVariantsRestriction, variables)}
export function useUpdatePlacingVariantsRestrictionMutation(variables: UpdatePlacingVariantsRestrictionMutationVariables) {return useMutation<UpdatePlacingVariantsRestrictionMutation, UpdatePlacingVariantsRestrictionMutationVariables>(UpdatePlacingVariantsRestriction, variables)}
export function useRemovePlacingVariantsRestrictionMutation(variables: RemovePlacingVariantsRestrictionMutationVariables) {return useMutation<RemovePlacingVariantsRestrictionMutation, RemovePlacingVariantsRestrictionMutationVariables>(RemovePlacingVariantsRestriction, variables)}
export function useGetServiceGroupsRestrictionsQuery(variables: GetServiceGroupsRestrictionsQueryVariables, context?: Context) {return useQuery<GetServiceGroupsRestrictionsQuery, GetServiceGroupsRestrictionsQueryVariables>(GetServiceGroupsRestrictions, variables, context)}
export function useAddServiceGroupsRestrictionMutation(variables: AddServiceGroupsRestrictionMutationVariables) {return useMutation<AddServiceGroupsRestrictionMutation, AddServiceGroupsRestrictionMutationVariables>(AddServiceGroupsRestriction, variables)}
export function useUpdateServiceGroupsRestrictionMutation(variables: UpdateServiceGroupsRestrictionMutationVariables) {return useMutation<UpdateServiceGroupsRestrictionMutation, UpdateServiceGroupsRestrictionMutationVariables>(UpdateServiceGroupsRestriction, variables)}
export function useRemoveServiceGroupsRestrictionMutation(variables: RemoveServiceGroupsRestrictionMutationVariables) {return useMutation<RemoveServiceGroupsRestrictionMutation, RemoveServiceGroupsRestrictionMutationVariables>(RemoveServiceGroupsRestriction, variables)}
export function useTariffScheduleServiceGroupsQuery(variables: TariffScheduleServiceGroupsQueryVariables, context?: Context) {return useQuery<TariffScheduleServiceGroupsQuery, TariffScheduleServiceGroupsQueryVariables>(TariffScheduleServiceGroups, variables, context)}
export function useGetServiceGroupSuggestedServicesQuery(variables: GetServiceGroupSuggestedServicesQueryVariables, context?: Context) {return useQuery<GetServiceGroupSuggestedServicesQuery, GetServiceGroupSuggestedServicesQueryVariables>(GetServiceGroupSuggestedServices, variables, context)}
export function useGetContractServiceGroupsQuery(variables: GetContractServiceGroupsQueryVariables, context?: Context) {return useQuery<GetContractServiceGroupsQuery, GetContractServiceGroupsQueryVariables>(GetContractServiceGroups, variables, context)}
export function useCalculateServiceSequenceQuery(variables: CalculateServiceSequenceQueryVariables, context?: Context) {return useQuery<CalculateServiceSequenceQuery, CalculateServiceSequenceQueryVariables>(CalculateServiceSequence, variables, context)}
export function useGetTariffScheduleServiceGroupsForRestrictionQuery(variables: GetTariffScheduleServiceGroupsForRestrictionQueryVariables, context?: Context) {return useQuery<GetTariffScheduleServiceGroupsForRestrictionQuery, GetTariffScheduleServiceGroupsForRestrictionQueryVariables>(GetTariffScheduleServiceGroupsForRestriction, variables, context)}
export function useCalculateTariffScheduleServiceGroupsQuery(variables: CalculateTariffScheduleServiceGroupsQueryVariables, context?: Context) {return useQuery<CalculateTariffScheduleServiceGroupsQuery, CalculateTariffScheduleServiceGroupsQueryVariables>(CalculateTariffScheduleServiceGroups, variables, context)}
export function useAddTariffScheduleServiceGroupMutation(variables: AddTariffScheduleServiceGroupMutationVariables) {return useMutation<AddTariffScheduleServiceGroupMutation, AddTariffScheduleServiceGroupMutationVariables>(AddTariffScheduleServiceGroup, variables)}
export function useGetTariffScheduleServiceGroupQuery(variables: GetTariffScheduleServiceGroupQueryVariables, context?: Context) {return useQuery<GetTariffScheduleServiceGroupQuery, GetTariffScheduleServiceGroupQueryVariables>(GetTariffScheduleServiceGroup, variables, context)}
export function useEditTariffScheduleServiceGroupMutation(variables: EditTariffScheduleServiceGroupMutationVariables) {return useMutation<EditTariffScheduleServiceGroupMutation, EditTariffScheduleServiceGroupMutationVariables>(EditTariffScheduleServiceGroup, variables)}
export function useKeepAliveTariffScheduleServiceGroupMutation(variables: KeepAliveTariffScheduleServiceGroupMutationVariables) {return useMutation<KeepAliveTariffScheduleServiceGroupMutation, KeepAliveTariffScheduleServiceGroupMutationVariables>(KeepAliveTariffScheduleServiceGroup, variables)}
export function useCancelTariffScheduleServiceGroupMutation(variables: CancelTariffScheduleServiceGroupMutationVariables) {return useMutation<CancelTariffScheduleServiceGroupMutation, CancelTariffScheduleServiceGroupMutationVariables>(CancelTariffScheduleServiceGroup, variables)}
export function useUpdateTariffScheduleServiceGroupMutation(variables: UpdateTariffScheduleServiceGroupMutationVariables) {return useMutation<UpdateTariffScheduleServiceGroupMutation, UpdateTariffScheduleServiceGroupMutationVariables>(UpdateTariffScheduleServiceGroup, variables)}
export function useEditTariffScheduleServiceGroupListMutation(variables: EditTariffScheduleServiceGroupListMutationVariables) {return useMutation<EditTariffScheduleServiceGroupListMutation, EditTariffScheduleServiceGroupListMutationVariables>(EditTariffScheduleServiceGroupList, variables)}
export function useKeepAliveTariffScheduleServiceGroupListMutation(variables: KeepAliveTariffScheduleServiceGroupListMutationVariables) {return useMutation<KeepAliveTariffScheduleServiceGroupListMutation, KeepAliveTariffScheduleServiceGroupListMutationVariables>(KeepAliveTariffScheduleServiceGroupList, variables)}
export function useCancelEditTariffScheduleServiceGroupListMutation(variables: CancelEditTariffScheduleServiceGroupListMutationVariables) {return useMutation<CancelEditTariffScheduleServiceGroupListMutation, CancelEditTariffScheduleServiceGroupListMutationVariables>(CancelEditTariffScheduleServiceGroupList, variables)}
export function useUpdateTariffScheduleServiceGroupListMutation(variables: UpdateTariffScheduleServiceGroupListMutationVariables) {return useMutation<UpdateTariffScheduleServiceGroupListMutation, UpdateTariffScheduleServiceGroupListMutationVariables>(UpdateTariffScheduleServiceGroupList, variables)}
export function useEditTariffScheduleMutation(variables: EditTariffScheduleMutationVariables) {return useMutation<EditTariffScheduleMutation, EditTariffScheduleMutationVariables>(EditTariffSchedule, variables)}
export function useCancelEditTariffScheduleMutation(variables: CancelEditTariffScheduleMutationVariables) {return useMutation<CancelEditTariffScheduleMutation, CancelEditTariffScheduleMutationVariables>(CancelEditTariffSchedule, variables)}
export function useSendTariffScheduleInWorkMutation(variables: SendTariffScheduleInWorkMutationVariables) {return useMutation<SendTariffScheduleInWorkMutation, SendTariffScheduleInWorkMutationVariables>(SendTariffScheduleInWork, variables)}
export function useTariffSchedulesQuery(variables: TariffSchedulesQueryVariables, context?: Context) {return useQuery<TariffSchedulesQuery, TariffSchedulesQueryVariables>(TariffSchedules, variables, context)}
export function useSupplierPayRuleListQuery(variables: SupplierPayRuleListQueryVariables, context?: Context) {return useQuery<SupplierPayRuleListQuery, SupplierPayRuleListQueryVariables>(SupplierPayRuleList, variables, context)}
export function usePenaltySchemeListQuery(variables: PenaltySchemeListQueryVariables, context?: Context) {return useQuery<PenaltySchemeListQuery, PenaltySchemeListQueryVariables>(PenaltySchemeList, variables, context)}
export function useGetTaxSchemeListQuery(variables: GetTaxSchemeListQueryVariables, context?: Context) {return useQuery<GetTaxSchemeListQuery, GetTaxSchemeListQueryVariables>(GetTaxSchemeList, variables, context)}
export function useGetTariffScheduleGridQuery(variables: GetTariffScheduleGridQueryVariables, context?: Context) {return useQuery<GetTariffScheduleGridQuery, GetTariffScheduleGridQueryVariables>(GetTariffScheduleGrid, variables, context)}
export function useAddTariffScheduleMutation(variables: AddTariffScheduleMutationVariables) {return useMutation<AddTariffScheduleMutation, AddTariffScheduleMutationVariables>(AddTariffSchedule, variables)}
export function useGetTariffScheduleQuery(variables: GetTariffScheduleQueryVariables, context?: Context) {return useQuery<GetTariffScheduleQuery, GetTariffScheduleQueryVariables>(GetTariffSchedule, variables, context)}
export function useEditTariffScheduleStartMutation(variables: EditTariffScheduleStartMutationVariables) {return useMutation<EditTariffScheduleStartMutation, EditTariffScheduleStartMutationVariables>(EditTariffScheduleStart, variables)}
export function useEditTariffScheduleKeepAliveMutation(variables: EditTariffScheduleKeepAliveMutationVariables) {return useMutation<EditTariffScheduleKeepAliveMutation, EditTariffScheduleKeepAliveMutationVariables>(EditTariffScheduleKeepAlive, variables)}
export function useEditTariffScheduleCancelMutation(variables: EditTariffScheduleCancelMutationVariables) {return useMutation<EditTariffScheduleCancelMutation, EditTariffScheduleCancelMutationVariables>(EditTariffScheduleCancel, variables)}
export function useEditTariffScheduleUpdateMutation(variables: EditTariffScheduleUpdateMutationVariables) {return useMutation<EditTariffScheduleUpdateMutation, EditTariffScheduleUpdateMutationVariables>(EditTariffScheduleUpdate, variables)}
export function useGetPlacingVariantsQuery(variables: GetPlacingVariantsQueryVariables, context?: Context) {return useQuery<GetPlacingVariantsQuery, GetPlacingVariantsQueryVariables>(GetPlacingVariants, variables, context)}
export function usePvmStartMutation(variables: PvmStartMutationVariables) {return useMutation<PvmStartMutation, PvmStartMutationVariables>(PvmStart, variables)}
export function usePvmKeepAliveMutation(variables: PvmKeepAliveMutationVariables) {return useMutation<PvmKeepAliveMutation, PvmKeepAliveMutationVariables>(PvmKeepAlive, variables)}
export function usePvmCancelEditMutation(variables: PvmCancelEditMutationVariables) {return useMutation<PvmCancelEditMutation, PvmCancelEditMutationVariables>(PvmCancelEdit, variables)}
export function usePvmCompleteMutation(variables: PvmCompleteMutationVariables) {return useMutation<PvmCompleteMutation, PvmCompleteMutationVariables>(PvmComplete, variables)}
export function usePvmGenerateMutation(variables: PvmGenerateMutationVariables) {return useMutation<PvmGenerateMutation, PvmGenerateMutationVariables>(PvmGenerate, variables)}
export function useStartPlacingVariantsEditMutation(variables: StartPlacingVariantsEditMutationVariables) {return useMutation<StartPlacingVariantsEditMutation, StartPlacingVariantsEditMutationVariables>(StartPlacingVariantsEdit, variables)}
export function useKeepAlivePlacingVariantsEditMutation(variables: KeepAlivePlacingVariantsEditMutationVariables) {return useMutation<KeepAlivePlacingVariantsEditMutation, KeepAlivePlacingVariantsEditMutationVariables>(KeepAlivePlacingVariantsEdit, variables)}
export function useUpdatePlacingVariantsMutation(variables: UpdatePlacingVariantsMutationVariables) {return useMutation<UpdatePlacingVariantsMutation, UpdatePlacingVariantsMutationVariables>(UpdatePlacingVariants, variables)}
export function useCancelPlacingVariantsEditMutation(variables: CancelPlacingVariantsEditMutationVariables) {return useMutation<CancelPlacingVariantsEditMutation, CancelPlacingVariantsEditMutationVariables>(CancelPlacingVariantsEdit, variables)}
export function useUsersQuery(variables: UsersQueryVariables, context?: Context) {return useQuery<UsersQuery, UsersQueryVariables>(Users, variables, context)}
export function useInvitationsQuery(variables: InvitationsQueryVariables, context?: Context) {return useQuery<InvitationsQuery, InvitationsQueryVariables>(Invitations, variables, context)}
export function useInviteUserToSupplierMutation(variables: InviteUserToSupplierMutationVariables) {return useMutation<InviteUserToSupplierMutation, InviteUserToSupplierMutationVariables>(InviteUserToSupplier, variables)}
export function useDeleteUserMutation(variables: DeleteUserMutationVariables) {return useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUser, variables)}
export function useSetUserRoleMutation(variables: SetUserRoleMutationVariables) {return useMutation<SetUserRoleMutation, SetUserRoleMutationVariables>(SetUserRole, variables)}
export function useSetInvitationRoleMutation(variables: SetInvitationRoleMutationVariables) {return useMutation<SetInvitationRoleMutation, SetInvitationRoleMutationVariables>(SetInvitationRole, variables)}
export function useGetUserQuery(variables: GetUserQueryVariables, context?: Context) {return useQuery<GetUserQuery, GetUserQueryVariables>(GetUser, variables, context)}
export function useGetActiveAccessRequestsQuery(variables: GetActiveAccessRequestsQueryVariables, context?: Context) {return useQuery<GetActiveAccessRequestsQuery, GetActiveAccessRequestsQueryVariables>(GetActiveAccessRequests, variables, context)}
export function useAccessRequestDeclineMutation(variables: AccessRequestDeclineMutationVariables) {return useMutation<AccessRequestDeclineMutation, AccessRequestDeclineMutationVariables>(AccessRequestDecline, variables)}
export function useAccessRequestAcceptMutation(variables: AccessRequestAcceptMutationVariables) {return useMutation<AccessRequestAcceptMutation, AccessRequestAcceptMutationVariables>(AccessRequestAccept, variables)}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Byte: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Long: { input: any; output: any; }
  Short: { input: any; output: any; }
  TimeSpan: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UnsignedInt: { input: any; output: any; }
  UnsignedLong: { input: any; output: any; }
  UnsignedShort: { input: any; output: any; }
};

export enum AccessMode {
  Edit = 'EDIT',
  View = 'VIEW'
}

export type AccessRequestAcceptError = AccessRequestInvalidStatusError | AccessRequestNotFoundError;

export type AccessRequestAcceptInput = {
  accessRequestId: Scalars['UUID']['input'];
};

export type AccessRequestAcceptPayload = {
  __typename?: 'AccessRequestAcceptPayload';
  errors?: Maybe<Array<AccessRequestAcceptError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AccessRequestDeclineError = AccessRequestInvalidStatusError | AccessRequestNotFoundError;

export type AccessRequestDeclineInput = {
  accessRequestId: Scalars['UUID']['input'];
};

export type AccessRequestDeclinePayload = {
  __typename?: 'AccessRequestDeclinePayload';
  errors?: Maybe<Array<AccessRequestDeclineError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AccessRequestInvalidStatusError = Error & {
  __typename?: 'AccessRequestInvalidStatusError';
  message: Scalars['String']['output'];
};

export type AccessRequestNotFoundError = Error & {
  __typename?: 'AccessRequestNotFoundError';
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
};

export enum AccessRequestStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Done = 'DONE',
  Granted = 'GRANTED',
  Sent = 'SENT'
}

export type AccessRequestView = {
  __typename?: 'AccessRequestView';
  areaCode: Scalars['String']['output'];
  creationTime: Scalars['DateTime']['output'];
  decisionBy?: Maybe<UserViewBase>;
  decisionTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  status: AccessRequestStatus;
  userFullName: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type AccommodationObjectCategory = {
  __typename?: 'AccommodationObjectCategory';
  cid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AccommodationObjectCommonInformationView = {
  __typename?: 'AccommodationObjectCommonInformationView';
  category: Scalars['String']['output'];
  name: Array<LangString>;
  status: ApproveStatus;
  town: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AccommodationObjectContactView = {
  __typename?: 'AccommodationObjectContactView';
  email: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  postalAddress: Array<LangString>;
  webSite?: Maybe<Scalars['String']['output']>;
};

export type AccommodationObjectInfoView = {
  __typename?: 'AccommodationObjectInfoView';
  cid: Scalars['String']['output'];
  commonInformation: AccommodationObjectCommonInformationView;
  contacts: AccommodationObjectContactView;
  contracts: Array<ContractView>;
  operations: AccommodationObjectOperations;
  timeZoneOffsetMin: Scalars['Short']['output'];
};

export type AccommodationObjectListItemView = {
  __typename?: 'AccommodationObjectListItemView';
  cid: Scalars['String']['output'];
  commonInformation: AccommodationObjectCommonInformationView;
  contracts: Array<ContractView>;
};

export type AccommodationObjectListOperations = {
  __typename?: 'AccommodationObjectListOperations';
  canAdd: OperationStatus;
  onApprovalLimitExceeded?: Maybe<OnApprovalLimitExceededView>;
};

export type AccommodationObjectListView = {
  __typename?: 'AccommodationObjectListView';
  accommodationObjects: Array<AccommodationObjectListItemView>;
  operations: AccommodationObjectListOperations;
};

export type AccommodationObjectNotFoundError = Error & {
  __typename?: 'AccommodationObjectNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AccommodationObjectOperations = {
  __typename?: 'AccommodationObjectOperations';
  canAddContract: OperationStatus;
};

export type AccommodationObjectType = {
  __typename?: 'AccommodationObjectType';
  cid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AccommodationObjectTypeInput = {
  cid: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AccommodationObjectView = {
  __typename?: 'AccommodationObjectView';
  cid: Scalars['String']['output'];
  commonInformation: CommonInformationView;
  contact: ContactView;
};

export type AddAccommodationObjectError = HotelCategoryNotFoundError | HotelMaxOnApprovalConflictError | HotelTypeNotFoundError | TownNotFoundError;

export type AddAccommodationObjectInput = {
  commonContact: CommonContactInput;
  commonInformation: CommonInformationInput;
};

export type AddAccommodationObjectPayload = {
  __typename?: 'AddAccommodationObjectPayload';
  accommodationObject?: Maybe<AccommodationObjectView>;
  errors?: Maybe<Array<AddAccommodationObjectError>>;
};

export type AddAccommodationObjectRoomCategoryError = AccommodationObjectNotFoundError | LockResourceFailedError | RoomCategoryNotFoundError | RoomTypeNotFoundError;

export type AddAccommodationObjectRoomCategoryInput = {
  accommodationObjectCid: Scalars['String']['input'];
  roomCategory: RoomCategoryInput;
};

export type AddAccommodationObjectRoomCategoryPayload = {
  __typename?: 'AddAccommodationObjectRoomCategoryPayload';
  errors?: Maybe<Array<AddAccommodationObjectRoomCategoryError>>;
  roomCategory?: Maybe<RoomCategoryView>;
};

export type AddAccommodationObjectServiceError = AccommodationObjectNotFoundError | ServiceTypeNotFoundError;

export type AddAccommodationObjectServiceInput = {
  accommodationObjectCid: Scalars['String']['input'];
  accommodationObjectService: ServiceInput;
};

export type AddAccommodationObjectServicePayload = {
  __typename?: 'AddAccommodationObjectServicePayload';
  errors?: Maybe<Array<AddAccommodationObjectServiceError>>;
  serviceView?: Maybe<ServiceView>;
};

export type AddContractError = AccommodationObjectNotFoundError | ConcurrencyConflictError | CurrencyNotFoundError | LegalNotFoundError;

export type AddContractInput = {
  accommodationObjectCID: Scalars['String']['input'];
  contractType: ContractType;
  currencyIsoCode: Scalars['String']['input'];
  legalCid: Scalars['String']['input'];
  legalOrigin: LegalOrigin;
};

export type AddContractPayload = {
  __typename?: 'AddContractPayload';
  Contract?: Maybe<ContractView>;
  errors?: Maybe<Array<AddContractError>>;
};

export type AddLegalError = LegalMaxOnApprovalConflictError | LegalTinAndKppConflictError | TownNotFoundError;

export type AddLegalExistingError = LegalExtranetAreaConflictError | LegalNotFoundError;

export type AddLegalExistingInput = {
  legalCid: Scalars['String']['input'];
};

export type AddLegalExistingPayload = {
  __typename?: 'AddLegalExistingPayload';
  errors?: Maybe<Array<AddLegalExistingError>>;
  legal?: Maybe<LegalListItemView>;
};

export type AddLegalPayload = {
  __typename?: 'AddLegalPayload';
  errors?: Maybe<Array<AddLegalError>>;
  legal?: Maybe<LegalListItemView>;
};

export type AddRestrictionsCheckInOutSettingError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | RestrictionDefaultConflictError | RestrictionNextDayCheckoutOverrideForbiddenError | RestrictionPeriodOverlapConflictError | RestrictionTariffSchedulePeriodConflictError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type AddRestrictionsCheckInOutSettingInput = {
  checkInOutSettings: CheckInOutSettingsInput;
  period: RangeOfDateOnlyInput;
  tariffScheduleCid: Scalars['String']['input'];
};

export type AddRestrictionsCheckInOutSettingPayload = {
  __typename?: 'AddRestrictionsCheckInOutSettingPayload';
  Grid?: Maybe<RestrictionsCheckInOutSettingsView>;
  errors?: Maybe<Array<AddRestrictionsCheckInOutSettingError>>;
};

export type AddRestrictionsPlacingVariantsError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | PlacingVariantsNotBelongsToTariffScheduleError | RestrictionDefaultConflictError | RestrictionPeriodOverlapConflictError | RestrictionTariffSchedulePeriodConflictError | RoomCategoryNotBelongsToTariffScheduleError | RoomCategoryNotFoundError | RoomPlacingListNotFoundError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type AddRestrictionsPlacingVariantsInput = {
  placingVariants: Array<RestrictionPlacingVariantInput>;
  roomCategoryCID: Scalars['String']['input'];
  tariffScheduleCid: Scalars['String']['input'];
};

export type AddRestrictionsPlacingVariantsPayload = {
  __typename?: 'AddRestrictionsPlacingVariantsPayload';
  Grid?: Maybe<RestrictionsPlacingVariantsView>;
  errors?: Maybe<Array<AddRestrictionsPlacingVariantsError>>;
};

export type AddRestrictionsServiceGroupError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | RestrictionDefaultConflictError | RestrictionPeriodOverlapConflictError | RestrictionTariffSchedulePeriodConflictError | ServiceGroupNotFoundError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type AddRestrictionsServiceGroupInput = {
  restrictions: Array<RestrictionServiceGroupInput>;
  tariffScheduleCid: Scalars['String']['input'];
};

export type AddRestrictionsServiceGroupPayload = {
  __typename?: 'AddRestrictionsServiceGroupPayload';
  Grid?: Maybe<RestrictionsServiceGroupsView>;
  errors?: Maybe<Array<AddRestrictionsServiceGroupError>>;
};

export type AddTariffScheduleError = ContractNotFoundError | PenaltySchemeNotFoundError | SupplierPayRuleNotFoundError | TariffScheduleOutOfContractPeriodError | TaxSchemeNotFoundError;

export type AddTariffScheduleInput = {
  applyingRules: ApplyingRulesInput;
  checkInOutSettings: CheckInOutSettingsInput;
  contractNumber: Scalars['Int']['input'];
  name: Array<LangStringInput>;
  taxSchemeCid: Scalars['String']['input'];
};

export type AddTariffSchedulePayload = {
  __typename?: 'AddTariffSchedulePayload';
  errors?: Maybe<Array<AddTariffScheduleError>>;
  tariffSchedule?: Maybe<TariffSchedule2View>;
  tariffScheduleCid?: Maybe<Scalars['String']['output']>;
};

export type AddTariffScheduleServiceGroupError = HotelSetHasRemoteIntegrationForbiddenError | HotelSetNotFoundError | LockResourceFailedError | ServicesNotAllowedForServiceGroupError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError | TariffScheduleServiceGroupMaxNumberExceedError | TariffScheduleServiceGroupMutuallyExclusiveCidsFoundError;

export type AddTariffScheduleServiceGroupInput = {
  hotelSetCid: Scalars['String']['input'];
  serviceGroup: ServiceGroupInput;
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
};

export type AddTariffScheduleServiceGroupPayload = {
  __typename?: 'AddTariffScheduleServiceGroupPayload';
  addedServiceGroup?: Maybe<TariffScheduleServiceGroupListItemView>;
  errors?: Maybe<Array<AddTariffScheduleServiceGroupError>>;
  serviceGroups?: Maybe<TariffScheduleServiceGroupsListView>;
};

export type AddressData = {
  __typename?: 'AddressData';
  address?: Maybe<Scalars['String']['output']>;
  addressML?: Maybe<Array<LangString>>;
  townName?: Maybe<Scalars['String']['output']>;
};

export type AddressDataInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressML?: InputMaybe<Array<LangStringInput>>;
  townName?: InputMaybe<Scalars['String']['input']>;
};

export type AgeCategories = {
  __typename?: 'AgeCategories';
  values: Array<AgeCategory>;
};

export type AgeCategoriesInput = {
  values: Array<AgeCategoryInput>;
};

export type AgeCategory = {
  __typename?: 'AgeCategory';
  from: Scalars['Byte']['output'];
  to: Scalars['Byte']['output'];
};

export type AgeCategoryInput = {
  from: Scalars['Byte']['input'];
  to: Scalars['Byte']['input'];
};

export type AgeCategoryView = {
  __typename?: 'AgeCategoryView';
  from: Scalars['Byte']['output'];
  to?: Maybe<Scalars['Byte']['output']>;
};

export type AgeSettings = {
  __typename?: 'AgeSettings';
  categories: AgeCategories;
  determineAgeMethod: DetermineAgeMethod;
  initialAge: Scalars['Byte']['output'];
  noSeatAge?: Maybe<Scalars['Byte']['output']>;
};

export type AgeSettingsInput = {
  categories: AgeCategoriesInput;
  determineAgeMethod: DetermineAgeMethod;
  initialAge: Scalars['Byte']['input'];
  noSeatAge?: InputMaybe<Scalars['Byte']['input']>;
};

export type AnalyticsAccomodationObjectDashboardRequestInput = {
  accommodationObjectCid: Scalars['String']['input'];
};

export enum ApplyMethod {
  ByPerson = 'BY_PERSON',
  ByRoom = 'BY_ROOM'
}

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type ApplyingRulesInput = {
  penaltySchemeShortName: Scalars['String']['input'];
  stopSalePeriod: Scalars['UnsignedInt']['input'];
  supplierPayRuleShortName: Scalars['String']['input'];
};

export type ApplyingRulesView = {
  __typename?: 'ApplyingRulesView';
  penaltyScheme: RuleView;
  stopSalePeriodHours: Scalars['UnsignedInt']['output'];
  supplierPayRule: RuleView;
};

export enum ApproveStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  OnApproval = 'ON_APPROVAL'
}

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  questionnaireId?: Maybe<Scalars['UUID']['output']>;
  size: Scalars['Long']['output'];
};

export type AttachmentInput = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  questionnaireId?: InputMaybe<Scalars['UUID']['input']>;
  size: Scalars['Long']['input'];
};

export type AvoidOrderError = LockResourceFailedError | OrderAccommodationHasBegunError | OrderHasNonStandardError | OrderIsConfirmedError | OrderIsRemoteError | OrderNotFoundError;

export type AvoidOrderInput = {
  orderId: Scalars['Int']['input'];
};

export type AvoidOrderPayload = {
  __typename?: 'AvoidOrderPayload';
  errors?: Maybe<Array<AvoidOrderError>>;
  order?: Maybe<OrderView>;
};

export type BaseSettingsView = {
  __typename?: 'BaseSettingsView';
  currencyIsoCode: Scalars['String']['output'];
  period: RangeOfDateOnly;
};

export type BlockedInfo = {
  __typename?: 'BlockedInfo';
  blockers: Array<Blocker>;
  isExclusive: Scalars['Boolean']['output'];
};

export type Blocker = {
  __typename?: 'Blocker';
  lockTime: Scalars['DateTime']['output'];
  userAlias: Scalars['String']['output'];
};

export type CalculatedServiceSequenceView = {
  __typename?: 'CalculatedServiceSequenceView';
  cid: Scalars['String']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  parentCid?: Maybe<Scalars['String']['output']>;
  sequenceNumber: Scalars['Int']['output'];
  shortName: Scalars['String']['output'];
};

export enum CalculationMethod {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  HourlyByDay = 'HOURLY_BY_DAY',
  Minutes = 'MINUTES',
  MinutesByDay = 'MINUTES_BY_DAY',
  Period = 'PERIOD',
  Seance = 'SEANCE',
  SeanceByDay = 'SEANCE_BY_DAY'
}

export enum CalculationMethodInput {
  Daily = 'DAILY',
  Seance = 'SEANCE'
}

export type CancelEditAccommodationObjectRoomCategoryError = OperationOnUnlockedResourceIsInvalidError;

export type CancelEditAccommodationObjectRoomCategoryInput = {
  accommodationObjectRoomCategoryCid: Scalars['String']['input'];
};

export type CancelEditAccommodationObjectRoomCategoryPayload = {
  __typename?: 'CancelEditAccommodationObjectRoomCategoryPayload';
  errors?: Maybe<Array<CancelEditAccommodationObjectRoomCategoryError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CancelEditQuotaAddRoomsError = OperationOnUnlockedResourceIsInvalidError | QuotaNotFoundError;

export type CancelEditQuotaAddRoomsInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type CancelEditQuotaAddRoomsPayload = {
  __typename?: 'CancelEditQuotaAddRoomsPayload';
  errors?: Maybe<Array<CancelEditQuotaAddRoomsError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CancelEditQuotaReservesUpdateError = OperationOnUnlockedResourceIsInvalidError | QuotaNotFoundError;

export type CancelEditQuotaReservesUpdateInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type CancelEditQuotaReservesUpdatePayload = {
  __typename?: 'CancelEditQuotaReservesUpdatePayload';
  errors?: Maybe<Array<CancelEditQuotaReservesUpdateError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CancelEditTariffScheduleError = OperationOnUnlockedResourceIsInvalidError;

export type CancelEditTariffScheduleInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type CancelEditTariffSchedulePayload = {
  __typename?: 'CancelEditTariffSchedulePayload';
  errors?: Maybe<Array<CancelEditTariffScheduleError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CancelEditTariffScheduleServiceGroupError = HotelSetNotFoundError | OperationOnUnlockedResourceIsInvalidError;

export type CancelEditTariffScheduleServiceGroupInput = {
  hotelSetCid: Scalars['String']['input'];
  serviceGroupCid: Scalars['String']['input'];
};

export type CancelEditTariffScheduleServiceGroupListError = HotelSetNotFoundError | OperationOnUnlockedResourceIsInvalidError | TariffScheduleNotFoundError;

export type CancelEditTariffScheduleServiceGroupListInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type CancelEditTariffScheduleServiceGroupListPayload = {
  __typename?: 'CancelEditTariffScheduleServiceGroupListPayload';
  errors?: Maybe<Array<CancelEditTariffScheduleServiceGroupListError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CancelEditTariffScheduleServiceGroupPayload = {
  __typename?: 'CancelEditTariffScheduleServiceGroupPayload';
  errors?: Maybe<Array<CancelEditTariffScheduleServiceGroupError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ChangeUserRoleToSupportForbiddenError = Error & {
  __typename?: 'ChangeUserRoleToSupportForbiddenError';
  message: Scalars['String']['output'];
};

export type ChannelManagerAdditionalMappingRequiredError = Error & {
  __typename?: 'ChannelManagerAdditionalMappingRequiredError';
  masterStep: TravelLineMasterStep;
  message: Scalars['String']['output'];
};

export enum ChannelManagerCode {
  Bnovo = 'BNOVO',
  Exely = 'EXELY',
  Kontur = 'KONTUR',
  RealtyCalendar = 'REALTY_CALENDAR',
  TravelLine = 'TRAVEL_LINE'
}

export type ChannelManagerInteractionInvalidStateError = Error & {
  __typename?: 'ChannelManagerInteractionInvalidStateError';
  actualState: InteractionState;
  expectedState: InteractionState;
  message: Scalars['String']['output'];
};

export type ChannelManagerInteractionNotFoundError = Error & {
  __typename?: 'ChannelManagerInteractionNotFoundError';
  contractNumber: Scalars['UnsignedInt']['output'];
  interactionId: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
};

export type ChannelManagerInvalidContractNumberError = Error & {
  __typename?: 'ChannelManagerInvalidContractNumberError';
  contractNumber: Scalars['UnsignedInt']['output'];
  message: Scalars['String']['output'];
};

export type ChannelManagerMasterInvalidOperationError = Error & {
  __typename?: 'ChannelManagerMasterInvalidOperationError';
  message: Scalars['String']['output'];
};

export type ChannelManagerReverseMasterInvalidOperationError = Error & {
  __typename?: 'ChannelManagerReverseMasterInvalidOperationError';
  message: Scalars['String']['output'];
};

export type CheckInOutSettings = {
  __typename?: 'CheckInOutSettings';
  checkInTime: Scalars['TimeSpan']['output'];
  checkOutTime: Scalars['TimeSpan']['output'];
  nextDayCheckout: Scalars['Boolean']['output'];
};

export type CheckInOutSettingsInput = {
  checkInTime: Scalars['TimeSpan']['input'];
  checkOutTime: Scalars['TimeSpan']['input'];
  nextDayCheckout: Scalars['Boolean']['input'];
};

export type CheckinDocumentDictionaries = {
  __typename?: 'CheckinDocumentDictionaries';
  adultDocuments: Array<CheckinDocumentGroup>;
  childrenDocuments: Array<CheckinDocumentGroup>;
  foreignerDocuments: Array<CheckinDocumentGroup>;
};

export type CheckinDocumentGroup = {
  __typename?: 'CheckinDocumentGroup';
  documents: Array<Scalars['String']['output']>;
  groupName: Scalars['String']['output'];
};

export type ComissionRateView = {
  __typename?: 'ComissionRateView';
  period: RangeOfDateOnly;
  rate: Scalars['Decimal']['output'];
};

export type ComissionsView = {
  __typename?: 'ComissionsView';
  comissions: Array<ComissionRateView>;
};

export type CommonContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalAddress: Array<LangStringInput>;
  webSite?: InputMaybe<Scalars['String']['input']>;
};

export type CommonContactView = {
  __typename?: 'CommonContactView';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalAddress: Array<LangString>;
  webSite?: Maybe<Scalars['String']['output']>;
};

export type CommonInformationDictionaries = {
  __typename?: 'CommonInformationDictionaries';
  checkinDocuments: CheckinDocumentDictionaries;
  hotelChains: Array<Scalars['String']['output']>;
  resortTypes: Array<Scalars['String']['output']>;
};

export type CommonInformationInput = {
  categoryCid: Scalars['String']['input'];
  name: Array<LangStringInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  townCid: Scalars['String']['input'];
  typeCid: Scalars['String']['input'];
};

export type CommonInformationView = {
  __typename?: 'CommonInformationView';
  category: AccommodationObjectCategory;
  name: Array<LangString>;
  town: Town;
  type: AccommodationObjectType;
};

export type ConcurrencyConflictError = Error & {
  __typename?: 'ConcurrencyConflictError';
  message: Scalars['String']['output'];
};

export type ConferenceServicesDictionaries = {
  __typename?: 'ConferenceServicesDictionaries';
  congressServices: Array<Scalars['String']['output']>;
  equipment: Array<Scalars['String']['output']>;
  furniture: Array<Scalars['String']['output']>;
  seatingOptions: Array<Scalars['String']['output']>;
};

export type ConfirmOrderError = LockResourceFailedError | OrderAccommodationHasBegunError | OrderHasNonStandardError | OrderIsAvoidedError | OrderIsRemoteError | OrderNotFoundError;

export type ConfirmOrderInput = {
  orderId: Scalars['Int']['input'];
};

export type ConfirmOrderPayload = {
  __typename?: 'ConfirmOrderPayload';
  errors?: Maybe<Array<ConfirmOrderError>>;
  order?: Maybe<OrderView>;
};

export type ContactView = {
  __typename?: 'ContactView';
  common?: Maybe<CommonContactView>;
  userContacts: Array<UserContactView>;
};

export type ContentServiceDictionaries = {
  __typename?: 'ContentServiceDictionaries';
  commonInformation: CommonInformationDictionaries;
  conferenceServices: ConferenceServicesDictionaries;
  equipment: EquipmentDictionaries;
  nutrition: NutritionDictionaries;
  rooms: RoomsDictionaries;
  servicesAndEntertainment: ServicesAndEntertainmentDictionaries;
  treatment: TreatmentDictionaries;
};

export type ContentServiceQuestionnaireAlreadyCreatedError = Error & {
  __typename?: 'ContentServiceQuestionnaireAlreadyCreatedError';
  message: Scalars['String']['output'];
};

export type ContentServiceQuestionnaireCancelEditError = ContentServiceQuestionnaireCancelNotEditedError | ContentServiceQuestionnaireNotFoundError;

export type ContentServiceQuestionnaireCancelEditInput = {
  questionnaireId: Scalars['UUID']['input'];
};

export type ContentServiceQuestionnaireCancelEditPayload = {
  __typename?: 'ContentServiceQuestionnaireCancelEditPayload';
  errors?: Maybe<Array<ContentServiceQuestionnaireCancelEditError>>;
  mutationResult?: Maybe<MutationResult>;
};

export type ContentServiceQuestionnaireCancelNotEditedError = Error & {
  __typename?: 'ContentServiceQuestionnaireCancelNotEditedError';
  message: Scalars['String']['output'];
};

export type ContentServiceQuestionnaireCreateError = AccommodationObjectNotFoundError | ContentServiceQuestionnaireAlreadyCreatedError | NoRoomCategoriesInAccomodationObjectError;

export type ContentServiceQuestionnaireCreateInput = {
  accommodationObjectCid: Scalars['String']['input'];
};

export type ContentServiceQuestionnaireCreatePayload = {
  __typename?: 'ContentServiceQuestionnaireCreatePayload';
  errors?: Maybe<Array<ContentServiceQuestionnaireCreateError>>;
  questionnaireAnswers?: Maybe<QuestionnaireAnswers>;
};

export type ContentServiceQuestionnaireEditError = AccommodationObjectNotFoundError | ContentServiceQuestionnaireNotFinishedError;

export type ContentServiceQuestionnaireEditInput = {
  accommodationObjectCid: Scalars['String']['input'];
};

export type ContentServiceQuestionnaireEditPayload = {
  __typename?: 'ContentServiceQuestionnaireEditPayload';
  errors?: Maybe<Array<ContentServiceQuestionnaireEditError>>;
  questionnaireAnswers?: Maybe<QuestionnaireAnswers>;
};

export type ContentServiceQuestionnaireEditingForbiddenError = Error & {
  __typename?: 'ContentServiceQuestionnaireEditingForbiddenError';
  message: Scalars['String']['output'];
};

export type ContentServiceQuestionnaireFinalizeError = AccommodationObjectNotFoundError | ContentServiceQuestionnaireEditingForbiddenError | ContentServiceQuestionnaireNotFoundError;

export type ContentServiceQuestionnaireFinalizeInput = {
  input: ContentServiceQuestionnaireSaveAnswersInput;
};

export type ContentServiceQuestionnaireFinalizePayload = {
  __typename?: 'ContentServiceQuestionnaireFinalizePayload';
  errors?: Maybe<Array<ContentServiceQuestionnaireFinalizeError>>;
  mutationResult?: Maybe<MutationResult>;
};

export type ContentServiceQuestionnaireMoveToNextStepError = AccommodationObjectNotFoundError | ContentServiceQuestionnaireEditingForbiddenError | ContentServiceQuestionnaireNotFoundError;

export type ContentServiceQuestionnaireMoveToNextStepInput = {
  accommodationObjectCid: Scalars['String']['input'];
  answers: QuestionnaireAnswersInput;
  finishedStep: QuestionnaireMasterStep;
};

export type ContentServiceQuestionnaireMoveToNextStepPayload = {
  __typename?: 'ContentServiceQuestionnaireMoveToNextStepPayload';
  errors?: Maybe<Array<ContentServiceQuestionnaireMoveToNextStepError>>;
  questionnaireAnswers?: Maybe<QuestionnaireAnswers>;
};

export type ContentServiceQuestionnaireNotFinishedError = Error & {
  __typename?: 'ContentServiceQuestionnaireNotFinishedError';
  message: Scalars['String']['output'];
};

export type ContentServiceQuestionnaireNotFoundError = Error & {
  __typename?: 'ContentServiceQuestionnaireNotFoundError';
  message: Scalars['String']['output'];
};

export type ContentServiceQuestionnaireSaveAnswersError = AccommodationObjectNotFoundError | ContentServiceQuestionnaireEditingForbiddenError | ContentServiceQuestionnaireNotFoundError;

export type ContentServiceQuestionnaireSaveAnswersInput = {
  accommodationObjectCid: Scalars['String']['input'];
  answers: QuestionnaireAnswersInput;
};

export type ContentServiceQuestionnaireSaveAnswersPayload = {
  __typename?: 'ContentServiceQuestionnaireSaveAnswersPayload';
  errors?: Maybe<Array<ContentServiceQuestionnaireSaveAnswersError>>;
  questionnaireAnswers?: Maybe<QuestionnaireAnswers>;
};

export enum ContentServiceQuestionnaireStatusView {
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Sent = 'SENT'
}

export type ContentServiceQuestionnaireView = {
  __typename?: 'ContentServiceQuestionnaireView';
  accommodationObjectCid: Scalars['String']['output'];
  archiveUrl?: Maybe<Scalars['String']['output']>;
  finished?: Maybe<Scalars['DateTime']['output']>;
  hasParent: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  shortName: Scalars['String']['output'];
  started: Scalars['DateTime']['output'];
  status: ContentServiceQuestionnaireStatusView;
};

export type ContractNotFoundError = Error & {
  __typename?: 'ContractNotFoundError';
  message: Scalars['String']['output'];
};

export type ContractReconciliationAvailableForPeriodView = {
  __typename?: 'ContractReconciliationAvailableForPeriodView';
  contractReconciliationState: ContractReconciliationStates;
};

export enum ContractReconciliationStates {
  AvailableToReconcile = 'AVAILABLE_TO_RECONCILE',
  HasNotReconciledOrders = 'HAS_NOT_RECONCILED_ORDERS',
  Reconciled = 'RECONCILED'
}

export type ContractReconciliationStatusForPeriodInput = {
  contractNumber: Scalars['Int']['input'];
  reportingDate: Scalars['Date']['input'];
};

export type ContractServiceGroupsView = {
  __typename?: 'ContractServiceGroupsView';
  serviceGroups: Array<TariffScheduleServiceGroupView>;
  tariffSchedule: DictNameView;
};

export enum ContractStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  OnApproval = 'ON_APPROVAL'
}

export type ContractStatusInappropriateForQuotaChangeError = Error & {
  __typename?: 'ContractStatusInappropriateForQuotaChangeError';
  message: Scalars['String']['output'];
};

export enum ContractType {
  Agency = 'AGENCY',
  Booking = 'BOOKING',
  Sale = 'SALE',
  SaleGross = 'SALE_GROSS'
}

export type ContractView = {
  __typename?: 'ContractView';
  contractNumber: Scalars['UnsignedInt']['output'];
  contractType: ContractType;
  currencyISOCode: Scalars['String']['output'];
  hasOffer: Scalars['Boolean']['output'];
  legal: DictMultiLangNameView;
  status: ContractStatus;
};

export type CreateSupplierError = UserNotFoundError;

export type CreateSupplierPayload = {
  __typename?: 'CreateSupplierPayload';
  SupplierCode?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateSupplierError>>;
};

export type Currency = {
  __typename?: 'Currency';
  currencyISOCode: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CurrencyListNotFoundError = Error & {
  __typename?: 'CurrencyListNotFoundError';
  ciDs: Array<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CurrencyNotFoundError = Error & {
  __typename?: 'CurrencyNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type DeleteUserError = DeletingOwnerError | SelfDeleteError | UserNotFoundError;

export type DeleteUserInput = {
  userId: Scalars['UUID']['input'];
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  errors?: Maybe<Array<DeleteUserError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DeletingOwnerError = Error & {
  __typename?: 'DeletingOwnerError';
  message: Scalars['String']['output'];
};

export enum DetermineAgeMethod {
  JourneyYear = 'JOURNEY_YEAR',
  OnBeginTravel = 'ON_BEGIN_TRAVEL',
  OnEndTravel = 'ON_END_TRAVEL'
}

export type DictMultiLangNameView = {
  __typename?: 'DictMultiLangNameView';
  cid?: Maybe<Scalars['String']['output']>;
  name: Array<LangString>;
};

export type DictNameView = {
  __typename?: 'DictNameView';
  cid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DocumentNotFoundError = Error & {
  __typename?: 'DocumentNotFoundError';
  message: Scalars['String']['output'];
};

export type DocumentResponseModel = {
  __typename?: 'DocumentResponseModel';
  documentDate: Scalars['Date']['output'];
  documentId: Scalars['UUID']['output'];
  documentName: Scalars['String']['output'];
  documentType: DocumentType;
  downloadId: Scalars['String']['output'];
  ediType: EdiType;
  fileName: Scalars['String']['output'];
  juridicalPerson: Scalars['String']['output'];
  reportPeriod: ReportPeriod;
  signatureStatus?: Maybe<ESignatureStatus>;
};

export type DocumentToSignResponseModel = {
  __typename?: 'DocumentToSignResponseModel';
  documentDate: Scalars['Date']['output'];
  documentId: Scalars['UUID']['output'];
  documentName: Scalars['String']['output'];
  fileUri: Scalars['String']['output'];
  previewFileUri: Scalars['String']['output'];
};

export enum DocumentType {
  /** Отчет агента */
  AgentReport = 'AGENT_REPORT',
  /** Отчет агента ПТУ */
  AgentReportPtu = 'AGENT_REPORT_PTU',
  /** Акт сверки */
  ReconciliationReport = 'RECONCILIATION_REPORT',
  /** УПД = счет-фактура + инвойс */
  Upd = 'UPD'
}

export enum EdiType {
  Extranet = 'EXTRANET',
  Other = 'OTHER'
}

export enum ESignatureStatus {
  MutuallySigned = 'MUTUALLY_SIGNED',
  NotSigned = 'NOT_SIGNED',
  Signed1C = 'SIGNED1_C',
  SignedExtranet = 'SIGNED_EXTRANET'
}

export type EditAccommodationObjectRoomCategoryError = LockResourceFailedError | RoomCategoryNotFoundError;

export type EditAccommodationObjectRoomCategoryInput = {
  accommodationObjectRoomCategoryCid: Scalars['String']['input'];
};

export type EditAccommodationObjectRoomCategoryPayload = {
  __typename?: 'EditAccommodationObjectRoomCategoryPayload';
  errors?: Maybe<Array<EditAccommodationObjectRoomCategoryError>>;
  roomCategory?: Maybe<RoomCategoryView>;
};

export type EditQuotaAddRoomsError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | OperationOnUnlockedResourceIsInvalidError | QuotaNotFoundError | RoomCategoriesForAddingNotFoundError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type EditQuotaAddRoomsInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type EditQuotaAddRoomsPayload = {
  __typename?: 'EditQuotaAddRoomsPayload';
  errors?: Maybe<Array<EditQuotaAddRoomsError>>;
  roomQuotas?: Maybe<Array<RoomCategoryView>>;
};

export type EditQuotaReservesUpdateError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | QuotaNotFoundError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type EditQuotaReservesUpdateInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type EditQuotaReservesUpdatePayload = {
  __typename?: 'EditQuotaReservesUpdatePayload';
  Quota?: Maybe<QuotaView>;
  errors?: Maybe<Array<EditQuotaReservesUpdateError>>;
};

export type EditTariffScheduleError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | OperationForbiddenError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type EditTariffScheduleInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type EditTariffSchedulePayload = {
  __typename?: 'EditTariffSchedulePayload';
  TariffSchedule?: Maybe<TariffScheduleCommonInformation>;
  errors?: Maybe<Array<EditTariffScheduleError>>;
};

export type EditTariffScheduleServiceGroupError = HotelSetHasRemoteIntegrationForbiddenError | HotelSetNotFoundError | LockResourceFailedError | ServiceGroupNotFoundError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type EditTariffScheduleServiceGroupInput = {
  hotelSetCid: Scalars['String']['input'];
  serviceGroupCid: Scalars['String']['input'];
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
};

export type EditTariffScheduleServiceGroupListError = HotelSetHasRemoteIntegrationForbiddenError | HotelSetNotFoundError | LockResourceFailedError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type EditTariffScheduleServiceGroupListInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type EditTariffScheduleServiceGroupListPayload = {
  __typename?: 'EditTariffScheduleServiceGroupListPayload';
  errors?: Maybe<Array<EditTariffScheduleServiceGroupListError>>;
  serviceGroups?: Maybe<TariffScheduleServiceGroupsListView>;
};

export type EditTariffScheduleServiceGroupPayload = {
  __typename?: 'EditTariffScheduleServiceGroupPayload';
  errors?: Maybe<Array<EditTariffScheduleServiceGroupError>>;
  serviceGroup?: Maybe<TariffScheduleServiceGroupView>;
};

export type EquipmentDictionaries = {
  __typename?: 'EquipmentDictionaries';
  anotherInfrastructure: Array<Scalars['String']['output']>;
  beachEntertainments: Array<Scalars['String']['output']>;
  beachEquipment: Array<Scalars['String']['output']>;
  beachTypes: Array<Scalars['String']['output']>;
  beautyInfrastructure: Array<Scalars['String']['output']>;
  childrenInfrastructure: Array<Scalars['String']['output']>;
  childrenPools: Array<Scalars['String']['output']>;
  disabilityInfrastructure: Array<Scalars['String']['output']>;
  indoorAreas: Array<Scalars['String']['output']>;
  openWinterPlaygrounds: Array<Scalars['String']['output']>;
  outdoorAreas: Array<Scalars['String']['output']>;
  paidBeachEquipment: Array<Scalars['String']['output']>;
  parkingTypes: Array<Scalars['String']['output']>;
  poolCharacteristics: Array<Scalars['String']['output']>;
  saunaPay: Array<Scalars['String']['output']>;
  saunaTypes: Array<Scalars['String']['output']>;
  skiResorts: Array<Scalars['String']['output']>;
};

export type Error = {
  message: Scalars['String']['output'];
};

export type ExternalHotel = {
  __typename?: 'ExternalHotel';
  hotelId: Scalars['UnsignedInt']['output'];
  hotelName: Scalars['String']['output'];
};

export type ExternalHotelContextQueryInput = {
  contractNumber: Scalars['UnsignedInt']['input'];
  externalHotel: ExternalHotelQueryInput;
};

export type ExternalHotelQuery = {
  __typename?: 'ExternalHotelQuery';
  hotelId: Scalars['UnsignedInt']['output'];
  hotelName: Scalars['String']['output'];
};

export type ExternalHotelQueryInput = {
  hotelId: Scalars['UnsignedInt']['input'];
  hotelName: Scalars['String']['input'];
};

export type ExternalHotelSuggestionView = {
  __typename?: 'ExternalHotelSuggestionView';
  channelManagerCode: ChannelManagerCode;
  externalHotelQuery: ExternalHotelQuery;
  uncompletedInteractionId?: Maybe<Scalars['UUID']['output']>;
};

export type ExternalObjectTranslationInput = {
  cid: Scalars['String']['input'];
  externalID: Scalars['String']['input'];
};

export type ExternalObjectTranslationView = {
  __typename?: 'ExternalObjectTranslationView';
  cid?: Maybe<Scalars['String']['output']>;
  externalObject: ExternalObjectView;
};

export type ExternalObjectView = {
  __typename?: 'ExternalObjectView';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FindFreeLegalInput = {
  tin: Scalars['String']['input'];
};

export type GeneratedPlacingVariantsView = {
  __typename?: 'GeneratedPlacingVariantsView';
  invalidRoomCategoryCids?: Maybe<Array<Scalars['String']['output']>>;
  placingVariantsTarification?: Maybe<Array<RoomCategoryPlacingsView>>;
};

export type GeneratedReversePlacingVariantsView = {
  __typename?: 'GeneratedReversePlacingVariantsView';
  invalidRoomCategoryCids?: Maybe<Array<Scalars['String']['output']>>;
  placingVariantsTarification?: Maybe<Array<RoomCategoryPlacingsView>>;
};

export type GetQuotaOrdersInput = {
  accommodationObjectCid?: InputMaybe<Scalars['String']['input']>;
  contractNumber?: InputMaybe<Scalars['Int']['input']>;
  dateFrom: Scalars['Date']['input'];
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
};

export type GridPeriodInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type HotelCategoryNotFoundError = Error & {
  __typename?: 'HotelCategoryNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type HotelMaxOnApprovalConflictError = Error & {
  __typename?: 'HotelMaxOnApprovalConflictError';
  message: Scalars['String']['output'];
};

export type HotelSetAgeSettingsInput = {
  determineAgeMethod: DetermineAgeMethod;
  initialAge: Scalars['Byte']['input'];
  noSeatAge?: InputMaybe<Scalars['Byte']['input']>;
};

export type HotelSetHasRemoteIntegrationForbiddenError = Error & {
  __typename?: 'HotelSetHasRemoteIntegrationForbiddenError';
  message: Scalars['String']['output'];
};

export type HotelSetNotFoundError = Error & {
  __typename?: 'HotelSetNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type HotelTypeNotFoundError = Error & {
  __typename?: 'HotelTypeNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum HttpStatusCode {
  Accepted = 'ACCEPTED',
  AlreadyReported = 'ALREADY_REPORTED',
  BadGateway = 'BAD_GATEWAY',
  BadRequest = 'BAD_REQUEST',
  Conflict = 'CONFLICT',
  Continue = 'CONTINUE',
  Created = 'CREATED',
  EarlyHints = 'EARLY_HINTS',
  ExpectationFailed = 'EXPECTATION_FAILED',
  FailedDependency = 'FAILED_DEPENDENCY',
  Forbidden = 'FORBIDDEN',
  Found = 'FOUND',
  GatewayTimeout = 'GATEWAY_TIMEOUT',
  Gone = 'GONE',
  HttpVersionNotSupported = 'HTTP_VERSION_NOT_SUPPORTED',
  ImUsed = 'IM_USED',
  InsufficientStorage = 'INSUFFICIENT_STORAGE',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  LengthRequired = 'LENGTH_REQUIRED',
  Locked = 'LOCKED',
  LoopDetected = 'LOOP_DETECTED',
  MethodNotAllowed = 'METHOD_NOT_ALLOWED',
  MisdirectedRequest = 'MISDIRECTED_REQUEST',
  MovedPermanently = 'MOVED_PERMANENTLY',
  MultipleChoices = 'MULTIPLE_CHOICES',
  MultiStatus = 'MULTI_STATUS',
  NetworkAuthenticationRequired = 'NETWORK_AUTHENTICATION_REQUIRED',
  NonAuthoritativeInformation = 'NON_AUTHORITATIVE_INFORMATION',
  NotAcceptable = 'NOT_ACCEPTABLE',
  NotExtended = 'NOT_EXTENDED',
  NotFound = 'NOT_FOUND',
  NotImplemented = 'NOT_IMPLEMENTED',
  NotModified = 'NOT_MODIFIED',
  NoContent = 'NO_CONTENT',
  Ok = 'OK',
  PartialContent = 'PARTIAL_CONTENT',
  PaymentRequired = 'PAYMENT_REQUIRED',
  PermanentRedirect = 'PERMANENT_REDIRECT',
  PreconditionFailed = 'PRECONDITION_FAILED',
  PreconditionRequired = 'PRECONDITION_REQUIRED',
  Processing = 'PROCESSING',
  ProxyAuthenticationRequired = 'PROXY_AUTHENTICATION_REQUIRED',
  RedirectKeepVerb = 'REDIRECT_KEEP_VERB',
  RequestedRangeNotSatisfiable = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  RequestEntityTooLarge = 'REQUEST_ENTITY_TOO_LARGE',
  RequestHeaderFieldsTooLarge = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  RequestTimeout = 'REQUEST_TIMEOUT',
  RequestUriTooLong = 'REQUEST_URI_TOO_LONG',
  ResetContent = 'RESET_CONTENT',
  SeeOther = 'SEE_OTHER',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  SwitchingProtocols = 'SWITCHING_PROTOCOLS',
  TooManyRequests = 'TOO_MANY_REQUESTS',
  Unauthorized = 'UNAUTHORIZED',
  UnavailableForLegalReasons = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  UnprocessableEntity = 'UNPROCESSABLE_ENTITY',
  UnsupportedMediaType = 'UNSUPPORTED_MEDIA_TYPE',
  Unused = 'UNUSED',
  UpgradeRequired = 'UPGRADE_REQUIRED',
  UseProxy = 'USE_PROXY',
  VariantAlsoNegotiates = 'VARIANT_ALSO_NEGOTIATES'
}

export type IdentityUserView = {
  __typename?: 'IdentityUserView';
  email: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type IncorrectQuotaChangeOperationError = Error & {
  __typename?: 'IncorrectQuotaChangeOperationError';
  booked: Scalars['UnsignedInt']['output'];
  from: Scalars['Date']['output'];
  message: Scalars['String']['output'];
  requiredReserve: Scalars['UnsignedInt']['output'];
  roomCategoryCid: Scalars['String']['output'];
  roomCategoryName: Scalars['String']['output'];
  to: Scalars['Date']['output'];
};

export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  checkInOutSettings: CheckInOutSettings;
  connectionName: Array<LangString>;
  penaltySchemeCode: Scalars['String']['output'];
  supplierPayRuleCode: Scalars['String']['output'];
};

export type IntegrationSettingsInput = {
  checkInOutSettings: CheckInOutSettingsInput;
  connectionName: Array<LangStringInput>;
  penaltySchemeCode: Scalars['String']['input'];
  supplierPayRuleCode: Scalars['String']['input'];
};

export type InteractionQueryInput = {
  contractNumber: Scalars['UnsignedInt']['input'];
  interactionId: Scalars['UUID']['input'];
};

export enum InteractionState {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type InvalidContractNumberError = Error & {
  __typename?: 'InvalidContractNumberError';
  actualContractNumber: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  requestedContractNumber: Scalars['UnsignedInt']['output'];
};

export type InvitationNotFoundError = Error & {
  __typename?: 'InvitationNotFoundError';
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
};

export type InvitationView = {
  __typename?: 'InvitationView';
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserView;
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  role?: Maybe<Role>;
};

export type InviteUserToSupplierInput = {
  emails: Array<Scalars['String']['input']>;
};

export type InviteUserToSupplierPayload = {
  __typename?: 'InviteUserToSupplierPayload';
  status: Scalars['String']['output'];
};

export type IsLegalFreeInput = {
  tin: Scalars['String']['input'];
};

export type IsNotStartedReverseInteractionView = {
  __typename?: 'IsNotStartedReverseInteractionView';
  interactionId: Scalars['UUID']['output'];
  isNotStarted: Scalars['Boolean']['output'];
};

export type JoinToSupplierError = UserAlreadyBelongsToSupplierError;

export type JoinToSupplierInput = {
  inviteCode: Scalars['String']['input'];
};

export type JoinToSupplierPayload = {
  __typename?: 'JoinToSupplierPayload';
  errors?: Maybe<Array<JoinToSupplierError>>;
  status?: Maybe<JoinToSupplierStatus>;
};

export enum JoinToSupplierStatus {
  InvalidInvitation = 'INVALID_INVITATION',
  Successfull = 'SUCCESSFULL'
}

export type KeepAliveAccommodationObjectRoomCategoryError = OperationOnUnlockedResourceIsInvalidError;

export type KeepAliveAccommodationObjectRoomCategoryInput = {
  accommodationObjectRoomCategoryCid: Scalars['String']['input'];
};

export type KeepAliveAccommodationObjectRoomCategoryPayload = {
  __typename?: 'KeepAliveAccommodationObjectRoomCategoryPayload';
  errors?: Maybe<Array<KeepAliveAccommodationObjectRoomCategoryError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type KeepAliveQuotaAddRoomsError = OperationOnUnlockedResourceIsInvalidError | QuotaNotFoundError;

export type KeepAliveQuotaAddRoomsInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type KeepAliveQuotaAddRoomsPayload = {
  __typename?: 'KeepAliveQuotaAddRoomsPayload';
  errors?: Maybe<Array<KeepAliveQuotaAddRoomsError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type KeepAliveQuotaReservesUpdateError = OperationOnUnlockedResourceIsInvalidError | QuotaNotFoundError;

export type KeepAliveQuotaReservesUpdateInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type KeepAliveQuotaReservesUpdatePayload = {
  __typename?: 'KeepAliveQuotaReservesUpdatePayload';
  errors?: Maybe<Array<KeepAliveQuotaReservesUpdateError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type KeepAliveTariffScheduleError = OperationOnUnlockedResourceIsInvalidError;

export type KeepAliveTariffScheduleInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type KeepAliveTariffSchedulePayload = {
  __typename?: 'KeepAliveTariffSchedulePayload';
  errors?: Maybe<Array<KeepAliveTariffScheduleError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type KeepAliveTariffScheduleServiceGroupError = HotelSetNotFoundError | OperationOnUnlockedResourceIsInvalidError;

export type KeepAliveTariffScheduleServiceGroupInput = {
  hotelSetCid: Scalars['String']['input'];
  serviceGroupCid: Scalars['String']['input'];
};

export type KeepAliveTariffScheduleServiceGroupListError = HotelSetNotFoundError | OperationOnUnlockedResourceIsInvalidError | TariffScheduleNotFoundError;

export type KeepAliveTariffScheduleServiceGroupListInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type KeepAliveTariffScheduleServiceGroupListPayload = {
  __typename?: 'KeepAliveTariffScheduleServiceGroupListPayload';
  errors?: Maybe<Array<KeepAliveTariffScheduleServiceGroupListError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type KeepAliveTariffScheduleServiceGroupPayload = {
  __typename?: 'KeepAliveTariffScheduleServiceGroupPayload';
  errors?: Maybe<Array<KeepAliveTariffScheduleServiceGroupError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LangString = {
  __typename?: 'LangString';
  langCode: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LangStringInput = {
  langCode: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LegalDataInput = {
  address: AddressDataInput;
  isNotTaxPayer: Scalars['Boolean']['input'];
  legalDetails: LegalDetailsInput;
  legalOrigin: LegalOrigin;
  name?: InputMaybe<Scalars['String']['input']>;
  nameML?: InputMaybe<Array<LangStringInput>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type LegalDataView = {
  __typename?: 'LegalDataView';
  address?: Maybe<Scalars['String']['output']>;
  addressML?: Maybe<Array<LangString>>;
  details: LegalDetails;
  ediType: EdiType;
  isIndividual: Scalars['Boolean']['output'];
  isNotTaxPayer: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nameML?: Maybe<Array<LangString>>;
  townName?: Maybe<Scalars['String']['output']>;
};

export type LegalDetails = {
  __typename?: 'LegalDetails';
  kpp?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  tin: Scalars['String']['output'];
};

export type LegalDetailsInput = {
  kpp?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  tin: Scalars['String']['input'];
};

export type LegalExtranetAreaConflictError = Error & {
  __typename?: 'LegalExtranetAreaConflictError';
  message: Scalars['String']['output'];
};

export type LegalListItemOperations = {
  __typename?: 'LegalListItemOperations';
  delete: OperationStatus;
};

export type LegalListItemView = {
  __typename?: 'LegalListItemView';
  approveStatus: ApproveStatus;
  cid: Scalars['String']['output'];
  legalDetails: LegalDetails;
  name: Array<LangString>;
  operations: LegalListItemOperations;
};

export type LegalListOperations = {
  __typename?: 'LegalListOperations';
  canAdd: OperationStatus;
  onApprovalLimitExceeded?: Maybe<OnApprovalLimitExceededView>;
};

export type LegalListView = {
  __typename?: 'LegalListView';
  legals: Array<LegalListItemView>;
  operations: LegalListOperations;
};

export type LegalMaxOnApprovalConflictError = Error & {
  __typename?: 'LegalMaxOnApprovalConflictError';
  message: Scalars['String']['output'];
};

export type LegalNotFoundError = Error & {
  __typename?: 'LegalNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type LegalOperations = {
  __typename?: 'LegalOperations';
  canUpdateEDI: OperationStatus;
};

export enum LegalOrigin {
  Other = 'OTHER',
  Ru = 'RU'
}

export type LegalSaveEdiTypeError = Error & {
  __typename?: 'LegalSaveEDITypeError';
  message: Scalars['String']['output'];
};

export type LegalTinAndKppConflictError = Error & {
  __typename?: 'LegalTINAndKPPConflictError';
  kpp?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  tin: Scalars['String']['output'];
};

export type LegalView = {
  __typename?: 'LegalView';
  cid: Scalars['String']['output'];
  data: LegalDataView;
  operations: LegalOperations;
  status: ApproveStatus;
};

export type LockResourceFailedError = Error & {
  __typename?: 'LockResourceFailedError';
  blockedInfo: BlockedInfo;
  message: Scalars['String']['output'];
};

export type MeView = {
  __typename?: 'MeView';
  email: Scalars['String']['output'];
  hasKsbAccount: Scalars['Boolean']['output'];
  hasProfile: Scalars['Boolean']['output'];
  hasSupplier: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isOwner: Scalars['Boolean']['output'];
  permissions: Array<PermissionTarget>;
  profile?: Maybe<UserProfileView>;
  role?: Maybe<Role>;
  supplierCode?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
  userRegistration?: Maybe<UserRegistration>;
};

export type MismatchOrderReconciliationError = ContractNotFoundError | OrderNotFoundError;

export type MismatchOrderReconciliationInput = {
  mismatch: OrderReconciliationMismatchInput;
  orderId: Scalars['Int']['input'];
};

export type MismatchOrderReconciliationPayload = {
  __typename?: 'MismatchOrderReconciliationPayload';
  errors?: Maybe<Array<MismatchOrderReconciliationError>>;
  orderReconciliation?: Maybe<OrderReconciliationView>;
};

export enum MismatchReason {
  EarlyCheckout = 'EARLY_CHECKOUT',
  IncorrectRate = 'INCORRECT_RATE',
  NoShow = 'NO_SHOW',
  Other = 'OTHER'
}

export type MoneyInput = {
  currencyISOCode: Scalars['String']['input'];
  value: Scalars['Decimal']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accessRequestAccept: AccessRequestAcceptPayload;
  accessRequestDecline: AccessRequestDeclinePayload;
  addAccommodationObject: AddAccommodationObjectPayload;
  addAccommodationObjectRoomCategory: AddAccommodationObjectRoomCategoryPayload;
  addAccommodationObjectService: AddAccommodationObjectServicePayload;
  addContract: AddContractPayload;
  addLegal: AddLegalPayload;
  addLegalExisting: AddLegalExistingPayload;
  addRestrictionsCheckInOutSetting: AddRestrictionsCheckInOutSettingPayload;
  addRestrictionsPlacingVariants: AddRestrictionsPlacingVariantsPayload;
  addRestrictionsServiceGroup: AddRestrictionsServiceGroupPayload;
  addTariffSchedule: AddTariffSchedulePayload;
  addTariffScheduleServiceGroup: AddTariffScheduleServiceGroupPayload;
  avoidOrder: AvoidOrderPayload;
  cancelEditAccommodationObjectRoomCategory: CancelEditAccommodationObjectRoomCategoryPayload;
  cancelEditQuotaAddRooms: CancelEditQuotaAddRoomsPayload;
  cancelEditQuotaReservesUpdate: CancelEditQuotaReservesUpdatePayload;
  cancelEditTariffSchedule: CancelEditTariffSchedulePayload;
  cancelEditTariffScheduleServiceGroup: CancelEditTariffScheduleServiceGroupPayload;
  cancelEditTariffScheduleServiceGroupList: CancelEditTariffScheduleServiceGroupListPayload;
  confirmOrder: ConfirmOrderPayload;
  contentServiceQuestionnaireCancelEdit: ContentServiceQuestionnaireCancelEditPayload;
  contentServiceQuestionnaireCreate: ContentServiceQuestionnaireCreatePayload;
  contentServiceQuestionnaireEdit: ContentServiceQuestionnaireEditPayload;
  contentServiceQuestionnaireFinalize: ContentServiceQuestionnaireFinalizePayload;
  contentServiceQuestionnaireMoveToNextStep: ContentServiceQuestionnaireMoveToNextStepPayload;
  contentServiceQuestionnaireSaveAnswers: ContentServiceQuestionnaireSaveAnswersPayload;
  createSupplier: CreateSupplierPayload;
  deleteUser: DeleteUserPayload;
  editAccommodationObjectRoomCategory: EditAccommodationObjectRoomCategoryPayload;
  editQuotaAddRooms: EditQuotaAddRoomsPayload;
  editQuotaReservesUpdate: EditQuotaReservesUpdatePayload;
  editTariffSchedule: EditTariffSchedulePayload;
  editTariffScheduleServiceGroup: EditTariffScheduleServiceGroupPayload;
  editTariffScheduleServiceGroupList: EditTariffScheduleServiceGroupListPayload;
  inviteUserToSupplier: InviteUserToSupplierPayload;
  joinToSupplier: JoinToSupplierPayload;
  keepAliveAccommodationObjectRoomCategory: KeepAliveAccommodationObjectRoomCategoryPayload;
  keepAliveQuotaAddRooms: KeepAliveQuotaAddRoomsPayload;
  keepAliveQuotaReservesUpdate: KeepAliveQuotaReservesUpdatePayload;
  keepAliveTariffSchedule: KeepAliveTariffSchedulePayload;
  keepAliveTariffScheduleServiceGroup: KeepAliveTariffScheduleServiceGroupPayload;
  keepAliveTariffScheduleServiceGroupList: KeepAliveTariffScheduleServiceGroupListPayload;
  mismatchOrderReconciliation: MismatchOrderReconciliationPayload;
  /** Снимает блокировку */
  placingVariantsCancelEdit: PlacingVariantsCancelEditPayload;
  /** Устанавливает блокировку на Тарифный План (HotelSet), возвращает набор ВР */
  placingVariantsEdit: PlacingVariantsEditPayload;
  /** Продлевает время жизни блокировки */
  placingVariantsKeepAlive: PlacingVariantsKeepAlivePayload;
  /** Снимает блокировку */
  placingVariantsMasterCancel: PlacingVariantsMasterCancelPayload;
  placingVariantsMasterComplete: PlacingVariantsMasterCompletePayload;
  placingVariantsMasterGenerate: PlacingVariantsMasterGeneratePayload;
  /** Продлевает время жизни блокировки */
  placingVariantsMasterKeepAlive: PlacingVariantsMasterKeepAlivePayload;
  placingVariantsMasterStart: PlacingVariantsMasterStartPayload;
  /** Обновляет набор ВР в KSB, снимает блокировку с тарифного плана */
  placingVariantsUpdate: PlacingVariantsUpdatePayload;
  reconcileContractForPeriod: ReconcileContractForPeriodPayload;
  reconcileOrdersReconciliation: ReconcileOrdersReconciliationPayload;
  registerKsbAccount: RegisterKsbAccountPayload;
  removeAccommodationObjectRoomCategory: RemoveAccommodationObjectRoomCategoryPayload;
  removeAccommodationObjectService: RemoveAccommodationObjectServicePayload;
  removeLegal: RemoveLegalPayload;
  removeRestrictionsCheckInOutSetting: RemoveRestrictionsCheckInOutSettingPayload;
  removeRestrictionsPlacingVariant: RemoveRestrictionsPlacingVariantPayload;
  removeRestrictionsServiceGroup: RemoveRestrictionsServiceGroupPayload;
  reverseRestartIntegration: ReverseRestartIntegrationPayload;
  reverseStartIntegration: ReverseStartIntegrationPayload;
  reverseUpdatePlacingVariants: ReverseUpdatePlacingVariantsPayload;
  reverseUpdateRoomCategories: ReverseUpdateRoomCategoriesPayload;
  reverseUpdateServiceGroups: ReverseUpdateServiceGroupsPayload;
  reverseUpdateTouristTypes: ReverseUpdateTouristTypesPayload;
  saveDocumentSignature: SaveDocumentSignaturePayload;
  saveLegalEDIType: SaveLegalEdiTypePayload;
  sendOrderToSupplier: SendOrderToSupplierPayload;
  sendSupplierQuestionnaire: SendSupplierQuestionnairePayload;
  sendTariffScheduleInWork: SendTariffScheduleInWorkPayload;
  setInvitationRole: SetInvitationRolePayload;
  setUserRole: SetUserRolePayload;
  tariffGridCancelEdit: TariffGridCancelEditPayload;
  tariffGridEdit: TariffGridEditPayload;
  tariffGridKeepAlive: TariffGridKeepAlivePayload;
  tariffGridUpdate: TariffGridUpdatePayload;
  travelLineRefreshTouristTypes: TravelLineRefreshTouristTypesPayload;
  travelLineRestartIntegration: TravelLineRestartIntegrationPayload;
  travelLineSaveRoomCategoriesMapping: TravelLineSaveRoomCategoriesMappingPayload;
  travelLineSaveServiceGroupsMapping: TravelLineSaveServiceGroupsMappingPayload;
  travelLineStartIntegration: TravelLineStartIntegrationPayload;
  travelLineUpdateIntegrationSettings: TravelLineUpdateIntegrationSettingsPayload;
  travelLineUpdatePlacingVariants: TravelLineUpdatePlacingVariantsPayload;
  travelLineUpdateRoomCategories: TravelLineUpdateRoomCategoriesPayload;
  travelLineUpdateServiceGroups: TravelLineUpdateServiceGroupsPayload;
  travelLineUpdateTouristTypes: TravelLineUpdateTouristTypesPayload;
  updateAccommodationObjectRoomCategory: UpdateAccommodationObjectRoomCategoryPayload;
  updateQuotaAddRooms: UpdateQuotaAddRoomsPayload;
  updateQuotaReservesUpdate: UpdateQuotaReservesUpdatePayload;
  updateRestrictionsCheckInOutSetting: UpdateRestrictionsCheckInOutSettingPayload;
  updateRestrictionsPlacingVariant: UpdateRestrictionsPlacingVariantPayload;
  updateRestrictionsServiceGroup: UpdateRestrictionsServiceGroupPayload;
  updateSupplierQuestionnaire: UpdateSupplierQuestionnairePayload;
  updateTariffSchedule: UpdateTariffSchedulePayload;
  updateTariffScheduleServiceGroup: UpdateTariffScheduleServiceGroupPayload;
  updateTariffScheduleServiceGroupList: UpdateTariffScheduleServiceGroupListPayload;
  updateUserProfile: UpdateUserProfilePayload;
};


export type MutationAccessRequestAcceptArgs = {
  input: AccessRequestAcceptInput;
};


export type MutationAccessRequestDeclineArgs = {
  input: AccessRequestDeclineInput;
};


export type MutationAddAccommodationObjectArgs = {
  addAccommodationObjectInput: AddAccommodationObjectInput;
};


export type MutationAddAccommodationObjectRoomCategoryArgs = {
  addAccommodationObjectRoomCategoryInput: AddAccommodationObjectRoomCategoryInput;
};


export type MutationAddAccommodationObjectServiceArgs = {
  addAccommodationObjectServiceInput: AddAccommodationObjectServiceInput;
};


export type MutationAddContractArgs = {
  addContractInput: AddContractInput;
};


export type MutationAddLegalArgs = {
  legal: LegalDataInput;
};


export type MutationAddLegalExistingArgs = {
  input: AddLegalExistingInput;
};


export type MutationAddRestrictionsCheckInOutSettingArgs = {
  input: AddRestrictionsCheckInOutSettingInput;
};


export type MutationAddRestrictionsPlacingVariantsArgs = {
  input: AddRestrictionsPlacingVariantsInput;
};


export type MutationAddRestrictionsServiceGroupArgs = {
  input: AddRestrictionsServiceGroupInput;
};


export type MutationAddTariffScheduleArgs = {
  addTariffScheduleInput: AddTariffScheduleInput;
};


export type MutationAddTariffScheduleServiceGroupArgs = {
  input: AddTariffScheduleServiceGroupInput;
};


export type MutationAvoidOrderArgs = {
  input: AvoidOrderInput;
};


export type MutationCancelEditAccommodationObjectRoomCategoryArgs = {
  cancelEditAccommodationObjectRoomCategoryInput: CancelEditAccommodationObjectRoomCategoryInput;
};


export type MutationCancelEditQuotaAddRoomsArgs = {
  input: CancelEditQuotaAddRoomsInput;
};


export type MutationCancelEditQuotaReservesUpdateArgs = {
  input: CancelEditQuotaReservesUpdateInput;
};


export type MutationCancelEditTariffScheduleArgs = {
  input: CancelEditTariffScheduleInput;
};


export type MutationCancelEditTariffScheduleServiceGroupArgs = {
  input: CancelEditTariffScheduleServiceGroupInput;
};


export type MutationCancelEditTariffScheduleServiceGroupListArgs = {
  input: CancelEditTariffScheduleServiceGroupListInput;
};


export type MutationConfirmOrderArgs = {
  input: ConfirmOrderInput;
};


export type MutationContentServiceQuestionnaireCancelEditArgs = {
  input: ContentServiceQuestionnaireCancelEditInput;
};


export type MutationContentServiceQuestionnaireCreateArgs = {
  input: ContentServiceQuestionnaireCreateInput;
};


export type MutationContentServiceQuestionnaireEditArgs = {
  input: ContentServiceQuestionnaireEditInput;
};


export type MutationContentServiceQuestionnaireFinalizeArgs = {
  input: ContentServiceQuestionnaireFinalizeInput;
};


export type MutationContentServiceQuestionnaireMoveToNextStepArgs = {
  input: ContentServiceQuestionnaireMoveToNextStepInput;
};


export type MutationContentServiceQuestionnaireSaveAnswersArgs = {
  input: ContentServiceQuestionnaireSaveAnswersInput;
};


export type MutationDeleteUserArgs = {
  deleteUserInput: DeleteUserInput;
};


export type MutationEditAccommodationObjectRoomCategoryArgs = {
  editAccommodationObjectRoomCategoryInput: EditAccommodationObjectRoomCategoryInput;
};


export type MutationEditQuotaAddRoomsArgs = {
  input: EditQuotaAddRoomsInput;
};


export type MutationEditQuotaReservesUpdateArgs = {
  input: EditQuotaReservesUpdateInput;
};


export type MutationEditTariffScheduleArgs = {
  input: EditTariffScheduleInput;
};


export type MutationEditTariffScheduleServiceGroupArgs = {
  input: EditTariffScheduleServiceGroupInput;
};


export type MutationEditTariffScheduleServiceGroupListArgs = {
  input: EditTariffScheduleServiceGroupListInput;
};


export type MutationInviteUserToSupplierArgs = {
  input: InviteUserToSupplierInput;
};


export type MutationJoinToSupplierArgs = {
  input: JoinToSupplierInput;
};


export type MutationKeepAliveAccommodationObjectRoomCategoryArgs = {
  keepAliveAccommodationObjectRoomCategoryInput: KeepAliveAccommodationObjectRoomCategoryInput;
};


export type MutationKeepAliveQuotaAddRoomsArgs = {
  input: KeepAliveQuotaAddRoomsInput;
};


export type MutationKeepAliveQuotaReservesUpdateArgs = {
  input: KeepAliveQuotaReservesUpdateInput;
};


export type MutationKeepAliveTariffScheduleArgs = {
  input: KeepAliveTariffScheduleInput;
};


export type MutationKeepAliveTariffScheduleServiceGroupArgs = {
  input: KeepAliveTariffScheduleServiceGroupInput;
};


export type MutationKeepAliveTariffScheduleServiceGroupListArgs = {
  input: KeepAliveTariffScheduleServiceGroupListInput;
};


export type MutationMismatchOrderReconciliationArgs = {
  input: MismatchOrderReconciliationInput;
};


export type MutationPlacingVariantsCancelEditArgs = {
  input: PlacingVariantsCancelEditInput;
};


export type MutationPlacingVariantsEditArgs = {
  input: PlacingVariantsEditInput;
};


export type MutationPlacingVariantsKeepAliveArgs = {
  input: PlacingVariantsKeepAliveInput;
};


export type MutationPlacingVariantsMasterCancelArgs = {
  input: PlacingVariantsMasterCancelInput;
};


export type MutationPlacingVariantsMasterCompleteArgs = {
  input: PlacingVariantsMasterCompleteInput;
};


export type MutationPlacingVariantsMasterGenerateArgs = {
  input: PlacingVariantsMasterGenerateInput;
};


export type MutationPlacingVariantsMasterKeepAliveArgs = {
  input: PlacingVariantsMasterKeepAliveInput;
};


export type MutationPlacingVariantsMasterStartArgs = {
  input: PlacingVariantsMasterStartInput;
};


export type MutationPlacingVariantsUpdateArgs = {
  input: PlacingVariantsUpdateInput;
};


export type MutationReconcileContractForPeriodArgs = {
  input: ReconcileContractForPeriodInput;
};


export type MutationReconcileOrdersReconciliationArgs = {
  input: ReconcileOrdersReconciliationInput;
};


export type MutationRemoveAccommodationObjectRoomCategoryArgs = {
  input: RemoveAccommodationObjectRoomCategoryInput;
};


export type MutationRemoveAccommodationObjectServiceArgs = {
  input: RemoveAccommodationObjectServiceInput;
};


export type MutationRemoveLegalArgs = {
  input: RemoveLegalInput;
};


export type MutationRemoveRestrictionsCheckInOutSettingArgs = {
  input: RemoveRestrictionsCheckInOutSettingInput;
};


export type MutationRemoveRestrictionsPlacingVariantArgs = {
  input: RemoveRestrictionsPlacingVariantInput;
};


export type MutationRemoveRestrictionsServiceGroupArgs = {
  input: RemoveRestrictionsServiceGroupInput;
};


export type MutationReverseRestartIntegrationArgs = {
  input: ReverseRestartIntegrationInput;
};


export type MutationReverseStartIntegrationArgs = {
  input: ReverseStartIntegrationInput;
};


export type MutationReverseUpdatePlacingVariantsArgs = {
  input: ReverseUpdatePlacingVariantsInput;
};


export type MutationReverseUpdateRoomCategoriesArgs = {
  input: ReverseUpdateRoomCategoriesInput;
};


export type MutationReverseUpdateServiceGroupsArgs = {
  input: ReverseUpdateServiceGroupsInput;
};


export type MutationReverseUpdateTouristTypesArgs = {
  input: ReverseUpdateTouristTypesInput;
};


export type MutationSaveDocumentSignatureArgs = {
  input: SaveDocumentSignatureInput;
};


export type MutationSaveLegalEdiTypeArgs = {
  input: SaveLegalEdiTypeInput;
};


export type MutationSendOrderToSupplierArgs = {
  input: SendOrderToSupplierInput;
};


export type MutationSendSupplierQuestionnaireArgs = {
  input: SendSupplierQuestionnaireInput;
};


export type MutationSendTariffScheduleInWorkArgs = {
  input: SendTariffScheduleInWorkInput;
};


export type MutationSetInvitationRoleArgs = {
  input: SetInvitationRoleInput;
};


export type MutationSetUserRoleArgs = {
  input: SetUserRoleInput;
};


export type MutationTariffGridCancelEditArgs = {
  input: TariffGridCancelEditInput;
};


export type MutationTariffGridEditArgs = {
  input: TariffGridEditInput;
};


export type MutationTariffGridKeepAliveArgs = {
  input: TariffGridKeepAliveInput;
};


export type MutationTariffGridUpdateArgs = {
  input: TariffGridUpdateInput;
};


export type MutationTravelLineRefreshTouristTypesArgs = {
  input: TravelLineRefreshTouristTypesInput;
};


export type MutationTravelLineRestartIntegrationArgs = {
  input: TravelLineRestartIntegrationInput;
};


export type MutationTravelLineSaveRoomCategoriesMappingArgs = {
  input: TravelLineSaveRoomCategoriesMappingInput;
};


export type MutationTravelLineSaveServiceGroupsMappingArgs = {
  input: TravelLineSaveServiceGroupsMappingInput;
};


export type MutationTravelLineStartIntegrationArgs = {
  input: TravelLineStartIntegrationInput;
};


export type MutationTravelLineUpdateIntegrationSettingsArgs = {
  input: TravelLineUpdateIntegrationSettingsInput;
};


export type MutationTravelLineUpdatePlacingVariantsArgs = {
  input: TravelLineUpdatePlacingVariantsInput;
};


export type MutationTravelLineUpdateRoomCategoriesArgs = {
  input: TravelLineUpdateRoomCategoriesInput;
};


export type MutationTravelLineUpdateServiceGroupsArgs = {
  input: TravelLineUpdateServiceGroupsInput;
};


export type MutationTravelLineUpdateTouristTypesArgs = {
  input: TravelLineUpdateTouristTypesInput;
};


export type MutationUpdateAccommodationObjectRoomCategoryArgs = {
  updateAccommodationObjectRoomCategoryInput: UpdateAccommodationObjectRoomCategoryInput;
};


export type MutationUpdateQuotaAddRoomsArgs = {
  input: UpdateQuotaAddRoomsInput;
};


export type MutationUpdateQuotaReservesUpdateArgs = {
  input: UpdateQuotaReservesUpdateInput;
};


export type MutationUpdateRestrictionsCheckInOutSettingArgs = {
  input: UpdateRestrictionsCheckInOutSettingInput;
};


export type MutationUpdateRestrictionsPlacingVariantArgs = {
  input: UpdateRestrictionsPlacingVariantInput;
};


export type MutationUpdateRestrictionsServiceGroupArgs = {
  input: UpdateRestrictionsServiceGroupInput;
};


export type MutationUpdateSupplierQuestionnaireArgs = {
  input: UpdateSupplierQuestionnaireInput;
};


export type MutationUpdateTariffScheduleArgs = {
  input: UpdateTariffScheduleInput;
};


export type MutationUpdateTariffScheduleServiceGroupArgs = {
  input: UpdateTariffScheduleServiceGroupInput;
};


export type MutationUpdateTariffScheduleServiceGroupListArgs = {
  input: UpdateTariffScheduleServiceGroupListInput;
};


export type MutationUpdateUserProfileArgs = {
  updateUserProfileInput: UpdateUserProfileInput;
};

export enum MutationResult {
  Success = 'SUCCESS'
}

export type NameSuggestion = {
  __typename?: 'NameSuggestion';
  cid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NoRoomCategoriesInAccomodationObjectError = Error & {
  __typename?: 'NoRoomCategoriesInAccomodationObjectError';
  message: Scalars['String']['output'];
};

export type NutritionDictionaries = {
  __typename?: 'NutritionDictionaries';
  childrenNutrition: Array<Scalars['String']['output']>;
  cuisine: Array<Scalars['String']['output']>;
  foodObjectType: Array<Scalars['String']['output']>;
};

export type OnApprovalLimitExceededView = {
  __typename?: 'OnApprovalLimitExceededView';
  limit: Scalars['UnsignedShort']['output'];
};

export type OperationForbiddenError = Error & {
  __typename?: 'OperationForbiddenError';
  message: Scalars['String']['output'];
};

export type OperationOnUnlockedResourceIsInvalidError = Error & {
  __typename?: 'OperationOnUnlockedResourceIsInvalidError';
  message: Scalars['String']['output'];
};

export enum OperationStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Hidden = 'HIDDEN'
}

export type OrderAccommodation = {
  __typename?: 'OrderAccommodation';
  accommodationHasBegun: Scalars['Boolean']['output'];
  cost?: Maybe<Scalars['Decimal']['output']>;
  currencyISOCode: Scalars['String']['output'];
  daysCount: Scalars['Int']['output'];
  hasAccommodationWithoutPacket: Scalars['Boolean']['output'];
  hasUnavoidedInvoice: Scalars['Boolean']['output'];
  orderWishes?: Maybe<Scalars['String']['output']>;
  period: RangeOfDateOnly;
  roomCount: Scalars['Int']['output'];
  specConditions?: Maybe<Scalars['String']['output']>;
};

export type OrderAccommodationHasBegunError = Error & {
  __typename?: 'OrderAccommodationHasBegunError';
  message: Scalars['String']['output'];
};

export enum OrderAvoidanceStatus {
  Avoided = 'AVOIDED',
  NotAvoided = 'NOT_AVOIDED',
  PartiallyAvoided = 'PARTIALLY_AVOIDED'
}

export type OrderCommonInfo = {
  __typename?: 'OrderCommonInfo';
  contractNumber: Scalars['Int']['output'];
  hotelCID: Scalars['String']['output'];
  hotelName: Scalars['String']['output'];
  orderDate: Scalars['Date']['output'];
  quotaShortName: Scalars['String']['output'];
  remoteInteract: Scalars['Boolean']['output'];
  roomCategoryName: Scalars['String']['output'];
};

export type OrderHasNonStandardError = Error & {
  __typename?: 'OrderHasNonStandardError';
  message: Scalars['String']['output'];
};

export type OrderInfo = {
  __typename?: 'OrderInfo';
  hasNonStandard: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  sentToSupplier: Scalars['Boolean']['output'];
  status: OrderStatus;
  subNumber: Scalars['Int']['output'];
};

export type OrderIsAvoidedError = Error & {
  __typename?: 'OrderIsAvoidedError';
  message: Scalars['String']['output'];
};

export type OrderIsConfirmedError = Error & {
  __typename?: 'OrderIsConfirmedError';
  message: Scalars['String']['output'];
};

export type OrderIsNotConfirmedError = Error & {
  __typename?: 'OrderIsNotConfirmedError';
  message: Scalars['String']['output'];
};

export type OrderIsRemoteError = Error & {
  __typename?: 'OrderIsRemoteError';
  message: Scalars['String']['output'];
};

export type OrderItemView = {
  __typename?: 'OrderItemView';
  orderDate: Scalars['Date']['output'];
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['Int']['output'];
  period: RangeOfDateOnly;
  roomCategory: RoomCategoryView;
  sentToSupplier: Scalars['Boolean']['output'];
  status: OrderStatus;
  subOrderNumber: Scalars['Int']['output'];
  tourists: Array<OrderTourist>;
};

export type OrderNotFoundError = Error & {
  __typename?: 'OrderNotFoundError';
  message: Scalars['String']['output'];
};

export type OrderOperations = {
  __typename?: 'OrderOperations';
  avoid: OperationStatus;
  confirm: OperationStatus;
  sendToSupplier: OperationStatus;
};

export type OrderReconciliationAmountInfo = {
  __typename?: 'OrderReconciliationAmountInfo';
  payable: Scalars['Decimal']['output'];
  payout: Scalars['Decimal']['output'];
};

export type OrderReconciliationCommonInfo = {
  __typename?: 'OrderReconciliationCommonInfo';
  amountsInfo: OrderReconciliationAmountInfo;
  orderAvoidanceStatus: OrderAvoidanceStatus;
  orderBookNumber: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['Int']['output'];
  orderReconciliationId: Scalars['UUID']['output'];
  orderReconciliationPeriodId: Scalars['UUID']['output'];
  orderReconciliationStatus: OrderReconciliationStatus;
  period: RangeOfDateOnly;
  reconciliationItemSubTitle: Scalars['String']['output'];
  reconciliationItemTitle: Scalars['String']['output'];
  supplierOrderNumber?: Maybe<Scalars['String']['output']>;
  tourists: Array<OrderReconciliationTourist>;
};

export type OrderReconciliationListFiltersView = {
  __typename?: 'OrderReconciliationListFiltersView';
  reportDates: Array<OrderReconciliationListReportDateItemView>;
};

export type OrderReconciliationListItemView = {
  __typename?: 'OrderReconciliationListItemView';
  commonInfo: OrderReconciliationCommonInfo;
};

export type OrderReconciliationListReportDateItemView = {
  __typename?: 'OrderReconciliationListReportDateItemView';
  reportDate: Scalars['Date']['output'];
};

export type OrderReconciliationListView = {
  __typename?: 'OrderReconciliationListView';
  count: Scalars['Int']['output'];
  operations: OrderReconciliationOperations;
  ordersReconciliation: Array<OrderReconciliationListItemView>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalAmountsInfo: OrderReconciliationAmountInfo;
};

export type OrderReconciliationMismatch = {
  __typename?: 'OrderReconciliationMismatch';
  description?: Maybe<Scalars['String']['output']>;
  reason: MismatchReason;
};

export type OrderReconciliationMismatchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  reason: MismatchReason;
};

export type OrderReconciliationMismatchOptions = {
  __typename?: 'OrderReconciliationMismatchOptions';
  reasons: Array<Scalars['String']['output']>;
};

export type OrderReconciliationOperations = {
  __typename?: 'OrderReconciliationOperations';
  edit: OperationStatus;
};

export type OrderReconciliationPeriodNotAvailableForReconciliationError = Error & {
  __typename?: 'OrderReconciliationPeriodNotAvailableForReconciliationError';
  message: Scalars['String']['output'];
};

export enum OrderReconciliationStatus {
  Mismatch = 'MISMATCH',
  NotReconciled = 'NOT_RECONCILED',
  Reconciled = 'RECONCILED',
  ReconciledByAlean = 'RECONCILED_BY_ALEAN'
}

export type OrderReconciliationTourist = {
  __typename?: 'OrderReconciliationTourist';
  name: Scalars['String']['output'];
};

export type OrderReconciliationView = {
  __typename?: 'OrderReconciliationView';
  commonInfo: OrderReconciliationCommonInfo;
  mismatch?: Maybe<OrderReconciliationMismatch>;
  operations: OrderReconciliationOperations;
};

export type OrderRoom = {
  __typename?: 'OrderRoom';
  hasNonStandardPrice: Scalars['Boolean']['output'];
  hasNonStandardService: Scalars['Boolean']['output'];
  hasNonStandardServicePrice: Scalars['Boolean']['output'];
  nonStandard: Scalars['Boolean']['output'];
  places: Array<OrderRoomPlace>;
  pricePerRoom: Scalars['Boolean']['output'];
  roomPlacingCid?: Maybe<Scalars['String']['output']>;
  roomPlacingName: Scalars['String']['output'];
  services: Array<OrderRoomService>;
  status: OrderStatus;
  summaryAccommodationCost?: Maybe<Scalars['Decimal']['output']>;
  summaryServiceCost?: Maybe<Scalars['Decimal']['output']>;
};

export type OrderRoomPacket = {
  __typename?: 'OrderRoomPacket';
  cost?: Maybe<Scalars['Decimal']['output']>;
  packetName: Scalars['String']['output'];
  period: RangeOfDateOnly;
  status: OrderStatus;
};

export type OrderRoomPlace = {
  __typename?: 'OrderRoomPlace';
  cost?: Maybe<Scalars['Decimal']['output']>;
  packets: Array<OrderRoomPacket>;
  period: RangeOfDateOnly;
  placeType: PlaceType;
  status: OrderStatus;
  touristName: Scalars['String']['output'];
  touristType: Scalars['String']['output'];
};

export type OrderRoomService = {
  __typename?: 'OrderRoomService';
  amount: Scalars['Int']['output'];
  cost?: Maybe<Scalars['Decimal']['output']>;
  hasNonStandardPrice: Scalars['Boolean']['output'];
  nonStandard: Scalars['Boolean']['output'];
  period: RangeOfDateOnly;
  serviceMethod: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  status: OrderStatus;
  touristName?: Maybe<Scalars['String']['output']>;
};

export type OrderSendToSupplierRemoteInteractError = Error & {
  __typename?: 'OrderSendToSupplierRemoteInteractError';
  message: Scalars['String']['output'];
};

export enum OrderStatus {
  Avoided = 'AVOIDED',
  Confirmed = 'CONFIRMED',
  NotConfirmed = 'NOT_CONFIRMED'
}

export type OrderTourist = {
  __typename?: 'OrderTourist';
  name: Scalars['String']['output'];
  placeType: PlaceType;
  touristType: Scalars['String']['output'];
};

export type OrderView = {
  __typename?: 'OrderView';
  accommodation: OrderAccommodation;
  commonInfo: OrderCommonInfo;
  operations: OrderOperations;
  orderInfo: OrderInfo;
  rooms: Array<OrderRoom>;
};

export type OrdersReconciliationFiltersInput = {
  contractNumber: Scalars['Int']['input'];
};

export type OrdersReconciliationFiltersValuesInput = {
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  reportingDate?: InputMaybe<Scalars['Date']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<OrderReconciliationStatus>>;
};

export type OrdersReconciliationInput = {
  contractNumber: Scalars['Int']['input'];
  filters?: InputMaybe<OrdersReconciliationFiltersValuesInput>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<OrdersReconciliationSortInput>;
};

export type OrdersReconciliationSortInput = {
  columnName: Scalars['String']['input'];
  sortOrder: SortOrders;
};

export type OutOfContractPeriodError = Error & {
  __typename?: 'OutOfContractPeriodError';
  message: Scalars['String']['output'];
};

export type PenaltyScheme = {
  __typename?: 'PenaltyScheme';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type PenaltySchemeNotFoundError = Error & {
  __typename?: 'PenaltySchemeNotFoundError';
  message: Scalars['String']['output'];
};

export enum PermissionTarget {
  AccessRequest = 'ACCESS_REQUEST',
  AccommodationObjects = 'ACCOMMODATION_OBJECTS',
  AccommodationObjectsContent = 'ACCOMMODATION_OBJECTS_CONTENT',
  Documents = 'DOCUMENTS',
  Legals = 'LEGALS',
  Orders = 'ORDERS',
  OrderReconciliation = 'ORDER_RECONCILIATION',
  RoomCategories = 'ROOM_CATEGORIES',
  TariffSchedules = 'TARIFF_SCHEDULES',
  Users = 'USERS'
}

export enum PlaceType {
  Additional = 'ADDITIONAL',
  Base = 'BASE',
  NoPlace = 'NO_PLACE'
}

export type PlacingFactorInput = {
  placingVariantCid?: InputMaybe<Scalars['String']['input']>;
  touristPlacing?: InputMaybe<TouristPlacingInput>;
};

export type PlacingFactorView = {
  __typename?: 'PlacingFactorView';
  roomPlacing?: Maybe<PlacingVariantDictView>;
  touristPlace?: Maybe<TouristPlaceView>;
};

export type PlacingVariantDictView = {
  __typename?: 'PlacingVariantDictView';
  cid: Scalars['String']['output'];
  placingVariant: PlacingVariantView;
};

export type PlacingVariantInput = {
  baseSeats: Array<TouristSeatsInput>;
  extSeats: Array<TouristSeatsInput>;
};

export type PlacingVariantTarification = {
  __typename?: 'PlacingVariantTarification';
  defaultAvailable: Scalars['Boolean']['output'];
  isNeedConfirm: Scalars['Boolean']['output'];
  maxNoSeatQuantity: Scalars['UnsignedShort']['output'];
  pricePerRoom: Scalars['Boolean']['output'];
  roomPlacingCid: Scalars['String']['output'];
};

export type PlacingVariantTarificationView = {
  __typename?: 'PlacingVariantTarificationView';
  isChecked: Scalars['Boolean']['output'];
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  placingVariant: PlacingVariantView;
  tarification?: Maybe<PlacingVariantTarification>;
};

export type PlacingVariantView = {
  __typename?: 'PlacingVariantView';
  baseSeats: Array<TouristSeatsView>;
  extSeats: Array<TouristSeatsView>;
  name: Scalars['String']['output'];
};

export type PlacingVariantsCancelEditError = OperationOnUnlockedResourceIsInvalidError;

export type PlacingVariantsCancelEditInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type PlacingVariantsCancelEditPayload = {
  __typename?: 'PlacingVariantsCancelEditPayload';
  errors?: Maybe<Array<PlacingVariantsCancelEditError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PlacingVariantsEditError = HotelSetHasRemoteIntegrationForbiddenError | HotelSetNotFoundError | LockResourceFailedError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type PlacingVariantsEditInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type PlacingVariantsEditPayload = {
  __typename?: 'PlacingVariantsEditPayload';
  errors?: Maybe<Array<PlacingVariantsEditError>>;
  placingVariantsTarification?: Maybe<Array<RoomCategoryPlacingsView>>;
};

export type PlacingVariantsKeepAliveError = OperationOnUnlockedResourceIsInvalidError;

export type PlacingVariantsKeepAliveInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type PlacingVariantsKeepAlivePayload = {
  __typename?: 'PlacingVariantsKeepAlivePayload';
  errors?: Maybe<Array<PlacingVariantsKeepAliveError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PlacingVariantsMapping = {
  __typename?: 'PlacingVariantsMapping';
  requiredPlacingVariants: Array<RequiredPlacingVariant>;
};

export type PlacingVariantsMasterCancelError = OperationOnUnlockedResourceIsInvalidError | TariffScheduleNotFoundError;

export type PlacingVariantsMasterCancelInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type PlacingVariantsMasterCancelPayload = {
  __typename?: 'PlacingVariantsMasterCancelPayload';
  errors?: Maybe<Array<PlacingVariantsMasterCancelError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PlacingVariantsMasterCompleteError = HotelSetNotFoundError | OperationOnUnlockedResourceIsInvalidError | RoomCategoriesCannotDeleteError | RoomCategoriesEmptyError | RoomCategoryListNotFoundError | RoomCategoryNotFoundError | RoomPlacingListNotFoundError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type PlacingVariantsMasterCompleteInput = {
  placingVariantsMasterData: PlacingVariantsMasterSettingsInput;
  roomPlacingVariants: Array<TariffScheduleRoomPlacingVariantInput>;
  tariffScheduleCid: Scalars['String']['input'];
};

export type PlacingVariantsMasterCompletePayload = {
  __typename?: 'PlacingVariantsMasterCompletePayload';
  errors?: Maybe<Array<PlacingVariantsMasterCompleteError>>;
  placingVariantsTarification?: Maybe<Array<RoomCategoryPlacingsView>>;
};

export type PlacingVariantsMasterGenerateError = HotelSetNotFoundError | OperationOnUnlockedResourceIsInvalidError | TariffScheduleNotFoundError;

export type PlacingVariantsMasterGenerateInput = {
  placingVariantsMasterData: PlacingVariantsMasterSettingsInput;
  tariffScheduleCid: Scalars['String']['input'];
};

export type PlacingVariantsMasterGeneratePayload = {
  __typename?: 'PlacingVariantsMasterGeneratePayload';
  errors?: Maybe<Array<PlacingVariantsMasterGenerateError>>;
  invalidRoomCategoryCids?: Maybe<Array<Scalars['String']['output']>>;
  placingVariantsTarification?: Maybe<Array<RoomCategoryPlacingsView>>;
};

export type PlacingVariantsMasterKeepAliveError = OperationOnUnlockedResourceIsInvalidError;

export type PlacingVariantsMasterKeepAliveInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type PlacingVariantsMasterKeepAlivePayload = {
  __typename?: 'PlacingVariantsMasterKeepAlivePayload';
  errors?: Maybe<Array<PlacingVariantsMasterKeepAliveError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PlacingVariantsMasterSettingsInput = {
  ageSettings: AgeSettingsInput;
  roomCategoryCids: Array<Scalars['String']['input']>;
};

export type PlacingVariantsMasterStartError = HotelSetHasRemoteIntegrationForbiddenError | HotelSetNotFoundError | LockResourceFailedError | RoomCategoryNotFoundError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type PlacingVariantsMasterStartInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type PlacingVariantsMasterStartPayload = {
  __typename?: 'PlacingVariantsMasterStartPayload';
  errors?: Maybe<Array<PlacingVariantsMasterStartError>>;
  settings?: Maybe<PlacingVariantsMasterStartSettings>;
};

export type PlacingVariantsMasterStartSettings = {
  __typename?: 'PlacingVariantsMasterStartSettings';
  ageSettings: AgeSettings;
  roomCategories: Array<RoomCategoryQuota>;
};

export type PlacingVariantsNotBelongsToTariffScheduleError = Error & {
  __typename?: 'PlacingVariantsNotBelongsToTariffScheduleError';
  message: Scalars['String']['output'];
};

export type PlacingVariantsUpdateError = HotelSetHasRemoteIntegrationForbiddenError | HotelSetNotFoundError | OperationOnUnlockedResourceIsInvalidError | RoomCategoriesCannotDeleteError | RoomCategoriesEmptyError | RoomCategoryListNotFoundError | RoomCategoryNotFoundError | RoomPlacingListNotFoundError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type PlacingVariantsUpdateInput = {
  ageSettings?: InputMaybe<HotelSetAgeSettingsInput>;
  roomPlacingVariants: Array<TariffScheduleRoomPlacingVariantInput>;
  tariffScheduleCid: Scalars['String']['input'];
};

export type PlacingVariantsUpdatePayload = {
  __typename?: 'PlacingVariantsUpdatePayload';
  errors?: Maybe<Array<PlacingVariantsUpdateError>>;
  placingVariantsTarification?: Maybe<Array<RoomCategoryPlacingsView>>;
};

export type PlacingVariantsView = {
  __typename?: 'PlacingVariantsView';
  placingVariants: Array<RoomCategoryPlacingsView>;
};

export type PriceGridOperations = {
  __typename?: 'PriceGridOperations';
  edit: OperationStatus;
};

export type Query = {
  __typename?: 'Query';
  accommodationObject2?: Maybe<AccommodationObjectInfoView>;
  accommodationObjects2: AccommodationObjectListView;
  accomodationObjectDashboardInfo: SupersetTokenView;
  activeAccessRequests: Array<AccessRequestView>;
  calculateServiceSequence?: Maybe<Array<CalculatedServiceSequenceView>>;
  calculateTariffScheduleServiceGroups: TariffScheduleServiceGroupsListView;
  checkIsNotStartedReverseInteraction?: Maybe<IsNotStartedReverseInteractionView>;
  contentServiceDictionaries: ContentServiceDictionaries;
  contentServiceQuestionnaire?: Maybe<ContentServiceQuestionnaireView>;
  contentServiceQuestionnaireAnswers?: Maybe<QuestionnaireAnswers>;
  contentServiceQuestionnaireAnswersById?: Maybe<QuestionnaireAnswers>;
  contentServiceQuestionnaireAnswersValidations: QuestionnaireStepsValidations;
  contentServiceQuestionnaireAnswersValidationsById: QuestionnaireStepsValidations;
  contractReconciliationAvailableForPeriod: ContractReconciliationAvailableForPeriodView;
  contractServiceGroups?: Maybe<Array<ContractServiceGroupsView>>;
  currencyList: Array<Currency>;
  documentToSign: DocumentToSignResponseModel;
  documents: Array<DocumentResponseModel>;
  findFreeLegal?: Maybe<LegalView>;
  greet: Scalars['String']['output'];
  hotelCategorySuggestions: Array<NameSuggestion>;
  hotelTypeSuggestions: Array<NameSuggestion>;
  invitations: Array<InvitationView>;
  isLegalFree: Scalars['Boolean']['output'];
  legal?: Maybe<LegalView>;
  legals: LegalListView;
  me: MeView;
  orderReconciliation?: Maybe<OrderReconciliationView>;
  orderReconciliationReasonsMismatch: OrderReconciliationMismatchOptions;
  ordersReconciliation: OrderReconciliationListView;
  ordersReconciliationFilters: OrderReconciliationListFiltersView;
  penaltySchemeList: Array<PenaltyScheme>;
  placingVariants: PlacingVariantsView;
  quota?: Maybe<QuotaView>;
  quotaOrder: OrderView;
  quotaOrders: Array<OrderItemView>;
  restrictionsCheckInOutSettings: RestrictionsCheckInOutSettingsView;
  restrictionsPlacingVariants: RestrictionsPlacingVariantsView;
  restrictionsServiceGroups: RestrictionsServiceGroupsView;
  reverseIntegration?: Maybe<ReverseIntegrationView>;
  reversePlacingVariants?: Maybe<GeneratedReversePlacingVariantsView>;
  roomCategories?: Maybe<RoomCategoryListView>;
  roomTypeSuggestions: Array<NameSuggestion>;
  serviceGroupSuggestedServices: Array<ServiceViewGrouped>;
  serviceTypeSuggestions: Array<NameSuggestion>;
  supplierPayRuleList: Array<SupplierPayRule>;
  tariffSchedule2?: Maybe<TariffSchedule2View>;
  tariffScheduleGrid?: Maybe<TariffScheduleGridView>;
  tariffScheduleServiceGroup?: Maybe<TariffScheduleServiceGroupView>;
  tariffScheduleServiceGroups: TariffScheduleServiceGroupsListView;
  tariffScheduleServiceGroupsForRestriction?: Maybe<TariffScheduleServiceGroupsListView>;
  tariffSchedules2?: Maybe<TariffScheduleList2View>;
  taxSchemeList: Array<TaxSchemeSuggestion>;
  testTimeout: Scalars['String']['output'];
  townSuggestions: Array<TownSuggestion>;
  travelLineExternalHotelSuggestions: Array<ExternalHotelSuggestionView>;
  travelLineIntegration?: Maybe<TravelLineIntegrationView>;
  travelLinePlacingVariants?: Maybe<GeneratedPlacingVariantsView>;
  uncompletedIntegrationInfo?: Maybe<TravelLineUncompletedIntegrationView>;
  uncompletedReverseInteraction?: Maybe<UncompletedReverseInteractionView>;
  user: SupplierUserView;
  userInfo?: Maybe<IdentityUserView>;
  users: Array<SupplierUserView>;
};


export type QueryAccommodationObject2Args = {
  accommodationObjectCid: Scalars['String']['input'];
};


export type QueryAccomodationObjectDashboardInfoArgs = {
  accomodationObjectDashboardInfoInput: AnalyticsAccomodationObjectDashboardRequestInput;
};


export type QueryCalculateServiceSequenceArgs = {
  hotelSetCid: Scalars['String']['input'];
  serviceCids: Array<Scalars['String']['input']>;
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCalculateTariffScheduleServiceGroupsArgs = {
  checkInOutSettings: CheckInOutSettingsInput;
  tariffScheduleCid: Scalars['String']['input'];
};


export type QueryCheckIsNotStartedReverseInteractionArgs = {
  input: ReverseIntegrationViewInput;
};


export type QueryContentServiceQuestionnaireArgs = {
  accommodationObjectCid: Scalars['String']['input'];
};


export type QueryContentServiceQuestionnaireAnswersArgs = {
  accommodationObjectCid: Scalars['String']['input'];
};


export type QueryContentServiceQuestionnaireAnswersByIdArgs = {
  questionnaireId: Scalars['UUID']['input'];
};


export type QueryContentServiceQuestionnaireAnswersValidationsArgs = {
  accommodationObjectCid: Scalars['String']['input'];
};


export type QueryContentServiceQuestionnaireAnswersValidationsByIdArgs = {
  questionnaireId: Scalars['UUID']['input'];
};


export type QueryContractReconciliationAvailableForPeriodArgs = {
  input: ContractReconciliationStatusForPeriodInput;
};


export type QueryContractServiceGroupsArgs = {
  contractNumber: Scalars['Int']['input'];
};


export type QueryDocumentToSignArgs = {
  documentId: Scalars['UUID']['input'];
};


export type QueryFindFreeLegalArgs = {
  input: FindFreeLegalInput;
};


export type QueryHotelCategorySuggestionsArgs = {
  suggestion: SuggestionKeyOptionalInput;
};


export type QueryHotelTypeSuggestionsArgs = {
  suggestion: SuggestionKeyOptionalInput;
};


export type QueryIsLegalFreeArgs = {
  input: IsLegalFreeInput;
};


export type QueryLegalArgs = {
  legalCid: Scalars['String']['input'];
};


export type QueryOrderReconciliationArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryOrdersReconciliationArgs = {
  input: OrdersReconciliationInput;
};


export type QueryOrdersReconciliationFiltersArgs = {
  input: OrdersReconciliationFiltersInput;
};


export type QueryPlacingVariantsArgs = {
  hotelSetCid: Scalars['String']['input'];
};


export type QueryQuotaArgs = {
  tariffScheduleCid: Scalars['String']['input'];
};


export type QueryQuotaOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryQuotaOrdersArgs = {
  getQuotaOrdersInput: GetQuotaOrdersInput;
};


export type QueryRestrictionsCheckInOutSettingsArgs = {
  tariffScheduleCid: Scalars['String']['input'];
};


export type QueryRestrictionsPlacingVariantsArgs = {
  tariffScheduleCid: Scalars['String']['input'];
};


export type QueryRestrictionsServiceGroupsArgs = {
  tariffScheduleCid: Scalars['String']['input'];
};


export type QueryReverseIntegrationArgs = {
  input: ReverseIntegrationViewInput;
};


export type QueryReversePlacingVariantsArgs = {
  interactionQuery: InteractionQueryInput;
};


export type QueryRoomCategoriesArgs = {
  accommodationObjectCid: Scalars['String']['input'];
};


export type QueryRoomTypeSuggestionsArgs = {
  suggestion: SuggestionKeyOptionalInput;
};


export type QueryServiceTypeSuggestionsArgs = {
  suggestion: SuggestionKeyOptionalInput;
};


export type QueryTariffSchedule2Args = {
  tariffScheduleCid: Scalars['String']['input'];
};


export type QueryTariffScheduleGridArgs = {
  tariffScheduleCid: Scalars['String']['input'];
};


export type QueryTariffScheduleServiceGroupArgs = {
  hotelSetCid: Scalars['String']['input'];
  serviceGroupCid: Scalars['String']['input'];
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTariffScheduleServiceGroupsArgs = {
  tariffScheduleCid: Scalars['String']['input'];
};


export type QueryTariffScheduleServiceGroupsForRestrictionArgs = {
  checkInOutRestrictionId: Scalars['Int']['input'];
  tariffScheduleCid: Scalars['String']['input'];
};


export type QueryTariffSchedules2Args = {
  contractNumber: Scalars['Int']['input'];
};


export type QueryTestTimeoutArgs = {
  seconds: Scalars['UnsignedInt']['input'];
};


export type QueryTownSuggestionsArgs = {
  suggestion: SuggestionInput;
};


export type QueryTravelLineExternalHotelSuggestionsArgs = {
  contractNumber: Scalars['UnsignedInt']['input'];
};


export type QueryTravelLineIntegrationArgs = {
  input: TravelLineIntegrationViewInput;
};


export type QueryTravelLinePlacingVariantsArgs = {
  interactionQuery: InteractionQueryInput;
};


export type QueryUncompletedIntegrationInfoArgs = {
  input: UncompletedIntegrationInfoInput;
};


export type QueryUncompletedReverseInteractionArgs = {
  input: UncompletedReverseInteractionInput;
};


export type QueryUserArgs = {
  userId: Scalars['UUID']['input'];
};


export type QueryUserInfoArgs = {
  userId: Scalars['UUID']['input'];
};

/** Ответы анкеты */
export type QuestionnaireAnswers = {
  __typename?: 'QuestionnaireAnswers';
  /** Конференц-услуги */
  conferenceServices?: Maybe<QuestionnaireAnswersConferenceServicesInfo>;
  /** Основная информация */
  generalInfo?: Maybe<QuestionnaireAnswersGeneralInfo>;
  /** Инфраструктура */
  infrastructureInfo?: Maybe<QuestionnaireAnswersInfrastructureInfo>;
  /** Признак завершенной анкеты */
  isFinished: Scalars['Boolean']['output'];
  /** Питание */
  nutritionInfo?: Maybe<QuestionnaireAnswersNutritionInfo>;
  /** Номера */
  roomCategories?: Maybe<Array<QuestionnaireAnswersRoomCategoryInfo>>;
  /** Услуги и развлечения */
  servicesAndEntertainment?: Maybe<QuestionnaireAnswersServicesAndEntertainmentInfo>;
  /** Текущий шаг мастера */
  step?: Maybe<QuestionnaireMasterStep>;
  /** Лечение */
  treatment?: Maybe<QuestionnaireAnswersTreatmentInfo>;
};

/** Конференц зал */
export type QuestionnaireAnswersConferenceRoomInfo = {
  __typename?: 'QuestionnaireAnswersConferenceRoomInfo';
  /** Площадь конференц-зал в м кв. */
  area?: Maybe<Scalars['UnsignedInt']['output']>;
  /** Прикреплённые файлы */
  attachments?: Maybe<Array<Attachment>>;
  /** Оборудование для конгрессных услуг */
  conferenceRoomEquipment?: Maybe<Array<Scalars['String']['output']>>;
  /** Мебель для конгрессных ресурсов */
  conferenceRoomFurniture?: Maybe<Array<Scalars['String']['output']>>;
  /** Id */
  conferenceRoomId: Scalars['UUID']['output'];
  /** Название */
  conferenceRoomName?: Maybe<Scalars['String']['output']>;
  /** Варианты расположения мест */
  conferenceRoomSeatingOptions?: Maybe<Array<Scalars['String']['output']>>;
  /** Ссылка на фотобанк */
  photobankUrl?: Maybe<Scalars['String']['output']>;
  /** Количество мест в конференц-зале */
  placesCount?: Maybe<Scalars['UnsignedInt']['output']>;
  questionnaireId?: Maybe<Scalars['UUID']['output']>;
};

/** Конференц зал */
export type QuestionnaireAnswersConferenceRoomInfoInput = {
  /** Площадь конференц-зал в м кв. */
  area?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** Прикреплённые файлы */
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /** Оборудование для конгрессных услуг */
  conferenceRoomEquipment?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Мебель для конгрессных ресурсов */
  conferenceRoomFurniture?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Id */
  conferenceRoomId: Scalars['UUID']['input'];
  /** Название */
  conferenceRoomName?: InputMaybe<Scalars['String']['input']>;
  /** Варианты расположения мест */
  conferenceRoomSeatingOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ссылка на фотобанк */
  photobankUrl?: InputMaybe<Scalars['String']['input']>;
  /** Количество мест в конференц-зале */
  placesCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  questionnaireId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Ответы раздела Конференц-услуги */
export type QuestionnaireAnswersConferenceServicesInfo = {
  __typename?: 'QuestionnaireAnswersConferenceServicesInfo';
  /** Оборудование для конгрессных услуг */
  conferenceRooms?: Maybe<Array<QuestionnaireAnswersConferenceRoomInfo>>;
  /** Конгрессные услуги */
  congressServices?: Maybe<Array<Scalars['String']['output']>>;
};

/** Ответы раздела Конференц-услуги */
export type QuestionnaireAnswersConferenceServicesInfoInput = {
  /** Оборудование для конгрессных услуг */
  conferenceRooms?: InputMaybe<Array<QuestionnaireAnswersConferenceRoomInfoInput>>;
  /** Конгрессные услуги */
  congressServices?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Объект питания */
export type QuestionnaireAnswersFoodObjectInfo = {
  __typename?: 'QuestionnaireAnswersFoodObjectInfo';
  /** Прикреплённые файлы */
  attachments?: Maybe<Array<Attachment>>;
  /** Кухня */
  cuisine?: Maybe<Array<Scalars['String']['output']>>;
  /** Id */
  foodObjectId: Scalars['UUID']['output'];
  /** Наименование объекта питания */
  foodObjectName?: Maybe<Scalars['String']['output']>;
  /** Время работы */
  foodObjectOpeningHours?: Maybe<Scalars['String']['output']>;
  /** Время работы С */
  foodObjectOpeningHoursFrom?: Maybe<Scalars['TimeSpan']['output']>;
  /** Время работы До */
  foodObjectOpeningHoursTo?: Maybe<Scalars['TimeSpan']['output']>;
  /** Тип объекта питания */
  foodObjectType?: Maybe<Scalars['String']['output']>;
  /** Ссылка на фотобанк */
  photobankUrl?: Maybe<Scalars['String']['output']>;
  questionnaireId?: Maybe<Scalars['UUID']['output']>;
};

/** Объект питания */
export type QuestionnaireAnswersFoodObjectInfoInput = {
  /** Прикреплённые файлы */
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /** Кухня */
  cuisine?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Id */
  foodObjectId: Scalars['UUID']['input'];
  /** Наименование объекта питания */
  foodObjectName?: InputMaybe<Scalars['String']['input']>;
  /** Время работы */
  foodObjectOpeningHours?: InputMaybe<Scalars['String']['input']>;
  /** Время работы С */
  foodObjectOpeningHoursFrom?: InputMaybe<Scalars['TimeSpan']['input']>;
  /** Время работы До */
  foodObjectOpeningHoursTo?: InputMaybe<Scalars['TimeSpan']['input']>;
  /** Тип объекта питания */
  foodObjectType?: InputMaybe<Scalars['String']['input']>;
  /** Ссылка на фотобанк */
  photobankUrl?: InputMaybe<Scalars['String']['input']>;
  questionnaireId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Ответы раздела Основная информация */
export type QuestionnaireAnswersGeneralInfo = {
  __typename?: 'QuestionnaireAnswersGeneralInfo';
  /** Адрес */
  address?: Maybe<Scalars['String']['output']>;
  /** Прикреплённые файлы */
  attachments?: Maybe<Array<Attachment>>;
  /** Год постройки объекта */
  buildYear?: Maybe<Scalars['UnsignedShort']['output']>;
  /** Время заезда */
  checkIn?: Maybe<Scalars['TimeSpan']['output']>;
  /** Время выезда */
  checkOut?: Maybe<Scalars['TimeSpan']['output']>;
  /** Email контактного лица */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** ФИО контактного лица */
  contactFullName?: Maybe<Scalars['String']['output']>;
  /** Описание комплекса */
  description?: Maybe<Scalars['String']['output']>;
  /** Сеть отелей */
  hotelChain?: Maybe<Scalars['String']['output']>;
  /** Принимает ли отель детей */
  isAcceptChildren?: Maybe<Scalars['Boolean']['output']>;
  /** Наименование объекта размещения */
  name?: Maybe<Array<LangString>>;
  /** Ближайший аэропорт (город, название) */
  nearestAeroport?: Maybe<Scalars['String']['output']>;
  /** Ближайшая станция метро */
  nearestSubwayStation?: Maybe<Scalars['String']['output']>;
  /** Ближайшая ж/д станция (название) */
  nearestTrainStation?: Maybe<Scalars['String']['output']>;
  /** Ограничение по весу, кг */
  petWeightLimitKg?: Maybe<Scalars['UnsignedInt']['output']>;
  /** Заезд с животными */
  petsAllowed?: Maybe<Scalars['String']['output']>;
  /** Ссылка на фотобанк */
  photobankUrl?: Maybe<Scalars['String']['output']>;
  /** Год реконструкции объекта */
  renovationYear?: Maybe<Scalars['UnsignedShort']['output']>;
  /** Необходимые документы для заезда взрослого */
  requiredDocumentsAdult?: Maybe<Array<Scalars['String']['output']>>;
  /** Необходимые документы для заезда ребенка */
  requiredDocumentsChildren?: Maybe<Array<Scalars['String']['output']>>;
  /** Необходимые документы для заезда иностранного гражданина */
  requiredDocumentsForeigner?: Maybe<Array<Scalars['String']['output']>>;
  /** Площадь территории (в га) */
  totalArea?: Maybe<Scalars['Decimal']['output']>;
  /** Официальный сайт */
  webSite?: Maybe<Scalars['String']['output']>;
};

/** Ответы раздела Основная информация */
export type QuestionnaireAnswersGeneralInfoInput = {
  /** Адрес */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Прикреплённые файлы */
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /** Год постройки объекта */
  buildYear?: InputMaybe<Scalars['UnsignedShort']['input']>;
  /** Время заезда */
  checkIn?: InputMaybe<Scalars['TimeSpan']['input']>;
  /** Время выезда */
  checkOut?: InputMaybe<Scalars['TimeSpan']['input']>;
  /** Email контактного лица */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** ФИО контактного лица */
  contactFullName?: InputMaybe<Scalars['String']['input']>;
  /** Описание комплекса */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Сеть отелей */
  hotelChain?: InputMaybe<Scalars['String']['input']>;
  /** Принимает ли отель детей */
  isAcceptChildren?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наименование объекта размещения */
  name?: InputMaybe<Array<LangStringInput>>;
  /** Ближайший аэропорт (город, название) */
  nearestAeroport?: InputMaybe<Scalars['String']['input']>;
  /** Ближайшая станция метро */
  nearestSubwayStation?: InputMaybe<Scalars['String']['input']>;
  /** Ближайшая ж/д станция (название) */
  nearestTrainStation?: InputMaybe<Scalars['String']['input']>;
  /** Ограничение по весу, кг */
  petWeightLimitKg?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** Заезд с животными */
  petsAllowed?: InputMaybe<Scalars['String']['input']>;
  /** Ссылка на фотобанк */
  photobankUrl?: InputMaybe<Scalars['String']['input']>;
  /** Год реконструкции объекта */
  renovationYear?: InputMaybe<Scalars['UnsignedShort']['input']>;
  /** Необходимые документы для заезда взрослого */
  requiredDocumentsAdult?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Необходимые документы для заезда ребенка */
  requiredDocumentsChildren?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Необходимые документы для заезда иностранного гражданина */
  requiredDocumentsForeigner?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Площадь территории (в га) */
  totalArea?: InputMaybe<Scalars['Decimal']['input']>;
  /** Официальный сайт */
  webSite?: InputMaybe<Scalars['String']['input']>;
};

/** Ответы раздела Инфраструктура */
export type QuestionnaireAnswersInfrastructureInfo = {
  __typename?: 'QuestionnaireAnswersInfrastructureInfo';
  /** Прочее */
  anotherInfrastructure?: Maybe<Array<Scalars['String']['output']>>;
  /** Прикреплённые файлы */
  attachments?: Maybe<Array<Attachment>>;
  /** Пляжи */
  beaches?: Maybe<Array<QuestionnaireAnswersInfrastructureInfoBeach>>;
  /** Красота и здоровье */
  beautyInfrastructure?: Maybe<Array<Scalars['String']['output']>>;
  /** Инфрастуктура для детей */
  childrenInfrastructure?: Maybe<Array<Scalars['String']['output']>>;
  /** Детские бассейны */
  childrenPool?: Maybe<Array<Scalars['String']['output']>>;
  /** Номера для людей с ограниченными возможностями */
  disabilityCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Удобства для людей с ограниченными возможностями */
  disabilityInfrastructure?: Maybe<Array<Scalars['String']['output']>>;
  /** Крытые залы */
  indoorAreas?: Maybe<Array<Scalars['String']['output']>>;
  /** Открытые площадки для занятий спортом */
  outdoorAreas?: Maybe<Array<Scalars['String']['output']>>;
  /** Парковка */
  parkingType?: Maybe<Array<Scalars['String']['output']>>;
  /** Ссылка на фотобанк */
  photobankUrl?: Maybe<Scalars['String']['output']>;
  /** Бассейны */
  pools?: Maybe<Array<QuestionnaireAnswersInfrastructureInfoPool>>;
  /** Бани и сауны */
  saunas?: Maybe<Array<QuestionnaireAnswersInfrastructureInfoSauna>>;
  /** Площадки для горнолыжного отдыха */
  skiResorts?: Maybe<Array<Scalars['String']['output']>>;
  /** Описание водного комплекса */
  waterComplexDescription?: Maybe<Scalars['String']['output']>;
  /** Расстояние до моря (м) */
  waterDistanceMeters?: Maybe<Scalars['UnsignedInt']['output']>;
  /** Открытые зимние площадки */
  winterPlaygrounds?: Maybe<Array<Scalars['String']['output']>>;
};

/** Ответы раздела Пляжи */
export type QuestionnaireAnswersInfrastructureInfoBeach = {
  __typename?: 'QuestionnaireAnswersInfrastructureInfoBeach';
  /** Расстояние до пляжа (м) */
  beachDistanceMeters?: Maybe<Scalars['UnsignedInt']['output']>;
  /** Досуг и развлечения на пляже */
  beachEntertainment?: Maybe<Array<Scalars['String']['output']>>;
  /** Оборудование на пляже */
  beachEquipment?: Maybe<Array<Scalars['String']['output']>>;
  /** Id */
  beachId: Scalars['UUID']['output'];
  /** Характеристики пляжа */
  beachType?: Maybe<Array<Scalars['String']['output']>>;
  /** Платное оборудование на пляже */
  paidBeachEquipment?: Maybe<Array<Scalars['String']['output']>>;
  questionnaireId?: Maybe<Scalars['UUID']['output']>;
};

/** Ответы раздела Пляжи */
export type QuestionnaireAnswersInfrastructureInfoBeachInput = {
  /** Расстояние до пляжа (м) */
  beachDistanceMeters?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** Досуг и развлечения на пляже */
  beachEntertainment?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Оборудование на пляже */
  beachEquipment?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Id */
  beachId: Scalars['UUID']['input'];
  /** Характеристики пляжа */
  beachType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Платное оборудование на пляже */
  paidBeachEquipment?: InputMaybe<Array<Scalars['String']['input']>>;
  questionnaireId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Ответы раздела Инфраструктура */
export type QuestionnaireAnswersInfrastructureInfoInput = {
  /** Прочее */
  anotherInfrastructure?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Прикреплённые файлы */
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /** Пляжи */
  beaches?: InputMaybe<Array<QuestionnaireAnswersInfrastructureInfoBeachInput>>;
  /** Красота и здоровье */
  beautyInfrastructure?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Инфрастуктура для детей */
  childrenInfrastructure?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Детские бассейны */
  childrenPool?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Номера для людей с ограниченными возможностями */
  disabilityCheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** Удобства для людей с ограниченными возможностями */
  disabilityInfrastructure?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Крытые залы */
  indoorAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Открытые площадки для занятий спортом */
  outdoorAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Парковка */
  parkingType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ссылка на фотобанк */
  photobankUrl?: InputMaybe<Scalars['String']['input']>;
  /** Бассейны */
  pools?: InputMaybe<Array<QuestionnaireAnswersInfrastructureInfoPoolInput>>;
  /** Бани и сауны */
  saunas?: InputMaybe<Array<QuestionnaireAnswersInfrastructureInfoSaunaInput>>;
  /** Площадки для горнолыжного отдыха */
  skiResorts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Описание водного комплекса */
  waterComplexDescription?: InputMaybe<Scalars['String']['input']>;
  /** Расстояние до моря (м) */
  waterDistanceMeters?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** Открытые зимние площадки */
  winterPlaygrounds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Ответы раздела Бассейны */
export type QuestionnaireAnswersInfrastructureInfoPool = {
  __typename?: 'QuestionnaireAnswersInfrastructureInfoPool';
  /** Прикреплённые файлы */
  attachments?: Maybe<Array<Attachment>>;
  /** Ссылка на фотобанк */
  photobankUrl?: Maybe<Scalars['String']['output']>;
  /** Характеристики бассейна */
  poolCharacteristics?: Maybe<Array<Scalars['String']['output']>>;
  /** Id */
  poolId: Scalars['UUID']['output'];
  /** Название */
  poolName?: Maybe<Scalars['String']['output']>;
  /** Бассейн работает */
  poolSeason?: Maybe<Scalars['String']['output']>;
  /** Бассейн */
  poolType?: Maybe<Scalars['String']['output']>;
  questionnaireId?: Maybe<Scalars['UUID']['output']>;
};

/** Ответы раздела Бассейны */
export type QuestionnaireAnswersInfrastructureInfoPoolInput = {
  /** Прикреплённые файлы */
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /** Ссылка на фотобанк */
  photobankUrl?: InputMaybe<Scalars['String']['input']>;
  /** Характеристики бассейна */
  poolCharacteristics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Id */
  poolId: Scalars['UUID']['input'];
  /** Название */
  poolName?: InputMaybe<Scalars['String']['input']>;
  /** Бассейн работает */
  poolSeason?: InputMaybe<Scalars['String']['input']>;
  /** Бассейн */
  poolType?: InputMaybe<Scalars['String']['input']>;
  questionnaireId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Ответы раздела Бассейны */
export type QuestionnaireAnswersInfrastructureInfoSauna = {
  __typename?: 'QuestionnaireAnswersInfrastructureInfoSauna';
  /** Прикреплённые файлы */
  attachments?: Maybe<Array<Attachment>>;
  /** Оплата */
  payment?: Maybe<Scalars['String']['output']>;
  /** Ссылка на фотобанк */
  photobankUrl?: Maybe<Scalars['String']['output']>;
  questionnaireId?: Maybe<Scalars['UUID']['output']>;
  /** Id */
  saunaId: Scalars['UUID']['output'];
  /** Тип бани и сауны */
  saunaType?: Maybe<Scalars['String']['output']>;
};

/** Ответы раздела Бассейны */
export type QuestionnaireAnswersInfrastructureInfoSaunaInput = {
  /** Прикреплённые файлы */
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /** Оплата */
  payment?: InputMaybe<Scalars['String']['input']>;
  /** Ссылка на фотобанк */
  photobankUrl?: InputMaybe<Scalars['String']['input']>;
  questionnaireId?: InputMaybe<Scalars['UUID']['input']>;
  /** Id */
  saunaId: Scalars['UUID']['input'];
  /** Тип бани и сауны */
  saunaType?: InputMaybe<Scalars['String']['input']>;
};

/** Ответы анкеты */
export type QuestionnaireAnswersInput = {
  /** Конференц-услуги */
  conferenceServices?: InputMaybe<QuestionnaireAnswersConferenceServicesInfoInput>;
  /** Основная информация */
  generalInfo?: InputMaybe<QuestionnaireAnswersGeneralInfoInput>;
  /** Инфраструктура */
  infrastructureInfo?: InputMaybe<QuestionnaireAnswersInfrastructureInfoInput>;
  /** Признак завершенной анкеты */
  isFinished: Scalars['Boolean']['input'];
  /** Питание */
  nutritionInfo?: InputMaybe<QuestionnaireAnswersNutritionInfoInput>;
  /** Номера */
  roomCategories?: InputMaybe<Array<QuestionnaireAnswersRoomCategoryInfoInput>>;
  /** Услуги и развлечения */
  servicesAndEntertainment?: InputMaybe<QuestionnaireAnswersServicesAndEntertainmentInfoInput>;
  /** Текущий шаг мастера */
  step?: InputMaybe<QuestionnaireMasterStep>;
  /** Лечение */
  treatment?: InputMaybe<QuestionnaireAnswersTreatmentInfoInput>;
};

/** Ответы раздела Питание */
export type QuestionnaireAnswersNutritionInfo = {
  __typename?: 'QuestionnaireAnswersNutritionInfo';
  /** Питание детей */
  childrenNutrition?: Maybe<Array<Scalars['String']['output']>>;
  /** Объекты питания */
  foodObjects?: Maybe<Array<QuestionnaireAnswersFoodObjectInfo>>;
  /** Доставка еды в номер */
  nutritionDelivery?: Maybe<Scalars['Boolean']['output']>;
};

/** Ответы раздела Питание */
export type QuestionnaireAnswersNutritionInfoInput = {
  /** Питание детей */
  childrenNutrition?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Объекты питания */
  foodObjects?: InputMaybe<Array<QuestionnaireAnswersFoodObjectInfoInput>>;
  /** Доставка еды в номер */
  nutritionDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Ответы раздела Номера */
export type QuestionnaireAnswersRoomCategoryInfo = {
  __typename?: 'QuestionnaireAnswersRoomCategoryInfo';
  /** Прикреплённые файлы */
  attachments?: Maybe<Array<Attachment>>;
  /** Наличие балкона в номере */
  balcony?: Maybe<Array<Scalars['String']['output']>>;
  /** Санузел */
  bathroom?: Maybe<Array<Scalars['String']['output']>>;
  /** Санузел оборудован */
  bathroomEquipment?: Maybe<Array<Scalars['String']['output']>>;
  /** Мебель в номере */
  furniture?: Maybe<Array<Scalars['String']['output']>>;
  /** Наличие кухни в номере */
  kitchenIsInRoom?: Maybe<Scalars['String']['output']>;
  /** Ссылка на фотобанк */
  photobankUrl?: Maybe<Scalars['String']['output']>;
  questionnaireId?: Maybe<Scalars['UUID']['output']>;
  /** Площадь номера (кв.м) */
  roomArea?: Maybe<Scalars['Decimal']['output']>;
  /** Количество основных мест из КСБ (нередактируемое) */
  roomCategoryBasePlaces?: Maybe<Scalars['UnsignedShort']['output']>;
  /** Идентификатор категории номера */
  roomCategoryCid: Scalars['String']['output'];
  /** Количество дополнительных мест из КСБ (нередактируемое) */
  roomCategoryExtPlaces?: Maybe<Scalars['UnsignedShort']['output']>;
  /** Наименование КН из КСБ (нередактируемое) */
  roomCategoryName?: Maybe<Scalars['String']['output']>;
  /** Тип КН из КСБ (нередактируемое) */
  roomCategoryTypeName?: Maybe<Scalars['String']['output']>;
  /** Оборудование в номере */
  roomEquipment?: Maybe<Array<Scalars['String']['output']>>;
  /** Сервис в номере */
  roomService?: Maybe<Array<Scalars['String']['output']>>;
  /** Вид из номера */
  roomView?: Maybe<Array<Scalars['String']['output']>>;
  /** Количество комнат в номере данной категории */
  roomsCount?: Maybe<Scalars['String']['output']>;
  /** Тип дополнительного места в номере данной категории */
  typeOfExtendedPlace?: Maybe<Array<Scalars['String']['output']>>;
};

/** Ответы раздела Номера */
export type QuestionnaireAnswersRoomCategoryInfoInput = {
  /** Прикреплённые файлы */
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /** Наличие балкона в номере */
  balcony?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Санузел */
  bathroom?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Санузел оборудован */
  bathroomEquipment?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Мебель в номере */
  furniture?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Наличие кухни в номере */
  kitchenIsInRoom?: InputMaybe<Scalars['String']['input']>;
  /** Ссылка на фотобанк */
  photobankUrl?: InputMaybe<Scalars['String']['input']>;
  questionnaireId?: InputMaybe<Scalars['UUID']['input']>;
  /** Площадь номера (кв.м) */
  roomArea?: InputMaybe<Scalars['Decimal']['input']>;
  /** Количество основных мест из КСБ (нередактируемое) */
  roomCategoryBasePlaces?: InputMaybe<Scalars['UnsignedShort']['input']>;
  /** Идентификатор категории номера */
  roomCategoryCid: Scalars['String']['input'];
  /** Количество дополнительных мест из КСБ (нередактируемое) */
  roomCategoryExtPlaces?: InputMaybe<Scalars['UnsignedShort']['input']>;
  /** Наименование КН из КСБ (нередактируемое) */
  roomCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** Тип КН из КСБ (нередактируемое) */
  roomCategoryTypeName?: InputMaybe<Scalars['String']['input']>;
  /** Оборудование в номере */
  roomEquipment?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Сервис в номере */
  roomService?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Вид из номера */
  roomView?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Количество комнат в номере данной категории */
  roomsCount?: InputMaybe<Scalars['String']['input']>;
  /** Тип дополнительного места в номере данной категории */
  typeOfExtendedPlace?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Ответы раздела Услуги и развлечения */
export type QuestionnaireAnswersServicesAndEntertainmentInfo = {
  __typename?: 'QuestionnaireAnswersServicesAndEntertainmentInfo';
  /** Анимация */
  animation?: Maybe<Array<Scalars['String']['output']>>;
  /** Развлечения для детей */
  childrenEntertainment?: Maybe<Array<Scalars['String']['output']>>;
  /** Прокат инвентаря для детей */
  childrenEquipment?: Maybe<Array<Scalars['String']['output']>>;
  /** Услуги для детей */
  childrenService?: Maybe<Array<Scalars['String']['output']>>;
  /** Развлечения */
  entertainmentTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Прокат спортивного инвентаря */
  equipmentRental?: Maybe<Array<Scalars['String']['output']>>;
  /** Бытовые службы */
  household?: Maybe<Array<Scalars['String']['output']>>;
  /** Доступ в интернет */
  internet?: Maybe<Array<Scalars['String']['output']>>;
  /** Организация досуга */
  leisure?: Maybe<Array<Scalars['String']['output']>>;
  /** Врачебная косметология */
  medicalCosmetology?: Maybe<Array<Scalars['String']['output']>>;
  /** Прочие услуги */
  other?: Maybe<Array<Scalars['String']['output']>>;
  /** На стойке регистрации */
  reception?: Maybe<Array<Scalars['String']['output']>>;
  /** Аренда */
  rent?: Maybe<Array<Scalars['String']['output']>>;
  /** Услуги для горнолыжного отдыха */
  skiResortService?: Maybe<Array<Scalars['String']['output']>>;
  /** SPA услуги */
  spaServices?: Maybe<Array<Scalars['String']['output']>>;
  /** Водные виды спорта */
  waterSports?: Maybe<Array<Scalars['String']['output']>>;
};

/** Ответы раздела Услуги и развлечения */
export type QuestionnaireAnswersServicesAndEntertainmentInfoInput = {
  /** Анимация */
  animation?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Развлечения для детей */
  childrenEntertainment?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Прокат инвентаря для детей */
  childrenEquipment?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Услуги для детей */
  childrenService?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Развлечения */
  entertainmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Прокат спортивного инвентаря */
  equipmentRental?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Бытовые службы */
  household?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Доступ в интернет */
  internet?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Организация досуга */
  leisure?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Врачебная косметология */
  medicalCosmetology?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Прочие услуги */
  other?: InputMaybe<Array<Scalars['String']['input']>>;
  /** На стойке регистрации */
  reception?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Аренда */
  rent?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Услуги для горнолыжного отдыха */
  skiResortService?: InputMaybe<Array<Scalars['String']['input']>>;
  /** SPA услуги */
  spaServices?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Водные виды спорта */
  waterSports?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QuestionnaireAnswersTreatmentInfo = {
  __typename?: 'QuestionnaireAnswersTreatmentInfo';
  enabled: Scalars['Boolean']['output'];
  treatmentCategories?: Maybe<Array<TreatmentCategory>>;
};

export type QuestionnaireAnswersTreatmentInfoInput = {
  enabled: Scalars['Boolean']['input'];
  treatmentCategories?: InputMaybe<Array<TreatmentCategoryInput>>;
};

export enum QuestionnaireMasterStep {
  ConferenceServices = 'CONFERENCE_SERVICES',
  Finish = 'FINISH',
  GeneralInfo = 'GENERAL_INFO',
  InfrastructureInfo = 'INFRASTRUCTURE_INFO',
  NutritionInfo = 'NUTRITION_INFO',
  RoomCategories = 'ROOM_CATEGORIES',
  ServicesAndEntertainment = 'SERVICES_AND_ENTERTAINMENT',
  Treatment = 'TREATMENT'
}

export type QuestionnaireStepsValidations = {
  __typename?: 'QuestionnaireStepsValidations';
  validations?: Maybe<Array<StepValidation>>;
};

export type QuotaAddRoomCategoryInput = {
  roomCategoryCID: Scalars['String']['input'];
  roomCount: Scalars['UnsignedInt']['input'];
};

export type QuotaNotFilledError = Error & {
  __typename?: 'QuotaNotFilledError';
  message: Scalars['String']['output'];
};

export type QuotaNotFoundError = Error & {
  __typename?: 'QuotaNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type QuotaOperationPeriodNotWithinContractPeriodError = Error & {
  __typename?: 'QuotaOperationPeriodNotWithinContractPeriodError';
  message: Scalars['String']['output'];
};

export type QuotaOperations = {
  __typename?: 'QuotaOperations';
  addRooms: OperationStatus;
  removeRooms: OperationStatus;
  setInitialValues: OperationStatus;
  updateReserves: OperationStatus;
};

export type QuotaPeriodView = {
  __typename?: 'QuotaPeriodView';
  isClosed: Scalars['Boolean']['output'];
  ordered: Scalars['UnsignedInt']['output'];
  period: RangeOfDateOnly;
  reserve?: Maybe<ReserveView>;
};

export type QuotaPricesRequiredError = Error & {
  __typename?: 'QuotaPricesRequiredError';
  message: Scalars['String']['output'];
};

export type QuotaReserveUpdateOperationInput = {
  operation: QuotaReserveUpdateOperationKind;
  period: RangeOfDateOnlyInput;
  roomCategoryCid: Scalars['String']['input'];
  roomsReserveCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export enum QuotaReserveUpdateOperationKind {
  Close = 'CLOSE',
  SetByRequest = 'SET_BY_REQUEST',
  SetRoomsCount = 'SET_ROOMS_COUNT'
}

export enum QuotaStatus {
  NoQuota = 'NO_QUOTA',
  QuotaInWork = 'QUOTA_IN_WORK',
  QuotaIsDraft = 'QUOTA_IS_DRAFT'
}

export type QuotaView = {
  __typename?: 'QuotaView';
  contractNumber: Scalars['Int']['output'];
  operations: QuotaOperations;
  roomQuotas: Array<RoomQuotaView>;
  shortName: Scalars['String']['output'];
};

export type RangeOfDateOnly = {
  __typename?: 'RangeOfDateOnly';
  from: Scalars['Date']['output'];
  to: Scalars['Date']['output'];
};

export type RangeOfDateOnlyInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type RatePriceView = {
  __typename?: 'RatePriceView';
  nominal: Scalars['Decimal']['output'];
  sale: Scalars['Decimal']['output'];
};

export type ReconcileContractForPeriodError = ContractNotFoundError | OrderReconciliationPeriodNotAvailableForReconciliationError;

export type ReconcileContractForPeriodInput = {
  contractNumber: Scalars['Int']['input'];
  reportingDate: Scalars['Date']['input'];
};

export type ReconcileContractForPeriodPayload = {
  __typename?: 'ReconcileContractForPeriodPayload';
  contractReconciliation?: Maybe<ContractReconciliationAvailableForPeriodView>;
  errors?: Maybe<Array<ReconcileContractForPeriodError>>;
};

export type ReconcileOrdersReconciliationError = ContractNotFoundError | OrderNotFoundError;

export type ReconcileOrdersReconciliationInput = {
  orderIds: Array<Scalars['Int']['input']>;
};

export type ReconcileOrdersReconciliationPayload = {
  __typename?: 'ReconcileOrdersReconciliationPayload';
  errors?: Maybe<Array<ReconcileOrdersReconciliationError>>;
  ordersReconciliation?: Maybe<Array<OrderReconciliationListItemView>>;
};

export type RegisterKsbAccountError = UserNotFoundError;

export type RegisterKsbAccountPayload = {
  __typename?: 'RegisterKsbAccountPayload';
  errors?: Maybe<Array<RegisterKsbAccountError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RemoveAccommodationObjectRoomCategoryError = LockResourceFailedError | OperationForbiddenError | RoomCategoryNotFoundError;

export type RemoveAccommodationObjectRoomCategoryInput = {
  accommodationObjectRoomCategoryCid: Scalars['String']['input'];
};

export type RemoveAccommodationObjectRoomCategoryPayload = {
  __typename?: 'RemoveAccommodationObjectRoomCategoryPayload';
  errors?: Maybe<Array<RemoveAccommodationObjectRoomCategoryError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RemoveAccommodationObjectServiceError = ServiceNotFoundError | ServiceTooOldToDeleteError;

export type RemoveAccommodationObjectServiceInput = {
  serviceCid: Scalars['String']['input'];
};

export type RemoveAccommodationObjectServicePayload = {
  __typename?: 'RemoveAccommodationObjectServicePayload';
  errors?: Maybe<Array<RemoveAccommodationObjectServiceError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RemoveLegalError = LegalNotFoundError | LockResourceFailedError | OperationForbiddenError;

export type RemoveLegalInput = {
  cid: Scalars['String']['input'];
};

export type RemoveLegalPayload = {
  __typename?: 'RemoveLegalPayload';
  errors?: Maybe<Array<RemoveLegalError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RemoveRestrictionsCheckInOutSettingError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | RestrictionNotFoundError | RestrictionPeriodOverrideForbiddenError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type RemoveRestrictionsCheckInOutSettingInput = {
  restrictionId: Scalars['Int']['input'];
  tariffScheduleCid: Scalars['String']['input'];
};

export type RemoveRestrictionsCheckInOutSettingPayload = {
  __typename?: 'RemoveRestrictionsCheckInOutSettingPayload';
  Grid?: Maybe<RestrictionsCheckInOutSettingsView>;
  errors?: Maybe<Array<RemoveRestrictionsCheckInOutSettingError>>;
};

export type RemoveRestrictionsPlacingVariantError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | RestrictionNotFoundError | RestrictionPeriodOverrideForbiddenError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type RemoveRestrictionsPlacingVariantInput = {
  restrictionId: Scalars['Int']['input'];
  tariffScheduleCid: Scalars['String']['input'];
};

export type RemoveRestrictionsPlacingVariantPayload = {
  __typename?: 'RemoveRestrictionsPlacingVariantPayload';
  Grid?: Maybe<RestrictionsPlacingVariantsView>;
  errors?: Maybe<Array<RemoveRestrictionsPlacingVariantError>>;
};

export type RemoveRestrictionsServiceGroupError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | RestrictionNotFoundError | RestrictionPeriodOverrideForbiddenError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type RemoveRestrictionsServiceGroupInput = {
  restrictionId: Scalars['Int']['input'];
  tariffScheduleCid: Scalars['String']['input'];
};

export type RemoveRestrictionsServiceGroupPayload = {
  __typename?: 'RemoveRestrictionsServiceGroupPayload';
  Grid?: Maybe<RestrictionsServiceGroupsView>;
  errors?: Maybe<Array<RemoveRestrictionsServiceGroupError>>;
};

export type ReportPeriod = {
  __typename?: 'ReportPeriod';
  month: Scalars['UnsignedShort']['output'];
  year: Scalars['UnsignedShort']['output'];
};

export type RequiredPlacingVariant = {
  __typename?: 'RequiredPlacingVariant';
  placingVariantName: Scalars['String']['output'];
  roomCategoryCid: Scalars['String']['output'];
};

export type ReserveView = {
  __typename?: 'ReserveView';
  byRequest: Scalars['Boolean']['output'];
  free: Scalars['UnsignedInt']['output'];
  reserved: Scalars['UnsignedInt']['output'];
};

export type RestrictionCheckInOutSettingsDefaultView = {
  __typename?: 'RestrictionCheckInOutSettingsDefaultView';
  defaultOptions: RestrictionsCheckInOutSettingsOptions;
};

export type RestrictionCheckInOutSettingsTableRowView = {
  __typename?: 'RestrictionCheckInOutSettingsTableRowView';
  restriction: RestrictionViewOfRestrictionsCheckInOutSettingsOptions;
};

export type RestrictionDefaultConflictError = Error & {
  __typename?: 'RestrictionDefaultConflictError';
  message: Scalars['String']['output'];
};

export type RestrictionFactorDefaultViewOfRestrictionsPlacingVariantsFactorKeyViewAndRestrictionsPlacingVariantsOptions = {
  __typename?: 'RestrictionFactorDefaultViewOfRestrictionsPlacingVariantsFactorKeyViewAndRestrictionsPlacingVariantsOptions';
  defaultOptions: RestrictionsPlacingVariantsOptions;
  restrictionFactorKey: RestrictionsPlacingVariantsFactorKeyView;
};

export type RestrictionFactorDefaultViewOfRestrictionsServiceGroupsFactorKeyViewAndRestrictionsServiceGroupsOptions = {
  __typename?: 'RestrictionFactorDefaultViewOfRestrictionsServiceGroupsFactorKeyViewAndRestrictionsServiceGroupsOptions';
  defaultOptions: RestrictionsServiceGroupsOptions;
  restrictionFactorKey: RestrictionsServiceGroupsFactorKeyView;
};

export type RestrictionGridPeriodView = {
  __typename?: 'RestrictionGridPeriodView';
  period: RangeOfDateOnly;
  restrictionId?: Maybe<Scalars['Int']['output']>;
};

export type RestrictionGridViewOfPlacingVariantDictView = {
  __typename?: 'RestrictionGridViewOfPlacingVariantDictView';
  restrictionFactor: PlacingVariantDictView;
  restrictionPeriods: Array<RestrictionGridPeriodView>;
};

export type RestrictionGridViewOfRestrictionsServiceGroupsFactorView = {
  __typename?: 'RestrictionGridViewOfRestrictionsServiceGroupsFactorView';
  restrictionFactor: RestrictionsServiceGroupsFactorView;
  restrictionPeriods: Array<RestrictionGridPeriodView>;
};

export type RestrictionNextDayCheckoutOverrideForbiddenError = Error & {
  __typename?: 'RestrictionNextDayCheckoutOverrideForbiddenError';
  message: Scalars['String']['output'];
};

export type RestrictionNoChangeConflictError = Error & {
  __typename?: 'RestrictionNoChangeConflictError';
  message: Scalars['String']['output'];
};

export type RestrictionNotFoundError = Error & {
  __typename?: 'RestrictionNotFoundError';
  message: Scalars['String']['output'];
};

export type RestrictionOperations = {
  __typename?: 'RestrictionOperations';
  add: OperationStatus;
  edit: OperationStatus;
  remove: OperationStatus;
};

export type RestrictionPeriodOverlapConflictError = Error & {
  __typename?: 'RestrictionPeriodOverlapConflictError';
  message: Scalars['String']['output'];
};

export type RestrictionPeriodOverrideForbiddenError = Error & {
  __typename?: 'RestrictionPeriodOverrideForbiddenError';
  message: Scalars['String']['output'];
};

export type RestrictionPlacingVariantInput = {
  options: RestrictionsPlacingVariantsOptionsInput;
  period: RangeOfDateOnlyInput;
  roomPlacingCid: Scalars['String']['input'];
};

export type RestrictionServiceGroupInput = {
  options: RestrictionsServiceGroupsOptionsInput;
  period: RangeOfDateOnlyInput;
  serviceGroupCid: Scalars['String']['input'];
};

export type RestrictionServiceGroupSaleOptions = {
  __typename?: 'RestrictionServiceGroupSaleOptions';
  isNeedConfirm: Scalars['Boolean']['output'];
  orderPeriod?: Maybe<ServiceGroupOrderPeriod>;
};

export type RestrictionServiceGroupSaleOptionsInput = {
  isNeedConfirm: Scalars['Boolean']['input'];
  orderPeriod?: InputMaybe<ServiceGroupOrderPeriodInput>;
};

export type RestrictionTableRowViewOfRestrictionsPlacingVariantsFactorViewAndRestrictionsPlacingVariantsOptions = {
  __typename?: 'RestrictionTableRowViewOfRestrictionsPlacingVariantsFactorViewAndRestrictionsPlacingVariantsOptions';
  restriction: RestrictionViewOfRestrictionsPlacingVariantsOptions;
  restrictionFactor: RestrictionsPlacingVariantsFactorView;
};

export type RestrictionTableRowViewOfRestrictionsServiceGroupsFactorViewAndRestrictionsServiceGroupsOptions = {
  __typename?: 'RestrictionTableRowViewOfRestrictionsServiceGroupsFactorViewAndRestrictionsServiceGroupsOptions';
  restriction: RestrictionViewOfRestrictionsServiceGroupsOptions;
  restrictionFactor: RestrictionsServiceGroupsFactorView;
};

export type RestrictionTariffSchedulePeriodConflictError = Error & {
  __typename?: 'RestrictionTariffSchedulePeriodConflictError';
  message: Scalars['String']['output'];
};

export type RestrictionViewOfRestrictionsCheckInOutSettingsOptions = {
  __typename?: 'RestrictionViewOfRestrictionsCheckInOutSettingsOptions';
  hasConflict: Scalars['Boolean']['output'];
  number: Scalars['UnsignedInt']['output'];
  options: RestrictionsCheckInOutSettingsOptions;
  period: RangeOfDateOnly;
  restrictionId: Scalars['Int']['output'];
};

export type RestrictionViewOfRestrictionsPlacingVariantsOptions = {
  __typename?: 'RestrictionViewOfRestrictionsPlacingVariantsOptions';
  hasConflict: Scalars['Boolean']['output'];
  number: Scalars['UnsignedInt']['output'];
  options: RestrictionsPlacingVariantsOptions;
  period: RangeOfDateOnly;
  restrictionId: Scalars['Int']['output'];
};

export type RestrictionViewOfRestrictionsServiceGroupsOptions = {
  __typename?: 'RestrictionViewOfRestrictionsServiceGroupsOptions';
  hasConflict: Scalars['Boolean']['output'];
  number: Scalars['UnsignedInt']['output'];
  options: RestrictionsServiceGroupsOptions;
  period: RangeOfDateOnly;
  restrictionId: Scalars['Int']['output'];
};

export type RestrictionsCheckInOutSettingsOperations = {
  __typename?: 'RestrictionsCheckInOutSettingsOperations';
  add: OperationStatus;
  edit: OperationStatus;
  remove: OperationStatus;
};

export type RestrictionsCheckInOutSettingsOptions = {
  __typename?: 'RestrictionsCheckInOutSettingsOptions';
  checkIn: Scalars['TimeSpan']['output'];
  checkOut: Scalars['TimeSpan']['output'];
  nextDayCheckout: Scalars['Boolean']['output'];
};

export type RestrictionsCheckInOutSettingsView = {
  __typename?: 'RestrictionsCheckInOutSettingsView';
  defaults: RestrictionCheckInOutSettingsDefaultView;
  grid: Array<RestrictionGridPeriodView>;
  operations: RestrictionsCheckInOutSettingsOperations;
  table: Array<RestrictionCheckInOutSettingsTableRowView>;
};

export type RestrictionsPlacingVariantsFactorKeyView = {
  __typename?: 'RestrictionsPlacingVariantsFactorKeyView';
  roomCategoryCid: Scalars['String']['output'];
  roomPlacingCid: Scalars['String']['output'];
};

export type RestrictionsPlacingVariantsFactorView = {
  __typename?: 'RestrictionsPlacingVariantsFactorView';
  roomCategory: RoomCategoryView;
  roomPlacing: PlacingVariantDictView;
};

export type RestrictionsPlacingVariantsOperations = {
  __typename?: 'RestrictionsPlacingVariantsOperations';
  add: OperationStatus;
  edit: OperationStatus;
  remove: OperationStatus;
};

export type RestrictionsPlacingVariantsOptions = {
  __typename?: 'RestrictionsPlacingVariantsOptions';
  isOpened: Scalars['Boolean']['output'];
  options?: Maybe<RestrictionsPlacingVariantsSaleOptions>;
};

export type RestrictionsPlacingVariantsOptionsInput = {
  isOpened: Scalars['Boolean']['input'];
  options?: InputMaybe<RestrictionsPlacingVariantsSaleOptionsInput>;
};

export type RestrictionsPlacingVariantsSaleOptions = {
  __typename?: 'RestrictionsPlacingVariantsSaleOptions';
  isNeedConfirm: Scalars['Boolean']['output'];
};

export type RestrictionsPlacingVariantsSaleOptionsInput = {
  isNeedConfirm: Scalars['Boolean']['input'];
};

export type RestrictionsPlacingVariantsView = {
  __typename?: 'RestrictionsPlacingVariantsView';
  defaults: Array<RestrictionFactorDefaultViewOfRestrictionsPlacingVariantsFactorKeyViewAndRestrictionsPlacingVariantsOptions>;
  grid: Array<RestrictionsRoomCategory>;
  gridPeriod: RangeOfDateOnly;
  operations: RestrictionsPlacingVariantsOperations;
  table: Array<RestrictionTableRowViewOfRestrictionsPlacingVariantsFactorViewAndRestrictionsPlacingVariantsOptions>;
};

export type RestrictionsRoomCategory = {
  __typename?: 'RestrictionsRoomCategory';
  roomCategory: RoomCategoryView;
  roomPlacings: Array<RestrictionGridViewOfPlacingVariantDictView>;
};

export type RestrictionsServiceGroupsFactorKeyView = {
  __typename?: 'RestrictionsServiceGroupsFactorKeyView';
  serviceGroupCid: Scalars['String']['output'];
};

export type RestrictionsServiceGroupsFactorView = {
  __typename?: 'RestrictionsServiceGroupsFactorView';
  cid: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
};

export type RestrictionsServiceGroupsOptions = {
  __typename?: 'RestrictionsServiceGroupsOptions';
  isOpened: Scalars['Boolean']['output'];
  options?: Maybe<RestrictionServiceGroupSaleOptions>;
};

export type RestrictionsServiceGroupsOptionsInput = {
  isOpened: Scalars['Boolean']['input'];
  options?: InputMaybe<RestrictionServiceGroupSaleOptionsInput>;
};

export type RestrictionsServiceGroupsView = {
  __typename?: 'RestrictionsServiceGroupsView';
  defaults: Array<RestrictionFactorDefaultViewOfRestrictionsServiceGroupsFactorKeyViewAndRestrictionsServiceGroupsOptions>;
  grid: Array<RestrictionGridViewOfRestrictionsServiceGroupsFactorView>;
  gridPeriod: RangeOfDateOnly;
  operations: RestrictionOperations;
  table: Array<RestrictionTableRowViewOfRestrictionsServiceGroupsFactorViewAndRestrictionsServiceGroupsOptions>;
};

export type ReverseIntegrationAgeSettingsInput = {
  categories: AgeCategoriesInput;
  determineAgeMethod: DetermineAgeMethod;
  initialAge: Scalars['Byte']['input'];
};

export type ReverseIntegrationMasterCompletedView = {
  __typename?: 'ReverseIntegrationMasterCompletedView';
  remoteInteractionUrl?: Maybe<Scalars['String']['output']>;
  tariffScheduleCID: Scalars['String']['output'];
};

export type ReverseIntegrationMasterView = {
  __typename?: 'ReverseIntegrationMasterView';
  hotelSetCid: Scalars['String']['output'];
  isRestarting: Scalars['Boolean']['output'];
  masterStep: ReverseMasterStep;
  steps: ReverseMasterStepsView;
};

export type ReverseIntegrationView = {
  __typename?: 'ReverseIntegrationView';
  channelManagerCode: ChannelManagerCode;
  master: ReverseIntegrationMasterView;
};

export type ReverseIntegrationViewInput = {
  query: InteractionQueryInput;
};

export enum ReverseMasterStep {
  PlacingVariantsSelecting = 'PLACING_VARIANTS_SELECTING',
  RoomCategoriesSelecting = 'ROOM_CATEGORIES_SELECTING',
  ServiceGroupsSelecting = 'SERVICE_GROUPS_SELECTING',
  TouristTypesSelecting = 'TOURIST_TYPES_SELECTING'
}

export type ReverseMasterStepsView = {
  __typename?: 'ReverseMasterStepsView';
  integrationSettings: IntegrationSettings;
  roomCategoriesSettings: RoomCategoriesSettings;
  serviceGroupsSettings: ServiceGroupsSettings;
  touristTypesSettings?: Maybe<TouristTypesSettings>;
};

export type ReverseRestartIntegrationError = ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | ContractNotFoundError;

export type ReverseRestartIntegrationInput = {
  interactionQuery: InteractionQueryInput;
};

export type ReverseRestartIntegrationPayload = {
  __typename?: 'ReverseRestartIntegrationPayload';
  View?: Maybe<ReverseRestartIntegrationView>;
  errors?: Maybe<Array<ReverseRestartIntegrationError>>;
};

export type ReverseRestartIntegrationView = {
  __typename?: 'ReverseRestartIntegrationView';
  interaction: ReverseIntegrationView;
  roomCategories: Array<RoomCategoryQuota>;
};

export type ReverseStartIntegrationError = ContractNotFoundError;

export type ReverseStartIntegrationInput = {
  channelManagerCode: ChannelManagerCode;
  contractNumber: Scalars['UnsignedInt']['input'];
  integrationSettings: IntegrationSettingsInput;
};

export type ReverseStartIntegrationPayload = {
  __typename?: 'ReverseStartIntegrationPayload';
  InteractionId?: Maybe<Scalars['UUID']['output']>;
  errors?: Maybe<Array<ReverseStartIntegrationError>>;
};

export type ReverseUpdatePlacingVariantsError = ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | ChannelManagerReverseMasterInvalidOperationError | HotelSetNotFoundError | InvalidContractNumberError | OperationOnUnlockedResourceIsInvalidError | RoomCategoriesCannotDeleteError | RoomCategoriesEmptyError | RoomCategoryListNotFoundError | RoomCategoryNotFoundError | RoomPlacingListNotFoundError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError | TravelLinePlacingVariantExceedsRoomCategoryCapacityError | TravelLinePlacingVariantsNotFulfilledError;

export type ReverseUpdatePlacingVariantsInput = {
  interactionQuery: InteractionQueryInput;
  roomPlacingVariants: Array<TariffScheduleRoomPlacingVariantInput>;
};

export type ReverseUpdatePlacingVariantsPayload = {
  __typename?: 'ReverseUpdatePlacingVariantsPayload';
  View?: Maybe<ReverseIntegrationMasterCompletedView>;
  errors?: Maybe<Array<ReverseUpdatePlacingVariantsError>>;
};

export type ReverseUpdateRoomCategoriesError = ChannelManagerInteractionNotFoundError | ContractNotFoundError | InvalidContractNumberError | RoomCategoryListNotFoundError;

export type ReverseUpdateRoomCategoriesInput = {
  contractNumber: Scalars['UnsignedInt']['input'];
  interactionId: Scalars['UUID']['input'];
  roomCategoryCids: Array<Scalars['String']['input']>;
};

export type ReverseUpdateRoomCategoriesPayload = {
  __typename?: 'ReverseUpdateRoomCategoriesPayload';
  View?: Maybe<ReverseIntegrationView>;
  errors?: Maybe<Array<ReverseUpdateRoomCategoriesError>>;
};

export type ReverseUpdateServiceGroupsError = ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | ChannelManagerReverseMasterInvalidOperationError | InvalidContractNumberError | ServiceGroupListNotFoundError;

export type ReverseUpdateServiceGroupsInput = {
  interactionQuery: InteractionQueryInput;
  serviceGroupCids: Array<Scalars['String']['input']>;
};

export type ReverseUpdateServiceGroupsPayload = {
  __typename?: 'ReverseUpdateServiceGroupsPayload';
  View?: Maybe<ReverseIntegrationView>;
  errors?: Maybe<Array<ReverseUpdateServiceGroupsError>>;
};

export type ReverseUpdateTouristTypesError = ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | ChannelManagerReverseMasterInvalidOperationError | InvalidContractNumberError;

export type ReverseUpdateTouristTypesInput = {
  ageSettings: ReverseIntegrationAgeSettingsInput;
  interactionQuery: InteractionQueryInput;
};

export type ReverseUpdateTouristTypesPayload = {
  __typename?: 'ReverseUpdateTouristTypesPayload';
  View?: Maybe<ReverseIntegrationView>;
  errors?: Maybe<Array<ReverseUpdateTouristTypesError>>;
};

export enum Role {
  Accountant = 'ACCOUNTANT',
  Administrator = 'ADMINISTRATOR',
  BookingManager = 'BOOKING_MANAGER',
  RevenueManager = 'REVENUE_MANAGER',
  Support = 'SUPPORT'
}

export type RoomCategoriesCannotDeleteError = Error & {
  __typename?: 'RoomCategoriesCannotDeleteError';
  message: Scalars['String']['output'];
};

export type RoomCategoriesEmptyError = Error & {
  __typename?: 'RoomCategoriesEmptyError';
  message: Scalars['String']['output'];
};

export type RoomCategoriesForAddingNotFoundError = Error & {
  __typename?: 'RoomCategoriesForAddingNotFoundError';
  message: Scalars['String']['output'];
};

export type RoomCategoriesMapping = {
  __typename?: 'RoomCategoriesMapping';
  roomCategories: Array<RoomCategoryView>;
  translationTable: Array<ExternalObjectTranslationView>;
};

export type RoomCategoriesNotBelongsToQuotaError = Error & {
  __typename?: 'RoomCategoriesNotBelongsToQuotaError';
  message: Scalars['String']['output'];
};

export type RoomCategoriesNotBelongsToTariffScheduleError = Error & {
  __typename?: 'RoomCategoriesNotBelongsToTariffScheduleError';
  message: Scalars['String']['output'];
};

export type RoomCategoriesSettings = {
  __typename?: 'RoomCategoriesSettings';
  roomCategories: Array<RoomCategoryView>;
  selectedRoomCategoryCIDs?: Maybe<Array<Scalars['String']['output']>>;
};

export type RoomCategoryInput = {
  description: Array<LangStringInput>;
  name: Array<LangStringInput>;
  roomTypeCid: Scalars['String']['input'];
  seat: RoomSeatInput;
};

export type RoomCategoryListNotFoundError = Error & {
  __typename?: 'RoomCategoryListNotFoundError';
  ciDs: Array<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type RoomCategoryListOperations = {
  __typename?: 'RoomCategoryListOperations';
  canAdd: OperationStatus;
};

export type RoomCategoryListView = {
  __typename?: 'RoomCategoryListView';
  operations: RoomCategoryListOperations;
  roomCategories: Array<RoomCategoryView>;
};

export type RoomCategoryNotBelongsToTariffScheduleError = Error & {
  __typename?: 'RoomCategoryNotBelongsToTariffScheduleError';
  message: Scalars['String']['output'];
};

export type RoomCategoryNotFoundError = Error & {
  __typename?: 'RoomCategoryNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type RoomCategoryOperations = {
  __typename?: 'RoomCategoryOperations';
  delete: OperationStatus;
  edit: OperationStatus;
  fullEdit: Scalars['Boolean']['output'];
};

export type RoomCategoryPlacingsView = {
  __typename?: 'RoomCategoryPlacingsView';
  conflictedPlacingVariants: Array<PlacingVariantTarificationView>;
  roomCategory: RoomCategoryView;
  suggestedPlacingVariants: Array<PlacingVariantTarificationView>;
};

export type RoomCategoryQuota = {
  __typename?: 'RoomCategoryQuota';
  quotaStatus: QuotaStatus;
  roomCategoryCid: Scalars['String']['output'];
};

export type RoomCategoryUpdateChangeError = Error & {
  __typename?: 'RoomCategoryUpdateChangeError';
  message: Scalars['String']['output'];
};

export type RoomCategoryView = {
  __typename?: 'RoomCategoryView';
  cid: Scalars['String']['output'];
  description: Array<LangString>;
  isActive: Scalars['Boolean']['output'];
  name: Array<LangString>;
  operations: RoomCategoryOperations;
  seat: RoomSeat;
  shortName: Scalars['String']['output'];
  type: RoomType;
};

export type RoomPlacingListNotFoundError = Error & {
  __typename?: 'RoomPlacingListNotFoundError';
  ciDs: Array<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type RoomQuotaView = {
  __typename?: 'RoomQuotaView';
  quotas: Array<QuotaPeriodView>;
  room: RoomCategoryView;
};

export type RoomSeat = {
  __typename?: 'RoomSeat';
  baseQuantity: Scalars['UnsignedShort']['output'];
  extQuantity: Scalars['UnsignedShort']['output'];
};

export type RoomSeatInput = {
  baseQuantity: Scalars['UnsignedShort']['input'];
  extQuantity: Scalars['UnsignedShort']['input'];
};

export type RoomType = {
  __typename?: 'RoomType';
  cid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RoomTypeNotFoundError = Error & {
  __typename?: 'RoomTypeNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type RoomsDictionaries = {
  __typename?: 'RoomsDictionaries';
  balconyTypes: Array<Scalars['String']['output']>;
  bathroomEquipment: Array<Scalars['String']['output']>;
  bathroomTypes: Array<Scalars['String']['output']>;
  equipment: Array<Scalars['String']['output']>;
  extrabedTypes: Array<Scalars['String']['output']>;
  furniture: Array<Scalars['String']['output']>;
  roomNumbers: Array<Scalars['String']['output']>;
  services: Array<Scalars['String']['output']>;
  views: Array<Scalars['String']['output']>;
};

export type RuleView = {
  __typename?: 'RuleView';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type SaveDocumentSignatureError = DocumentNotFoundError;

export type SaveDocumentSignatureInput = {
  documentId: Scalars['UUID']['input'];
  signature: Scalars['String']['input'];
};

export type SaveDocumentSignaturePayload = {
  __typename?: 'SaveDocumentSignaturePayload';
  errors?: Maybe<Array<SaveDocumentSignatureError>>;
  mutationResult?: Maybe<MutationResult>;
};

export type SaveLegalEdiTypeError = LegalNotFoundError | LegalSaveEdiTypeError;

export type SaveLegalEdiTypeInput = {
  ediType: EdiType;
  legalCID: Scalars['String']['input'];
};

export type SaveLegalEdiTypePayload = {
  __typename?: 'SaveLegalEDITypePayload';
  errors?: Maybe<Array<SaveLegalEdiTypeError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SelfDeleteError = Error & {
  __typename?: 'SelfDeleteError';
  message: Scalars['String']['output'];
};

export type SelfSetRoleError = Error & {
  __typename?: 'SelfSetRoleError';
  message: Scalars['String']['output'];
};

export type SendOrderToSupplierError = LockResourceFailedError | OrderIsNotConfirmedError | OrderNotFoundError | OrderSendToSupplierRemoteInteractError;

export type SendOrderToSupplierInput = {
  orderId: Scalars['Int']['input'];
};

export type SendOrderToSupplierPayload = {
  __typename?: 'SendOrderToSupplierPayload';
  errors?: Maybe<Array<SendOrderToSupplierError>>;
  order?: Maybe<OrderView>;
};

export type SendSupplierQuestionnaireError = UserNotFoundError;

export type SendSupplierQuestionnaireInput = {
  accommodationObject: SupplierQuestionnaireAccommodationObjectInput;
  contact: SupplierQuestionnaireContactInput;
  isNew: Scalars['Boolean']['input'];
  legal: LegalDataInput;
  version: Scalars['Int']['input'];
};

export type SendSupplierQuestionnairePayload = {
  __typename?: 'SendSupplierQuestionnairePayload';
  SupplierCode?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<SendSupplierQuestionnaireError>>;
};

export type SendTariffScheduleInWorkError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | QuotaNotFilledError | QuotaPricesRequiredError | TariffScheduleAlreadyInWorkError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type SendTariffScheduleInWorkInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type SendTariffScheduleInWorkPayload = {
  __typename?: 'SendTariffScheduleInWorkPayload';
  errors?: Maybe<Array<SendTariffScheduleInWorkError>>;
  tariffSchedule2View?: Maybe<TariffSchedule2View>;
};

export type ServiceGroupInput = {
  description?: InputMaybe<Array<LangStringInput>>;
  isActive: Scalars['Boolean']['input'];
  name: Array<LangStringInput>;
  serviceCids: Array<Scalars['String']['input']>;
};

export type ServiceGroupListInput = {
  defaultAvailable: Scalars['Boolean']['input'];
  isNeedConfirm: Scalars['Boolean']['input'];
  orderPeriod: ServiceGroupOrderPeriodInput;
  serviceGroupCid: Scalars['String']['input'];
};

export type ServiceGroupListNotBelongsToTariffScheduleError = Error & {
  __typename?: 'ServiceGroupListNotBelongsToTariffScheduleError';
  message: Scalars['String']['output'];
};

export type ServiceGroupListNotFoundError = Error & {
  __typename?: 'ServiceGroupListNotFoundError';
  ciDs: Array<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ServiceGroupListOperations = {
  __typename?: 'ServiceGroupListOperations';
  add: OperationStatus;
  edit: OperationStatus;
  hasMaximumServiceGroups: Scalars['Boolean']['output'];
};

export type ServiceGroupNotFoundError = Error & {
  __typename?: 'ServiceGroupNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ServiceGroupOperations = {
  __typename?: 'ServiceGroupOperations';
  edit: OperationStatus;
};

export type ServiceGroupOrderPeriod = {
  __typename?: 'ServiceGroupOrderPeriod';
  maxOrderPeriod?: Maybe<Scalars['UnsignedShort']['output']>;
  minOrderPeriod: Scalars['UnsignedShort']['output'];
};

export type ServiceGroupOrderPeriodInput = {
  maxOrderPeriod?: InputMaybe<Scalars['UnsignedShort']['input']>;
  minOrderPeriod: Scalars['UnsignedShort']['input'];
};

export type ServiceGroupsMapping = {
  __typename?: 'ServiceGroupsMapping';
  serviceGroups: Array<TravelLineServiceGroupView>;
  translationTable: Array<ExternalObjectTranslationView>;
};

export type ServiceGroupsNotBelongsToTariffScheduleError = Error & {
  __typename?: 'ServiceGroupsNotBelongsToTariffScheduleError';
  message: Scalars['String']['output'];
};

export type ServiceGroupsSettings = {
  __typename?: 'ServiceGroupsSettings';
  selectedServiceGroupeCIDs?: Maybe<Array<Scalars['String']['output']>>;
  serviceGroups: Array<TariffScheduleServiceGroupBase>;
};

export type ServiceInput = {
  applyMethod: ApplyMethod;
  calculationMethod: CalculationMethodInput;
  name: Array<LangStringInput>;
  serviceTypeCid: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
};

export type ServiceNotFoundError = Error & {
  __typename?: 'ServiceNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ServiceOperations = {
  __typename?: 'ServiceOperations';
  delete: OperationStatus;
};

export type ServiceTooOldToDeleteError = Error & {
  __typename?: 'ServiceTooOldToDeleteError';
  message: Scalars['String']['output'];
};

export type ServiceType = {
  __typename?: 'ServiceType';
  cid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type ServiceTypeNotFoundError = Error & {
  __typename?: 'ServiceTypeNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ServiceView = {
  __typename?: 'ServiceView';
  applyMethod: ApplyMethod;
  calculationMethod: CalculationMethod;
  cid: Scalars['String']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  name: Array<LangString>;
  operations: ServiceOperations;
  serviceType: ServiceType;
  shortName: Scalars['String']['output'];
  sortNumber: Scalars['Int']['output'];
};

export type ServiceViewGrouped = {
  __typename?: 'ServiceViewGrouped';
  groupName: Scalars['String']['output'];
  services: Array<ServiceView>;
};

export type ServicesAndEntertainmentDictionaries = {
  __typename?: 'ServicesAndEntertainmentDictionaries';
  animations: Array<Scalars['String']['output']>;
  childrenEntertainments: Array<Scalars['String']['output']>;
  childrenEquipmentRental: Array<Scalars['String']['output']>;
  childrenServices: Array<Scalars['String']['output']>;
  equipmentRental: Array<Scalars['String']['output']>;
  household: Array<Scalars['String']['output']>;
  internet: Array<Scalars['String']['output']>;
  leisure: Array<Scalars['String']['output']>;
  medicalCosmetology: Array<Scalars['String']['output']>;
  other: Array<Scalars['String']['output']>;
  reception: Array<Scalars['String']['output']>;
  rental: Array<Scalars['String']['output']>;
  skiResortServices: Array<Scalars['String']['output']>;
  spaServices: Array<Scalars['String']['output']>;
  sportAndEntertainmentTypes: Array<Scalars['String']['output']>;
  waterSports: Array<Scalars['String']['output']>;
};

export type ServicesNotAllowedForServiceGroupError = Error & {
  __typename?: 'ServicesNotAllowedForServiceGroupError';
  ciDs: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type SetInvitationRoleError = InvitationNotFoundError;

export type SetInvitationRoleInput = {
  invitationId: Scalars['UUID']['input'];
  role: Role;
};

export type SetInvitationRolePayload = {
  __typename?: 'SetInvitationRolePayload';
  errors?: Maybe<Array<SetInvitationRoleError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SetRoleOwnerError = Error & {
  __typename?: 'SetRoleOwnerError';
  message: Scalars['String']['output'];
};

export type SetUserRoleError = ChangeUserRoleToSupportForbiddenError | SelfSetRoleError | SetRoleOwnerError | SupportRoleChangeForbiddenError | UserNotFoundError;

export type SetUserRoleInput = {
  role: Role;
  userId: Scalars['UUID']['input'];
};

export type SetUserRolePayload = {
  __typename?: 'SetUserRolePayload';
  errors?: Maybe<Array<SetUserRoleError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum SortOrders {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StepValidation = {
  __typename?: 'StepValidation';
  isValid: Scalars['Boolean']['output'];
  step: QuestionnaireMasterStep;
};

export type SuggestionInput = {
  key: Scalars['String']['input'];
  maxResults?: Scalars['Int']['input'];
};

export type SuggestionKeyOptionalInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  maxResults?: Scalars['Int']['input'];
};

export type SupersetTokenView = {
  __typename?: 'SupersetTokenView';
  dashboards: Array<KeyValuePairOfStringAndString>;
  guestToken: Scalars['String']['output'];
  status: HttpStatusCode;
  supersetDomain: Scalars['String']['output'];
};

export type SupplierPayRule = {
  __typename?: 'SupplierPayRule';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type SupplierPayRuleNotFoundError = Error & {
  __typename?: 'SupplierPayRuleNotFoundError';
  message: Scalars['String']['output'];
};

export type SupplierQuestionnaireAccommodationObject = {
  __typename?: 'SupplierQuestionnaireAccommodationObject';
  addressData: AddressData;
  name?: Maybe<Scalars['String']['output']>;
  nameML?: Maybe<Array<LangString>>;
  type: AccommodationObjectType;
};

export type SupplierQuestionnaireAccommodationObjectInput = {
  addressData: AddressDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
  nameML?: InputMaybe<Array<LangStringInput>>;
  type: AccommodationObjectTypeInput;
};

export type SupplierQuestionnaireContact = {
  __typename?: 'SupplierQuestionnaireContact';
  email: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  webSite?: Maybe<Scalars['String']['output']>;
};

export type SupplierQuestionnaireContactInput = {
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  webSite?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierQuestionnaireNotUpdatedError = Error & {
  __typename?: 'SupplierQuestionnaireNotUpdatedError';
  message: Scalars['String']['output'];
};

export type SupplierQuestionnaireView = {
  __typename?: 'SupplierQuestionnaireView';
  accommodationObject: SupplierQuestionnaireAccommodationObject;
  contact: SupplierQuestionnaireContact;
  isNew: Scalars['Boolean']['output'];
  legal: LegalDataView;
  legalOrigin: LegalOrigin;
  version: Scalars['Int']['output'];
};

export type SupplierUserView = {
  __typename?: 'SupplierUserView';
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isOwner: Scalars['Boolean']['output'];
  operations: UserOperations;
  profile: UserProfileView;
  role?: Maybe<Role>;
  userName: Scalars['String']['output'];
};

export type SupportRoleChangeForbiddenError = Error & {
  __typename?: 'SupportRoleChangeForbiddenError';
  message: Scalars['String']['output'];
};

export type TabsView = {
  __typename?: 'TabsView';
  comissions: ComissionsView;
  grid: TariffGridView;
};

export type TariffFactorInput = {
  placingFactor: PlacingFactorInput;
  roomCategoryCid: Scalars['String']['input'];
  serviceGroupCid: Scalars['String']['input'];
};

export type TariffGridCancelEditError = OperationOnUnlockedResourceIsInvalidError | TariffScheduleNotFoundError;

export type TariffGridCancelEditInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type TariffGridCancelEditPayload = {
  __typename?: 'TariffGridCancelEditPayload';
  errors?: Maybe<Array<TariffGridCancelEditError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TariffGridEditError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type TariffGridEditInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type TariffGridEditPayload = {
  __typename?: 'TariffGridEditPayload';
  Grid?: Maybe<TariffScheduleGridView>;
  errors?: Maybe<Array<TariffGridEditError>>;
};

export type TariffGridKeepAliveError = OperationOnUnlockedResourceIsInvalidError | TariffScheduleNotFoundError;

export type TariffGridKeepAliveInput = {
  tariffScheduleCid: Scalars['String']['input'];
};

export type TariffGridKeepAlivePayload = {
  __typename?: 'TariffGridKeepAlivePayload';
  errors?: Maybe<Array<TariffGridKeepAliveError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TariffGridPlacingFactorView = {
  __typename?: 'TariffGridPlacingFactorView';
  placingFactor: PlacingFactorView;
  rates: Array<TariffRateView>;
};

export type TariffGridRoomCategoryView = {
  __typename?: 'TariffGridRoomCategoryView';
  placingFactors: Array<TariffGridPlacingFactorView>;
  roomCategory: RoomCategoryView;
};

export type TariffGridServiceView = {
  __typename?: 'TariffGridServiceView';
  roomCategories: Array<TariffGridRoomCategoryView>;
  serviceGroup: TariffScheduleServiceGroupView;
};

export type TariffGridUpdateError = ConcurrencyConflictError | CurrencyListNotFoundError | HotelSetHasRemoteIntegrationForbiddenError | OperationForbiddenError | OperationOnUnlockedResourceIsInvalidError | PlacingVariantsNotBelongsToTariffScheduleError | RoomCategoriesNotBelongsToTariffScheduleError | RoomCategoryListNotFoundError | RoomPlacingListNotFoundError | ServiceGroupsNotBelongsToTariffScheduleError | TariffScheduleGridPeriodConflictBasePeriodError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError | TouristTypeListNotFoundError | TouristTypesNotBelongsToTariffScheduleError;

export type TariffGridUpdateInput = {
  lines: Array<TariffLineInput>;
  tariffScheduleCid: Scalars['String']['input'];
};

export type TariffGridUpdatePayload = {
  __typename?: 'TariffGridUpdatePayload';
  Grid?: Maybe<TariffScheduleGridView>;
  errors?: Maybe<Array<TariffGridUpdateError>>;
};

export type TariffGridView = {
  __typename?: 'TariffGridView';
  services: Array<TariffGridServiceView>;
};

export type TariffLineInput = {
  rate: MoneyInput;
  schedulePeriod: GridPeriodInput;
  tariffFactor: TariffFactorInput;
};

export type TariffRateView = {
  __typename?: 'TariffRateView';
  period: RangeOfDateOnly;
  price?: Maybe<RatePriceView>;
};

export type TariffSchedule2View = {
  __typename?: 'TariffSchedule2View';
  baseSettings: TariffScheduleBaseSettings2;
  commonInformation: TariffScheduleCommonInformation;
  contractType: ContractType;
  hotelSetCid: Scalars['String']['output'];
  operations: TariffScheduleOperations;
  remoteInteraction?: Maybe<TariffScheduleRemoteInteraction>;
  status: TariffScheduleStatus;
  tariffScheduleCid: Scalars['String']['output'];
};

export type TariffScheduleAlreadyInWorkError = Error & {
  __typename?: 'TariffScheduleAlreadyInWorkError';
  message: Scalars['String']['output'];
};

export type TariffScheduleBaseSettings2 = {
  __typename?: 'TariffScheduleBaseSettings2';
  ageSettings: AgeSettings;
  completed: Scalars['Boolean']['output'];
  roomCategories: Array<RoomCategoryQuota>;
};

export type TariffScheduleCommonInformation = {
  __typename?: 'TariffScheduleCommonInformation';
  applyingRules: ApplyingRulesView;
  checkInOutSettings: CheckInOutSettings;
  hotelSetHasRemote: Scalars['Boolean']['output'];
  isRemote: Scalars['Boolean']['output'];
  name: Array<LangString>;
  period: RangeOfDateOnly;
  taxScheme: TaxSchemeSuggestion;
  visitTimetableCount: Scalars['Int']['output'];
};

export type TariffScheduleCommonInformationUpdated = {
  __typename?: 'TariffScheduleCommonInformationUpdated';
  applyingRules: ApplyingRulesView;
  checkInOutSettings: CheckInOutSettings;
  hasServiceSequenceChanged: Scalars['Boolean']['output'];
  hotelSetHasRemote: Scalars['Boolean']['output'];
  isRemote: Scalars['Boolean']['output'];
  name: Array<LangString>;
  period: RangeOfDateOnly;
  taxScheme: TaxSchemeSuggestion;
  visitTimetableCount: Scalars['Int']['output'];
};

export type TariffScheduleGridPeriodConflictBasePeriodError = Error & {
  __typename?: 'TariffScheduleGridPeriodConflictBasePeriodError';
  message: Scalars['String']['output'];
};

export type TariffScheduleGridView = {
  __typename?: 'TariffScheduleGridView';
  baseSettings: BaseSettingsView;
  contractType: ContractType;
  invalidCommissions: Scalars['Boolean']['output'];
  operations: PriceGridOperations;
  tabs?: Maybe<TabsView>;
};

export type TariffScheduleList2View = {
  __typename?: 'TariffScheduleList2View';
  extranet: Array<TariffScheduleListItem2ExtranetView>;
  operations: TariffScheduleListOperations;
  remote: Array<TariffScheduleListItem2RemoteView>;
};

export type TariffScheduleListItem2ExtranetView = {
  __typename?: 'TariffScheduleListItem2ExtranetView';
  name: Array<LangString>;
  status: TariffScheduleStatus;
  stopSalePeriodHours: Scalars['UnsignedInt']['output'];
  tariffScheduleCid: Scalars['String']['output'];
};

export type TariffScheduleListItem2RemoteTariffSchedule = {
  __typename?: 'TariffScheduleListItem2RemoteTariffSchedule';
  activeRemoting: Scalars['Boolean']['output'];
  contractClosed: Scalars['Boolean']['output'];
  tariffScheduleCid: Scalars['String']['output'];
};

export type TariffScheduleListItem2RemoteView = {
  __typename?: 'TariffScheduleListItem2RemoteView';
  channelManagerCode: ChannelManagerCode;
  interactionId: Scalars['UUID']['output'];
  name: Array<LangString>;
  tariffSchedule?: Maybe<TariffScheduleListItem2RemoteTariffSchedule>;
};

export type TariffScheduleListOperations = {
  __typename?: 'TariffScheduleListOperations';
  canAddExtranetTariffSchedule: OperationStatus;
  canAddRemoteTariffSchedule: OperationStatus;
};

export type TariffScheduleMultipleVisitTimetableForbiddenError = Error & {
  __typename?: 'TariffScheduleMultipleVisitTimetableForbiddenError';
  message: Scalars['String']['output'];
};

export type TariffScheduleNotFoundError = Error & {
  __typename?: 'TariffScheduleNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TariffScheduleOperations = {
  __typename?: 'TariffScheduleOperations';
  canEditPlacingVariants: OperationStatus;
  sendInWork: OperationStatus;
  startPVM: OperationStatus;
  update: OperationStatus;
};

export type TariffScheduleOutOfContractPeriodError = Error & {
  __typename?: 'TariffScheduleOutOfContractPeriodError';
  message: Scalars['String']['output'];
};

export type TariffSchedulePlacingVariantInput = {
  defaultAvailable: Scalars['Boolean']['input'];
  isNeedConfirm: Scalars['Boolean']['input'];
  maxNoSeatQuantity: Scalars['Short']['input'];
  placings?: InputMaybe<PlacingVariantInput>;
  pricePerRoom: Scalars['Boolean']['input'];
  roomPlacingCID?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
};

export type TariffScheduleRemoteInteraction = {
  __typename?: 'TariffScheduleRemoteInteraction';
  activeRemoting: Scalars['Boolean']['output'];
  channelManagerCode: ChannelManagerCode;
  interactionId: Scalars['UUID']['output'];
  remoteIntegrationUrl?: Maybe<Scalars['String']['output']>;
};

export type TariffScheduleRoomPlacingVariantInput = {
  roomCategoryCid: Scalars['String']['input'];
  variants: Array<TariffSchedulePlacingVariantInput>;
};

export type TariffScheduleServiceGroupBase = {
  __typename?: 'TariffScheduleServiceGroupBase';
  cid: Scalars['String']['output'];
  description: Array<LangString>;
  isActive: Scalars['Boolean']['output'];
  name: Array<LangString>;
  services: Array<ServiceView>;
  shortName: Scalars['String']['output'];
};

export type TariffScheduleServiceGroupListItemView = {
  __typename?: 'TariffScheduleServiceGroupListItemView';
  defaultAvailable: Scalars['Boolean']['output'];
  description: Array<LangString>;
  isActive: Scalars['Boolean']['output'];
  isNeedConfirm: Scalars['Boolean']['output'];
  name: Array<LangString>;
  orderPeriod: ServiceGroupOrderPeriod;
  serviceGroupCid: Scalars['String']['output'];
  services: Array<ServiceView>;
  shortName: Scalars['String']['output'];
};

export type TariffScheduleServiceGroupMaxNumberExceedError = Error & {
  __typename?: 'TariffScheduleServiceGroupMaxNumberExceedError';
  message: Scalars['String']['output'];
};

export type TariffScheduleServiceGroupMutuallyExclusiveCidsFoundError = Error & {
  __typename?: 'TariffScheduleServiceGroupMutuallyExclusiveCidsFoundError';
  message: Scalars['String']['output'];
};

export type TariffScheduleServiceGroupView = {
  __typename?: 'TariffScheduleServiceGroupView';
  cid: Scalars['String']['output'];
  description: Array<LangString>;
  isActive: Scalars['Boolean']['output'];
  name: Array<LangString>;
  operations: ServiceGroupOperations;
  services: Array<ServiceView>;
  shortName: Scalars['String']['output'];
};

export type TariffScheduleServiceGroupsListView = {
  __typename?: 'TariffScheduleServiceGroupsListView';
  operations: ServiceGroupListOperations;
  serviceGroups: Array<TariffScheduleServiceGroupListItemView>;
};

export enum TariffScheduleStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  InWork = 'IN_WORK',
  OnApproval = 'ON_APPROVAL'
}

export type TaxSchemeNotFoundError = Error & {
  __typename?: 'TaxSchemeNotFoundError';
  message: Scalars['String']['output'];
};

export type TaxSchemeSuggestion = {
  __typename?: 'TaxSchemeSuggestion';
  cid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TouristPlaceDto = {
  __typename?: 'TouristPlaceDto';
  isAdditional: Scalars['Boolean']['output'];
  touristTypeCID: Scalars['String']['output'];
};

export type TouristPlaceView = {
  __typename?: 'TouristPlaceView';
  relatedRoomPlacings: Array<Scalars['String']['output']>;
  touristPlace: TouristPlaceDto;
  touristType: TouristTypeView;
};

export type TouristPlacingInput = {
  isAdditional: Scalars['Boolean']['input'];
  touristTypeCid: Scalars['String']['input'];
};

export type TouristSeatsInput = {
  seats: Scalars['UnsignedShort']['input'];
  touristType: TouristTypeInput;
};

export type TouristSeatsView = {
  __typename?: 'TouristSeatsView';
  seats: Scalars['UnsignedShort']['output'];
  touristType: TouristTypeView;
};

export type TouristTypeInput = {
  ageCategory?: InputMaybe<AgeCategoryInput>;
};

export type TouristTypeListNotFoundError = Error & {
  __typename?: 'TouristTypeListNotFoundError';
  ciDs: Array<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type TouristTypeView = {
  __typename?: 'TouristTypeView';
  ageCategory?: Maybe<AgeCategoryView>;
  isAdult: Scalars['Boolean']['output'];
};

export type TouristTypesMapping = {
  __typename?: 'TouristTypesMapping';
  ageSettings: AgeSettings;
  touristTypesRefreshRequired: Scalars['Boolean']['output'];
};

export type TouristTypesNotBelongsToTariffScheduleError = Error & {
  __typename?: 'TouristTypesNotBelongsToTariffScheduleError';
  message: Scalars['String']['output'];
};

export type TouristTypesSettings = {
  __typename?: 'TouristTypesSettings';
  ageSettings: AgeSettings;
};

export type Town = {
  __typename?: 'Town';
  cid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  toponymsPath: Array<Scalars['String']['output']>;
};

export type TownNotFoundError = Error & {
  __typename?: 'TownNotFoundError';
  cid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TownSuggestion = {
  __typename?: 'TownSuggestion';
  cid: Scalars['String']['output'];
  toponymsPath: Array<Scalars['String']['output']>;
};

export enum TranslationTableFulfillment {
  Empty = 'EMPTY',
  PlacingVariants = 'PLACING_VARIANTS',
  RoomCategories = 'ROOM_CATEGORIES',
  ServiceGroups = 'SERVICE_GROUPS',
  TouristTypes = 'TOURIST_TYPES'
}

export type TravelLineCanNotCahengeExternalObjectMappingError = Error & {
  __typename?: 'TravelLineCanNotCahengeExternalObjectMappingError';
  message: Scalars['String']['output'];
};

export type TravelLineExternalIntegration = {
  __typename?: 'TravelLineExternalIntegration';
  externalHotel?: Maybe<ExternalHotel>;
  externalId: Scalars['String']['output'];
  integrationUrl?: Maybe<Scalars['String']['output']>;
};

export type TravelLineExternalIntegrationIssueError = Error & {
  __typename?: 'TravelLineExternalIntegrationIssueError';
  message: Scalars['String']['output'];
};

export type TravelLineFulfillmentErrorError = Error & {
  __typename?: 'TravelLineFulfillmentErrorError';
  currentFulfillment: TranslationTableFulfillment;
  message: Scalars['String']['output'];
  requiredFulfillment: TranslationTableFulfillment;
};

export type TravelLineHotelNotFoundError = Error & {
  __typename?: 'TravelLineHotelNotFoundError';
  hotelID: Scalars['UnsignedInt']['output'];
  hotelName: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TravelLineInitialAgeExceedError = Error & {
  __typename?: 'TravelLineInitialAgeExceedError';
  message: Scalars['String']['output'];
};

export type TravelLineInitialAgeOverrideError = Error & {
  __typename?: 'TravelLineInitialAgeOverrideError';
  message: Scalars['String']['output'];
};

export type TravelLineIntegrationMasterView = {
  __typename?: 'TravelLineIntegrationMasterView';
  hotelSetCid: Scalars['String']['output'];
  masterStep: TravelLineMasterStep;
  steps: TravelLineMasterStepsView;
};

export type TravelLineIntegrationView = {
  __typename?: 'TravelLineIntegrationView';
  channelManagerCode: ChannelManagerCode;
  externalIntegration?: Maybe<TravelLineExternalIntegration>;
  hasExternalIntegrationIssue: Scalars['Boolean']['output'];
  master?: Maybe<TravelLineIntegrationMasterView>;
};

export type TravelLineIntegrationViewInput = {
  query: InteractionQueryInput;
};

export type TravelLineMasterCompletedView = {
  __typename?: 'TravelLineMasterCompletedView';
  tariffScheduleCID: Scalars['String']['output'];
};

export enum TravelLineMasterStep {
  IntegrationSettings = 'INTEGRATION_SETTINGS',
  PlacingVariantsMapping = 'PLACING_VARIANTS_MAPPING',
  RoomCategoriesMapping = 'ROOM_CATEGORIES_MAPPING',
  ServiceGroupsMapping = 'SERVICE_GROUPS_MAPPING',
  TouristTypesMapping = 'TOURIST_TYPES_MAPPING'
}

export type TravelLineMasterStepsView = {
  __typename?: 'TravelLineMasterStepsView';
  integrationSettings?: Maybe<IntegrationSettings>;
  placingVariantsMapping?: Maybe<PlacingVariantsMapping>;
  roomCategoriesMapping?: Maybe<RoomCategoriesMapping>;
  serviceGroupsMapping?: Maybe<ServiceGroupsMapping>;
  touristTypesMapping?: Maybe<TouristTypesMapping>;
};

export type TravelLinePlacingVariantExceedsRoomCategoryCapacityError = Error & {
  __typename?: 'TravelLinePlacingVariantExceedsRoomCategoryCapacityError';
  message: Scalars['String']['output'];
};

export type TravelLinePlacingVariantsNotFulfilledError = Error & {
  __typename?: 'TravelLinePlacingVariantsNotFulfilledError';
  message: Scalars['String']['output'];
};

export type TravelLineRefreshTouristTypesInput = {
  interactionQuery: InteractionQueryInput;
};

export type TravelLineRefreshTouristTypesPayload = {
  __typename?: 'TravelLineRefreshTouristTypesPayload';
  status: Scalars['String']['output'];
};

export type TravelLineRestartIntegrationError = ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | ChannelManagerInvalidContractNumberError | ChannelManagerMasterInvalidOperationError | HotelSetNotFoundError | InvalidContractNumberError;

export type TravelLineRestartIntegrationInput = {
  interactionQuery: InteractionQueryInput;
};

export type TravelLineRestartIntegrationPayload = {
  __typename?: 'TravelLineRestartIntegrationPayload';
  View?: Maybe<TravelLineRestartIntegrationView>;
  errors?: Maybe<Array<TravelLineRestartIntegrationError>>;
};

export type TravelLineRestartIntegrationView = {
  __typename?: 'TravelLineRestartIntegrationView';
  channelManagerCode: ChannelManagerCode;
  hasExternalIntegrationIssue: Scalars['Boolean']['output'];
  master?: Maybe<TravelLineIntegrationMasterView>;
};

export type TravelLineSaveRoomCategoriesMappingError = ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | InvalidContractNumberError;

export type TravelLineSaveRoomCategoriesMappingInput = {
  interactionQuery: InteractionQueryInput;
  roomCategories: Array<ExternalObjectTranslationInput>;
};

export type TravelLineSaveRoomCategoriesMappingPayload = {
  __typename?: 'TravelLineSaveRoomCategoriesMappingPayload';
  errors?: Maybe<Array<TravelLineSaveRoomCategoriesMappingError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TravelLineSaveServiceGroupsMappingError = ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | InvalidContractNumberError;

export type TravelLineSaveServiceGroupsMappingInput = {
  interactionQuery: InteractionQueryInput;
  serviceGroups: Array<ExternalObjectTranslationInput>;
};

export type TravelLineSaveServiceGroupsMappingPayload = {
  __typename?: 'TravelLineSaveServiceGroupsMappingPayload';
  errors?: Maybe<Array<TravelLineSaveServiceGroupsMappingError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TravelLineServiceGroupView = {
  __typename?: 'TravelLineServiceGroupView';
  canChange: Scalars['Boolean']['output'];
  cid: Scalars['String']['output'];
  description: Array<LangString>;
  isActive: Scalars['Boolean']['output'];
  name: Array<LangString>;
  services: Array<ServiceView>;
  shortName: Scalars['String']['output'];
};

export type TravelLineStartIntegrationError = ContractNotFoundError | TravelLineExternalIntegrationIssueError | TravelLineHotelNotFoundError;

export type TravelLineStartIntegrationInput = {
  channelManagerCode: ChannelManagerCode;
  query: ExternalHotelContextQueryInput;
};

export type TravelLineStartIntegrationPayload = {
  __typename?: 'TravelLineStartIntegrationPayload';
  InteractionId?: Maybe<Scalars['UUID']['output']>;
  errors?: Maybe<Array<TravelLineStartIntegrationError>>;
};

export type TravelLineTouristTypesHasGapsError = Error & {
  __typename?: 'TravelLineTouristTypesHasGapsError';
  ageCategories: Array<AgeCategory>;
  message: Scalars['String']['output'];
};

export type TravelLineUncompletedIntegrationView = {
  __typename?: 'TravelLineUncompletedIntegrationView';
  channelManagerCode: ChannelManagerCode;
  externalIntegration: TravelLineExternalIntegration;
  integrationId: Scalars['UUID']['output'];
};

export type TravelLineUpdateIntegrationSettingsError = ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | ChannelManagerMasterInvalidOperationError | ContractNotFoundError | OutOfContractPeriodError;

export type TravelLineUpdateIntegrationSettingsInput = {
  integrationSettings: IntegrationSettingsInput;
  interactionQuery: InteractionQueryInput;
};

export type TravelLineUpdateIntegrationSettingsPayload = {
  __typename?: 'TravelLineUpdateIntegrationSettingsPayload';
  View?: Maybe<TravelLineMasterStepsView>;
  errors?: Maybe<Array<TravelLineUpdateIntegrationSettingsError>>;
};

export type TravelLineUpdatePlacingVariantsError = ChannelManagerAdditionalMappingRequiredError | ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | ChannelManagerMasterInvalidOperationError | InvalidContractNumberError | RoomCategoryNotFoundError | TravelLineExternalIntegrationIssueError | TravelLineFulfillmentErrorError | TravelLinePlacingVariantExceedsRoomCategoryCapacityError | TravelLinePlacingVariantsNotFulfilledError;

export type TravelLineUpdatePlacingVariantsInput = {
  interactionQuery: InteractionQueryInput;
  roomPlacingVariants: Array<TariffScheduleRoomPlacingVariantInput>;
};

export type TravelLineUpdatePlacingVariantsPayload = {
  __typename?: 'TravelLineUpdatePlacingVariantsPayload';
  View?: Maybe<TravelLineMasterCompletedView>;
  errors?: Maybe<Array<TravelLineUpdatePlacingVariantsError>>;
};

export type TravelLineUpdateRoomCategoriesError = ChannelManagerAdditionalMappingRequiredError | ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | ChannelManagerMasterInvalidOperationError | InvalidContractNumberError | RoomCategoryNotFoundError | TravelLineExternalIntegrationIssueError | TravelLineFulfillmentErrorError;

export type TravelLineUpdateRoomCategoriesInput = {
  interactionQuery: InteractionQueryInput;
  roomCategories: Array<ExternalObjectTranslationInput>;
};

export type TravelLineUpdateRoomCategoriesPayload = {
  __typename?: 'TravelLineUpdateRoomCategoriesPayload';
  View?: Maybe<TravelLineMasterStepsView>;
  errors?: Maybe<Array<TravelLineUpdateRoomCategoriesError>>;
};

export type TravelLineUpdateServiceGroupsError = ChannelManagerAdditionalMappingRequiredError | ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | ChannelManagerMasterInvalidOperationError | InvalidContractNumberError | ServiceGroupNotFoundError | TravelLineCanNotCahengeExternalObjectMappingError | TravelLineExternalIntegrationIssueError | TravelLineFulfillmentErrorError;

export type TravelLineUpdateServiceGroupsInput = {
  interactionQuery: InteractionQueryInput;
  serviceGroups: Array<ExternalObjectTranslationInput>;
};

export type TravelLineUpdateServiceGroupsPayload = {
  __typename?: 'TravelLineUpdateServiceGroupsPayload';
  View?: Maybe<TravelLineMasterStepsView>;
  errors?: Maybe<Array<TravelLineUpdateServiceGroupsError>>;
};

export type TravelLineUpdateTouristTypesError = ChannelManagerInteractionInvalidStateError | ChannelManagerInteractionNotFoundError | ChannelManagerMasterInvalidOperationError | InvalidContractNumberError | TravelLineExternalIntegrationIssueError | TravelLineFulfillmentErrorError | TravelLineInitialAgeExceedError | TravelLineInitialAgeOverrideError | TravelLineTouristTypesHasGapsError;

export type TravelLineUpdateTouristTypesInput = {
  determineAgeMethod: DetermineAgeMethod;
  interactionQuery: InteractionQueryInput;
};

export type TravelLineUpdateTouristTypesPayload = {
  __typename?: 'TravelLineUpdateTouristTypesPayload';
  View?: Maybe<TravelLineMasterStepsView>;
  errors?: Maybe<Array<TravelLineUpdateTouristTypesError>>;
};

export type TreatmentCategory = {
  __typename?: 'TreatmentCategory';
  groups: Array<TreatmentGroup>;
  name: Scalars['String']['output'];
};

export type TreatmentCategoryDict = {
  __typename?: 'TreatmentCategoryDict';
  groups: Array<TreatmentGroupDict>;
  name: Scalars['String']['output'];
};

export type TreatmentCategoryInput = {
  groups: Array<TreatmentGroupInput>;
  name: Scalars['String']['input'];
};

export type TreatmentDictionaries = {
  __typename?: 'TreatmentDictionaries';
  categories: Array<TreatmentCategoryDict>;
};

export type TreatmentGroup = {
  __typename?: 'TreatmentGroup';
  items: Array<TreatmentItem>;
  name: Scalars['String']['output'];
};

export type TreatmentGroupDict = {
  __typename?: 'TreatmentGroupDict';
  items: Array<TreatmentItemDict>;
  name: Scalars['String']['output'];
};

export type TreatmentGroupInput = {
  items: Array<TreatmentItemInput>;
  name: Scalars['String']['input'];
};

export type TreatmentItem = {
  __typename?: 'TreatmentItem';
  name: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
};

export type TreatmentItemDict = {
  __typename?: 'TreatmentItemDict';
  name: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
};

export type TreatmentItemInput = {
  name: Scalars['String']['input'];
  options: Array<Scalars['String']['input']>;
};

export type UncompletedIntegrationInfoInput = {
  channelManagerCode: ChannelManagerCode;
  query: ExternalHotelContextQueryInput;
};

export type UncompletedReverseIntegrationView = {
  __typename?: 'UncompletedReverseIntegrationView';
  channelManagerCode: ChannelManagerCode;
  isNotStarted: Scalars['Boolean']['output'];
};

export type UncompletedReverseInteractionInput = {
  channelManagerCode: ChannelManagerCode;
  contractNumber: Scalars['UnsignedInt']['input'];
};

export type UncompletedReverseInteractionView = {
  __typename?: 'UncompletedReverseInteractionView';
  interactionId: Scalars['UUID']['output'];
  uncompletedInteraction: UncompletedReverseIntegrationView;
};

export type UpdateAccommodationObjectRoomCategoryError = AccommodationObjectNotFoundError | OperationOnUnlockedResourceIsInvalidError | RoomCategoryNotFoundError | RoomCategoryUpdateChangeError | RoomTypeNotFoundError;

export type UpdateAccommodationObjectRoomCategoryInput = {
  accommodationObjectRoomCategoryCid: Scalars['String']['input'];
  roomCategory: RoomCategoryInput;
};

export type UpdateAccommodationObjectRoomCategoryPayload = {
  __typename?: 'UpdateAccommodationObjectRoomCategoryPayload';
  errors?: Maybe<Array<UpdateAccommodationObjectRoomCategoryError>>;
  roomCategory?: Maybe<RoomCategoryView>;
};

export type UpdateQuotaAddRoomsError = HotelSetHasRemoteIntegrationForbiddenError | OperationOnUnlockedResourceIsInvalidError | QuotaNotFoundError | RoomCategoriesNotBelongsToQuotaError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type UpdateQuotaAddRoomsInput = {
  roomCategories: Array<QuotaAddRoomCategoryInput>;
  tariffScheduleCid: Scalars['String']['input'];
};

export type UpdateQuotaAddRoomsPayload = {
  __typename?: 'UpdateQuotaAddRoomsPayload';
  errors?: Maybe<Array<UpdateQuotaAddRoomsError>>;
  quotaView?: Maybe<QuotaView>;
};

export type UpdateQuotaReservesUpdateError = ContractStatusInappropriateForQuotaChangeError | HotelSetHasRemoteIntegrationForbiddenError | IncorrectQuotaChangeOperationError | OperationOnUnlockedResourceIsInvalidError | QuotaNotFoundError | QuotaOperationPeriodNotWithinContractPeriodError | RoomCategoriesNotBelongsToQuotaError | RoomCategoryListNotFoundError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type UpdateQuotaReservesUpdateInput = {
  operations: Array<QuotaReserveUpdateOperationInput>;
  tariffScheduleCid: Scalars['String']['input'];
};

export type UpdateQuotaReservesUpdatePayload = {
  __typename?: 'UpdateQuotaReservesUpdatePayload';
  Quota?: Maybe<QuotaView>;
  errors?: Maybe<Array<UpdateQuotaReservesUpdateError>>;
};

export type UpdateRestrictionsCheckInOutSettingError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | RestrictionDefaultConflictError | RestrictionNextDayCheckoutOverrideForbiddenError | RestrictionNoChangeConflictError | RestrictionNotFoundError | RestrictionPeriodOverlapConflictError | RestrictionPeriodOverrideForbiddenError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type UpdateRestrictionsCheckInOutSettingInput = {
  checkInOutSettings: CheckInOutSettingsInput;
  period: RangeOfDateOnlyInput;
  restrictionId: Scalars['Int']['input'];
  tariffScheduleCid: Scalars['String']['input'];
};

export type UpdateRestrictionsCheckInOutSettingPayload = {
  __typename?: 'UpdateRestrictionsCheckInOutSettingPayload';
  Grid?: Maybe<RestrictionsCheckInOutSettingsView>;
  errors?: Maybe<Array<UpdateRestrictionsCheckInOutSettingError>>;
};

export type UpdateRestrictionsPlacingVariantError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | RestrictionDefaultConflictError | RestrictionNoChangeConflictError | RestrictionNotFoundError | RestrictionPeriodOverlapConflictError | RestrictionPeriodOverrideForbiddenError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type UpdateRestrictionsPlacingVariantInput = {
  options: RestrictionsPlacingVariantsOptionsInput;
  period: RangeOfDateOnlyInput;
  restrictionId: Scalars['Int']['input'];
  tariffScheduleCid: Scalars['String']['input'];
};

export type UpdateRestrictionsPlacingVariantPayload = {
  __typename?: 'UpdateRestrictionsPlacingVariantPayload';
  Grid?: Maybe<RestrictionsPlacingVariantsView>;
  errors?: Maybe<Array<UpdateRestrictionsPlacingVariantError>>;
};

export type UpdateRestrictionsServiceGroupError = HotelSetHasRemoteIntegrationForbiddenError | LockResourceFailedError | RestrictionDefaultConflictError | RestrictionNoChangeConflictError | RestrictionNotFoundError | RestrictionPeriodOverlapConflictError | RestrictionPeriodOverrideForbiddenError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type UpdateRestrictionsServiceGroupInput = {
  options: RestrictionsServiceGroupsOptionsInput;
  period: RangeOfDateOnlyInput;
  restrictionId: Scalars['Int']['input'];
  tariffScheduleCid: Scalars['String']['input'];
};

export type UpdateRestrictionsServiceGroupPayload = {
  __typename?: 'UpdateRestrictionsServiceGroupPayload';
  Grid?: Maybe<RestrictionsServiceGroupsView>;
  errors?: Maybe<Array<UpdateRestrictionsServiceGroupError>>;
};

export type UpdateSupplierQuestionnaireError = SupplierQuestionnaireNotUpdatedError;

export type UpdateSupplierQuestionnaireInput = {
  accommodationObject: SupplierQuestionnaireAccommodationObjectInput;
  contact: SupplierQuestionnaireContactInput;
  isNew: Scalars['Boolean']['input'];
  legal: LegalDataInput;
  version: Scalars['Int']['input'];
};

export type UpdateSupplierQuestionnairePayload = {
  __typename?: 'UpdateSupplierQuestionnairePayload';
  errors?: Maybe<Array<UpdateSupplierQuestionnaireError>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type UpdateTariffScheduleError = HotelSetHasRemoteIntegrationForbiddenError | OperationForbiddenError | OperationOnUnlockedResourceIsInvalidError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError | TariffScheduleOutOfContractPeriodError;

export type UpdateTariffScheduleInput = {
  applyingRules: ApplyingRulesInput;
  checkInOutSettings: CheckInOutSettingsInput;
  name: Array<LangStringInput>;
  tariffScheduleCid: Scalars['String']['input'];
  taxSchemeCid: Scalars['String']['input'];
};

export type UpdateTariffSchedulePayload = {
  __typename?: 'UpdateTariffSchedulePayload';
  TariffSchedule?: Maybe<TariffScheduleCommonInformationUpdated>;
  errors?: Maybe<Array<UpdateTariffScheduleError>>;
};

export type UpdateTariffScheduleServiceGroupError = HotelSetHasRemoteIntegrationForbiddenError | HotelSetNotFoundError | OperationOnUnlockedResourceIsInvalidError | ServiceGroupListNotBelongsToTariffScheduleError | ServiceGroupNotFoundError | ServicesNotAllowedForServiceGroupError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError | TariffScheduleServiceGroupMutuallyExclusiveCidsFoundError;

export type UpdateTariffScheduleServiceGroupInput = {
  hotelSetCid: Scalars['String']['input'];
  serviceGroup: ServiceGroupInput;
  serviceGroupCid: Scalars['String']['input'];
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTariffScheduleServiceGroupListError = HotelSetHasRemoteIntegrationForbiddenError | HotelSetNotFoundError | OperationOnUnlockedResourceIsInvalidError | ServiceGroupsNotBelongsToTariffScheduleError | TariffScheduleMultipleVisitTimetableForbiddenError | TariffScheduleNotFoundError;

export type UpdateTariffScheduleServiceGroupListInput = {
  serviceGroups: Array<ServiceGroupListInput>;
  tariffScheduleCid: Scalars['String']['input'];
};

export type UpdateTariffScheduleServiceGroupListPayload = {
  __typename?: 'UpdateTariffScheduleServiceGroupListPayload';
  errors?: Maybe<Array<UpdateTariffScheduleServiceGroupListError>>;
  serviceGroups?: Maybe<TariffScheduleServiceGroupsListView>;
};

export type UpdateTariffScheduleServiceGroupPayload = {
  __typename?: 'UpdateTariffScheduleServiceGroupPayload';
  errors?: Maybe<Array<UpdateTariffScheduleServiceGroupError>>;
  serviceGroup?: Maybe<TariffScheduleServiceGroupView>;
};

export type UpdateUserProfileError = UserNotFoundError;

export type UpdateUserProfileInput = {
  userProfile: UserProfileDtoInput;
};

export type UpdateUserProfilePayload = {
  __typename?: 'UpdateUserProfilePayload';
  errors?: Maybe<Array<UpdateUserProfileError>>;
  user?: Maybe<UserView>;
};

export type UserAlreadyBelongsToSupplierError = Error & {
  __typename?: 'UserAlreadyBelongsToSupplierError';
  message: Scalars['String']['output'];
};

export type UserAvatar = {
  __typename?: 'UserAvatar';
  canNotLoad: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type UserContactView = {
  __typename?: 'UserContactView';
  email?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type UserNotFoundError = Error & {
  __typename?: 'UserNotFoundError';
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
};

export type UserOperations = {
  __typename?: 'UserOperations';
  delete: OperationStatus;
};

export type UserProfileDtoInput = {
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type UserProfileView = {
  __typename?: 'UserProfileView';
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  userAvatar: UserAvatar;
};

export type UserRegistration = {
  __typename?: 'UserRegistration';
  questionnaire?: Maybe<SupplierQuestionnaireView>;
  status: UserRegistrationStatus;
};

export enum UserRegistrationStatus {
  Declined = 'DECLINED',
  OnApproval = 'ON_APPROVAL'
}

export type UserView = {
  __typename?: 'UserView';
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  profile: UserProfileView;
  role?: Maybe<Role>;
  userName: Scalars['String']['output'];
};

export type UserViewBase = {
  __typename?: 'UserViewBase';
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  role?: Maybe<Role>;
  userName: Scalars['String']['output'];
};

type Error_AccessRequestInvalidStatusError_Fragment = { __typename: 'AccessRequestInvalidStatusError', message: string };

type Error_AccessRequestNotFoundError_Fragment = { __typename: 'AccessRequestNotFoundError', message: string };

type Error_AccommodationObjectNotFoundError_Fragment = { __typename: 'AccommodationObjectNotFoundError', message: string };

type Error_ChangeUserRoleToSupportForbiddenError_Fragment = { __typename: 'ChangeUserRoleToSupportForbiddenError', message: string };

type Error_ChannelManagerAdditionalMappingRequiredError_Fragment = { __typename: 'ChannelManagerAdditionalMappingRequiredError', message: string };

type Error_ChannelManagerInteractionInvalidStateError_Fragment = { __typename: 'ChannelManagerInteractionInvalidStateError', message: string };

type Error_ChannelManagerInteractionNotFoundError_Fragment = { __typename: 'ChannelManagerInteractionNotFoundError', message: string };

type Error_ChannelManagerInvalidContractNumberError_Fragment = { __typename: 'ChannelManagerInvalidContractNumberError', message: string };

type Error_ChannelManagerMasterInvalidOperationError_Fragment = { __typename: 'ChannelManagerMasterInvalidOperationError', message: string };

type Error_ChannelManagerReverseMasterInvalidOperationError_Fragment = { __typename: 'ChannelManagerReverseMasterInvalidOperationError', message: string };

type Error_ConcurrencyConflictError_Fragment = { __typename: 'ConcurrencyConflictError', message: string };

type Error_ContentServiceQuestionnaireAlreadyCreatedError_Fragment = { __typename: 'ContentServiceQuestionnaireAlreadyCreatedError', message: string };

type Error_ContentServiceQuestionnaireCancelNotEditedError_Fragment = { __typename: 'ContentServiceQuestionnaireCancelNotEditedError', message: string };

type Error_ContentServiceQuestionnaireEditingForbiddenError_Fragment = { __typename: 'ContentServiceQuestionnaireEditingForbiddenError', message: string };

type Error_ContentServiceQuestionnaireNotFinishedError_Fragment = { __typename: 'ContentServiceQuestionnaireNotFinishedError', message: string };

type Error_ContentServiceQuestionnaireNotFoundError_Fragment = { __typename: 'ContentServiceQuestionnaireNotFoundError', message: string };

type Error_ContractNotFoundError_Fragment = { __typename: 'ContractNotFoundError', message: string };

type Error_ContractStatusInappropriateForQuotaChangeError_Fragment = { __typename: 'ContractStatusInappropriateForQuotaChangeError', message: string };

type Error_CurrencyListNotFoundError_Fragment = { __typename: 'CurrencyListNotFoundError', message: string };

type Error_CurrencyNotFoundError_Fragment = { __typename: 'CurrencyNotFoundError', message: string };

type Error_DeletingOwnerError_Fragment = { __typename: 'DeletingOwnerError', message: string };

type Error_DocumentNotFoundError_Fragment = { __typename: 'DocumentNotFoundError', message: string };

type Error_HotelCategoryNotFoundError_Fragment = { __typename: 'HotelCategoryNotFoundError', message: string };

type Error_HotelMaxOnApprovalConflictError_Fragment = { __typename: 'HotelMaxOnApprovalConflictError', message: string };

type Error_HotelSetHasRemoteIntegrationForbiddenError_Fragment = { __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string };

type Error_HotelSetNotFoundError_Fragment = { __typename: 'HotelSetNotFoundError', message: string };

type Error_HotelTypeNotFoundError_Fragment = { __typename: 'HotelTypeNotFoundError', message: string };

type Error_IncorrectQuotaChangeOperationError_Fragment = { __typename: 'IncorrectQuotaChangeOperationError', message: string };

type Error_InvalidContractNumberError_Fragment = { __typename: 'InvalidContractNumberError', message: string };

type Error_InvitationNotFoundError_Fragment = { __typename: 'InvitationNotFoundError', message: string };

type Error_LegalExtranetAreaConflictError_Fragment = { __typename: 'LegalExtranetAreaConflictError', message: string };

type Error_LegalMaxOnApprovalConflictError_Fragment = { __typename: 'LegalMaxOnApprovalConflictError', message: string };

type Error_LegalNotFoundError_Fragment = { __typename: 'LegalNotFoundError', message: string };

type Error_LegalSaveEdiTypeError_Fragment = { __typename: 'LegalSaveEDITypeError', message: string };

type Error_LegalTinAndKppConflictError_Fragment = { __typename: 'LegalTINAndKPPConflictError', message: string };

type Error_LockResourceFailedError_Fragment = { __typename: 'LockResourceFailedError', message: string };

type Error_NoRoomCategoriesInAccomodationObjectError_Fragment = { __typename: 'NoRoomCategoriesInAccomodationObjectError', message: string };

type Error_OperationForbiddenError_Fragment = { __typename: 'OperationForbiddenError', message: string };

type Error_OperationOnUnlockedResourceIsInvalidError_Fragment = { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string };

type Error_OrderAccommodationHasBegunError_Fragment = { __typename: 'OrderAccommodationHasBegunError', message: string };

type Error_OrderHasNonStandardError_Fragment = { __typename: 'OrderHasNonStandardError', message: string };

type Error_OrderIsAvoidedError_Fragment = { __typename: 'OrderIsAvoidedError', message: string };

type Error_OrderIsConfirmedError_Fragment = { __typename: 'OrderIsConfirmedError', message: string };

type Error_OrderIsNotConfirmedError_Fragment = { __typename: 'OrderIsNotConfirmedError', message: string };

type Error_OrderIsRemoteError_Fragment = { __typename: 'OrderIsRemoteError', message: string };

type Error_OrderNotFoundError_Fragment = { __typename: 'OrderNotFoundError', message: string };

type Error_OrderReconciliationPeriodNotAvailableForReconciliationError_Fragment = { __typename: 'OrderReconciliationPeriodNotAvailableForReconciliationError', message: string };

type Error_OrderSendToSupplierRemoteInteractError_Fragment = { __typename: 'OrderSendToSupplierRemoteInteractError', message: string };

type Error_OutOfContractPeriodError_Fragment = { __typename: 'OutOfContractPeriodError', message: string };

type Error_PenaltySchemeNotFoundError_Fragment = { __typename: 'PenaltySchemeNotFoundError', message: string };

type Error_PlacingVariantsNotBelongsToTariffScheduleError_Fragment = { __typename: 'PlacingVariantsNotBelongsToTariffScheduleError', message: string };

type Error_QuotaNotFilledError_Fragment = { __typename: 'QuotaNotFilledError', message: string };

type Error_QuotaNotFoundError_Fragment = { __typename: 'QuotaNotFoundError', message: string };

type Error_QuotaOperationPeriodNotWithinContractPeriodError_Fragment = { __typename: 'QuotaOperationPeriodNotWithinContractPeriodError', message: string };

type Error_QuotaPricesRequiredError_Fragment = { __typename: 'QuotaPricesRequiredError', message: string };

type Error_RestrictionDefaultConflictError_Fragment = { __typename: 'RestrictionDefaultConflictError', message: string };

type Error_RestrictionNextDayCheckoutOverrideForbiddenError_Fragment = { __typename: 'RestrictionNextDayCheckoutOverrideForbiddenError', message: string };

type Error_RestrictionNoChangeConflictError_Fragment = { __typename: 'RestrictionNoChangeConflictError', message: string };

type Error_RestrictionNotFoundError_Fragment = { __typename: 'RestrictionNotFoundError', message: string };

type Error_RestrictionPeriodOverlapConflictError_Fragment = { __typename: 'RestrictionPeriodOverlapConflictError', message: string };

type Error_RestrictionPeriodOverrideForbiddenError_Fragment = { __typename: 'RestrictionPeriodOverrideForbiddenError', message: string };

type Error_RestrictionTariffSchedulePeriodConflictError_Fragment = { __typename: 'RestrictionTariffSchedulePeriodConflictError', message: string };

type Error_RoomCategoriesCannotDeleteError_Fragment = { __typename: 'RoomCategoriesCannotDeleteError', message: string };

type Error_RoomCategoriesEmptyError_Fragment = { __typename: 'RoomCategoriesEmptyError', message: string };

type Error_RoomCategoriesForAddingNotFoundError_Fragment = { __typename: 'RoomCategoriesForAddingNotFoundError', message: string };

type Error_RoomCategoriesNotBelongsToQuotaError_Fragment = { __typename: 'RoomCategoriesNotBelongsToQuotaError', message: string };

type Error_RoomCategoriesNotBelongsToTariffScheduleError_Fragment = { __typename: 'RoomCategoriesNotBelongsToTariffScheduleError', message: string };

type Error_RoomCategoryListNotFoundError_Fragment = { __typename: 'RoomCategoryListNotFoundError', message: string };

type Error_RoomCategoryNotBelongsToTariffScheduleError_Fragment = { __typename: 'RoomCategoryNotBelongsToTariffScheduleError', message: string };

type Error_RoomCategoryNotFoundError_Fragment = { __typename: 'RoomCategoryNotFoundError', message: string };

type Error_RoomCategoryUpdateChangeError_Fragment = { __typename: 'RoomCategoryUpdateChangeError', message: string };

type Error_RoomPlacingListNotFoundError_Fragment = { __typename: 'RoomPlacingListNotFoundError', message: string };

type Error_RoomTypeNotFoundError_Fragment = { __typename: 'RoomTypeNotFoundError', message: string };

type Error_SelfDeleteError_Fragment = { __typename: 'SelfDeleteError', message: string };

type Error_SelfSetRoleError_Fragment = { __typename: 'SelfSetRoleError', message: string };

type Error_ServiceGroupListNotBelongsToTariffScheduleError_Fragment = { __typename: 'ServiceGroupListNotBelongsToTariffScheduleError', message: string };

type Error_ServiceGroupListNotFoundError_Fragment = { __typename: 'ServiceGroupListNotFoundError', message: string };

type Error_ServiceGroupNotFoundError_Fragment = { __typename: 'ServiceGroupNotFoundError', message: string };

type Error_ServiceGroupsNotBelongsToTariffScheduleError_Fragment = { __typename: 'ServiceGroupsNotBelongsToTariffScheduleError', message: string };

type Error_ServiceNotFoundError_Fragment = { __typename: 'ServiceNotFoundError', message: string };

type Error_ServiceTooOldToDeleteError_Fragment = { __typename: 'ServiceTooOldToDeleteError', message: string };

type Error_ServiceTypeNotFoundError_Fragment = { __typename: 'ServiceTypeNotFoundError', message: string };

type Error_ServicesNotAllowedForServiceGroupError_Fragment = { __typename: 'ServicesNotAllowedForServiceGroupError', message: string };

type Error_SetRoleOwnerError_Fragment = { __typename: 'SetRoleOwnerError', message: string };

type Error_SupplierPayRuleNotFoundError_Fragment = { __typename: 'SupplierPayRuleNotFoundError', message: string };

type Error_SupplierQuestionnaireNotUpdatedError_Fragment = { __typename: 'SupplierQuestionnaireNotUpdatedError', message: string };

type Error_SupportRoleChangeForbiddenError_Fragment = { __typename: 'SupportRoleChangeForbiddenError', message: string };

type Error_TariffScheduleAlreadyInWorkError_Fragment = { __typename: 'TariffScheduleAlreadyInWorkError', message: string };

type Error_TariffScheduleGridPeriodConflictBasePeriodError_Fragment = { __typename: 'TariffScheduleGridPeriodConflictBasePeriodError', message: string };

type Error_TariffScheduleMultipleVisitTimetableForbiddenError_Fragment = { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string };

type Error_TariffScheduleNotFoundError_Fragment = { __typename: 'TariffScheduleNotFoundError', message: string };

type Error_TariffScheduleOutOfContractPeriodError_Fragment = { __typename: 'TariffScheduleOutOfContractPeriodError', message: string };

type Error_TariffScheduleServiceGroupMaxNumberExceedError_Fragment = { __typename: 'TariffScheduleServiceGroupMaxNumberExceedError', message: string };

type Error_TariffScheduleServiceGroupMutuallyExclusiveCidsFoundError_Fragment = { __typename: 'TariffScheduleServiceGroupMutuallyExclusiveCidsFoundError', message: string };

type Error_TaxSchemeNotFoundError_Fragment = { __typename: 'TaxSchemeNotFoundError', message: string };

type Error_TouristTypeListNotFoundError_Fragment = { __typename: 'TouristTypeListNotFoundError', message: string };

type Error_TouristTypesNotBelongsToTariffScheduleError_Fragment = { __typename: 'TouristTypesNotBelongsToTariffScheduleError', message: string };

type Error_TownNotFoundError_Fragment = { __typename: 'TownNotFoundError', message: string };

type Error_TravelLineCanNotCahengeExternalObjectMappingError_Fragment = { __typename: 'TravelLineCanNotCahengeExternalObjectMappingError', message: string };

type Error_TravelLineExternalIntegrationIssueError_Fragment = { __typename: 'TravelLineExternalIntegrationIssueError', message: string };

type Error_TravelLineFulfillmentErrorError_Fragment = { __typename: 'TravelLineFulfillmentErrorError', message: string };

type Error_TravelLineHotelNotFoundError_Fragment = { __typename: 'TravelLineHotelNotFoundError', message: string };

type Error_TravelLineInitialAgeExceedError_Fragment = { __typename: 'TravelLineInitialAgeExceedError', message: string };

type Error_TravelLineInitialAgeOverrideError_Fragment = { __typename: 'TravelLineInitialAgeOverrideError', message: string };

type Error_TravelLinePlacingVariantExceedsRoomCategoryCapacityError_Fragment = { __typename: 'TravelLinePlacingVariantExceedsRoomCategoryCapacityError', message: string };

type Error_TravelLinePlacingVariantsNotFulfilledError_Fragment = { __typename: 'TravelLinePlacingVariantsNotFulfilledError', message: string };

type Error_TravelLineTouristTypesHasGapsError_Fragment = { __typename: 'TravelLineTouristTypesHasGapsError', message: string };

type Error_UserAlreadyBelongsToSupplierError_Fragment = { __typename: 'UserAlreadyBelongsToSupplierError', message: string };

type Error_UserNotFoundError_Fragment = { __typename: 'UserNotFoundError', message: string };

export type ErrorFragment = Error_AccessRequestInvalidStatusError_Fragment | Error_AccessRequestNotFoundError_Fragment | Error_AccommodationObjectNotFoundError_Fragment | Error_ChangeUserRoleToSupportForbiddenError_Fragment | Error_ChannelManagerAdditionalMappingRequiredError_Fragment | Error_ChannelManagerInteractionInvalidStateError_Fragment | Error_ChannelManagerInteractionNotFoundError_Fragment | Error_ChannelManagerInvalidContractNumberError_Fragment | Error_ChannelManagerMasterInvalidOperationError_Fragment | Error_ChannelManagerReverseMasterInvalidOperationError_Fragment | Error_ConcurrencyConflictError_Fragment | Error_ContentServiceQuestionnaireAlreadyCreatedError_Fragment | Error_ContentServiceQuestionnaireCancelNotEditedError_Fragment | Error_ContentServiceQuestionnaireEditingForbiddenError_Fragment | Error_ContentServiceQuestionnaireNotFinishedError_Fragment | Error_ContentServiceQuestionnaireNotFoundError_Fragment | Error_ContractNotFoundError_Fragment | Error_ContractStatusInappropriateForQuotaChangeError_Fragment | Error_CurrencyListNotFoundError_Fragment | Error_CurrencyNotFoundError_Fragment | Error_DeletingOwnerError_Fragment | Error_DocumentNotFoundError_Fragment | Error_HotelCategoryNotFoundError_Fragment | Error_HotelMaxOnApprovalConflictError_Fragment | Error_HotelSetHasRemoteIntegrationForbiddenError_Fragment | Error_HotelSetNotFoundError_Fragment | Error_HotelTypeNotFoundError_Fragment | Error_IncorrectQuotaChangeOperationError_Fragment | Error_InvalidContractNumberError_Fragment | Error_InvitationNotFoundError_Fragment | Error_LegalExtranetAreaConflictError_Fragment | Error_LegalMaxOnApprovalConflictError_Fragment | Error_LegalNotFoundError_Fragment | Error_LegalSaveEdiTypeError_Fragment | Error_LegalTinAndKppConflictError_Fragment | Error_LockResourceFailedError_Fragment | Error_NoRoomCategoriesInAccomodationObjectError_Fragment | Error_OperationForbiddenError_Fragment | Error_OperationOnUnlockedResourceIsInvalidError_Fragment | Error_OrderAccommodationHasBegunError_Fragment | Error_OrderHasNonStandardError_Fragment | Error_OrderIsAvoidedError_Fragment | Error_OrderIsConfirmedError_Fragment | Error_OrderIsNotConfirmedError_Fragment | Error_OrderIsRemoteError_Fragment | Error_OrderNotFoundError_Fragment | Error_OrderReconciliationPeriodNotAvailableForReconciliationError_Fragment | Error_OrderSendToSupplierRemoteInteractError_Fragment | Error_OutOfContractPeriodError_Fragment | Error_PenaltySchemeNotFoundError_Fragment | Error_PlacingVariantsNotBelongsToTariffScheduleError_Fragment | Error_QuotaNotFilledError_Fragment | Error_QuotaNotFoundError_Fragment | Error_QuotaOperationPeriodNotWithinContractPeriodError_Fragment | Error_QuotaPricesRequiredError_Fragment | Error_RestrictionDefaultConflictError_Fragment | Error_RestrictionNextDayCheckoutOverrideForbiddenError_Fragment | Error_RestrictionNoChangeConflictError_Fragment | Error_RestrictionNotFoundError_Fragment | Error_RestrictionPeriodOverlapConflictError_Fragment | Error_RestrictionPeriodOverrideForbiddenError_Fragment | Error_RestrictionTariffSchedulePeriodConflictError_Fragment | Error_RoomCategoriesCannotDeleteError_Fragment | Error_RoomCategoriesEmptyError_Fragment | Error_RoomCategoriesForAddingNotFoundError_Fragment | Error_RoomCategoriesNotBelongsToQuotaError_Fragment | Error_RoomCategoriesNotBelongsToTariffScheduleError_Fragment | Error_RoomCategoryListNotFoundError_Fragment | Error_RoomCategoryNotBelongsToTariffScheduleError_Fragment | Error_RoomCategoryNotFoundError_Fragment | Error_RoomCategoryUpdateChangeError_Fragment | Error_RoomPlacingListNotFoundError_Fragment | Error_RoomTypeNotFoundError_Fragment | Error_SelfDeleteError_Fragment | Error_SelfSetRoleError_Fragment | Error_ServiceGroupListNotBelongsToTariffScheduleError_Fragment | Error_ServiceGroupListNotFoundError_Fragment | Error_ServiceGroupNotFoundError_Fragment | Error_ServiceGroupsNotBelongsToTariffScheduleError_Fragment | Error_ServiceNotFoundError_Fragment | Error_ServiceTooOldToDeleteError_Fragment | Error_ServiceTypeNotFoundError_Fragment | Error_ServicesNotAllowedForServiceGroupError_Fragment | Error_SetRoleOwnerError_Fragment | Error_SupplierPayRuleNotFoundError_Fragment | Error_SupplierQuestionnaireNotUpdatedError_Fragment | Error_SupportRoleChangeForbiddenError_Fragment | Error_TariffScheduleAlreadyInWorkError_Fragment | Error_TariffScheduleGridPeriodConflictBasePeriodError_Fragment | Error_TariffScheduleMultipleVisitTimetableForbiddenError_Fragment | Error_TariffScheduleNotFoundError_Fragment | Error_TariffScheduleOutOfContractPeriodError_Fragment | Error_TariffScheduleServiceGroupMaxNumberExceedError_Fragment | Error_TariffScheduleServiceGroupMutuallyExclusiveCidsFoundError_Fragment | Error_TaxSchemeNotFoundError_Fragment | Error_TouristTypeListNotFoundError_Fragment | Error_TouristTypesNotBelongsToTariffScheduleError_Fragment | Error_TownNotFoundError_Fragment | Error_TravelLineCanNotCahengeExternalObjectMappingError_Fragment | Error_TravelLineExternalIntegrationIssueError_Fragment | Error_TravelLineFulfillmentErrorError_Fragment | Error_TravelLineHotelNotFoundError_Fragment | Error_TravelLineInitialAgeExceedError_Fragment | Error_TravelLineInitialAgeOverrideError_Fragment | Error_TravelLinePlacingVariantExceedsRoomCategoryCapacityError_Fragment | Error_TravelLinePlacingVariantsNotFulfilledError_Fragment | Error_TravelLineTouristTypesHasGapsError_Fragment | Error_UserAlreadyBelongsToSupplierError_Fragment | Error_UserNotFoundError_Fragment;

export type LangFieldFragment = { __typename?: 'LangString', langCode: string, value: string };

export type LockResourceErrorFragment = { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } };

export type TownSuggestionQueryVariables = Exact<{
  key: Scalars['String']['input'];
  maxResults: Scalars['Int']['input'];
}>;


export type TownSuggestionQuery = { __typename?: 'Query', townSuggestions: Array<{ __typename?: 'TownSuggestion', cid: string, toponymsPath: Array<string> }> };

export type CurrencyListQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrencyListQuery = { __typename?: 'Query', currencyList: Array<{ __typename?: 'Currency', currencyISOCode: string, isActive: boolean, name: string }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'MeView', id: any, hasSupplier: boolean, hasProfile: boolean, hasKsbAccount: boolean, email: string, role?: Role | null, isOwner: boolean, supplierCode?: string | null, permissions: Array<PermissionTarget>, userRegistration?: { __typename?: 'UserRegistration', status: UserRegistrationStatus, questionnaire?: { __typename?: 'SupplierQuestionnaireView', legalOrigin: LegalOrigin, legal: { __typename?: 'LegalDataView', name?: string | null, address?: string | null, townName?: string | null, isNotTaxPayer: boolean, nameML?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, details: { __typename?: 'LegalDetails', tin: string, kpp?: string | null, ogrn?: string | null }, addressML?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null }, accommodationObject: { __typename?: 'SupplierQuestionnaireAccommodationObject', name?: string | null, nameML?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, type: { __typename?: 'AccommodationObjectType', cid: string, name: string }, addressData: { __typename?: 'AddressData', townName?: string | null, address?: string | null, addressML?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null } }, contact: { __typename?: 'SupplierQuestionnaireContact', phone: string, email: string, webSite?: string | null } } | null } | null, profile?: { __typename?: 'UserProfileView', lastName: string, middleName?: string | null, name: string, phoneNumber: string, userAvatar: { __typename?: 'UserAvatar', url?: string | null, canNotLoad: boolean } } | null } };

export type UpdateUserProfileMutationVariables = Exact<{
  middleName?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'UpdateUserProfilePayload', user?: { __typename?: 'UserView', id: any } | null, errors?: Array<{ __typename: 'UserNotFoundError', message: string }> | null } };

export type IsLegalFreeQueryVariables = Exact<{
  tin: Scalars['String']['input'];
}>;


export type IsLegalFreeQuery = { __typename?: 'Query', isLegalFree: boolean };

export type JoinToSupplierMutationVariables = Exact<{
  inviteCode: Scalars['String']['input'];
}>;


export type JoinToSupplierMutation = { __typename?: 'Mutation', joinToSupplier: { __typename?: 'JoinToSupplierPayload', status?: JoinToSupplierStatus | null, errors?: Array<{ __typename: 'UserAlreadyBelongsToSupplierError', message: string }> | null } };

export type SendSupplierQuestionnaireMutationVariables = Exact<{
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameML?: InputMaybe<Array<LangStringInput> | LangStringInput>;
  kpp?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  tin: Scalars['String']['input'];
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  legalAddressML?: InputMaybe<Array<LangStringInput> | LangStringInput>;
  legalTownName?: InputMaybe<Scalars['String']['input']>;
  objectName?: InputMaybe<Scalars['String']['input']>;
  objectNameML?: InputMaybe<Array<LangStringInput> | LangStringInput>;
  objectTypeName: Scalars['String']['input'];
  objectTypeCid: Scalars['String']['input'];
  objectAddress?: InputMaybe<Scalars['String']['input']>;
  objectAddressML?: InputMaybe<Array<LangStringInput> | LangStringInput>;
  objectTownName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  email: Scalars['String']['input'];
  webSite?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
  isNew: Scalars['Boolean']['input'];
  isNotTaxPayer: Scalars['Boolean']['input'];
  legalOrigin: LegalOrigin;
}>;


export type SendSupplierQuestionnaireMutation = { __typename?: 'Mutation', sendSupplierQuestionnaire: { __typename?: 'SendSupplierQuestionnairePayload', SupplierCode?: string | null, errors?: Array<{ __typename: 'UserNotFoundError', message: string }> | null } };

export type UpdateSupplierQuestionnaireMutationVariables = Exact<{
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameML?: InputMaybe<Array<LangStringInput> | LangStringInput>;
  kpp?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  tin: Scalars['String']['input'];
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  legalAddressML?: InputMaybe<Array<LangStringInput> | LangStringInput>;
  legalTownName?: InputMaybe<Scalars['String']['input']>;
  objectName?: InputMaybe<Scalars['String']['input']>;
  objectNameML?: InputMaybe<Array<LangStringInput> | LangStringInput>;
  objectTypeName: Scalars['String']['input'];
  objectTypeCid: Scalars['String']['input'];
  objectAddress?: InputMaybe<Scalars['String']['input']>;
  objectAddressML?: InputMaybe<Array<LangStringInput> | LangStringInput>;
  objectTownName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  email: Scalars['String']['input'];
  webSite?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
  isNew: Scalars['Boolean']['input'];
  isNotTaxPayer: Scalars['Boolean']['input'];
  legalOrigin: LegalOrigin;
}>;


export type UpdateSupplierQuestionnaireMutation = { __typename?: 'Mutation', updateSupplierQuestionnaire: { __typename?: 'UpdateSupplierQuestionnairePayload', status?: string | null, errors?: Array<{ __typename: 'SupplierQuestionnaireNotUpdatedError', message: string }> | null } };

export type CreateSupplierMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSupplierMutation = { __typename?: 'Mutation', createSupplier: { __typename?: 'CreateSupplierPayload', SupplierCode?: string | null } };

export type RegisterKsbAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type RegisterKsbAccountMutation = { __typename?: 'Mutation', registerKsbAccount: { __typename?: 'RegisterKsbAccountPayload', status?: string | null } };

export type OrderInfoFragment = { __typename?: 'OrderView', accommodation: { __typename?: 'OrderAccommodation', cost?: any | null, currencyISOCode: string, daysCount: number, hasAccommodationWithoutPacket: boolean, hasUnavoidedInvoice: boolean, accommodationHasBegun: boolean, roomCount: number, specConditions?: string | null, orderWishes?: string | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, commonInfo: { __typename?: 'OrderCommonInfo', contractNumber: number, hotelName: string, orderDate: any, quotaShortName: string, remoteInteract: boolean, roomCategoryName: string }, operations: { __typename?: 'OrderOperations', avoid: OperationStatus, confirm: OperationStatus, sendToSupplier: OperationStatus }, orderInfo: { __typename?: 'OrderInfo', id: number, number: number, status: OrderStatus, subNumber: number, sentToSupplier: boolean, hasNonStandard: boolean }, rooms: Array<{ __typename?: 'OrderRoom', nonStandard: boolean, pricePerRoom: boolean, roomPlacingCid?: string | null, roomPlacingName: string, status: OrderStatus, summaryAccommodationCost?: any | null, summaryServiceCost?: any | null, places: Array<{ __typename?: 'OrderRoomPlace', cost?: any | null, placeType: PlaceType, status: OrderStatus, touristName: string, touristType: string, packets: Array<{ __typename?: 'OrderRoomPacket', cost?: any | null, packetName: string, status: OrderStatus, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, services: Array<{ __typename?: 'OrderRoomService', amount: number, cost?: any | null, serviceMethod: string, serviceName: string, status: OrderStatus, touristName?: string | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }> };

export type QuotaOrderQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type QuotaOrderQuery = { __typename?: 'Query', quotaOrder: { __typename?: 'OrderView', accommodation: { __typename?: 'OrderAccommodation', cost?: any | null, currencyISOCode: string, daysCount: number, hasAccommodationWithoutPacket: boolean, hasUnavoidedInvoice: boolean, accommodationHasBegun: boolean, roomCount: number, specConditions?: string | null, orderWishes?: string | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, commonInfo: { __typename?: 'OrderCommonInfo', contractNumber: number, hotelName: string, orderDate: any, quotaShortName: string, remoteInteract: boolean, roomCategoryName: string }, operations: { __typename?: 'OrderOperations', avoid: OperationStatus, confirm: OperationStatus, sendToSupplier: OperationStatus }, orderInfo: { __typename?: 'OrderInfo', id: number, number: number, status: OrderStatus, subNumber: number, sentToSupplier: boolean, hasNonStandard: boolean }, rooms: Array<{ __typename?: 'OrderRoom', nonStandard: boolean, pricePerRoom: boolean, roomPlacingCid?: string | null, roomPlacingName: string, status: OrderStatus, summaryAccommodationCost?: any | null, summaryServiceCost?: any | null, places: Array<{ __typename?: 'OrderRoomPlace', cost?: any | null, placeType: PlaceType, status: OrderStatus, touristName: string, touristType: string, packets: Array<{ __typename?: 'OrderRoomPacket', cost?: any | null, packetName: string, status: OrderStatus, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, services: Array<{ __typename?: 'OrderRoomService', amount: number, cost?: any | null, serviceMethod: string, serviceName: string, status: OrderStatus, touristName?: string | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }> } };

export type QuotaOrdersQueryVariables = Exact<{
  accommodationObjectCid?: InputMaybe<Scalars['String']['input']>;
  dateFrom: Scalars['Date']['input'];
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  contractNumber?: InputMaybe<Scalars['Int']['input']>;
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
}>;


export type QuotaOrdersQuery = { __typename?: 'Query', quotaOrders: Array<{ __typename?: 'OrderItemView', orderId: number, orderNumber: number, subOrderNumber: number, orderDate: any, status: OrderStatus, sentToSupplier: boolean, roomCategory: { __typename?: 'RoomCategoryView', cid: string, shortName: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, tourists: Array<{ __typename?: 'OrderTourist', name: string, touristType: string, placeType: PlaceType }> }> };

export type AvoidOrderMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type AvoidOrderMutation = { __typename?: 'Mutation', avoidOrder: { __typename?: 'AvoidOrderPayload', order?: { __typename?: 'OrderView', accommodation: { __typename?: 'OrderAccommodation', cost?: any | null, currencyISOCode: string, daysCount: number, hasAccommodationWithoutPacket: boolean, hasUnavoidedInvoice: boolean, accommodationHasBegun: boolean, roomCount: number, specConditions?: string | null, orderWishes?: string | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, commonInfo: { __typename?: 'OrderCommonInfo', contractNumber: number, hotelName: string, orderDate: any, quotaShortName: string, remoteInteract: boolean, roomCategoryName: string }, operations: { __typename?: 'OrderOperations', avoid: OperationStatus, confirm: OperationStatus, sendToSupplier: OperationStatus }, orderInfo: { __typename?: 'OrderInfo', id: number, number: number, status: OrderStatus, subNumber: number, sentToSupplier: boolean, hasNonStandard: boolean }, rooms: Array<{ __typename?: 'OrderRoom', nonStandard: boolean, pricePerRoom: boolean, roomPlacingCid?: string | null, roomPlacingName: string, status: OrderStatus, summaryAccommodationCost?: any | null, summaryServiceCost?: any | null, places: Array<{ __typename?: 'OrderRoomPlace', cost?: any | null, placeType: PlaceType, status: OrderStatus, touristName: string, touristType: string, packets: Array<{ __typename?: 'OrderRoomPacket', cost?: any | null, packetName: string, status: OrderStatus, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, services: Array<{ __typename?: 'OrderRoomService', amount: number, cost?: any | null, serviceMethod: string, serviceName: string, status: OrderStatus, touristName?: string | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }> } | null, errors?: Array<{ __typename: 'LockResourceFailedError', message: string } | { __typename: 'OrderAccommodationHasBegunError', message: string } | { __typename: 'OrderHasNonStandardError', message: string } | { __typename: 'OrderIsConfirmedError', message: string } | { __typename: 'OrderIsRemoteError', message: string } | { __typename: 'OrderNotFoundError', message: string }> | null } };

export type ConfirmOrderMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type ConfirmOrderMutation = { __typename?: 'Mutation', confirmOrder: { __typename?: 'ConfirmOrderPayload', order?: { __typename?: 'OrderView', accommodation: { __typename?: 'OrderAccommodation', cost?: any | null, currencyISOCode: string, daysCount: number, hasAccommodationWithoutPacket: boolean, hasUnavoidedInvoice: boolean, accommodationHasBegun: boolean, roomCount: number, specConditions?: string | null, orderWishes?: string | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, commonInfo: { __typename?: 'OrderCommonInfo', contractNumber: number, hotelName: string, orderDate: any, quotaShortName: string, remoteInteract: boolean, roomCategoryName: string }, operations: { __typename?: 'OrderOperations', avoid: OperationStatus, confirm: OperationStatus, sendToSupplier: OperationStatus }, orderInfo: { __typename?: 'OrderInfo', id: number, number: number, status: OrderStatus, subNumber: number, sentToSupplier: boolean, hasNonStandard: boolean }, rooms: Array<{ __typename?: 'OrderRoom', nonStandard: boolean, pricePerRoom: boolean, roomPlacingCid?: string | null, roomPlacingName: string, status: OrderStatus, summaryAccommodationCost?: any | null, summaryServiceCost?: any | null, places: Array<{ __typename?: 'OrderRoomPlace', cost?: any | null, placeType: PlaceType, status: OrderStatus, touristName: string, touristType: string, packets: Array<{ __typename?: 'OrderRoomPacket', cost?: any | null, packetName: string, status: OrderStatus, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, services: Array<{ __typename?: 'OrderRoomService', amount: number, cost?: any | null, serviceMethod: string, serviceName: string, status: OrderStatus, touristName?: string | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }> } | null, errors?: Array<{ __typename: 'LockResourceFailedError', message: string } | { __typename: 'OrderAccommodationHasBegunError', message: string } | { __typename: 'OrderHasNonStandardError', message: string } | { __typename: 'OrderIsAvoidedError', message: string } | { __typename: 'OrderIsRemoteError', message: string } | { __typename: 'OrderNotFoundError', message: string }> | null } };

export type SendOrderToSupplierMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type SendOrderToSupplierMutation = { __typename?: 'Mutation', sendOrderToSupplier: { __typename?: 'SendOrderToSupplierPayload', order?: { __typename?: 'OrderView', accommodation: { __typename?: 'OrderAccommodation', cost?: any | null, currencyISOCode: string, daysCount: number, hasAccommodationWithoutPacket: boolean, hasUnavoidedInvoice: boolean, accommodationHasBegun: boolean, roomCount: number, specConditions?: string | null, orderWishes?: string | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, commonInfo: { __typename?: 'OrderCommonInfo', contractNumber: number, hotelName: string, orderDate: any, quotaShortName: string, remoteInteract: boolean, roomCategoryName: string }, operations: { __typename?: 'OrderOperations', avoid: OperationStatus, confirm: OperationStatus, sendToSupplier: OperationStatus }, orderInfo: { __typename?: 'OrderInfo', id: number, number: number, status: OrderStatus, subNumber: number, sentToSupplier: boolean, hasNonStandard: boolean }, rooms: Array<{ __typename?: 'OrderRoom', nonStandard: boolean, pricePerRoom: boolean, roomPlacingCid?: string | null, roomPlacingName: string, status: OrderStatus, summaryAccommodationCost?: any | null, summaryServiceCost?: any | null, places: Array<{ __typename?: 'OrderRoomPlace', cost?: any | null, placeType: PlaceType, status: OrderStatus, touristName: string, touristType: string, packets: Array<{ __typename?: 'OrderRoomPacket', cost?: any | null, packetName: string, status: OrderStatus, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, services: Array<{ __typename?: 'OrderRoomService', amount: number, cost?: any | null, serviceMethod: string, serviceName: string, status: OrderStatus, touristName?: string | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }> } | null, errors?: Array<{ __typename: 'LockResourceFailedError', message: string } | { __typename: 'OrderIsNotConfirmedError', message: string } | { __typename: 'OrderNotFoundError', message: string } | { __typename: 'OrderSendToSupplierRemoteInteractError', message: string }> | null } };

export type ContentServiceDictionariesQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentServiceDictionariesQuery = { __typename?: 'Query', contentServiceDictionaries: { __typename?: 'ContentServiceDictionaries', commonInformation: { __typename?: 'CommonInformationDictionaries', hotelChains: Array<string>, resortTypes: Array<string>, checkinDocuments: { __typename?: 'CheckinDocumentDictionaries', adultDocuments: Array<{ __typename?: 'CheckinDocumentGroup', groupName: string, documents: Array<string> }>, childrenDocuments: Array<{ __typename?: 'CheckinDocumentGroup', groupName: string, documents: Array<string> }>, foreignerDocuments: Array<{ __typename?: 'CheckinDocumentGroup', groupName: string, documents: Array<string> }> } }, rooms: { __typename?: 'RoomsDictionaries', roomNumbers: Array<string>, extrabedTypes: Array<string>, balconyTypes: Array<string>, equipment: Array<string>, furniture: Array<string>, bathroomTypes: Array<string>, bathroomEquipment: Array<string>, services: Array<string>, views: Array<string> }, equipment: { __typename?: 'EquipmentDictionaries', anotherInfrastructure: Array<string>, beachEntertainments: Array<string>, beachEquipment: Array<string>, beachTypes: Array<string>, beautyInfrastructure: Array<string>, childrenInfrastructure: Array<string>, childrenPools: Array<string>, disabilityInfrastructure: Array<string>, indoorAreas: Array<string>, openWinterPlaygrounds: Array<string>, outdoorAreas: Array<string>, paidBeachEquipment: Array<string>, parkingTypes: Array<string>, poolCharacteristics: Array<string>, saunaPay: Array<string>, saunaTypes: Array<string>, skiResorts: Array<string> }, nutrition: { __typename?: 'NutritionDictionaries', childrenNutrition: Array<string>, cuisine: Array<string>, foodObjectType: Array<string> }, servicesAndEntertainment: { __typename?: 'ServicesAndEntertainmentDictionaries', animations: Array<string>, childrenEntertainments: Array<string>, childrenEquipmentRental: Array<string>, childrenServices: Array<string>, equipmentRental: Array<string>, household: Array<string>, internet: Array<string>, leisure: Array<string>, medicalCosmetology: Array<string>, other: Array<string>, reception: Array<string>, rental: Array<string>, skiResortServices: Array<string>, spaServices: Array<string>, sportAndEntertainmentTypes: Array<string>, waterSports: Array<string> }, treatment: { __typename?: 'TreatmentDictionaries', categories: Array<{ __typename?: 'TreatmentCategoryDict', name: string, groups: Array<{ __typename?: 'TreatmentGroupDict', name: string, items: Array<{ __typename?: 'TreatmentItemDict', name: string, options: Array<string> }> }> }> }, conferenceServices: { __typename?: 'ConferenceServicesDictionaries', equipment: Array<string>, seatingOptions: Array<string>, furniture: Array<string>, congressServices: Array<string> } } };

export type AttachmentFragmentFragment = { __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null };

export type ContentServiceQuestionnaireAnswersFragmentFragment = { __typename?: 'QuestionnaireAnswers', step?: QuestionnaireMasterStep | null, isFinished: boolean, generalInfo?: { __typename?: 'QuestionnaireAnswersGeneralInfo', hotelChain?: string | null, address?: string | null, buildYear?: any | null, renovationYear?: any | null, totalArea?: any | null, nearestAeroport?: string | null, nearestTrainStation?: string | null, nearestSubwayStation?: string | null, checkIn?: any | null, checkOut?: any | null, petsAllowed?: string | null, petWeightLimitKg?: any | null, requiredDocumentsAdult?: Array<string> | null, isAcceptChildren?: boolean | null, requiredDocumentsChildren?: Array<string> | null, requiredDocumentsForeigner?: Array<string> | null, description?: string | null, webSite?: string | null, contactFullName?: string | null, contactEmail?: string | null, photobankUrl?: string | null, name?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, roomCategories?: Array<{ __typename?: 'QuestionnaireAnswersRoomCategoryInfo', roomCategoryCid: string, roomCategoryName?: string | null, roomCategoryTypeName?: string | null, roomCategoryBasePlaces?: any | null, roomCategoryExtPlaces?: any | null, roomsCount?: string | null, roomArea?: any | null, typeOfExtendedPlace?: Array<string> | null, kitchenIsInRoom?: string | null, balcony?: Array<string> | null, roomEquipment?: Array<string> | null, furniture?: Array<string> | null, bathroom?: Array<string> | null, bathroomEquipment?: Array<string> | null, roomService?: Array<string> | null, roomView?: Array<string> | null, photobankUrl?: string | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, infrastructureInfo?: { __typename?: 'QuestionnaireAnswersInfrastructureInfo', anotherInfrastructure?: Array<string> | null, beautyInfrastructure?: Array<string> | null, childrenInfrastructure?: Array<string> | null, childrenPool?: Array<string> | null, disabilityCheck?: boolean | null, disabilityInfrastructure?: Array<string> | null, indoorAreas?: Array<string> | null, outdoorAreas?: Array<string> | null, parkingType?: Array<string> | null, skiResorts?: Array<string> | null, waterComplexDescription?: string | null, winterPlaygrounds?: Array<string> | null, photobankUrl?: string | null, waterDistanceMeters?: any | null, beaches?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoBeach', beachId: any, beachType?: Array<string> | null, beachEquipment?: Array<string> | null, paidBeachEquipment?: Array<string> | null, beachEntertainment?: Array<string> | null, questionnaireId?: any | null, beachDistanceMeters?: any | null }> | null, pools?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoPool', poolId: any, poolName?: string | null, poolType?: string | null, poolCharacteristics?: Array<string> | null, poolSeason?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, saunas?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoSauna', saunaId: any, saunaType?: string | null, payment?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, nutritionInfo?: { __typename?: 'QuestionnaireAnswersNutritionInfo', nutritionDelivery?: boolean | null, childrenNutrition?: Array<string> | null, foodObjects?: Array<{ __typename?: 'QuestionnaireAnswersFoodObjectInfo', foodObjectId: any, foodObjectName?: string | null, foodObjectOpeningHours?: string | null, foodObjectOpeningHoursFrom?: any | null, foodObjectOpeningHoursTo?: any | null, foodObjectType?: string | null, cuisine?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null, servicesAndEntertainment?: { __typename?: 'QuestionnaireAnswersServicesAndEntertainmentInfo', household?: Array<string> | null, reception?: Array<string> | null, rent?: Array<string> | null, internet?: Array<string> | null, other?: Array<string> | null, waterSports?: Array<string> | null, equipmentRental?: Array<string> | null, skiResortService?: Array<string> | null, animation?: Array<string> | null, entertainmentTypes?: Array<string> | null, leisure?: Array<string> | null, childrenEntertainment?: Array<string> | null, childrenService?: Array<string> | null, childrenEquipment?: Array<string> | null, spaServices?: Array<string> | null, medicalCosmetology?: Array<string> | null } | null, treatment?: { __typename?: 'QuestionnaireAnswersTreatmentInfo', enabled: boolean, treatmentCategories?: Array<{ __typename?: 'TreatmentCategory', name: string, groups: Array<{ __typename?: 'TreatmentGroup', name: string, items: Array<{ __typename?: 'TreatmentItem', name: string, options: Array<string> }> }> }> | null } | null, conferenceServices?: { __typename?: 'QuestionnaireAnswersConferenceServicesInfo', congressServices?: Array<string> | null, conferenceRooms?: Array<{ __typename?: 'QuestionnaireAnswersConferenceRoomInfo', conferenceRoomId: any, conferenceRoomName?: string | null, placesCount?: any | null, area?: any | null, conferenceRoomEquipment?: Array<string> | null, conferenceRoomSeatingOptions?: Array<string> | null, conferenceRoomFurniture?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null };

export type ContentServiceQuestionnaireAnswersQueryVariables = Exact<{
  questionnaireId: Scalars['UUID']['input'];
}>;


export type ContentServiceQuestionnaireAnswersQuery = { __typename?: 'Query', contentServiceQuestionnaireAnswersById?: { __typename?: 'QuestionnaireAnswers', step?: QuestionnaireMasterStep | null, isFinished: boolean, generalInfo?: { __typename?: 'QuestionnaireAnswersGeneralInfo', hotelChain?: string | null, address?: string | null, buildYear?: any | null, renovationYear?: any | null, totalArea?: any | null, nearestAeroport?: string | null, nearestTrainStation?: string | null, nearestSubwayStation?: string | null, checkIn?: any | null, checkOut?: any | null, petsAllowed?: string | null, petWeightLimitKg?: any | null, requiredDocumentsAdult?: Array<string> | null, isAcceptChildren?: boolean | null, requiredDocumentsChildren?: Array<string> | null, requiredDocumentsForeigner?: Array<string> | null, description?: string | null, webSite?: string | null, contactFullName?: string | null, contactEmail?: string | null, photobankUrl?: string | null, name?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, roomCategories?: Array<{ __typename?: 'QuestionnaireAnswersRoomCategoryInfo', roomCategoryCid: string, roomCategoryName?: string | null, roomCategoryTypeName?: string | null, roomCategoryBasePlaces?: any | null, roomCategoryExtPlaces?: any | null, roomsCount?: string | null, roomArea?: any | null, typeOfExtendedPlace?: Array<string> | null, kitchenIsInRoom?: string | null, balcony?: Array<string> | null, roomEquipment?: Array<string> | null, furniture?: Array<string> | null, bathroom?: Array<string> | null, bathroomEquipment?: Array<string> | null, roomService?: Array<string> | null, roomView?: Array<string> | null, photobankUrl?: string | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, infrastructureInfo?: { __typename?: 'QuestionnaireAnswersInfrastructureInfo', anotherInfrastructure?: Array<string> | null, beautyInfrastructure?: Array<string> | null, childrenInfrastructure?: Array<string> | null, childrenPool?: Array<string> | null, disabilityCheck?: boolean | null, disabilityInfrastructure?: Array<string> | null, indoorAreas?: Array<string> | null, outdoorAreas?: Array<string> | null, parkingType?: Array<string> | null, skiResorts?: Array<string> | null, waterComplexDescription?: string | null, winterPlaygrounds?: Array<string> | null, photobankUrl?: string | null, waterDistanceMeters?: any | null, beaches?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoBeach', beachId: any, beachType?: Array<string> | null, beachEquipment?: Array<string> | null, paidBeachEquipment?: Array<string> | null, beachEntertainment?: Array<string> | null, questionnaireId?: any | null, beachDistanceMeters?: any | null }> | null, pools?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoPool', poolId: any, poolName?: string | null, poolType?: string | null, poolCharacteristics?: Array<string> | null, poolSeason?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, saunas?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoSauna', saunaId: any, saunaType?: string | null, payment?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, nutritionInfo?: { __typename?: 'QuestionnaireAnswersNutritionInfo', nutritionDelivery?: boolean | null, childrenNutrition?: Array<string> | null, foodObjects?: Array<{ __typename?: 'QuestionnaireAnswersFoodObjectInfo', foodObjectId: any, foodObjectName?: string | null, foodObjectOpeningHours?: string | null, foodObjectOpeningHoursFrom?: any | null, foodObjectOpeningHoursTo?: any | null, foodObjectType?: string | null, cuisine?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null, servicesAndEntertainment?: { __typename?: 'QuestionnaireAnswersServicesAndEntertainmentInfo', household?: Array<string> | null, reception?: Array<string> | null, rent?: Array<string> | null, internet?: Array<string> | null, other?: Array<string> | null, waterSports?: Array<string> | null, equipmentRental?: Array<string> | null, skiResortService?: Array<string> | null, animation?: Array<string> | null, entertainmentTypes?: Array<string> | null, leisure?: Array<string> | null, childrenEntertainment?: Array<string> | null, childrenService?: Array<string> | null, childrenEquipment?: Array<string> | null, spaServices?: Array<string> | null, medicalCosmetology?: Array<string> | null } | null, treatment?: { __typename?: 'QuestionnaireAnswersTreatmentInfo', enabled: boolean, treatmentCategories?: Array<{ __typename?: 'TreatmentCategory', name: string, groups: Array<{ __typename?: 'TreatmentGroup', name: string, items: Array<{ __typename?: 'TreatmentItem', name: string, options: Array<string> }> }> }> | null } | null, conferenceServices?: { __typename?: 'QuestionnaireAnswersConferenceServicesInfo', congressServices?: Array<string> | null, conferenceRooms?: Array<{ __typename?: 'QuestionnaireAnswersConferenceRoomInfo', conferenceRoomId: any, conferenceRoomName?: string | null, placesCount?: any | null, area?: any | null, conferenceRoomEquipment?: Array<string> | null, conferenceRoomSeatingOptions?: Array<string> | null, conferenceRoomFurniture?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null } | null };

export type ContentServiceQuestionnaireStepsValidationsFragmentFragment = { __typename?: 'QuestionnaireStepsValidations', validations?: Array<{ __typename?: 'StepValidation', step: QuestionnaireMasterStep, isValid: boolean }> | null };

export type ContentServiceQuestionnaireAnswersValidationsByIdQueryVariables = Exact<{
  questionnaireId: Scalars['UUID']['input'];
}>;


export type ContentServiceQuestionnaireAnswersValidationsByIdQuery = { __typename?: 'Query', contentServiceQuestionnaireAnswersValidationsById: { __typename?: 'QuestionnaireStepsValidations', validations?: Array<{ __typename?: 'StepValidation', step: QuestionnaireMasterStep, isValid: boolean }> | null } };

export type ContentServiceQuestionnaireQueryVariables = Exact<{
  accommodationObjectCid: Scalars['String']['input'];
}>;


export type ContentServiceQuestionnaireQuery = { __typename?: 'Query', contentServiceQuestionnaire?: { __typename?: 'ContentServiceQuestionnaireView', id: any, hasParent: boolean, status: ContentServiceQuestionnaireStatusView } | null };

export type ContentServiceQuestionnaireSaveMutationVariables = Exact<{
  input: ContentServiceQuestionnaireSaveAnswersInput;
}>;


export type ContentServiceQuestionnaireSaveMutation = { __typename?: 'Mutation', contentServiceQuestionnaireSaveAnswers: { __typename?: 'ContentServiceQuestionnaireSaveAnswersPayload', questionnaireAnswers?: { __typename?: 'QuestionnaireAnswers', step?: QuestionnaireMasterStep | null, isFinished: boolean, generalInfo?: { __typename?: 'QuestionnaireAnswersGeneralInfo', hotelChain?: string | null, address?: string | null, buildYear?: any | null, renovationYear?: any | null, totalArea?: any | null, nearestAeroport?: string | null, nearestTrainStation?: string | null, nearestSubwayStation?: string | null, checkIn?: any | null, checkOut?: any | null, petsAllowed?: string | null, petWeightLimitKg?: any | null, requiredDocumentsAdult?: Array<string> | null, isAcceptChildren?: boolean | null, requiredDocumentsChildren?: Array<string> | null, requiredDocumentsForeigner?: Array<string> | null, description?: string | null, webSite?: string | null, contactFullName?: string | null, contactEmail?: string | null, photobankUrl?: string | null, name?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, roomCategories?: Array<{ __typename?: 'QuestionnaireAnswersRoomCategoryInfo', roomCategoryCid: string, roomCategoryName?: string | null, roomCategoryTypeName?: string | null, roomCategoryBasePlaces?: any | null, roomCategoryExtPlaces?: any | null, roomsCount?: string | null, roomArea?: any | null, typeOfExtendedPlace?: Array<string> | null, kitchenIsInRoom?: string | null, balcony?: Array<string> | null, roomEquipment?: Array<string> | null, furniture?: Array<string> | null, bathroom?: Array<string> | null, bathroomEquipment?: Array<string> | null, roomService?: Array<string> | null, roomView?: Array<string> | null, photobankUrl?: string | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, infrastructureInfo?: { __typename?: 'QuestionnaireAnswersInfrastructureInfo', anotherInfrastructure?: Array<string> | null, beautyInfrastructure?: Array<string> | null, childrenInfrastructure?: Array<string> | null, childrenPool?: Array<string> | null, disabilityCheck?: boolean | null, disabilityInfrastructure?: Array<string> | null, indoorAreas?: Array<string> | null, outdoorAreas?: Array<string> | null, parkingType?: Array<string> | null, skiResorts?: Array<string> | null, waterComplexDescription?: string | null, winterPlaygrounds?: Array<string> | null, photobankUrl?: string | null, waterDistanceMeters?: any | null, beaches?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoBeach', beachId: any, beachType?: Array<string> | null, beachEquipment?: Array<string> | null, paidBeachEquipment?: Array<string> | null, beachEntertainment?: Array<string> | null, questionnaireId?: any | null, beachDistanceMeters?: any | null }> | null, pools?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoPool', poolId: any, poolName?: string | null, poolType?: string | null, poolCharacteristics?: Array<string> | null, poolSeason?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, saunas?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoSauna', saunaId: any, saunaType?: string | null, payment?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, nutritionInfo?: { __typename?: 'QuestionnaireAnswersNutritionInfo', nutritionDelivery?: boolean | null, childrenNutrition?: Array<string> | null, foodObjects?: Array<{ __typename?: 'QuestionnaireAnswersFoodObjectInfo', foodObjectId: any, foodObjectName?: string | null, foodObjectOpeningHours?: string | null, foodObjectOpeningHoursFrom?: any | null, foodObjectOpeningHoursTo?: any | null, foodObjectType?: string | null, cuisine?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null, servicesAndEntertainment?: { __typename?: 'QuestionnaireAnswersServicesAndEntertainmentInfo', household?: Array<string> | null, reception?: Array<string> | null, rent?: Array<string> | null, internet?: Array<string> | null, other?: Array<string> | null, waterSports?: Array<string> | null, equipmentRental?: Array<string> | null, skiResortService?: Array<string> | null, animation?: Array<string> | null, entertainmentTypes?: Array<string> | null, leisure?: Array<string> | null, childrenEntertainment?: Array<string> | null, childrenService?: Array<string> | null, childrenEquipment?: Array<string> | null, spaServices?: Array<string> | null, medicalCosmetology?: Array<string> | null } | null, treatment?: { __typename?: 'QuestionnaireAnswersTreatmentInfo', enabled: boolean, treatmentCategories?: Array<{ __typename?: 'TreatmentCategory', name: string, groups: Array<{ __typename?: 'TreatmentGroup', name: string, items: Array<{ __typename?: 'TreatmentItem', name: string, options: Array<string> }> }> }> | null } | null, conferenceServices?: { __typename?: 'QuestionnaireAnswersConferenceServicesInfo', congressServices?: Array<string> | null, conferenceRooms?: Array<{ __typename?: 'QuestionnaireAnswersConferenceRoomInfo', conferenceRoomId: any, conferenceRoomName?: string | null, placesCount?: any | null, area?: any | null, conferenceRoomEquipment?: Array<string> | null, conferenceRoomSeatingOptions?: Array<string> | null, conferenceRoomFurniture?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null } | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'ContentServiceQuestionnaireEditingForbiddenError', message: string } | { __typename: 'ContentServiceQuestionnaireNotFoundError', message: string }> | null } };

export type ContentServiceQuestionnaireCreateMutationVariables = Exact<{
  input: ContentServiceQuestionnaireCreateInput;
}>;


export type ContentServiceQuestionnaireCreateMutation = { __typename?: 'Mutation', contentServiceQuestionnaireCreate: { __typename?: 'ContentServiceQuestionnaireCreatePayload', questionnaireAnswers?: { __typename?: 'QuestionnaireAnswers', step?: QuestionnaireMasterStep | null, isFinished: boolean, generalInfo?: { __typename?: 'QuestionnaireAnswersGeneralInfo', hotelChain?: string | null, address?: string | null, buildYear?: any | null, renovationYear?: any | null, totalArea?: any | null, nearestAeroport?: string | null, nearestTrainStation?: string | null, nearestSubwayStation?: string | null, checkIn?: any | null, checkOut?: any | null, petsAllowed?: string | null, petWeightLimitKg?: any | null, requiredDocumentsAdult?: Array<string> | null, isAcceptChildren?: boolean | null, requiredDocumentsChildren?: Array<string> | null, requiredDocumentsForeigner?: Array<string> | null, description?: string | null, webSite?: string | null, contactFullName?: string | null, contactEmail?: string | null, photobankUrl?: string | null, name?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, roomCategories?: Array<{ __typename?: 'QuestionnaireAnswersRoomCategoryInfo', roomCategoryCid: string, roomCategoryName?: string | null, roomCategoryTypeName?: string | null, roomCategoryBasePlaces?: any | null, roomCategoryExtPlaces?: any | null, roomsCount?: string | null, roomArea?: any | null, typeOfExtendedPlace?: Array<string> | null, kitchenIsInRoom?: string | null, balcony?: Array<string> | null, roomEquipment?: Array<string> | null, furniture?: Array<string> | null, bathroom?: Array<string> | null, bathroomEquipment?: Array<string> | null, roomService?: Array<string> | null, roomView?: Array<string> | null, photobankUrl?: string | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, infrastructureInfo?: { __typename?: 'QuestionnaireAnswersInfrastructureInfo', anotherInfrastructure?: Array<string> | null, beautyInfrastructure?: Array<string> | null, childrenInfrastructure?: Array<string> | null, childrenPool?: Array<string> | null, disabilityCheck?: boolean | null, disabilityInfrastructure?: Array<string> | null, indoorAreas?: Array<string> | null, outdoorAreas?: Array<string> | null, parkingType?: Array<string> | null, skiResorts?: Array<string> | null, waterComplexDescription?: string | null, winterPlaygrounds?: Array<string> | null, photobankUrl?: string | null, waterDistanceMeters?: any | null, beaches?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoBeach', beachId: any, beachType?: Array<string> | null, beachEquipment?: Array<string> | null, paidBeachEquipment?: Array<string> | null, beachEntertainment?: Array<string> | null, questionnaireId?: any | null, beachDistanceMeters?: any | null }> | null, pools?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoPool', poolId: any, poolName?: string | null, poolType?: string | null, poolCharacteristics?: Array<string> | null, poolSeason?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, saunas?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoSauna', saunaId: any, saunaType?: string | null, payment?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, nutritionInfo?: { __typename?: 'QuestionnaireAnswersNutritionInfo', nutritionDelivery?: boolean | null, childrenNutrition?: Array<string> | null, foodObjects?: Array<{ __typename?: 'QuestionnaireAnswersFoodObjectInfo', foodObjectId: any, foodObjectName?: string | null, foodObjectOpeningHours?: string | null, foodObjectOpeningHoursFrom?: any | null, foodObjectOpeningHoursTo?: any | null, foodObjectType?: string | null, cuisine?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null, servicesAndEntertainment?: { __typename?: 'QuestionnaireAnswersServicesAndEntertainmentInfo', household?: Array<string> | null, reception?: Array<string> | null, rent?: Array<string> | null, internet?: Array<string> | null, other?: Array<string> | null, waterSports?: Array<string> | null, equipmentRental?: Array<string> | null, skiResortService?: Array<string> | null, animation?: Array<string> | null, entertainmentTypes?: Array<string> | null, leisure?: Array<string> | null, childrenEntertainment?: Array<string> | null, childrenService?: Array<string> | null, childrenEquipment?: Array<string> | null, spaServices?: Array<string> | null, medicalCosmetology?: Array<string> | null } | null, treatment?: { __typename?: 'QuestionnaireAnswersTreatmentInfo', enabled: boolean, treatmentCategories?: Array<{ __typename?: 'TreatmentCategory', name: string, groups: Array<{ __typename?: 'TreatmentGroup', name: string, items: Array<{ __typename?: 'TreatmentItem', name: string, options: Array<string> }> }> }> | null } | null, conferenceServices?: { __typename?: 'QuestionnaireAnswersConferenceServicesInfo', congressServices?: Array<string> | null, conferenceRooms?: Array<{ __typename?: 'QuestionnaireAnswersConferenceRoomInfo', conferenceRoomId: any, conferenceRoomName?: string | null, placesCount?: any | null, area?: any | null, conferenceRoomEquipment?: Array<string> | null, conferenceRoomSeatingOptions?: Array<string> | null, conferenceRoomFurniture?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null } | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'ContentServiceQuestionnaireAlreadyCreatedError', message: string } | { __typename: 'NoRoomCategoriesInAccomodationObjectError', message: string }> | null } };

export type ContentServiceQuestionnaireMoveToNextStepMutationVariables = Exact<{
  accommodationObjectCid: Scalars['String']['input'];
  answers: QuestionnaireAnswersInput;
  finishedStep: QuestionnaireMasterStep;
}>;


export type ContentServiceQuestionnaireMoveToNextStepMutation = { __typename?: 'Mutation', contentServiceQuestionnaireMoveToNextStep: { __typename?: 'ContentServiceQuestionnaireMoveToNextStepPayload', questionnaireAnswers?: { __typename?: 'QuestionnaireAnswers', step?: QuestionnaireMasterStep | null, isFinished: boolean, generalInfo?: { __typename?: 'QuestionnaireAnswersGeneralInfo', hotelChain?: string | null, address?: string | null, buildYear?: any | null, renovationYear?: any | null, totalArea?: any | null, nearestAeroport?: string | null, nearestTrainStation?: string | null, nearestSubwayStation?: string | null, checkIn?: any | null, checkOut?: any | null, petsAllowed?: string | null, petWeightLimitKg?: any | null, requiredDocumentsAdult?: Array<string> | null, isAcceptChildren?: boolean | null, requiredDocumentsChildren?: Array<string> | null, requiredDocumentsForeigner?: Array<string> | null, description?: string | null, webSite?: string | null, contactFullName?: string | null, contactEmail?: string | null, photobankUrl?: string | null, name?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, roomCategories?: Array<{ __typename?: 'QuestionnaireAnswersRoomCategoryInfo', roomCategoryCid: string, roomCategoryName?: string | null, roomCategoryTypeName?: string | null, roomCategoryBasePlaces?: any | null, roomCategoryExtPlaces?: any | null, roomsCount?: string | null, roomArea?: any | null, typeOfExtendedPlace?: Array<string> | null, kitchenIsInRoom?: string | null, balcony?: Array<string> | null, roomEquipment?: Array<string> | null, furniture?: Array<string> | null, bathroom?: Array<string> | null, bathroomEquipment?: Array<string> | null, roomService?: Array<string> | null, roomView?: Array<string> | null, photobankUrl?: string | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, infrastructureInfo?: { __typename?: 'QuestionnaireAnswersInfrastructureInfo', anotherInfrastructure?: Array<string> | null, beautyInfrastructure?: Array<string> | null, childrenInfrastructure?: Array<string> | null, childrenPool?: Array<string> | null, disabilityCheck?: boolean | null, disabilityInfrastructure?: Array<string> | null, indoorAreas?: Array<string> | null, outdoorAreas?: Array<string> | null, parkingType?: Array<string> | null, skiResorts?: Array<string> | null, waterComplexDescription?: string | null, winterPlaygrounds?: Array<string> | null, photobankUrl?: string | null, waterDistanceMeters?: any | null, beaches?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoBeach', beachId: any, beachType?: Array<string> | null, beachEquipment?: Array<string> | null, paidBeachEquipment?: Array<string> | null, beachEntertainment?: Array<string> | null, questionnaireId?: any | null, beachDistanceMeters?: any | null }> | null, pools?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoPool', poolId: any, poolName?: string | null, poolType?: string | null, poolCharacteristics?: Array<string> | null, poolSeason?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, saunas?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoSauna', saunaId: any, saunaType?: string | null, payment?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, nutritionInfo?: { __typename?: 'QuestionnaireAnswersNutritionInfo', nutritionDelivery?: boolean | null, childrenNutrition?: Array<string> | null, foodObjects?: Array<{ __typename?: 'QuestionnaireAnswersFoodObjectInfo', foodObjectId: any, foodObjectName?: string | null, foodObjectOpeningHours?: string | null, foodObjectOpeningHoursFrom?: any | null, foodObjectOpeningHoursTo?: any | null, foodObjectType?: string | null, cuisine?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null, servicesAndEntertainment?: { __typename?: 'QuestionnaireAnswersServicesAndEntertainmentInfo', household?: Array<string> | null, reception?: Array<string> | null, rent?: Array<string> | null, internet?: Array<string> | null, other?: Array<string> | null, waterSports?: Array<string> | null, equipmentRental?: Array<string> | null, skiResortService?: Array<string> | null, animation?: Array<string> | null, entertainmentTypes?: Array<string> | null, leisure?: Array<string> | null, childrenEntertainment?: Array<string> | null, childrenService?: Array<string> | null, childrenEquipment?: Array<string> | null, spaServices?: Array<string> | null, medicalCosmetology?: Array<string> | null } | null, treatment?: { __typename?: 'QuestionnaireAnswersTreatmentInfo', enabled: boolean, treatmentCategories?: Array<{ __typename?: 'TreatmentCategory', name: string, groups: Array<{ __typename?: 'TreatmentGroup', name: string, items: Array<{ __typename?: 'TreatmentItem', name: string, options: Array<string> }> }> }> | null } | null, conferenceServices?: { __typename?: 'QuestionnaireAnswersConferenceServicesInfo', congressServices?: Array<string> | null, conferenceRooms?: Array<{ __typename?: 'QuestionnaireAnswersConferenceRoomInfo', conferenceRoomId: any, conferenceRoomName?: string | null, placesCount?: any | null, area?: any | null, conferenceRoomEquipment?: Array<string> | null, conferenceRoomSeatingOptions?: Array<string> | null, conferenceRoomFurniture?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null } | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'ContentServiceQuestionnaireEditingForbiddenError', message: string } | { __typename: 'ContentServiceQuestionnaireNotFoundError', message: string }> | null } };

export type ContentServiceQuestionnaireFinalizeMutationVariables = Exact<{
  accommodationObjectCid: Scalars['String']['input'];
  answers: QuestionnaireAnswersInput;
}>;


export type ContentServiceQuestionnaireFinalizeMutation = { __typename?: 'Mutation', contentServiceQuestionnaireFinalize: { __typename?: 'ContentServiceQuestionnaireFinalizePayload', mutationResult?: MutationResult | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'ContentServiceQuestionnaireEditingForbiddenError', message: string } | { __typename: 'ContentServiceQuestionnaireNotFoundError', message: string }> | null } };

export type ContentServiceQuestionnaireEditMutationVariables = Exact<{
  accommodationObjectCid: Scalars['String']['input'];
}>;


export type ContentServiceQuestionnaireEditMutation = { __typename?: 'Mutation', contentServiceQuestionnaireEdit: { __typename?: 'ContentServiceQuestionnaireEditPayload', questionnaireAnswers?: { __typename?: 'QuestionnaireAnswers', step?: QuestionnaireMasterStep | null, isFinished: boolean, generalInfo?: { __typename?: 'QuestionnaireAnswersGeneralInfo', hotelChain?: string | null, address?: string | null, buildYear?: any | null, renovationYear?: any | null, totalArea?: any | null, nearestAeroport?: string | null, nearestTrainStation?: string | null, nearestSubwayStation?: string | null, checkIn?: any | null, checkOut?: any | null, petsAllowed?: string | null, petWeightLimitKg?: any | null, requiredDocumentsAdult?: Array<string> | null, isAcceptChildren?: boolean | null, requiredDocumentsChildren?: Array<string> | null, requiredDocumentsForeigner?: Array<string> | null, description?: string | null, webSite?: string | null, contactFullName?: string | null, contactEmail?: string | null, photobankUrl?: string | null, name?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, roomCategories?: Array<{ __typename?: 'QuestionnaireAnswersRoomCategoryInfo', roomCategoryCid: string, roomCategoryName?: string | null, roomCategoryTypeName?: string | null, roomCategoryBasePlaces?: any | null, roomCategoryExtPlaces?: any | null, roomsCount?: string | null, roomArea?: any | null, typeOfExtendedPlace?: Array<string> | null, kitchenIsInRoom?: string | null, balcony?: Array<string> | null, roomEquipment?: Array<string> | null, furniture?: Array<string> | null, bathroom?: Array<string> | null, bathroomEquipment?: Array<string> | null, roomService?: Array<string> | null, roomView?: Array<string> | null, photobankUrl?: string | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, infrastructureInfo?: { __typename?: 'QuestionnaireAnswersInfrastructureInfo', anotherInfrastructure?: Array<string> | null, beautyInfrastructure?: Array<string> | null, childrenInfrastructure?: Array<string> | null, childrenPool?: Array<string> | null, disabilityCheck?: boolean | null, disabilityInfrastructure?: Array<string> | null, indoorAreas?: Array<string> | null, outdoorAreas?: Array<string> | null, parkingType?: Array<string> | null, skiResorts?: Array<string> | null, waterComplexDescription?: string | null, winterPlaygrounds?: Array<string> | null, photobankUrl?: string | null, waterDistanceMeters?: any | null, beaches?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoBeach', beachId: any, beachType?: Array<string> | null, beachEquipment?: Array<string> | null, paidBeachEquipment?: Array<string> | null, beachEntertainment?: Array<string> | null, questionnaireId?: any | null, beachDistanceMeters?: any | null }> | null, pools?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoPool', poolId: any, poolName?: string | null, poolType?: string | null, poolCharacteristics?: Array<string> | null, poolSeason?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, saunas?: Array<{ __typename?: 'QuestionnaireAnswersInfrastructureInfoSauna', saunaId: any, saunaType?: string | null, payment?: string | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null } | null, nutritionInfo?: { __typename?: 'QuestionnaireAnswersNutritionInfo', nutritionDelivery?: boolean | null, childrenNutrition?: Array<string> | null, foodObjects?: Array<{ __typename?: 'QuestionnaireAnswersFoodObjectInfo', foodObjectId: any, foodObjectName?: string | null, foodObjectOpeningHours?: string | null, foodObjectOpeningHoursFrom?: any | null, foodObjectOpeningHoursTo?: any | null, foodObjectType?: string | null, cuisine?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null, servicesAndEntertainment?: { __typename?: 'QuestionnaireAnswersServicesAndEntertainmentInfo', household?: Array<string> | null, reception?: Array<string> | null, rent?: Array<string> | null, internet?: Array<string> | null, other?: Array<string> | null, waterSports?: Array<string> | null, equipmentRental?: Array<string> | null, skiResortService?: Array<string> | null, animation?: Array<string> | null, entertainmentTypes?: Array<string> | null, leisure?: Array<string> | null, childrenEntertainment?: Array<string> | null, childrenService?: Array<string> | null, childrenEquipment?: Array<string> | null, spaServices?: Array<string> | null, medicalCosmetology?: Array<string> | null } | null, treatment?: { __typename?: 'QuestionnaireAnswersTreatmentInfo', enabled: boolean, treatmentCategories?: Array<{ __typename?: 'TreatmentCategory', name: string, groups: Array<{ __typename?: 'TreatmentGroup', name: string, items: Array<{ __typename?: 'TreatmentItem', name: string, options: Array<string> }> }> }> | null } | null, conferenceServices?: { __typename?: 'QuestionnaireAnswersConferenceServicesInfo', congressServices?: Array<string> | null, conferenceRooms?: Array<{ __typename?: 'QuestionnaireAnswersConferenceRoomInfo', conferenceRoomId: any, conferenceRoomName?: string | null, placesCount?: any | null, area?: any | null, conferenceRoomEquipment?: Array<string> | null, conferenceRoomSeatingOptions?: Array<string> | null, conferenceRoomFurniture?: Array<string> | null, photobankUrl?: string | null, questionnaireId?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: any, name: string, size: any, questionnaireId?: any | null }> | null }> | null } | null } | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'ContentServiceQuestionnaireNotFinishedError', message: string }> | null } };

export type ContentServiceQuestionnaireCancelEditMutationVariables = Exact<{
  questionnaireId: Scalars['UUID']['input'];
}>;


export type ContentServiceQuestionnaireCancelEditMutation = { __typename?: 'Mutation', contentServiceQuestionnaireCancelEdit: { __typename?: 'ContentServiceQuestionnaireCancelEditPayload', errors?: Array<{ __typename: 'ContentServiceQuestionnaireCancelNotEditedError', message: string } | { __typename: 'ContentServiceQuestionnaireNotFoundError', message: string }> | null } };

export type DocumentFragmentFragment = { __typename?: 'DocumentResponseModel', documentId: any, documentName: string, documentDate: any, documentType: DocumentType, downloadId: string, fileName: string, juridicalPerson: string, ediType: EdiType, signatureStatus?: ESignatureStatus | null, reportPeriod: { __typename?: 'ReportPeriod', month: any, year: any } };

export type GetDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'DocumentResponseModel', documentId: any, documentName: string, documentDate: any, documentType: DocumentType, downloadId: string, fileName: string, juridicalPerson: string, ediType: EdiType, signatureStatus?: ESignatureStatus | null, reportPeriod: { __typename?: 'ReportPeriod', month: any, year: any } }> };

export type GetDocumentToSignQueryVariables = Exact<{
  documentId: Scalars['UUID']['input'];
}>;


export type GetDocumentToSignQuery = { __typename?: 'Query', documentToSign: { __typename?: 'DocumentToSignResponseModel', documentDate: any, documentId: any, documentName: string, fileUri: string, previewFileUri: string } };

export type SaveDocumentSignatureMutationVariables = Exact<{
  documentId: Scalars['UUID']['input'];
  signature: Scalars['String']['input'];
}>;


export type SaveDocumentSignatureMutation = { __typename?: 'Mutation', saveDocumentSignature: { __typename?: 'SaveDocumentSignaturePayload', mutationResult?: MutationResult | null, errors?: Array<{ __typename: 'DocumentNotFoundError', message: string }> | null } };

export type LegalListItemFragmentFragment = { __typename?: 'LegalListItemView', approveStatus: ApproveStatus, cid: string, legalDetails: { __typename?: 'LegalDetails', kpp?: string | null, ogrn?: string | null, tin: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'LegalListItemOperations', delete: OperationStatus } };

export type LegalFragmentFragment = { __typename?: 'LegalView', cid: string, status: ApproveStatus, data: { __typename?: 'LegalDataView', address?: string | null, isIndividual: boolean, isNotTaxPayer: boolean, name?: string | null, ediType: EdiType, addressML?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, details: { __typename?: 'LegalDetails', kpp?: string | null, ogrn?: string | null, tin: string }, nameML?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null }, operations: { __typename?: 'LegalOperations', canUpdateEDI: OperationStatus } };

export type GetLegalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLegalsQuery = { __typename?: 'Query', legals: { __typename?: 'LegalListView', operations: { __typename?: 'LegalListOperations', canAdd: OperationStatus, onApprovalLimitExceeded?: { __typename?: 'OnApprovalLimitExceededView', limit: any } | null }, legals: Array<{ __typename?: 'LegalListItemView', approveStatus: ApproveStatus, cid: string, legalDetails: { __typename?: 'LegalDetails', kpp?: string | null, ogrn?: string | null, tin: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'LegalListItemOperations', delete: OperationStatus } }> } };

export type GetLegalQueryVariables = Exact<{
  legalCid: Scalars['String']['input'];
}>;


export type GetLegalQuery = { __typename?: 'Query', legal?: { __typename?: 'LegalView', cid: string, status: ApproveStatus, data: { __typename?: 'LegalDataView', address?: string | null, isIndividual: boolean, isNotTaxPayer: boolean, name?: string | null, ediType: EdiType, addressML?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, details: { __typename?: 'LegalDetails', kpp?: string | null, ogrn?: string | null, tin: string }, nameML?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null }, operations: { __typename?: 'LegalOperations', canUpdateEDI: OperationStatus } } | null };

export type GetIsLegalFreeQueryVariables = Exact<{
  input: IsLegalFreeInput;
}>;


export type GetIsLegalFreeQuery = { __typename?: 'Query', isLegalFree: boolean };

export type FindFreeLegalQueryVariables = Exact<{
  input: FindFreeLegalInput;
}>;


export type FindFreeLegalQuery = { __typename?: 'Query', findFreeLegal?: { __typename?: 'LegalView', cid: string, status: ApproveStatus, data: { __typename?: 'LegalDataView', address?: string | null, isIndividual: boolean, isNotTaxPayer: boolean, name?: string | null, ediType: EdiType, addressML?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null, details: { __typename?: 'LegalDetails', kpp?: string | null, ogrn?: string | null, tin: string }, nameML?: Array<{ __typename?: 'LangString', langCode: string, value: string }> | null }, operations: { __typename?: 'LegalOperations', canUpdateEDI: OperationStatus } } | null };

export type AddLegalMutationVariables = Exact<{
  input: LegalDataInput;
}>;


export type AddLegalMutation = { __typename?: 'Mutation', addLegal: { __typename?: 'AddLegalPayload', legal?: { __typename?: 'LegalListItemView', approveStatus: ApproveStatus, cid: string, legalDetails: { __typename?: 'LegalDetails', kpp?: string | null, ogrn?: string | null, tin: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'LegalListItemOperations', delete: OperationStatus } } | null, errors?: Array<{ __typename: 'LegalMaxOnApprovalConflictError', message: string } | { __typename: 'LegalTINAndKPPConflictError', message: string } | { __typename: 'TownNotFoundError', message: string }> | null } };

export type AddLegalExistingMutationVariables = Exact<{
  input: AddLegalExistingInput;
}>;


export type AddLegalExistingMutation = { __typename?: 'Mutation', addLegalExisting: { __typename?: 'AddLegalExistingPayload', legal?: { __typename?: 'LegalListItemView', approveStatus: ApproveStatus, cid: string, legalDetails: { __typename?: 'LegalDetails', kpp?: string | null, ogrn?: string | null, tin: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'LegalListItemOperations', delete: OperationStatus } } | null, errors?: Array<{ __typename: 'LegalExtranetAreaConflictError', message: string } | { __typename: 'LegalNotFoundError', message: string }> | null } };

export type LegalDetailsFragment = { __typename?: 'LegalDetails', tin: string, kpp?: string | null, ogrn?: string | null };

export type LegalListItemFragment = { __typename?: 'LegalListItemView', cid: string, approveStatus: ApproveStatus, operations: { __typename?: 'LegalListItemOperations', delete: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, legalDetails: { __typename?: 'LegalDetails', tin: string, kpp?: string | null, ogrn?: string | null } };

export type RemoveLegalMutationVariables = Exact<{
  cid: Scalars['String']['input'];
}>;


export type RemoveLegalMutation = { __typename?: 'Mutation', removeLegal: { __typename?: 'RemoveLegalPayload', status?: string | null, errors?: Array<{ __typename: 'LegalNotFoundError' } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'OperationForbiddenError' }> | null } };

export type SaveLegalEdiTypeMutationVariables = Exact<{
  legalCID: Scalars['String']['input'];
  ediType: EdiType;
}>;


export type SaveLegalEdiTypeMutation = { __typename?: 'Mutation', saveLegalEDIType: { __typename?: 'SaveLegalEDITypePayload', status?: string | null, errors?: Array<{ __typename: 'LegalNotFoundError', message: string } | { __typename: 'LegalSaveEDITypeError', message: string }> | null } };

export type ContractFragment = { __typename?: 'ContractView', hasOffer: boolean, contractNumber: any, contractType: ContractType, status: ContractStatus, currencyISOCode: string, legal: { __typename?: 'DictMultiLangNameView', cid?: string | null, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> } };

export type AccommodationObjects2QueryVariables = Exact<{ [key: string]: never; }>;


export type AccommodationObjects2Query = { __typename?: 'Query', accommodationObjects2: { __typename?: 'AccommodationObjectListView', operations: { __typename?: 'AccommodationObjectListOperations', canAdd: OperationStatus, onApprovalLimitExceeded?: { __typename?: 'OnApprovalLimitExceededView', limit: any } | null }, accommodationObjects: Array<{ __typename?: 'AccommodationObjectListItemView', cid: string, commonInformation: { __typename?: 'AccommodationObjectCommonInformationView', type: string, category: string, town: string, status: ApproveStatus, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }, contracts: Array<{ __typename?: 'ContractView', hasOffer: boolean, contractNumber: any, contractType: ContractType, status: ContractStatus, currencyISOCode: string, legal: { __typename?: 'DictMultiLangNameView', cid?: string | null, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> } }> }> } };

export type AccomodationObjectDashboardInfoQueryVariables = Exact<{
  accommodationObjectCid: Scalars['String']['input'];
}>;


export type AccomodationObjectDashboardInfoQuery = { __typename?: 'Query', accomodationObjectDashboardInfo: { __typename?: 'SupersetTokenView', status: HttpStatusCode, supersetDomain: string, guestToken: string, dashboards: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> } };

export type AccommodationObject2QueryVariables = Exact<{
  accommodationObjectCid: Scalars['String']['input'];
}>;


export type AccommodationObject2Query = { __typename?: 'Query', accommodationObject2?: { __typename?: 'AccommodationObjectInfoView', cid: string, timeZoneOffsetMin: any, commonInformation: { __typename?: 'AccommodationObjectCommonInformationView', type: string, category: string, town: string, status: ApproveStatus, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }, contacts: { __typename?: 'AccommodationObjectContactView', phone: string, email: string, webSite?: string | null, postalAddress: Array<{ __typename?: 'LangString', langCode: string, value: string }> }, contracts: Array<{ __typename?: 'ContractView', hasOffer: boolean, contractNumber: any, contractType: ContractType, status: ContractStatus, currencyISOCode: string, legal: { __typename?: 'DictMultiLangNameView', cid?: string | null, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> } }>, operations: { __typename?: 'AccommodationObjectOperations', canAddContract: OperationStatus } } | null };

export type HotelCategorySuggestionsQueryVariables = Exact<{
  key?: InputMaybe<Scalars['String']['input']>;
  maxResults: Scalars['Int']['input'];
}>;


export type HotelCategorySuggestionsQuery = { __typename?: 'Query', hotelCategorySuggestions: Array<{ __typename?: 'NameSuggestion', cid: string, name: string }> };

export type HotelTypeSuggestionsQueryVariables = Exact<{
  key?: InputMaybe<Scalars['String']['input']>;
  maxResults: Scalars['Int']['input'];
}>;


export type HotelTypeSuggestionsQuery = { __typename?: 'Query', hotelTypeSuggestions: Array<{ __typename?: 'NameSuggestion', cid: string, name: string }> };

export type RoomTypeSuggestionsQueryVariables = Exact<{
  key: Scalars['String']['input'];
  maxResults: Scalars['Int']['input'];
}>;


export type RoomTypeSuggestionsQuery = { __typename?: 'Query', roomTypeSuggestions: Array<{ __typename?: 'NameSuggestion', cid: string, name: string }> };

export type AddAccommodationObjectRoomCategoryMutationVariables = Exact<{
  baseQuantity: Scalars['UnsignedShort']['input'];
  extQuantity: Scalars['UnsignedShort']['input'];
  name: Array<LangStringInput> | LangStringInput;
  description: Array<LangStringInput> | LangStringInput;
  accommodationObjectCid: Scalars['String']['input'];
  roomTypeCid: Scalars['String']['input'];
}>;


export type AddAccommodationObjectRoomCategoryMutation = { __typename?: 'Mutation', addAccommodationObjectRoomCategory: { __typename?: 'AddAccommodationObjectRoomCategoryPayload', roomCategory?: { __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } } | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'RoomTypeNotFoundError', message: string }> | null } };

export type EditAccommodationObjectRoomCategoryMutationVariables = Exact<{
  accommodationObjectRoomCategoryCid: Scalars['String']['input'];
}>;


export type EditAccommodationObjectRoomCategoryMutation = { __typename?: 'Mutation', editAccommodationObjectRoomCategory: { __typename?: 'EditAccommodationObjectRoomCategoryPayload', roomCategory?: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } } | null, errors?: Array<{ __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename?: 'RoomCategoryNotFoundError' }> | null } };

export type CancelEditAccommodationObjectRoomCategoryMutationVariables = Exact<{
  accommodationObjectRoomCategoryCid: Scalars['String']['input'];
}>;


export type CancelEditAccommodationObjectRoomCategoryMutation = { __typename?: 'Mutation', cancelEditAccommodationObjectRoomCategory: { __typename?: 'CancelEditAccommodationObjectRoomCategoryPayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type AddAccommodationObjectServiceMutationVariables = Exact<{
  applyMethod: ApplyMethod;
  calculationMethod: CalculationMethodInput;
  name: Array<LangStringInput> | LangStringInput;
  shortName: Scalars['String']['input'];
  accommodationObjectCid: Scalars['String']['input'];
  serviceTypeCid: Scalars['String']['input'];
}>;


export type AddAccommodationObjectServiceMutation = { __typename?: 'Mutation', addAccommodationObjectService: { __typename?: 'AddAccommodationObjectServicePayload', serviceView?: { __typename?: 'ServiceView', applyMethod: ApplyMethod, calculationMethod: CalculationMethod, cid: string, shortName: string, operations: { __typename?: 'ServiceOperations', delete: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, serviceType: { __typename?: 'ServiceType', cid: string, name: string, shortName: string } } | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'ServiceTypeNotFoundError', message: string }> | null } };

export type UpdateAccommodationObjectRoomCategoryMutationVariables = Exact<{
  accommodationObjectRoomCategoryCid: Scalars['String']['input'];
  roomTypeCid: Scalars['String']['input'];
  baseQuantity: Scalars['UnsignedShort']['input'];
  extQuantity: Scalars['UnsignedShort']['input'];
  description: Array<LangStringInput> | LangStringInput;
  name: Array<LangStringInput> | LangStringInput;
}>;


export type UpdateAccommodationObjectRoomCategoryMutation = { __typename?: 'Mutation', updateAccommodationObjectRoomCategory: { __typename?: 'UpdateAccommodationObjectRoomCategoryPayload', roomCategory?: { __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } } | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'RoomCategoryUpdateChangeError', message: string } | { __typename: 'RoomTypeNotFoundError', message: string }> | null } };

export type RemoveAccommodationObjectRoomCategoryMutationVariables = Exact<{
  accommodationObjectRoomCategoryCid: Scalars['String']['input'];
}>;


export type RemoveAccommodationObjectRoomCategoryMutation = { __typename?: 'Mutation', removeAccommodationObjectRoomCategory: { __typename?: 'RemoveAccommodationObjectRoomCategoryPayload', status?: string | null, errors?: Array<{ __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'OperationForbiddenError', message: string } | { __typename: 'RoomCategoryNotFoundError', message: string }> | null } };

export type AddContractMutationVariables = Exact<{
  contractType: ContractType;
  accommodationObjectCID: Scalars['String']['input'];
  legalCid: Scalars['String']['input'];
  currencyIsoCode: Scalars['String']['input'];
  legalOrigin: LegalOrigin;
}>;


export type AddContractMutation = { __typename?: 'Mutation', addContract: { __typename?: 'AddContractPayload', Contract?: { __typename?: 'ContractView', hasOffer: boolean, contractNumber: any, contractType: ContractType, status: ContractStatus, currencyISOCode: string, legal: { __typename?: 'DictMultiLangNameView', cid?: string | null, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> } } | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'ConcurrencyConflictError', message: string } | { __typename: 'CurrencyNotFoundError', message: string } | { __typename: 'LegalNotFoundError', message: string }> | null } };

export type AddAccommodationObjectMutationVariables = Exact<{
  commonInformation: CommonInformationInput;
  commonContact: CommonContactInput;
}>;


export type AddAccommodationObjectMutation = { __typename?: 'Mutation', addAccommodationObject: { __typename?: 'AddAccommodationObjectPayload', accommodationObject?: { __typename?: 'AccommodationObjectView', cid: string } | null, errors?: Array<{ __typename: 'HotelCategoryNotFoundError', message: string } | { __typename: 'HotelMaxOnApprovalConflictError', message: string } | { __typename: 'HotelTypeNotFoundError', message: string } | { __typename: 'TownNotFoundError', message: string }> | null } };

export type GetOrdersReconciliationQueryVariables = Exact<{
  input: OrdersReconciliationInput;
}>;


export type GetOrdersReconciliationQuery = { __typename?: 'Query', ordersReconciliation: { __typename?: 'OrderReconciliationListView', count: number, ordersReconciliation: Array<{ __typename?: 'OrderReconciliationListItemView', commonInfo: { __typename?: 'OrderReconciliationCommonInfo', orderId: number, orderBookNumber: number, orderNumber: number, orderReconciliationStatus: OrderReconciliationStatus, orderAvoidanceStatus: OrderAvoidanceStatus, reconciliationItemSubTitle: string, reconciliationItemTitle: string, supplierOrderNumber?: string | null, orderReconciliationId: any, orderReconciliationPeriodId: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, tourists: Array<{ __typename?: 'OrderReconciliationTourist', name: string }>, amountsInfo: { __typename?: 'OrderReconciliationAmountInfo', payable: any, payout: any } } }>, operations: { __typename?: 'OrderReconciliationOperations', edit: OperationStatus }, totalAmountsInfo: { __typename?: 'OrderReconciliationAmountInfo', payable: any, payout: any } } };

export type GetOrdersReconciliationFiltersQueryVariables = Exact<{
  input: OrdersReconciliationFiltersInput;
}>;


export type GetOrdersReconciliationFiltersQuery = { __typename?: 'Query', ordersReconciliationFilters: { __typename?: 'OrderReconciliationListFiltersView', reportDates: Array<{ __typename?: 'OrderReconciliationListReportDateItemView', reportDate: any }> } };

export type ReconcileContractForPeriodMutationVariables = Exact<{
  input: ReconcileContractForPeriodInput;
}>;


export type ReconcileContractForPeriodMutation = { __typename?: 'Mutation', reconcileContractForPeriod: { __typename?: 'ReconcileContractForPeriodPayload', contractReconciliation?: { __typename?: 'ContractReconciliationAvailableForPeriodView', contractReconciliationState: ContractReconciliationStates } | null, errors?: Array<{ __typename: 'ContractNotFoundError', message: string } | { __typename: 'OrderReconciliationPeriodNotAvailableForReconciliationError', message: string }> | null } };

export type ReconcileOrdersReconciliationMutationVariables = Exact<{
  input: ReconcileOrdersReconciliationInput;
}>;


export type ReconcileOrdersReconciliationMutation = { __typename?: 'Mutation', reconcileOrdersReconciliation: { __typename?: 'ReconcileOrdersReconciliationPayload', ordersReconciliation?: Array<{ __typename?: 'OrderReconciliationListItemView', commonInfo: { __typename?: 'OrderReconciliationCommonInfo', orderId: number, orderNumber: number, orderReconciliationStatus: OrderReconciliationStatus } }> | null, errors?: Array<{ __typename: 'ContractNotFoundError', message: string } | { __typename: 'OrderNotFoundError', message: string }> | null } };

export type MismatchOrderReconciliationMutationVariables = Exact<{
  input: MismatchOrderReconciliationInput;
}>;


export type MismatchOrderReconciliationMutation = { __typename?: 'Mutation', mismatchOrderReconciliation: { __typename?: 'MismatchOrderReconciliationPayload', errors?: Array<{ __typename: 'ContractNotFoundError', message: string } | { __typename: 'OrderNotFoundError', message: string }> | null, orderReconciliation?: { __typename?: 'OrderReconciliationView', commonInfo: { __typename?: 'OrderReconciliationCommonInfo', orderId: number, orderNumber: number, orderReconciliationStatus: OrderReconciliationStatus, reconciliationItemSubTitle: string, reconciliationItemTitle: string, supplierOrderNumber?: string | null, amountsInfo: { __typename?: 'OrderReconciliationAmountInfo', payable: any, payout: any }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, tourists: Array<{ __typename?: 'OrderReconciliationTourist', name: string }> }, mismatch?: { __typename?: 'OrderReconciliationMismatch', description?: string | null, reason: MismatchReason } | null } | null } };

export type GetOrderReconciliationQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetOrderReconciliationQuery = { __typename?: 'Query', orderReconciliation?: { __typename?: 'OrderReconciliationView', commonInfo: { __typename?: 'OrderReconciliationCommonInfo', orderId: number, orderBookNumber: number, orderNumber: number, orderReconciliationStatus: OrderReconciliationStatus, orderAvoidanceStatus: OrderAvoidanceStatus, reconciliationItemSubTitle: string, reconciliationItemTitle: string, supplierOrderNumber?: string | null, orderReconciliationId: any, orderReconciliationPeriodId: any, amountsInfo: { __typename?: 'OrderReconciliationAmountInfo', payable: any, payout: any }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, tourists: Array<{ __typename?: 'OrderReconciliationTourist', name: string }> }, mismatch?: { __typename?: 'OrderReconciliationMismatch', description?: string | null, reason: MismatchReason } | null, operations: { __typename?: 'OrderReconciliationOperations', edit: OperationStatus } } | null };

export type GetContractReconciliationAvailableForPeriodQueryVariables = Exact<{
  input: ContractReconciliationStatusForPeriodInput;
}>;


export type GetContractReconciliationAvailableForPeriodQuery = { __typename?: 'Query', contractReconciliationAvailableForPeriod: { __typename?: 'ContractReconciliationAvailableForPeriodView', contractReconciliationState: ContractReconciliationStates } };

export type RoomTypeFragment = { __typename?: 'RoomType', cid: string, name: string };

export type RoomCategoryViewFragment = { __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } };

export type RoomCategoryFragmentFragment = { __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } };

export type GetRoomCategoriesQueryVariables = Exact<{
  accommodationObjectCid: Scalars['String']['input'];
}>;


export type GetRoomCategoriesQuery = { __typename?: 'Query', roomCategories?: { __typename?: 'RoomCategoryListView', operations: { __typename?: 'RoomCategoryListOperations', canAdd: OperationStatus }, roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } }> } | null };

export type AddRoomCategoryMutationVariables = Exact<{
  addAccommodationObjectRoomCategoryInput: AddAccommodationObjectRoomCategoryInput;
}>;


export type AddRoomCategoryMutation = { __typename?: 'Mutation', addAccommodationObjectRoomCategory: { __typename?: 'AddAccommodationObjectRoomCategoryPayload', roomCategory?: { __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } } | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'RoomTypeNotFoundError', message: string }> | null } };

export type EditRoomCategoryStartMutationVariables = Exact<{
  editAccommodationObjectRoomCategoryInput: EditAccommodationObjectRoomCategoryInput;
}>;


export type EditRoomCategoryStartMutation = { __typename?: 'Mutation', editAccommodationObjectRoomCategory: { __typename?: 'EditAccommodationObjectRoomCategoryPayload', roomCategory?: { __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } } | null, errors?: Array<{ __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RoomCategoryNotFoundError', message: string }> | null } };

export type EditRoomCategoryKeepAliveMutationVariables = Exact<{
  keepAliveAccommodationObjectRoomCategoryInput: KeepAliveAccommodationObjectRoomCategoryInput;
}>;


export type EditRoomCategoryKeepAliveMutation = { __typename?: 'Mutation', keepAliveAccommodationObjectRoomCategory: { __typename?: 'KeepAliveAccommodationObjectRoomCategoryPayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type EditRoomCategoryCancelMutationVariables = Exact<{
  cancelEditAccommodationObjectRoomCategoryInput: CancelEditAccommodationObjectRoomCategoryInput;
}>;


export type EditRoomCategoryCancelMutation = { __typename?: 'Mutation', cancelEditAccommodationObjectRoomCategory: { __typename?: 'CancelEditAccommodationObjectRoomCategoryPayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type EditRoomCategoryUpdateMutationVariables = Exact<{
  updateAccommodationObjectRoomCategoryInput: UpdateAccommodationObjectRoomCategoryInput;
}>;


export type EditRoomCategoryUpdateMutation = { __typename?: 'Mutation', updateAccommodationObjectRoomCategory: { __typename?: 'UpdateAccommodationObjectRoomCategoryPayload', roomCategory?: { __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } } | null, errors?: Array<{ __typename: 'AccommodationObjectNotFoundError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'RoomCategoryUpdateChangeError', message: string } | { __typename: 'RoomTypeNotFoundError', message: string }> | null } };

export type RemoveRoomCategoryMutationVariables = Exact<{
  input: RemoveAccommodationObjectRoomCategoryInput;
}>;


export type RemoveRoomCategoryMutation = { __typename?: 'Mutation', removeAccommodationObjectRoomCategory: { __typename?: 'RemoveAccommodationObjectRoomCategoryPayload', status?: string | null, errors?: Array<{ __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'OperationForbiddenError', message: string } | { __typename: 'RoomCategoryNotFoundError', message: string }> | null } };

export type ReverseStartIntegrationMutationVariables = Exact<{
  input: ReverseStartIntegrationInput;
}>;


export type ReverseStartIntegrationMutation = { __typename?: 'Mutation', reverseStartIntegration: { __typename?: 'ReverseStartIntegrationPayload', InteractionId?: any | null, errors?: Array<{ __typename: 'ContractNotFoundError', message: string }> | null } };

export type ReverseIntegrationFragmentFragment = { __typename?: 'ReverseIntegrationView', channelManagerCode: ChannelManagerCode, master: { __typename?: 'ReverseIntegrationMasterView', hotelSetCid: string, masterStep: ReverseMasterStep, isRestarting: boolean, steps: { __typename?: 'ReverseMasterStepsView', integrationSettings: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } }, roomCategoriesSettings: { __typename?: 'RoomCategoriesSettings', selectedRoomCategoryCIDs?: Array<string> | null, roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } }> }, serviceGroupsSettings: { __typename?: 'ServiceGroupsSettings', selectedServiceGroupeCIDs?: Array<string> | null, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupBase', cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', cid: string, shortName: string }> }> }, touristTypesSettings?: { __typename?: 'TouristTypesSettings', ageSettings: { __typename?: 'AgeSettings', initialAge: any, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null } } };

export type ReverseIntegrationQueryVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
}>;


export type ReverseIntegrationQuery = { __typename?: 'Query', reverseIntegration?: { __typename?: 'ReverseIntegrationView', channelManagerCode: ChannelManagerCode, master: { __typename?: 'ReverseIntegrationMasterView', hotelSetCid: string, masterStep: ReverseMasterStep, isRestarting: boolean, steps: { __typename?: 'ReverseMasterStepsView', integrationSettings: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } }, roomCategoriesSettings: { __typename?: 'RoomCategoriesSettings', selectedRoomCategoryCIDs?: Array<string> | null, roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } }> }, serviceGroupsSettings: { __typename?: 'ServiceGroupsSettings', selectedServiceGroupeCIDs?: Array<string> | null, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupBase', cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', cid: string, shortName: string }> }> }, touristTypesSettings?: { __typename?: 'TouristTypesSettings', ageSettings: { __typename?: 'AgeSettings', initialAge: any, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null } } } | null };

export type UncompletedReverseIntegrationFragmentFragment = { __typename?: 'UncompletedReverseInteractionView', interactionId: any, uncompletedInteraction: { __typename?: 'UncompletedReverseIntegrationView', channelManagerCode: ChannelManagerCode, isNotStarted: boolean } };

export type UncompletedReverseInteractionQueryVariables = Exact<{
  channelManagerCode: ChannelManagerCode;
  contractNumber: Scalars['UnsignedInt']['input'];
}>;


export type UncompletedReverseInteractionQuery = { __typename?: 'Query', uncompletedReverseInteraction?: { __typename?: 'UncompletedReverseInteractionView', interactionId: any, uncompletedInteraction: { __typename?: 'UncompletedReverseIntegrationView', channelManagerCode: ChannelManagerCode, isNotStarted: boolean } } | null };

export type CheckIsNotStartedReverseInteractionQueryVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
}>;


export type CheckIsNotStartedReverseInteractionQuery = { __typename?: 'Query', checkIsNotStartedReverseInteraction?: { __typename?: 'IsNotStartedReverseInteractionView', interactionId: any, isNotStarted: boolean } | null };

export type UpdateReverseRoomCategoriesMutationVariables = Exact<{
  input: ReverseUpdateRoomCategoriesInput;
}>;


export type UpdateReverseRoomCategoriesMutation = { __typename?: 'Mutation', reverseUpdateRoomCategories: { __typename?: 'ReverseUpdateRoomCategoriesPayload', View?: { __typename?: 'ReverseIntegrationView', channelManagerCode: ChannelManagerCode, master: { __typename?: 'ReverseIntegrationMasterView', hotelSetCid: string, masterStep: ReverseMasterStep, isRestarting: boolean, steps: { __typename?: 'ReverseMasterStepsView', integrationSettings: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } }, roomCategoriesSettings: { __typename?: 'RoomCategoriesSettings', selectedRoomCategoryCIDs?: Array<string> | null, roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } }> }, serviceGroupsSettings: { __typename?: 'ServiceGroupsSettings', selectedServiceGroupeCIDs?: Array<string> | null, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupBase', cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', cid: string, shortName: string }> }> }, touristTypesSettings?: { __typename?: 'TouristTypesSettings', ageSettings: { __typename?: 'AgeSettings', initialAge: any, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null } } } | null, errors?: Array<{ __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ContractNotFoundError', message: string } | { __typename: 'InvalidContractNumberError', message: string } | { __typename: 'RoomCategoryListNotFoundError', message: string }> | null } };

export type UpdateReverseServiceGroupsMutationVariables = Exact<{
  input: ReverseUpdateServiceGroupsInput;
}>;


export type UpdateReverseServiceGroupsMutation = { __typename?: 'Mutation', reverseUpdateServiceGroups: { __typename?: 'ReverseUpdateServiceGroupsPayload', View?: { __typename?: 'ReverseIntegrationView', channelManagerCode: ChannelManagerCode, master: { __typename?: 'ReverseIntegrationMasterView', hotelSetCid: string, masterStep: ReverseMasterStep, isRestarting: boolean, steps: { __typename?: 'ReverseMasterStepsView', integrationSettings: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } }, roomCategoriesSettings: { __typename?: 'RoomCategoriesSettings', selectedRoomCategoryCIDs?: Array<string> | null, roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } }> }, serviceGroupsSettings: { __typename?: 'ServiceGroupsSettings', selectedServiceGroupeCIDs?: Array<string> | null, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupBase', cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', cid: string, shortName: string }> }> }, touristTypesSettings?: { __typename?: 'TouristTypesSettings', ageSettings: { __typename?: 'AgeSettings', initialAge: any, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null } } } | null, errors?: Array<{ __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ChannelManagerReverseMasterInvalidOperationError', message: string } | { __typename: 'InvalidContractNumberError', message: string } | { __typename: 'ServiceGroupListNotFoundError', message: string }> | null } };

export type UpdateReverseTouristTypesMutationVariables = Exact<{
  input: ReverseUpdateTouristTypesInput;
}>;


export type UpdateReverseTouristTypesMutation = { __typename?: 'Mutation', reverseUpdateTouristTypes: { __typename?: 'ReverseUpdateTouristTypesPayload', View?: { __typename?: 'ReverseIntegrationView', channelManagerCode: ChannelManagerCode, master: { __typename?: 'ReverseIntegrationMasterView', hotelSetCid: string, masterStep: ReverseMasterStep, isRestarting: boolean, steps: { __typename?: 'ReverseMasterStepsView', integrationSettings: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } }, roomCategoriesSettings: { __typename?: 'RoomCategoriesSettings', selectedRoomCategoryCIDs?: Array<string> | null, roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } }> }, serviceGroupsSettings: { __typename?: 'ServiceGroupsSettings', selectedServiceGroupeCIDs?: Array<string> | null, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupBase', cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', cid: string, shortName: string }> }> }, touristTypesSettings?: { __typename?: 'TouristTypesSettings', ageSettings: { __typename?: 'AgeSettings', initialAge: any, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null } } } | null, errors?: Array<{ __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ChannelManagerReverseMasterInvalidOperationError', message: string } | { __typename: 'InvalidContractNumberError', message: string }> | null } };

export type GetReversePlacingVariantsQueryVariables = Exact<{
  interactionQuery: InteractionQueryInput;
}>;


export type GetReversePlacingVariantsQuery = { __typename?: 'Query', reversePlacingVariants?: { __typename?: 'GeneratedReversePlacingVariantsView', placingVariantsTarification?: Array<{ __typename?: 'RoomCategoryPlacingsView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, type: { __typename?: 'RoomType', cid: string, name: string } }, suggestedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }>, conflictedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }> }> | null } | null };

export type UpdateReversePlacingVariantsMutationVariables = Exact<{
  input: ReverseUpdatePlacingVariantsInput;
}>;


export type UpdateReversePlacingVariantsMutation = { __typename?: 'Mutation', reverseUpdatePlacingVariants: { __typename?: 'ReverseUpdatePlacingVariantsPayload', View?: { __typename?: 'ReverseIntegrationMasterCompletedView', tariffScheduleCID: string, remoteInteractionUrl?: string | null } | null, errors?: Array<{ __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ChannelManagerReverseMasterInvalidOperationError', message: string } | { __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'InvalidContractNumberError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'RoomCategoriesCannotDeleteError', message: string } | { __typename: 'RoomCategoriesEmptyError', message: string } | { __typename: 'RoomCategoryListNotFoundError', message: string } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'RoomPlacingListNotFoundError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string } | { __typename: 'TravelLinePlacingVariantExceedsRoomCategoryCapacityError', message: string } | { __typename: 'TravelLinePlacingVariantsNotFulfilledError', message: string }> | null } };

export type ReverseRestartIntegrationMutationVariables = Exact<{
  input: ReverseRestartIntegrationInput;
}>;


export type ReverseRestartIntegrationMutation = { __typename?: 'Mutation', reverseRestartIntegration: { __typename?: 'ReverseRestartIntegrationPayload', View?: { __typename?: 'ReverseRestartIntegrationView', interaction: { __typename?: 'ReverseIntegrationView', channelManagerCode: ChannelManagerCode, master: { __typename?: 'ReverseIntegrationMasterView', hotelSetCid: string, masterStep: ReverseMasterStep, isRestarting: boolean, steps: { __typename?: 'ReverseMasterStepsView', integrationSettings: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } }, roomCategoriesSettings: { __typename?: 'RoomCategoriesSettings', selectedRoomCategoryCIDs?: Array<string> | null, roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } }> }, serviceGroupsSettings: { __typename?: 'ServiceGroupsSettings', selectedServiceGroupeCIDs?: Array<string> | null, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupBase', cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', cid: string, shortName: string }> }> }, touristTypesSettings?: { __typename?: 'TouristTypesSettings', ageSettings: { __typename?: 'AgeSettings', initialAge: any, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null } } }, roomCategories: Array<{ __typename?: 'RoomCategoryQuota', roomCategoryCid: string, quotaStatus: QuotaStatus }> } | null, errors?: Array<{ __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ContractNotFoundError', message: string }> | null } };

export type TravelLineExternalHotelSuggestionsQueryVariables = Exact<{
  contractNumber: Scalars['UnsignedInt']['input'];
}>;


export type TravelLineExternalHotelSuggestionsQuery = { __typename?: 'Query', travelLineExternalHotelSuggestions: Array<{ __typename?: 'ExternalHotelSuggestionView', uncompletedInteractionId?: any | null, channelManagerCode: ChannelManagerCode, externalHotelQuery: { __typename?: 'ExternalHotelQuery', hotelId: any, hotelName: string } }> };

export type TravelLineIntegrationMasterStepsViewFragment = { __typename?: 'TravelLineMasterStepsView', integrationSettings?: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } } | null, roomCategoriesMapping?: { __typename?: 'RoomCategoriesMapping', roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null, touristTypesMapping?: { __typename?: 'TouristTypesMapping', touristTypesRefreshRequired: boolean, ageSettings: { __typename?: 'AgeSettings', initialAge: any, noSeatAge?: any | null, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null, placingVariantsMapping?: { __typename?: 'PlacingVariantsMapping', requiredPlacingVariants: Array<{ __typename?: 'RequiredPlacingVariant', roomCategoryCid: string, placingVariantName: string }> } | null, serviceGroupsMapping?: { __typename?: 'ServiceGroupsMapping', serviceGroups: Array<{ __typename?: 'TravelLineServiceGroupView', canChange: boolean, cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null };

export type TravelLineIntegrationViewFragment = { __typename?: 'TravelLineIntegrationView', hasExternalIntegrationIssue: boolean, channelManagerCode: ChannelManagerCode, master?: { __typename?: 'TravelLineIntegrationMasterView', masterStep: TravelLineMasterStep, hotelSetCid: string, steps: { __typename?: 'TravelLineMasterStepsView', integrationSettings?: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } } | null, roomCategoriesMapping?: { __typename?: 'RoomCategoriesMapping', roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null, touristTypesMapping?: { __typename?: 'TouristTypesMapping', touristTypesRefreshRequired: boolean, ageSettings: { __typename?: 'AgeSettings', initialAge: any, noSeatAge?: any | null, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null, placingVariantsMapping?: { __typename?: 'PlacingVariantsMapping', requiredPlacingVariants: Array<{ __typename?: 'RequiredPlacingVariant', roomCategoryCid: string, placingVariantName: string }> } | null, serviceGroupsMapping?: { __typename?: 'ServiceGroupsMapping', serviceGroups: Array<{ __typename?: 'TravelLineServiceGroupView', canChange: boolean, cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null } } | null, externalIntegration?: { __typename?: 'TravelLineExternalIntegration', externalId: string, integrationUrl?: string | null, externalHotel?: { __typename?: 'ExternalHotel', hotelId: any, hotelName: string } | null } | null };

export type TravelLineRestartIntegrationViewFragment = { __typename?: 'TravelLineRestartIntegrationView', hasExternalIntegrationIssue: boolean, channelManagerCode: ChannelManagerCode, master?: { __typename?: 'TravelLineIntegrationMasterView', masterStep: TravelLineMasterStep, hotelSetCid: string, steps: { __typename?: 'TravelLineMasterStepsView', integrationSettings?: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } } | null, roomCategoriesMapping?: { __typename?: 'RoomCategoriesMapping', roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null, touristTypesMapping?: { __typename?: 'TouristTypesMapping', touristTypesRefreshRequired: boolean, ageSettings: { __typename?: 'AgeSettings', initialAge: any, noSeatAge?: any | null, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null, placingVariantsMapping?: { __typename?: 'PlacingVariantsMapping', requiredPlacingVariants: Array<{ __typename?: 'RequiredPlacingVariant', roomCategoryCid: string, placingVariantName: string }> } | null, serviceGroupsMapping?: { __typename?: 'ServiceGroupsMapping', serviceGroups: Array<{ __typename?: 'TravelLineServiceGroupView', canChange: boolean, cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null } } | null };

export type TravelLineUncompletedIntegrationViewFragment = { __typename?: 'TravelLineUncompletedIntegrationView', channelManagerCode: ChannelManagerCode, integrationId: any, externalIntegration: { __typename?: 'TravelLineExternalIntegration', externalId: string, integrationUrl?: string | null, externalHotel?: { __typename?: 'ExternalHotel', hotelId: any, hotelName: string } | null } };

export type TravelLineRefreshTouristTypesMutationVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
}>;


export type TravelLineRefreshTouristTypesMutation = { __typename?: 'Mutation', travelLineRefreshTouristTypes: { __typename?: 'TravelLineRefreshTouristTypesPayload', status: string } };

export type GetTravelLineRestartIntegrationMutationVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
}>;


export type GetTravelLineRestartIntegrationMutation = { __typename?: 'Mutation', travelLineRestartIntegration: { __typename?: 'TravelLineRestartIntegrationPayload', View?: { __typename?: 'TravelLineRestartIntegrationView', hasExternalIntegrationIssue: boolean, channelManagerCode: ChannelManagerCode, master?: { __typename?: 'TravelLineIntegrationMasterView', masterStep: TravelLineMasterStep, hotelSetCid: string, steps: { __typename?: 'TravelLineMasterStepsView', integrationSettings?: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } } | null, roomCategoriesMapping?: { __typename?: 'RoomCategoriesMapping', roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null, touristTypesMapping?: { __typename?: 'TouristTypesMapping', touristTypesRefreshRequired: boolean, ageSettings: { __typename?: 'AgeSettings', initialAge: any, noSeatAge?: any | null, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null, placingVariantsMapping?: { __typename?: 'PlacingVariantsMapping', requiredPlacingVariants: Array<{ __typename?: 'RequiredPlacingVariant', roomCategoryCid: string, placingVariantName: string }> } | null, serviceGroupsMapping?: { __typename?: 'ServiceGroupsMapping', serviceGroups: Array<{ __typename?: 'TravelLineServiceGroupView', canChange: boolean, cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null } } | null } | null, errors?: Array<{ __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ChannelManagerInvalidContractNumberError', message: string } | { __typename: 'ChannelManagerMasterInvalidOperationError', message: string } | { __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'InvalidContractNumberError', message: string }> | null } };

export type TravelLineIntegrationQueryVariables = Exact<{
  contractNumber: Scalars['UnsignedInt']['input'];
  interactionId: Scalars['UUID']['input'];
}>;


export type TravelLineIntegrationQuery = { __typename?: 'Query', travelLineIntegration?: { __typename?: 'TravelLineIntegrationView', hasExternalIntegrationIssue: boolean, channelManagerCode: ChannelManagerCode, master?: { __typename?: 'TravelLineIntegrationMasterView', masterStep: TravelLineMasterStep, hotelSetCid: string, steps: { __typename?: 'TravelLineMasterStepsView', integrationSettings?: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } } | null, roomCategoriesMapping?: { __typename?: 'RoomCategoriesMapping', roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null, touristTypesMapping?: { __typename?: 'TouristTypesMapping', touristTypesRefreshRequired: boolean, ageSettings: { __typename?: 'AgeSettings', initialAge: any, noSeatAge?: any | null, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null, placingVariantsMapping?: { __typename?: 'PlacingVariantsMapping', requiredPlacingVariants: Array<{ __typename?: 'RequiredPlacingVariant', roomCategoryCid: string, placingVariantName: string }> } | null, serviceGroupsMapping?: { __typename?: 'ServiceGroupsMapping', serviceGroups: Array<{ __typename?: 'TravelLineServiceGroupView', canChange: boolean, cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null } } | null, externalIntegration?: { __typename?: 'TravelLineExternalIntegration', externalId: string, integrationUrl?: string | null, externalHotel?: { __typename?: 'ExternalHotel', hotelId: any, hotelName: string } | null } | null } | null };

export type UncompletedIntegrationInfoQueryVariables = Exact<{
  hotelId: Scalars['UnsignedInt']['input'];
  hotelName: Scalars['String']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
  channelManagerCode: ChannelManagerCode;
}>;


export type UncompletedIntegrationInfoQuery = { __typename?: 'Query', uncompletedIntegrationInfo?: { __typename?: 'TravelLineUncompletedIntegrationView', channelManagerCode: ChannelManagerCode, integrationId: any, externalIntegration: { __typename?: 'TravelLineExternalIntegration', externalId: string, integrationUrl?: string | null, externalHotel?: { __typename?: 'ExternalHotel', hotelId: any, hotelName: string } | null } } | null };

export type TlPlacingVariantFragment = { __typename?: 'PlacingVariantTarificationView', name: string, isChecked: boolean, mandatory: boolean, tarification?: { __typename?: 'PlacingVariantTarification', maxNoSeatQuantity: any, roomPlacingCid: string, pricePerRoom: boolean, isNeedConfirm: boolean, defaultAvailable: boolean } | null, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } };

export type GetTravelLinePlacingVariantsQueryVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
}>;


export type GetTravelLinePlacingVariantsQuery = { __typename?: 'Query', travelLinePlacingVariants?: { __typename?: 'GeneratedPlacingVariantsView', invalidRoomCategoryCids?: Array<string> | null, placingVariantsTarification?: Array<{ __typename?: 'RoomCategoryPlacingsView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }, suggestedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', name: string, isChecked: boolean, mandatory: boolean, tarification?: { __typename?: 'PlacingVariantTarification', maxNoSeatQuantity: any, roomPlacingCid: string, pricePerRoom: boolean, isNeedConfirm: boolean, defaultAvailable: boolean } | null, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } }>, conflictedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', name: string, isChecked: boolean, mandatory: boolean, tarification?: { __typename?: 'PlacingVariantTarification', maxNoSeatQuantity: any, roomPlacingCid: string, pricePerRoom: boolean, isNeedConfirm: boolean, defaultAvailable: boolean } | null, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } }> }> | null } | null };

export type TravelLineStartIntegrationMutationVariables = Exact<{
  hotelId: Scalars['UnsignedInt']['input'];
  hotelName: Scalars['String']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
  channelManagerCode: ChannelManagerCode;
}>;


export type TravelLineStartIntegrationMutation = { __typename?: 'Mutation', travelLineStartIntegration: { __typename?: 'TravelLineStartIntegrationPayload', InteractionId?: any | null, errors?: Array<{ __typename: 'ContractNotFoundError', message: string } | { __typename: 'TravelLineExternalIntegrationIssueError', message: string } | { __typename: 'TravelLineHotelNotFoundError', message: string }> | null } };

export type TravelLineUpdateIntegrationSettingsMutationVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
  connectionName: Array<LangStringInput> | LangStringInput;
  penaltySchemeCode: Scalars['String']['input'];
  supplierPayRuleCode: Scalars['String']['input'];
  checkInTime: Scalars['TimeSpan']['input'];
  checkOutTime: Scalars['TimeSpan']['input'];
  nextDayCheckout: Scalars['Boolean']['input'];
}>;


export type TravelLineUpdateIntegrationSettingsMutation = { __typename?: 'Mutation', travelLineUpdateIntegrationSettings: { __typename?: 'TravelLineUpdateIntegrationSettingsPayload', View?: { __typename?: 'TravelLineMasterStepsView', integrationSettings?: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } } | null, roomCategoriesMapping?: { __typename?: 'RoomCategoriesMapping', roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null, touristTypesMapping?: { __typename?: 'TouristTypesMapping', touristTypesRefreshRequired: boolean, ageSettings: { __typename?: 'AgeSettings', initialAge: any, noSeatAge?: any | null, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null, placingVariantsMapping?: { __typename?: 'PlacingVariantsMapping', requiredPlacingVariants: Array<{ __typename?: 'RequiredPlacingVariant', roomCategoryCid: string, placingVariantName: string }> } | null, serviceGroupsMapping?: { __typename?: 'ServiceGroupsMapping', serviceGroups: Array<{ __typename?: 'TravelLineServiceGroupView', canChange: boolean, cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null } | null, errors?: Array<{ __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ChannelManagerMasterInvalidOperationError', message: string } | { __typename: 'ContractNotFoundError', message: string } | { __typename: 'OutOfContractPeriodError', message: string }> | null } };

export type TravelLineSaveRoomCategoriesMappingMutationVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
  roomCategories: Array<ExternalObjectTranslationInput> | ExternalObjectTranslationInput;
}>;


export type TravelLineSaveRoomCategoriesMappingMutation = { __typename?: 'Mutation', travelLineSaveRoomCategoriesMapping: { __typename?: 'TravelLineSaveRoomCategoriesMappingPayload', status?: string | null, errors?: Array<{ __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'InvalidContractNumberError', message: string }> | null } };

export type TravelLineSaveServiceGroupsMappingMutationVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
  serviceGroups: Array<ExternalObjectTranslationInput> | ExternalObjectTranslationInput;
}>;


export type TravelLineSaveServiceGroupsMappingMutation = { __typename?: 'Mutation', travelLineSaveServiceGroupsMapping: { __typename?: 'TravelLineSaveServiceGroupsMappingPayload', status?: string | null, errors?: Array<{ __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'InvalidContractNumberError', message: string }> | null } };

export type TravelLineUpdateServiceGroupsMutationVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
  serviceGroups: Array<ExternalObjectTranslationInput> | ExternalObjectTranslationInput;
}>;


export type TravelLineUpdateServiceGroupsMutation = { __typename?: 'Mutation', travelLineUpdateServiceGroups: { __typename?: 'TravelLineUpdateServiceGroupsPayload', View?: { __typename?: 'TravelLineMasterStepsView', integrationSettings?: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } } | null, roomCategoriesMapping?: { __typename?: 'RoomCategoriesMapping', roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null, touristTypesMapping?: { __typename?: 'TouristTypesMapping', touristTypesRefreshRequired: boolean, ageSettings: { __typename?: 'AgeSettings', initialAge: any, noSeatAge?: any | null, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null, placingVariantsMapping?: { __typename?: 'PlacingVariantsMapping', requiredPlacingVariants: Array<{ __typename?: 'RequiredPlacingVariant', roomCategoryCid: string, placingVariantName: string }> } | null, serviceGroupsMapping?: { __typename?: 'ServiceGroupsMapping', serviceGroups: Array<{ __typename?: 'TravelLineServiceGroupView', canChange: boolean, cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null } | null, errors?: Array<{ __typename: 'ChannelManagerAdditionalMappingRequiredError', message: string } | { __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ChannelManagerMasterInvalidOperationError', message: string } | { __typename: 'InvalidContractNumberError', message: string } | { __typename: 'ServiceGroupNotFoundError', message: string } | { __typename: 'TravelLineCanNotCahengeExternalObjectMappingError', message: string } | { __typename: 'TravelLineExternalIntegrationIssueError', message: string } | { __typename: 'TravelLineFulfillmentErrorError', message: string }> | null } };

export type TravelLineUpdateRoomCategoriesMutationVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
  roomCategories: Array<ExternalObjectTranslationInput> | ExternalObjectTranslationInput;
}>;


export type TravelLineUpdateRoomCategoriesMutation = { __typename?: 'Mutation', travelLineUpdateRoomCategories: { __typename?: 'TravelLineUpdateRoomCategoriesPayload', View?: { __typename?: 'TravelLineMasterStepsView', integrationSettings?: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } } | null, roomCategoriesMapping?: { __typename?: 'RoomCategoriesMapping', roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null, touristTypesMapping?: { __typename?: 'TouristTypesMapping', touristTypesRefreshRequired: boolean, ageSettings: { __typename?: 'AgeSettings', initialAge: any, noSeatAge?: any | null, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null, placingVariantsMapping?: { __typename?: 'PlacingVariantsMapping', requiredPlacingVariants: Array<{ __typename?: 'RequiredPlacingVariant', roomCategoryCid: string, placingVariantName: string }> } | null, serviceGroupsMapping?: { __typename?: 'ServiceGroupsMapping', serviceGroups: Array<{ __typename?: 'TravelLineServiceGroupView', canChange: boolean, cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null } | null, errors?: Array<{ __typename: 'ChannelManagerAdditionalMappingRequiredError', message: string } | { __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ChannelManagerMasterInvalidOperationError', message: string } | { __typename: 'InvalidContractNumberError', message: string } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'TravelLineExternalIntegrationIssueError', message: string } | { __typename: 'TravelLineFulfillmentErrorError', message: string }> | null } };

export type TravelLineUpdateTouristTypesMutationVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
  determineAgeMethod: DetermineAgeMethod;
}>;


export type TravelLineUpdateTouristTypesMutation = { __typename?: 'Mutation', travelLineUpdateTouristTypes: { __typename?: 'TravelLineUpdateTouristTypesPayload', View?: { __typename?: 'TravelLineMasterStepsView', integrationSettings?: { __typename?: 'IntegrationSettings', penaltySchemeCode: string, supplierPayRuleCode: string, connectionName: Array<{ __typename?: 'LangString', langCode: string, value: string }>, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean } } | null, roomCategoriesMapping?: { __typename?: 'RoomCategoriesMapping', roomCategories: Array<{ __typename?: 'RoomCategoryView', cid: string, shortName: string, isActive: boolean, type: { __typename?: 'RoomType', cid: string, name: string }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus, fullEdit: boolean } }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null, touristTypesMapping?: { __typename?: 'TouristTypesMapping', touristTypesRefreshRequired: boolean, ageSettings: { __typename?: 'AgeSettings', initialAge: any, noSeatAge?: any | null, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null, placingVariantsMapping?: { __typename?: 'PlacingVariantsMapping', requiredPlacingVariants: Array<{ __typename?: 'RequiredPlacingVariant', roomCategoryCid: string, placingVariantName: string }> } | null, serviceGroupsMapping?: { __typename?: 'ServiceGroupsMapping', serviceGroups: Array<{ __typename?: 'TravelLineServiceGroupView', canChange: boolean, cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, translationTable: Array<{ __typename?: 'ExternalObjectTranslationView', cid?: string | null, externalObject: { __typename?: 'ExternalObjectView', id: string, name: string } }> } | null } | null, errors?: Array<{ __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ChannelManagerMasterInvalidOperationError', message: string } | { __typename: 'InvalidContractNumberError', message: string } | { __typename: 'TravelLineExternalIntegrationIssueError', message: string } | { __typename: 'TravelLineFulfillmentErrorError', message: string } | { __typename: 'TravelLineInitialAgeExceedError', message: string } | { __typename: 'TravelLineInitialAgeOverrideError', message: string } | { __typename: 'TravelLineTouristTypesHasGapsError', message: string }> | null } };

export type TravelLineUpdatePlacingVariantsMutationVariables = Exact<{
  interactionId: Scalars['UUID']['input'];
  contractNumber: Scalars['UnsignedInt']['input'];
  roomPlacingVariants: Array<TariffScheduleRoomPlacingVariantInput> | TariffScheduleRoomPlacingVariantInput;
}>;


export type TravelLineUpdatePlacingVariantsMutation = { __typename?: 'Mutation', travelLineUpdatePlacingVariants: { __typename?: 'TravelLineUpdatePlacingVariantsPayload', View?: { __typename?: 'TravelLineMasterCompletedView', tariffScheduleCID: string } | null, errors?: Array<{ __typename: 'ChannelManagerAdditionalMappingRequiredError', message: string } | { __typename: 'ChannelManagerInteractionInvalidStateError', message: string } | { __typename: 'ChannelManagerInteractionNotFoundError', message: string } | { __typename: 'ChannelManagerMasterInvalidOperationError', message: string } | { __typename: 'InvalidContractNumberError', message: string } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'TravelLineExternalIntegrationIssueError', message: string } | { __typename: 'TravelLineFulfillmentErrorError', message: string } | { __typename: 'TravelLinePlacingVariantExceedsRoomCategoryCapacityError', message: string } | { __typename: 'TravelLinePlacingVariantsNotFulfilledError', message: string }> | null } };

export type TabsFragment = { __typename?: 'TabsView', grid: { __typename?: 'TariffGridView', services: Array<{ __typename?: 'TariffGridServiceView', roomCategories: Array<{ __typename?: 'TariffGridRoomCategoryView', placingFactors: Array<{ __typename?: 'TariffGridPlacingFactorView', placingFactor: { __typename?: 'PlacingFactorView', roomPlacing?: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } } | null, touristPlace?: { __typename?: 'TouristPlaceView', relatedRoomPlacings: Array<string>, touristPlace: { __typename?: 'TouristPlaceDto', isAdditional: boolean, touristTypeCID: string }, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } } | null }, rates: Array<{ __typename?: 'TariffRateView', period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, price?: { __typename?: 'RatePriceView', nominal: any, sale: any } | null }> }>, roomCategory: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus }, type: { __typename?: 'RoomType', cid: string, name: string } } }>, serviceGroup: { __typename?: 'TariffScheduleServiceGroupView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'ServiceGroupOperations', edit: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', applyMethod: ApplyMethod, calculationMethod: CalculationMethod, cid: string, shortName: string, operations: { __typename?: 'ServiceOperations', delete: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, serviceType: { __typename?: 'ServiceType', cid: string, name: string, shortName: string } }> } }> }, comissions: { __typename?: 'ComissionsView', comissions: Array<{ __typename?: 'ComissionRateView', rate: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> } };

export type GridFragment = { __typename?: 'TariffScheduleGridView', invalidCommissions: boolean, baseSettings: { __typename?: 'BaseSettingsView', currencyIsoCode: string, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, operations: { __typename?: 'PriceGridOperations', edit: OperationStatus }, tabs?: { __typename?: 'TabsView', grid: { __typename?: 'TariffGridView', services: Array<{ __typename?: 'TariffGridServiceView', roomCategories: Array<{ __typename?: 'TariffGridRoomCategoryView', placingFactors: Array<{ __typename?: 'TariffGridPlacingFactorView', placingFactor: { __typename?: 'PlacingFactorView', roomPlacing?: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } } | null, touristPlace?: { __typename?: 'TouristPlaceView', relatedRoomPlacings: Array<string>, touristPlace: { __typename?: 'TouristPlaceDto', isAdditional: boolean, touristTypeCID: string }, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } } | null }, rates: Array<{ __typename?: 'TariffRateView', period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, price?: { __typename?: 'RatePriceView', nominal: any, sale: any } | null }> }>, roomCategory: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus }, type: { __typename?: 'RoomType', cid: string, name: string } } }>, serviceGroup: { __typename?: 'TariffScheduleServiceGroupView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'ServiceGroupOperations', edit: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', applyMethod: ApplyMethod, calculationMethod: CalculationMethod, cid: string, shortName: string, operations: { __typename?: 'ServiceOperations', delete: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, serviceType: { __typename?: 'ServiceType', cid: string, name: string, shortName: string } }> } }> }, comissions: { __typename?: 'ComissionsView', comissions: Array<{ __typename?: 'ComissionRateView', rate: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> } } | null };

export type SeatsFragmentFragment = { __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } };

export type RoomPlacingPlacingVariantFragment = { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> };

export type StartTariffGridEditMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type StartTariffGridEditMutation = { __typename?: 'Mutation', tariffGridEdit: { __typename?: 'TariffGridEditPayload', Grid?: { __typename?: 'TariffScheduleGridView', invalidCommissions: boolean, baseSettings: { __typename?: 'BaseSettingsView', currencyIsoCode: string, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, operations: { __typename?: 'PriceGridOperations', edit: OperationStatus }, tabs?: { __typename?: 'TabsView', grid: { __typename?: 'TariffGridView', services: Array<{ __typename?: 'TariffGridServiceView', roomCategories: Array<{ __typename?: 'TariffGridRoomCategoryView', placingFactors: Array<{ __typename?: 'TariffGridPlacingFactorView', placingFactor: { __typename?: 'PlacingFactorView', roomPlacing?: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } } | null, touristPlace?: { __typename?: 'TouristPlaceView', relatedRoomPlacings: Array<string>, touristPlace: { __typename?: 'TouristPlaceDto', isAdditional: boolean, touristTypeCID: string }, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } } | null }, rates: Array<{ __typename?: 'TariffRateView', period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, price?: { __typename?: 'RatePriceView', nominal: any, sale: any } | null }> }>, roomCategory: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus }, type: { __typename?: 'RoomType', cid: string, name: string } } }>, serviceGroup: { __typename?: 'TariffScheduleServiceGroupView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'ServiceGroupOperations', edit: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', applyMethod: ApplyMethod, calculationMethod: CalculationMethod, cid: string, shortName: string, operations: { __typename?: 'ServiceOperations', delete: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, serviceType: { __typename?: 'ServiceType', cid: string, name: string, shortName: string } }> } }> }, comissions: { __typename?: 'ComissionsView', comissions: Array<{ __typename?: 'ComissionRateView', rate: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> } } | null } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type KeepAliveTariffGridEditMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type KeepAliveTariffGridEditMutation = { __typename?: 'Mutation', tariffGridKeepAlive: { __typename?: 'TariffGridKeepAlivePayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type CancelTariffGridEditMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type CancelTariffGridEditMutation = { __typename?: 'Mutation', tariffGridCancelEdit: { __typename?: 'TariffGridCancelEditPayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type UpdateTariffGridMutationVariables = Exact<{
  input: TariffGridUpdateInput;
}>;


export type UpdateTariffGridMutation = { __typename?: 'Mutation', tariffGridUpdate: { __typename?: 'TariffGridUpdatePayload', Grid?: { __typename?: 'TariffScheduleGridView', invalidCommissions: boolean, baseSettings: { __typename?: 'BaseSettingsView', currencyIsoCode: string, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, operations: { __typename?: 'PriceGridOperations', edit: OperationStatus }, tabs?: { __typename?: 'TabsView', grid: { __typename?: 'TariffGridView', services: Array<{ __typename?: 'TariffGridServiceView', roomCategories: Array<{ __typename?: 'TariffGridRoomCategoryView', placingFactors: Array<{ __typename?: 'TariffGridPlacingFactorView', placingFactor: { __typename?: 'PlacingFactorView', roomPlacing?: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } } | null, touristPlace?: { __typename?: 'TouristPlaceView', relatedRoomPlacings: Array<string>, touristPlace: { __typename?: 'TouristPlaceDto', isAdditional: boolean, touristTypeCID: string }, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } } | null }, rates: Array<{ __typename?: 'TariffRateView', period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, price?: { __typename?: 'RatePriceView', nominal: any, sale: any } | null }> }>, roomCategory: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus }, type: { __typename?: 'RoomType', cid: string, name: string } } }>, serviceGroup: { __typename?: 'TariffScheduleServiceGroupView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'ServiceGroupOperations', edit: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', applyMethod: ApplyMethod, calculationMethod: CalculationMethod, cid: string, shortName: string, operations: { __typename?: 'ServiceOperations', delete: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, serviceType: { __typename?: 'ServiceType', cid: string, name: string, shortName: string } }> } }> }, comissions: { __typename?: 'ComissionsView', comissions: Array<{ __typename?: 'ComissionRateView', rate: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> } } | null } | null, errors?: Array<{ __typename: 'ConcurrencyConflictError', message: string } | { __typename: 'CurrencyListNotFoundError', message: string } | { __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'OperationForbiddenError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'PlacingVariantsNotBelongsToTariffScheduleError', message: string } | { __typename: 'RoomCategoriesNotBelongsToTariffScheduleError', message: string } | { __typename: 'RoomCategoryListNotFoundError', message: string } | { __typename: 'RoomPlacingListNotFoundError', message: string } | { __typename: 'ServiceGroupsNotBelongsToTariffScheduleError', message: string } | { __typename: 'TariffScheduleGridPeriodConflictBasePeriodError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string } | { __typename: 'TouristTypeListNotFoundError', message: string } | { __typename: 'TouristTypesNotBelongsToTariffScheduleError', message: string }> | null } };

export type QuotaFragmentFragment = { __typename?: 'QuotaView', contractNumber: number, shortName: string, operations: { __typename?: 'QuotaOperations', addRooms: OperationStatus, removeRooms: OperationStatus, updateReserves: OperationStatus }, roomQuotas: Array<{ __typename?: 'RoomQuotaView', quotas: Array<{ __typename?: 'QuotaPeriodView', isClosed: boolean, ordered: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, reserve?: { __typename?: 'ReserveView', byRequest: boolean, free: any, reserved: any } | null }>, room: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', edit: OperationStatus, delete: OperationStatus }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', cid: string, name: string } } }> };

export type QuotaRoomCategoryFragmentFragment = { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', edit: OperationStatus, delete: OperationStatus }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } };

export type GetQuotaQueryVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type GetQuotaQuery = { __typename?: 'Query', quota?: { __typename?: 'QuotaView', contractNumber: number, shortName: string, operations: { __typename?: 'QuotaOperations', addRooms: OperationStatus, removeRooms: OperationStatus, updateReserves: OperationStatus }, roomQuotas: Array<{ __typename?: 'RoomQuotaView', quotas: Array<{ __typename?: 'QuotaPeriodView', isClosed: boolean, ordered: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, reserve?: { __typename?: 'ReserveView', byRequest: boolean, free: any, reserved: any } | null }>, room: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', edit: OperationStatus, delete: OperationStatus }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', cid: string, name: string } } }> } | null };

export type EditQuotaInitialValuesStartMutationVariables = Exact<{
  input: EditQuotaAddRoomsInput;
}>;


export type EditQuotaInitialValuesStartMutation = { __typename?: 'Mutation', editQuotaAddRooms: { __typename?: 'EditQuotaAddRoomsPayload', roomQuotas?: Array<{ __typename?: 'RoomCategoryView', cid: string, isActive: boolean, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', edit: OperationStatus, delete: OperationStatus }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', name: string, cid: string } }> | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'QuotaNotFoundError', message: string } | { __typename: 'RoomCategoriesForAddingNotFoundError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type EditQuotaInitialValuesKeepAliveMutationVariables = Exact<{
  input: KeepAliveQuotaAddRoomsInput;
}>;


export type EditQuotaInitialValuesKeepAliveMutation = { __typename?: 'Mutation', keepAliveQuotaAddRooms: { __typename?: 'KeepAliveQuotaAddRoomsPayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'QuotaNotFoundError', message: string }> | null } };

export type EditQuotaInitialValuesCancelMutationVariables = Exact<{
  input: CancelEditQuotaAddRoomsInput;
}>;


export type EditQuotaInitialValuesCancelMutation = { __typename?: 'Mutation', cancelEditQuotaAddRooms: { __typename?: 'CancelEditQuotaAddRoomsPayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'QuotaNotFoundError', message: string }> | null } };

export type EditQuotaInitialValuesUpdateMutationVariables = Exact<{
  input: UpdateQuotaAddRoomsInput;
}>;


export type EditQuotaInitialValuesUpdateMutation = { __typename?: 'Mutation', updateQuotaAddRooms: { __typename?: 'UpdateQuotaAddRoomsPayload', quotaView?: { __typename?: 'QuotaView', contractNumber: number, shortName: string, operations: { __typename?: 'QuotaOperations', addRooms: OperationStatus, removeRooms: OperationStatus, updateReserves: OperationStatus }, roomQuotas: Array<{ __typename?: 'RoomQuotaView', quotas: Array<{ __typename?: 'QuotaPeriodView', isClosed: boolean, ordered: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, reserve?: { __typename?: 'ReserveView', byRequest: boolean, free: any, reserved: any } | null }>, room: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', edit: OperationStatus, delete: OperationStatus }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', cid: string, name: string } } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'QuotaNotFoundError', message: string } | { __typename: 'RoomCategoriesNotBelongsToQuotaError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type EditQuotaReservesStartMutationVariables = Exact<{
  input: EditQuotaReservesUpdateInput;
}>;


export type EditQuotaReservesStartMutation = { __typename?: 'Mutation', editQuotaReservesUpdate: { __typename?: 'EditQuotaReservesUpdatePayload', Quota?: { __typename?: 'QuotaView', contractNumber: number, shortName: string, operations: { __typename?: 'QuotaOperations', addRooms: OperationStatus, removeRooms: OperationStatus, updateReserves: OperationStatus }, roomQuotas: Array<{ __typename?: 'RoomQuotaView', quotas: Array<{ __typename?: 'QuotaPeriodView', isClosed: boolean, ordered: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, reserve?: { __typename?: 'ReserveView', byRequest: boolean, free: any, reserved: any } | null }>, room: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', edit: OperationStatus, delete: OperationStatus }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', cid: string, name: string } } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'QuotaNotFoundError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type EditQuotaReservesKeepAliveMutationVariables = Exact<{
  input: KeepAliveQuotaReservesUpdateInput;
}>;


export type EditQuotaReservesKeepAliveMutation = { __typename?: 'Mutation', keepAliveQuotaReservesUpdate: { __typename?: 'KeepAliveQuotaReservesUpdatePayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'QuotaNotFoundError', message: string }> | null } };

export type EditQuotaReservesCancelMutationVariables = Exact<{
  input: CancelEditQuotaReservesUpdateInput;
}>;


export type EditQuotaReservesCancelMutation = { __typename?: 'Mutation', cancelEditQuotaReservesUpdate: { __typename?: 'CancelEditQuotaReservesUpdatePayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'QuotaNotFoundError', message: string }> | null } };

export type IncorrectQuotaChangeErrorFragment = { __typename?: 'IncorrectQuotaChangeOperationError', roomCategoryCid: string, roomCategoryName: string, from: any, to: any, requiredReserve: any, booked: any };

export type EditQuotaReservesUpdateMutationVariables = Exact<{
  input: UpdateQuotaReservesUpdateInput;
}>;


export type EditQuotaReservesUpdateMutation = { __typename?: 'Mutation', updateQuotaReservesUpdate: { __typename?: 'UpdateQuotaReservesUpdatePayload', Quota?: { __typename?: 'QuotaView', contractNumber: number, shortName: string, operations: { __typename?: 'QuotaOperations', addRooms: OperationStatus, removeRooms: OperationStatus, updateReserves: OperationStatus }, roomQuotas: Array<{ __typename?: 'RoomQuotaView', quotas: Array<{ __typename?: 'QuotaPeriodView', isClosed: boolean, ordered: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, reserve?: { __typename?: 'ReserveView', byRequest: boolean, free: any, reserved: any } | null }>, room: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'RoomCategoryOperations', edit: OperationStatus, delete: OperationStatus }, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, type: { __typename?: 'RoomType', cid: string, name: string } } }> } | null, errors?: Array<{ __typename: 'ContractStatusInappropriateForQuotaChangeError', message: string } | { __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'IncorrectQuotaChangeOperationError', message: string, roomCategoryCid: string, roomCategoryName: string, from: any, to: any, requiredReserve: any, booked: any } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'QuotaNotFoundError', message: string } | { __typename: 'QuotaOperationPeriodNotWithinContractPeriodError', message: string } | { __typename: 'RoomCategoriesNotBelongsToQuotaError', message: string } | { __typename: 'RoomCategoryListNotFoundError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type CheckInOutRestrictionsFragmentFragment = { __typename?: 'RestrictionsCheckInOutSettingsView', operations: { __typename?: 'RestrictionsCheckInOutSettingsOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: { __typename?: 'RestrictionCheckInOutSettingsDefaultView', defaultOptions: { __typename?: 'RestrictionsCheckInOutSettingsOptions', nextDayCheckout: boolean, checkIn: any, checkOut: any } }, grid: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, table: Array<{ __typename?: 'RestrictionCheckInOutSettingsTableRowView', restriction: { __typename?: 'RestrictionViewOfRestrictionsCheckInOutSettingsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsCheckInOutSettingsOptions', checkIn: any, checkOut: any, nextDayCheckout: boolean }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } } }> };

export type GetCheckInOutRestrictionsQueryVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type GetCheckInOutRestrictionsQuery = { __typename?: 'Query', restrictionsCheckInOutSettings: { __typename?: 'RestrictionsCheckInOutSettingsView', operations: { __typename?: 'RestrictionsCheckInOutSettingsOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: { __typename?: 'RestrictionCheckInOutSettingsDefaultView', defaultOptions: { __typename?: 'RestrictionsCheckInOutSettingsOptions', nextDayCheckout: boolean, checkIn: any, checkOut: any } }, grid: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, table: Array<{ __typename?: 'RestrictionCheckInOutSettingsTableRowView', restriction: { __typename?: 'RestrictionViewOfRestrictionsCheckInOutSettingsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsCheckInOutSettingsOptions', checkIn: any, checkOut: any, nextDayCheckout: boolean }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } } }> } };

export type AddCheckInOutRestrictionMutationVariables = Exact<{
  input: AddRestrictionsCheckInOutSettingInput;
}>;


export type AddCheckInOutRestrictionMutation = { __typename?: 'Mutation', addRestrictionsCheckInOutSetting: { __typename?: 'AddRestrictionsCheckInOutSettingPayload', Grid?: { __typename?: 'RestrictionsCheckInOutSettingsView', operations: { __typename?: 'RestrictionsCheckInOutSettingsOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: { __typename?: 'RestrictionCheckInOutSettingsDefaultView', defaultOptions: { __typename?: 'RestrictionsCheckInOutSettingsOptions', nextDayCheckout: boolean, checkIn: any, checkOut: any } }, grid: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, table: Array<{ __typename?: 'RestrictionCheckInOutSettingsTableRowView', restriction: { __typename?: 'RestrictionViewOfRestrictionsCheckInOutSettingsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsCheckInOutSettingsOptions', checkIn: any, checkOut: any, nextDayCheckout: boolean }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RestrictionDefaultConflictError', message: string } | { __typename: 'RestrictionNextDayCheckoutOverrideForbiddenError', message: string } | { __typename: 'RestrictionPeriodOverlapConflictError', message: string } | { __typename: 'RestrictionTariffSchedulePeriodConflictError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type UpdateCheckInOutRestrictionMutationVariables = Exact<{
  input: UpdateRestrictionsCheckInOutSettingInput;
}>;


export type UpdateCheckInOutRestrictionMutation = { __typename?: 'Mutation', updateRestrictionsCheckInOutSetting: { __typename?: 'UpdateRestrictionsCheckInOutSettingPayload', Grid?: { __typename?: 'RestrictionsCheckInOutSettingsView', operations: { __typename?: 'RestrictionsCheckInOutSettingsOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: { __typename?: 'RestrictionCheckInOutSettingsDefaultView', defaultOptions: { __typename?: 'RestrictionsCheckInOutSettingsOptions', nextDayCheckout: boolean, checkIn: any, checkOut: any } }, grid: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, table: Array<{ __typename?: 'RestrictionCheckInOutSettingsTableRowView', restriction: { __typename?: 'RestrictionViewOfRestrictionsCheckInOutSettingsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsCheckInOutSettingsOptions', checkIn: any, checkOut: any, nextDayCheckout: boolean }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RestrictionDefaultConflictError', message: string } | { __typename: 'RestrictionNextDayCheckoutOverrideForbiddenError', message: string } | { __typename: 'RestrictionNoChangeConflictError', message: string } | { __typename: 'RestrictionNotFoundError', message: string } | { __typename: 'RestrictionPeriodOverlapConflictError', message: string } | { __typename: 'RestrictionPeriodOverrideForbiddenError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type RemoveCheckInOutRestrictionMutationVariables = Exact<{
  input: RemoveRestrictionsCheckInOutSettingInput;
}>;


export type RemoveCheckInOutRestrictionMutation = { __typename?: 'Mutation', removeRestrictionsCheckInOutSetting: { __typename?: 'RemoveRestrictionsCheckInOutSettingPayload', Grid?: { __typename?: 'RestrictionsCheckInOutSettingsView', operations: { __typename?: 'RestrictionsCheckInOutSettingsOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: { __typename?: 'RestrictionCheckInOutSettingsDefaultView', defaultOptions: { __typename?: 'RestrictionsCheckInOutSettingsOptions', nextDayCheckout: boolean, checkIn: any, checkOut: any } }, grid: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }>, table: Array<{ __typename?: 'RestrictionCheckInOutSettingsTableRowView', restriction: { __typename?: 'RestrictionViewOfRestrictionsCheckInOutSettingsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsCheckInOutSettingsOptions', checkIn: any, checkOut: any, nextDayCheckout: boolean }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RestrictionNotFoundError', message: string } | { __typename: 'RestrictionPeriodOverrideForbiddenError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type PlacingVariantsRestrictionsOptionsFragmentFragment = { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null };

export type PlacingVariantsRestrictionsRoomCategoryFragmentFragment = { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } };

export type PlacingVariantsRestrictionsFragmentFragment = { __typename?: 'RestrictionsPlacingVariantsView', operations: { __typename?: 'RestrictionsPlacingVariantsOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: Array<{ __typename?: 'RestrictionFactorDefaultViewOfRestrictionsPlacingVariantsFactorKeyViewAndRestrictionsPlacingVariantsOptions', defaultOptions: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, restrictionFactorKey: { __typename?: 'RestrictionsPlacingVariantsFactorKeyView', roomCategoryCid: string, roomPlacingCid: string } }>, grid: Array<{ __typename?: 'RestrictionsRoomCategory', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } }, roomPlacings: Array<{ __typename?: 'RestrictionGridViewOfPlacingVariantDictView', restrictionFactor: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } }, restrictionPeriods: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }> }>, gridPeriod: { __typename?: 'RangeOfDateOnly', from: any, to: any }, table: Array<{ __typename?: 'RestrictionTableRowViewOfRestrictionsPlacingVariantsFactorViewAndRestrictionsPlacingVariantsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsPlacingVariantsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsPlacingVariantsFactorView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } }, roomPlacing: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string } } } }> };

export type GetPlacingVariantsRestrictionsQueryVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type GetPlacingVariantsRestrictionsQuery = { __typename?: 'Query', restrictionsPlacingVariants: { __typename?: 'RestrictionsPlacingVariantsView', operations: { __typename?: 'RestrictionsPlacingVariantsOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: Array<{ __typename?: 'RestrictionFactorDefaultViewOfRestrictionsPlacingVariantsFactorKeyViewAndRestrictionsPlacingVariantsOptions', defaultOptions: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, restrictionFactorKey: { __typename?: 'RestrictionsPlacingVariantsFactorKeyView', roomCategoryCid: string, roomPlacingCid: string } }>, grid: Array<{ __typename?: 'RestrictionsRoomCategory', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } }, roomPlacings: Array<{ __typename?: 'RestrictionGridViewOfPlacingVariantDictView', restrictionFactor: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } }, restrictionPeriods: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }> }>, gridPeriod: { __typename?: 'RangeOfDateOnly', from: any, to: any }, table: Array<{ __typename?: 'RestrictionTableRowViewOfRestrictionsPlacingVariantsFactorViewAndRestrictionsPlacingVariantsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsPlacingVariantsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsPlacingVariantsFactorView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } }, roomPlacing: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string } } } }> } };

export type AddPlacingVariantsRestrictionMutationVariables = Exact<{
  input: AddRestrictionsPlacingVariantsInput;
}>;


export type AddPlacingVariantsRestrictionMutation = { __typename?: 'Mutation', addRestrictionsPlacingVariants: { __typename?: 'AddRestrictionsPlacingVariantsPayload', Grid?: { __typename?: 'RestrictionsPlacingVariantsView', operations: { __typename?: 'RestrictionsPlacingVariantsOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: Array<{ __typename?: 'RestrictionFactorDefaultViewOfRestrictionsPlacingVariantsFactorKeyViewAndRestrictionsPlacingVariantsOptions', defaultOptions: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, restrictionFactorKey: { __typename?: 'RestrictionsPlacingVariantsFactorKeyView', roomCategoryCid: string, roomPlacingCid: string } }>, grid: Array<{ __typename?: 'RestrictionsRoomCategory', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } }, roomPlacings: Array<{ __typename?: 'RestrictionGridViewOfPlacingVariantDictView', restrictionFactor: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } }, restrictionPeriods: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }> }>, gridPeriod: { __typename?: 'RangeOfDateOnly', from: any, to: any }, table: Array<{ __typename?: 'RestrictionTableRowViewOfRestrictionsPlacingVariantsFactorViewAndRestrictionsPlacingVariantsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsPlacingVariantsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsPlacingVariantsFactorView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } }, roomPlacing: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string } } } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'PlacingVariantsNotBelongsToTariffScheduleError', message: string } | { __typename: 'RestrictionDefaultConflictError', message: string } | { __typename: 'RestrictionPeriodOverlapConflictError', message: string } | { __typename: 'RestrictionTariffSchedulePeriodConflictError', message: string } | { __typename: 'RoomCategoryNotBelongsToTariffScheduleError', message: string } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'RoomPlacingListNotFoundError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type UpdatePlacingVariantsRestrictionMutationVariables = Exact<{
  input: UpdateRestrictionsPlacingVariantInput;
}>;


export type UpdatePlacingVariantsRestrictionMutation = { __typename?: 'Mutation', updateRestrictionsPlacingVariant: { __typename?: 'UpdateRestrictionsPlacingVariantPayload', Grid?: { __typename?: 'RestrictionsPlacingVariantsView', operations: { __typename?: 'RestrictionsPlacingVariantsOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: Array<{ __typename?: 'RestrictionFactorDefaultViewOfRestrictionsPlacingVariantsFactorKeyViewAndRestrictionsPlacingVariantsOptions', defaultOptions: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, restrictionFactorKey: { __typename?: 'RestrictionsPlacingVariantsFactorKeyView', roomCategoryCid: string, roomPlacingCid: string } }>, grid: Array<{ __typename?: 'RestrictionsRoomCategory', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } }, roomPlacings: Array<{ __typename?: 'RestrictionGridViewOfPlacingVariantDictView', restrictionFactor: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } }, restrictionPeriods: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }> }>, gridPeriod: { __typename?: 'RangeOfDateOnly', from: any, to: any }, table: Array<{ __typename?: 'RestrictionTableRowViewOfRestrictionsPlacingVariantsFactorViewAndRestrictionsPlacingVariantsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsPlacingVariantsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsPlacingVariantsFactorView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } }, roomPlacing: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string } } } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RestrictionDefaultConflictError', message: string } | { __typename: 'RestrictionNoChangeConflictError', message: string } | { __typename: 'RestrictionNotFoundError', message: string } | { __typename: 'RestrictionPeriodOverlapConflictError', message: string } | { __typename: 'RestrictionPeriodOverrideForbiddenError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type RemovePlacingVariantsRestrictionMutationVariables = Exact<{
  input: RemoveRestrictionsPlacingVariantInput;
}>;


export type RemovePlacingVariantsRestrictionMutation = { __typename?: 'Mutation', removeRestrictionsPlacingVariant: { __typename?: 'RemoveRestrictionsPlacingVariantPayload', Grid?: { __typename?: 'RestrictionsPlacingVariantsView', operations: { __typename?: 'RestrictionsPlacingVariantsOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: Array<{ __typename?: 'RestrictionFactorDefaultViewOfRestrictionsPlacingVariantsFactorKeyViewAndRestrictionsPlacingVariantsOptions', defaultOptions: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, restrictionFactorKey: { __typename?: 'RestrictionsPlacingVariantsFactorKeyView', roomCategoryCid: string, roomPlacingCid: string } }>, grid: Array<{ __typename?: 'RestrictionsRoomCategory', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } }, roomPlacings: Array<{ __typename?: 'RestrictionGridViewOfPlacingVariantDictView', restrictionFactor: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } }, restrictionPeriods: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }> }>, gridPeriod: { __typename?: 'RangeOfDateOnly', from: any, to: any }, table: Array<{ __typename?: 'RestrictionTableRowViewOfRestrictionsPlacingVariantsFactorViewAndRestrictionsPlacingVariantsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsPlacingVariantsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsPlacingVariantsFactorView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, name: Array<{ __typename?: 'LangString', value: string }>, type: { __typename?: 'RoomType', name: string } }, roomPlacing: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string } } } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RestrictionNotFoundError', message: string } | { __typename: 'RestrictionPeriodOverrideForbiddenError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type ServiceGroupsRestrictionsOptionsFragmentFragment = { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null };

export type ServiceGroupsRestrictionsFragmentFragment = { __typename?: 'RestrictionsServiceGroupsView', operations: { __typename?: 'RestrictionOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: Array<{ __typename?: 'RestrictionFactorDefaultViewOfRestrictionsServiceGroupsFactorKeyViewAndRestrictionsServiceGroupsOptions', defaultOptions: { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null }, restrictionFactorKey: { __typename?: 'RestrictionsServiceGroupsFactorKeyView', serviceGroupCid: string } }>, grid: Array<{ __typename?: 'RestrictionGridViewOfRestrictionsServiceGroupsFactorView', restrictionFactor: { __typename?: 'RestrictionsServiceGroupsFactorView', cid: string, name?: string | null, shortName: string }, restrictionPeriods: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }>, gridPeriod: { __typename?: 'RangeOfDateOnly', from: any, to: any }, table: Array<{ __typename?: 'RestrictionTableRowViewOfRestrictionsServiceGroupsFactorViewAndRestrictionsServiceGroupsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsServiceGroupsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsServiceGroupsFactorView', cid: string, name?: string | null, shortName: string } }> };

export type GetServiceGroupsRestrictionsQueryVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type GetServiceGroupsRestrictionsQuery = { __typename?: 'Query', restrictionsServiceGroups: { __typename?: 'RestrictionsServiceGroupsView', operations: { __typename?: 'RestrictionOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: Array<{ __typename?: 'RestrictionFactorDefaultViewOfRestrictionsServiceGroupsFactorKeyViewAndRestrictionsServiceGroupsOptions', defaultOptions: { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null }, restrictionFactorKey: { __typename?: 'RestrictionsServiceGroupsFactorKeyView', serviceGroupCid: string } }>, grid: Array<{ __typename?: 'RestrictionGridViewOfRestrictionsServiceGroupsFactorView', restrictionFactor: { __typename?: 'RestrictionsServiceGroupsFactorView', cid: string, name?: string | null, shortName: string }, restrictionPeriods: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }>, gridPeriod: { __typename?: 'RangeOfDateOnly', from: any, to: any }, table: Array<{ __typename?: 'RestrictionTableRowViewOfRestrictionsServiceGroupsFactorViewAndRestrictionsServiceGroupsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsServiceGroupsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsServiceGroupsFactorView', cid: string, name?: string | null, shortName: string } }> } };

export type AddServiceGroupsRestrictionMutationVariables = Exact<{
  input: AddRestrictionsServiceGroupInput;
}>;


export type AddServiceGroupsRestrictionMutation = { __typename?: 'Mutation', addRestrictionsServiceGroup: { __typename?: 'AddRestrictionsServiceGroupPayload', Grid?: { __typename?: 'RestrictionsServiceGroupsView', operations: { __typename?: 'RestrictionOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: Array<{ __typename?: 'RestrictionFactorDefaultViewOfRestrictionsServiceGroupsFactorKeyViewAndRestrictionsServiceGroupsOptions', defaultOptions: { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null }, restrictionFactorKey: { __typename?: 'RestrictionsServiceGroupsFactorKeyView', serviceGroupCid: string } }>, grid: Array<{ __typename?: 'RestrictionGridViewOfRestrictionsServiceGroupsFactorView', restrictionFactor: { __typename?: 'RestrictionsServiceGroupsFactorView', cid: string, name?: string | null, shortName: string }, restrictionPeriods: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }>, gridPeriod: { __typename?: 'RangeOfDateOnly', from: any, to: any }, table: Array<{ __typename?: 'RestrictionTableRowViewOfRestrictionsServiceGroupsFactorViewAndRestrictionsServiceGroupsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsServiceGroupsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsServiceGroupsFactorView', cid: string, name?: string | null, shortName: string } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RestrictionDefaultConflictError', message: string } | { __typename: 'RestrictionPeriodOverlapConflictError', message: string } | { __typename: 'RestrictionTariffSchedulePeriodConflictError', message: string } | { __typename: 'ServiceGroupNotFoundError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type UpdateServiceGroupsRestrictionMutationVariables = Exact<{
  input: UpdateRestrictionsServiceGroupInput;
}>;


export type UpdateServiceGroupsRestrictionMutation = { __typename?: 'Mutation', updateRestrictionsServiceGroup: { __typename?: 'UpdateRestrictionsServiceGroupPayload', Grid?: { __typename?: 'RestrictionsServiceGroupsView', operations: { __typename?: 'RestrictionOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: Array<{ __typename?: 'RestrictionFactorDefaultViewOfRestrictionsServiceGroupsFactorKeyViewAndRestrictionsServiceGroupsOptions', defaultOptions: { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null }, restrictionFactorKey: { __typename?: 'RestrictionsServiceGroupsFactorKeyView', serviceGroupCid: string } }>, grid: Array<{ __typename?: 'RestrictionGridViewOfRestrictionsServiceGroupsFactorView', restrictionFactor: { __typename?: 'RestrictionsServiceGroupsFactorView', cid: string, name?: string | null, shortName: string }, restrictionPeriods: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }>, gridPeriod: { __typename?: 'RangeOfDateOnly', from: any, to: any }, table: Array<{ __typename?: 'RestrictionTableRowViewOfRestrictionsServiceGroupsFactorViewAndRestrictionsServiceGroupsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsServiceGroupsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsServiceGroupsFactorView', cid: string, name?: string | null, shortName: string } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RestrictionDefaultConflictError', message: string } | { __typename: 'RestrictionNoChangeConflictError', message: string } | { __typename: 'RestrictionNotFoundError', message: string } | { __typename: 'RestrictionPeriodOverlapConflictError', message: string } | { __typename: 'RestrictionPeriodOverrideForbiddenError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type RemoveServiceGroupsRestrictionMutationVariables = Exact<{
  input: RemoveRestrictionsServiceGroupInput;
}>;


export type RemoveServiceGroupsRestrictionMutation = { __typename?: 'Mutation', removeRestrictionsServiceGroup: { __typename?: 'RemoveRestrictionsServiceGroupPayload', Grid?: { __typename?: 'RestrictionsServiceGroupsView', operations: { __typename?: 'RestrictionOperations', add: OperationStatus, edit: OperationStatus, remove: OperationStatus }, defaults: Array<{ __typename?: 'RestrictionFactorDefaultViewOfRestrictionsServiceGroupsFactorKeyViewAndRestrictionsServiceGroupsOptions', defaultOptions: { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null }, restrictionFactorKey: { __typename?: 'RestrictionsServiceGroupsFactorKeyView', serviceGroupCid: string } }>, grid: Array<{ __typename?: 'RestrictionGridViewOfRestrictionsServiceGroupsFactorView', restrictionFactor: { __typename?: 'RestrictionsServiceGroupsFactorView', cid: string, name?: string | null, shortName: string }, restrictionPeriods: Array<{ __typename?: 'RestrictionGridPeriodView', restrictionId?: number | null, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> }>, gridPeriod: { __typename?: 'RangeOfDateOnly', from: any, to: any }, table: Array<{ __typename?: 'RestrictionTableRowViewOfRestrictionsServiceGroupsFactorViewAndRestrictionsServiceGroupsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsServiceGroupsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsServiceGroupsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionServiceGroupSaleOptions', isNeedConfirm: boolean, orderPeriod?: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any } | null } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsServiceGroupsFactorView', cid: string, name?: string | null, shortName: string } }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RestrictionNotFoundError', message: string } | { __typename: 'RestrictionPeriodOverrideForbiddenError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type ServiceGroupsFragment = { __typename?: 'TariffScheduleServiceGroupListItemView', isActive: boolean, defaultAvailable: boolean, isNeedConfirm: boolean, serviceGroupCid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, orderPeriod: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number }> };

export type ServiceGroupsListFragment = { __typename?: 'TariffScheduleServiceGroupsListView', operations: { __typename?: 'ServiceGroupListOperations', add: OperationStatus, edit: OperationStatus, hasMaximumServiceGroups: boolean }, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupListItemView', isActive: boolean, defaultAvailable: boolean, isNeedConfirm: boolean, serviceGroupCid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, orderPeriod: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number }> }> };

export type TariffScheduleServiceGroupsQueryVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type TariffScheduleServiceGroupsQuery = { __typename?: 'Query', tariffScheduleServiceGroups: { __typename?: 'TariffScheduleServiceGroupsListView', operations: { __typename?: 'ServiceGroupListOperations', add: OperationStatus, edit: OperationStatus, hasMaximumServiceGroups: boolean }, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupListItemView', isActive: boolean, defaultAvailable: boolean, isNeedConfirm: boolean, serviceGroupCid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, orderPeriod: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number }> }> } };

export type GetServiceGroupSuggestedServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceGroupSuggestedServicesQuery = { __typename?: 'Query', serviceGroupSuggestedServices: Array<{ __typename?: 'ServiceViewGrouped', services: Array<{ __typename?: 'ServiceView', cid: string, shortName: string, isFirst: boolean, isLast: boolean, sortNumber: number }> }> };

export type GetContractServiceGroupsQueryVariables = Exact<{
  contractNumber: Scalars['Int']['input'];
}>;


export type GetContractServiceGroupsQuery = { __typename?: 'Query', contractServiceGroups?: Array<{ __typename?: 'ContractServiceGroupsView', tariffSchedule: { __typename?: 'DictNameView', name: string, cid?: string | null }, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupView', cid: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number }> }> }> | null };

export type CalculateServiceSequenceQueryVariables = Exact<{
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
  serviceCids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  hotelSetCid: Scalars['String']['input'];
}>;


export type CalculateServiceSequenceQuery = { __typename?: 'Query', calculateServiceSequence?: Array<{ __typename?: 'CalculatedServiceSequenceView', cid: string, shortName: string, parentCid?: string | null, isFirst: boolean, isLast: boolean, sequenceNumber: number }> | null };

export type GetTariffScheduleServiceGroupsForRestrictionQueryVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
  checkInOutRestrictionId: Scalars['Int']['input'];
}>;


export type GetTariffScheduleServiceGroupsForRestrictionQuery = { __typename?: 'Query', tariffScheduleServiceGroupsForRestriction?: { __typename?: 'TariffScheduleServiceGroupsListView', operations: { __typename?: 'ServiceGroupListOperations', add: OperationStatus, edit: OperationStatus, hasMaximumServiceGroups: boolean }, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupListItemView', isActive: boolean, defaultAvailable: boolean, isNeedConfirm: boolean, serviceGroupCid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, orderPeriod: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number }> }> } | null };

export type CalculateTariffScheduleServiceGroupsQueryVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
  checkInOutSettings: CheckInOutSettingsInput;
}>;


export type CalculateTariffScheduleServiceGroupsQuery = { __typename?: 'Query', calculateTariffScheduleServiceGroups: { __typename?: 'TariffScheduleServiceGroupsListView', operations: { __typename?: 'ServiceGroupListOperations', add: OperationStatus, edit: OperationStatus, hasMaximumServiceGroups: boolean }, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupListItemView', isActive: boolean, defaultAvailable: boolean, isNeedConfirm: boolean, serviceGroupCid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, orderPeriod: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number }> }> } };

export type AddTariffScheduleServiceGroupMutationVariables = Exact<{
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
  hotelSetCid: Scalars['String']['input'];
  serviceGroup: ServiceGroupInput;
}>;


export type AddTariffScheduleServiceGroupMutation = { __typename?: 'Mutation', addTariffScheduleServiceGroup: { __typename?: 'AddTariffScheduleServiceGroupPayload', serviceGroups?: { __typename?: 'TariffScheduleServiceGroupsListView', operations: { __typename?: 'ServiceGroupListOperations', add: OperationStatus, edit: OperationStatus, hasMaximumServiceGroups: boolean }, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupListItemView', isActive: boolean, defaultAvailable: boolean, isNeedConfirm: boolean, serviceGroupCid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, orderPeriod: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number }> }> } | null, addedServiceGroup?: { __typename?: 'TariffScheduleServiceGroupListItemView', serviceGroupCid: string, services: Array<{ __typename?: 'ServiceView', cid: string, shortName: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError' } | { __typename: 'HotelSetNotFoundError' } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'ServicesNotAllowedForServiceGroupError' } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError' } | { __typename: 'TariffScheduleNotFoundError' } | { __typename: 'TariffScheduleServiceGroupMaxNumberExceedError' } | { __typename: 'TariffScheduleServiceGroupMutuallyExclusiveCidsFoundError' }> | null } };

export type TariffScheduleServiceGroupFragment = { __typename?: 'TariffScheduleServiceGroupView', cid: string, isActive: boolean, shortName: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'ServiceGroupOperations', edit: OperationStatus }, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }> };

export type GetTariffScheduleServiceGroupQueryVariables = Exact<{
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
  serviceGroupCid: Scalars['String']['input'];
  hotelSetCid: Scalars['String']['input'];
}>;


export type GetTariffScheduleServiceGroupQuery = { __typename?: 'Query', tariffScheduleServiceGroup?: { __typename?: 'TariffScheduleServiceGroupView', cid: string, isActive: boolean, shortName: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'ServiceGroupOperations', edit: OperationStatus }, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }> } | null };

export type EditTariffScheduleServiceGroupMutationVariables = Exact<{
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
  serviceGroupCid: Scalars['String']['input'];
  hotelSetCid: Scalars['String']['input'];
}>;


export type EditTariffScheduleServiceGroupMutation = { __typename?: 'Mutation', editTariffScheduleServiceGroup: { __typename?: 'EditTariffScheduleServiceGroupPayload', serviceGroup?: { __typename?: 'TariffScheduleServiceGroupView', cid: string, isActive: boolean, shortName: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'ServiceGroupOperations', edit: OperationStatus }, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'ServiceGroupNotFoundError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type KeepAliveTariffScheduleServiceGroupMutationVariables = Exact<{
  serviceGroupCid: Scalars['String']['input'];
  hotelSetCid: Scalars['String']['input'];
}>;


export type KeepAliveTariffScheduleServiceGroupMutation = { __typename?: 'Mutation', keepAliveTariffScheduleServiceGroup: { __typename?: 'KeepAliveTariffScheduleServiceGroupPayload', status?: string | null, errors?: Array<{ __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type CancelTariffScheduleServiceGroupMutationVariables = Exact<{
  serviceGroupCid: Scalars['String']['input'];
  hotelSetCid: Scalars['String']['input'];
}>;


export type CancelTariffScheduleServiceGroupMutation = { __typename?: 'Mutation', cancelEditTariffScheduleServiceGroup: { __typename?: 'CancelEditTariffScheduleServiceGroupPayload', status?: string | null, errors?: Array<{ __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type UpdateTariffScheduleServiceGroupMutationVariables = Exact<{
  hotelSetCid: Scalars['String']['input'];
  tariffScheduleCid?: InputMaybe<Scalars['String']['input']>;
  serviceGroupCid: Scalars['String']['input'];
  serviceGroup: ServiceGroupInput;
}>;


export type UpdateTariffScheduleServiceGroupMutation = { __typename?: 'Mutation', updateTariffScheduleServiceGroup: { __typename?: 'UpdateTariffScheduleServiceGroupPayload', serviceGroup?: { __typename?: 'TariffScheduleServiceGroupView', cid: string, isActive: boolean, shortName: string, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'ServiceGroupOperations', edit: OperationStatus }, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'ServiceGroupListNotBelongsToTariffScheduleError', message: string } | { __typename: 'ServiceGroupNotFoundError', message: string } | { __typename: 'ServicesNotAllowedForServiceGroupError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string } | { __typename: 'TariffScheduleServiceGroupMutuallyExclusiveCidsFoundError', message: string }> | null } };

export type EditTariffScheduleServiceGroupListMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type EditTariffScheduleServiceGroupListMutation = { __typename?: 'Mutation', editTariffScheduleServiceGroupList: { __typename?: 'EditTariffScheduleServiceGroupListPayload', serviceGroups?: { __typename?: 'TariffScheduleServiceGroupsListView', operations: { __typename?: 'ServiceGroupListOperations', add: OperationStatus, edit: OperationStatus, hasMaximumServiceGroups: boolean }, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupListItemView', isActive: boolean, defaultAvailable: boolean, isNeedConfirm: boolean, serviceGroupCid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, orderPeriod: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number }> }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError' } | { __typename: 'HotelSetNotFoundError' } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError' } | { __typename: 'TariffScheduleNotFoundError' }> | null } };

export type KeepAliveTariffScheduleServiceGroupListMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type KeepAliveTariffScheduleServiceGroupListMutation = { __typename?: 'Mutation', keepAliveTariffScheduleServiceGroupList: { __typename?: 'KeepAliveTariffScheduleServiceGroupListPayload', status?: string | null, errors?: Array<{ __typename: 'HotelSetNotFoundError' } | { __typename: 'OperationOnUnlockedResourceIsInvalidError' } | { __typename: 'TariffScheduleNotFoundError' }> | null } };

export type CancelEditTariffScheduleServiceGroupListMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type CancelEditTariffScheduleServiceGroupListMutation = { __typename?: 'Mutation', cancelEditTariffScheduleServiceGroupList: { __typename?: 'CancelEditTariffScheduleServiceGroupListPayload', status?: string | null, errors?: Array<{ __typename?: 'HotelSetNotFoundError', message: string } | { __typename?: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename?: 'TariffScheduleNotFoundError', message: string }> | null } };

export type UpdateTariffScheduleServiceGroupListMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
  serviceGroups: Array<ServiceGroupListInput> | ServiceGroupListInput;
}>;


export type UpdateTariffScheduleServiceGroupListMutation = { __typename?: 'Mutation', updateTariffScheduleServiceGroupList: { __typename?: 'UpdateTariffScheduleServiceGroupListPayload', serviceGroups?: { __typename?: 'TariffScheduleServiceGroupsListView', operations: { __typename?: 'ServiceGroupListOperations', add: OperationStatus, edit: OperationStatus, hasMaximumServiceGroups: boolean }, serviceGroups: Array<{ __typename?: 'TariffScheduleServiceGroupListItemView', isActive: boolean, defaultAvailable: boolean, isNeedConfirm: boolean, serviceGroupCid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, orderPeriod: { __typename?: 'ServiceGroupOrderPeriod', maxOrderPeriod?: any | null, minOrderPeriod: any }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', shortName: string, cid: string, isFirst: boolean, isLast: boolean, sortNumber: number }> }> } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'ServiceGroupsNotBelongsToTariffScheduleError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type RoomCategoryPlacingsViewFragment = { __typename?: 'RoomCategoryPlacingsView', conflictedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }>, roomCategory: { __typename?: 'RoomCategoryView', cid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, type: { __typename?: 'RoomType', cid: string, name: string } }, suggestedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }> };

export type PlacingVariantsViewFragment = { __typename?: 'PlacingVariantsView', placingVariants: Array<{ __typename?: 'RoomCategoryPlacingsView', conflictedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }>, roomCategory: { __typename?: 'RoomCategoryView', cid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, type: { __typename?: 'RoomType', cid: string, name: string } }, suggestedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }> }> };

export type TableFragment = { __typename?: 'RestrictionTableRowViewOfRestrictionsPlacingVariantsFactorViewAndRestrictionsPlacingVariantsOptions', restriction: { __typename?: 'RestrictionViewOfRestrictionsPlacingVariantsOptions', hasConflict: boolean, number: any, restrictionId: number, options: { __typename?: 'RestrictionsPlacingVariantsOptions', isOpened: boolean, options?: { __typename?: 'RestrictionsPlacingVariantsSaleOptions', isNeedConfirm: boolean } | null }, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, restrictionFactor: { __typename?: 'RestrictionsPlacingVariantsFactorView', roomPlacing: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } } } };

export type EditTariffScheduleMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type EditTariffScheduleMutation = { __typename?: 'Mutation', editTariffSchedule: { __typename?: 'EditTariffSchedulePayload', errors?: Array<{ __typename?: 'HotelSetHasRemoteIntegrationForbiddenError' } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename?: 'OperationForbiddenError' } | { __typename?: 'TariffScheduleMultipleVisitTimetableForbiddenError' } | { __typename?: 'TariffScheduleNotFoundError' }> | null } };

export type CancelEditTariffScheduleMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type CancelEditTariffScheduleMutation = { __typename?: 'Mutation', cancelEditTariffSchedule: { __typename?: 'CancelEditTariffSchedulePayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type SendTariffScheduleInWorkMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type SendTariffScheduleInWorkMutation = { __typename?: 'Mutation', sendTariffScheduleInWork: { __typename?: 'SendTariffScheduleInWorkPayload', tariffSchedule2View?: { __typename?: 'TariffSchedule2View', contractType: ContractType, status: TariffScheduleStatus, tariffScheduleCid: string, hotelSetCid: string, baseSettings: { __typename?: 'TariffScheduleBaseSettings2', completed: boolean, ageSettings: { __typename?: 'AgeSettings', determineAgeMethod: DetermineAgeMethod, initialAge: any, noSeatAge?: any | null, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } }, roomCategories: Array<{ __typename?: 'RoomCategoryQuota', roomCategoryCid: string, quotaStatus: QuotaStatus }> }, commonInformation: { __typename?: 'TariffScheduleCommonInformation', visitTimetableCount: number, hotelSetHasRemote: boolean, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, applyingRules: { __typename?: 'ApplyingRulesView', stopSalePeriodHours: any, penaltyScheme: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string }, supplierPayRule: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string } }, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean }, taxScheme: { __typename?: 'TaxSchemeSuggestion', cid: string, name: string } }, operations: { __typename?: 'TariffScheduleOperations', sendInWork: OperationStatus, startPVM: OperationStatus, update: OperationStatus, canEditPlacingVariants: OperationStatus }, remoteInteraction?: { __typename?: 'TariffScheduleRemoteInteraction', activeRemoting: boolean, channelManagerCode: ChannelManagerCode, interactionId: any, remoteIntegrationUrl?: string | null } | null } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'QuotaNotFilledError', message: string } | { __typename: 'QuotaPricesRequiredError', message: string } | { __typename: 'TariffScheduleAlreadyInWorkError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type TariffScheduleCommonInformationFragmentFragment = { __typename?: 'TariffScheduleCommonInformation', visitTimetableCount: number, hotelSetHasRemote: boolean, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, applyingRules: { __typename?: 'ApplyingRulesView', stopSalePeriodHours: any, penaltyScheme: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string }, supplierPayRule: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string } }, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean }, taxScheme: { __typename?: 'TaxSchemeSuggestion', cid: string, name: string } };

export type TariffScheduleCommonInformationUpdatedFragmentFragment = { __typename?: 'TariffScheduleCommonInformationUpdated', visitTimetableCount: number, hotelSetHasRemote: boolean, hasServiceSequenceChanged: boolean, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, applyingRules: { __typename?: 'ApplyingRulesView', stopSalePeriodHours: any, penaltyScheme: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string }, supplierPayRule: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string } }, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean }, taxScheme: { __typename?: 'TaxSchemeSuggestion', cid: string, name: string } };

export type TariffScheduleFragmentFragment = { __typename?: 'TariffSchedule2View', contractType: ContractType, status: TariffScheduleStatus, tariffScheduleCid: string, hotelSetCid: string, baseSettings: { __typename?: 'TariffScheduleBaseSettings2', completed: boolean, ageSettings: { __typename?: 'AgeSettings', determineAgeMethod: DetermineAgeMethod, initialAge: any, noSeatAge?: any | null, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } }, roomCategories: Array<{ __typename?: 'RoomCategoryQuota', roomCategoryCid: string, quotaStatus: QuotaStatus }> }, commonInformation: { __typename?: 'TariffScheduleCommonInformation', visitTimetableCount: number, hotelSetHasRemote: boolean, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, applyingRules: { __typename?: 'ApplyingRulesView', stopSalePeriodHours: any, penaltyScheme: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string }, supplierPayRule: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string } }, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean }, taxScheme: { __typename?: 'TaxSchemeSuggestion', cid: string, name: string } }, operations: { __typename?: 'TariffScheduleOperations', sendInWork: OperationStatus, startPVM: OperationStatus, update: OperationStatus, canEditPlacingVariants: OperationStatus }, remoteInteraction?: { __typename?: 'TariffScheduleRemoteInteraction', activeRemoting: boolean, channelManagerCode: ChannelManagerCode, interactionId: any, remoteIntegrationUrl?: string | null } | null };

export type TariffSchedulesQueryVariables = Exact<{
  contractNumber: Scalars['Int']['input'];
}>;


export type TariffSchedulesQuery = { __typename?: 'Query', tariffSchedules2?: { __typename?: 'TariffScheduleList2View', operations: { __typename?: 'TariffScheduleListOperations', canAddExtranetTariffSchedule: OperationStatus, canAddRemoteTariffSchedule: OperationStatus }, extranet: Array<{ __typename?: 'TariffScheduleListItem2ExtranetView', tariffScheduleCid: string, stopSalePeriodHours: any, status: TariffScheduleStatus, name: Array<{ __typename?: 'LangString', langCode: string, value: string }> }>, remote: Array<{ __typename?: 'TariffScheduleListItem2RemoteView', channelManagerCode: ChannelManagerCode, interactionId: any, name: Array<{ __typename?: 'LangString', value: string, langCode: string }>, tariffSchedule?: { __typename?: 'TariffScheduleListItem2RemoteTariffSchedule', activeRemoting: boolean, tariffScheduleCid: string, contractClosed: boolean } | null }> } | null };

export type TariffScheduleGridViewFragment = { __typename?: 'TariffScheduleGridView', invalidCommissions: boolean, operations: { __typename?: 'PriceGridOperations', edit: OperationStatus }, baseSettings: { __typename?: 'BaseSettingsView', currencyIsoCode: string, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, tabs?: { __typename?: 'TabsView', grid: { __typename?: 'TariffGridView', services: Array<{ __typename?: 'TariffGridServiceView', roomCategories: Array<{ __typename?: 'TariffGridRoomCategoryView', placingFactors: Array<{ __typename?: 'TariffGridPlacingFactorView', placingFactor: { __typename?: 'PlacingFactorView', roomPlacing?: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } } | null, touristPlace?: { __typename?: 'TouristPlaceView', relatedRoomPlacings: Array<string>, touristPlace: { __typename?: 'TouristPlaceDto', isAdditional: boolean, touristTypeCID: string }, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } } | null }, rates: Array<{ __typename?: 'TariffRateView', period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, price?: { __typename?: 'RatePriceView', nominal: any, sale: any } | null }> }>, roomCategory: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus }, type: { __typename?: 'RoomType', cid: string, name: string } } }>, serviceGroup: { __typename?: 'TariffScheduleServiceGroupView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'ServiceGroupOperations', edit: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', applyMethod: ApplyMethod, calculationMethod: CalculationMethod, cid: string, shortName: string, operations: { __typename?: 'ServiceOperations', delete: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, serviceType: { __typename?: 'ServiceType', cid: string, name: string, shortName: string } }> } }> }, comissions: { __typename?: 'ComissionsView', comissions: Array<{ __typename?: 'ComissionRateView', rate: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> } } | null };

export type SupplierPayRuleListQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplierPayRuleListQuery = { __typename?: 'Query', supplierPayRuleList: Array<{ __typename?: 'SupplierPayRule', shortName: string, name: string }> };

export type PenaltySchemeListQueryVariables = Exact<{ [key: string]: never; }>;


export type PenaltySchemeListQuery = { __typename?: 'Query', penaltySchemeList: Array<{ __typename?: 'PenaltyScheme', shortName: string, name: string }> };

export type GetTaxSchemeListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxSchemeListQuery = { __typename?: 'Query', taxSchemeList: Array<{ __typename?: 'TaxSchemeSuggestion', cid: string, name: string }> };

export type GetTariffScheduleGridQueryVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type GetTariffScheduleGridQuery = { __typename?: 'Query', tariffScheduleGrid?: { __typename?: 'TariffScheduleGridView', invalidCommissions: boolean, operations: { __typename?: 'PriceGridOperations', edit: OperationStatus }, baseSettings: { __typename?: 'BaseSettingsView', currencyIsoCode: string, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }, tabs?: { __typename?: 'TabsView', grid: { __typename?: 'TariffGridView', services: Array<{ __typename?: 'TariffGridServiceView', roomCategories: Array<{ __typename?: 'TariffGridRoomCategoryView', placingFactors: Array<{ __typename?: 'TariffGridPlacingFactorView', placingFactor: { __typename?: 'PlacingFactorView', roomPlacing?: { __typename?: 'PlacingVariantDictView', cid: string, placingVariant: { __typename?: 'PlacingVariantView', name: string, baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> } } | null, touristPlace?: { __typename?: 'TouristPlaceView', relatedRoomPlacings: Array<string>, touristPlace: { __typename?: 'TouristPlaceDto', isAdditional: boolean, touristTypeCID: string }, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } } | null }, rates: Array<{ __typename?: 'TariffRateView', period: { __typename?: 'RangeOfDateOnly', from: any, to: any }, price?: { __typename?: 'RatePriceView', nominal: any, sale: any } | null }> }>, roomCategory: { __typename?: 'RoomCategoryView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, seat: { __typename?: 'RoomSeat', baseQuantity: any, extQuantity: any }, operations: { __typename?: 'RoomCategoryOperations', delete: OperationStatus, edit: OperationStatus }, type: { __typename?: 'RoomType', cid: string, name: string } } }>, serviceGroup: { __typename?: 'TariffScheduleServiceGroupView', cid: string, isActive: boolean, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, operations: { __typename?: 'ServiceGroupOperations', edit: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, services: Array<{ __typename?: 'ServiceView', applyMethod: ApplyMethod, calculationMethod: CalculationMethod, cid: string, shortName: string, operations: { __typename?: 'ServiceOperations', delete: OperationStatus }, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, serviceType: { __typename?: 'ServiceType', cid: string, name: string, shortName: string } }> } }> }, comissions: { __typename?: 'ComissionsView', comissions: Array<{ __typename?: 'ComissionRateView', rate: any, period: { __typename?: 'RangeOfDateOnly', from: any, to: any } }> } } | null } | null };

export type AddTariffScheduleMutationVariables = Exact<{
  addTariffScheduleInput: AddTariffScheduleInput;
}>;


export type AddTariffScheduleMutation = { __typename?: 'Mutation', addTariffSchedule: { __typename?: 'AddTariffSchedulePayload', tariffScheduleCid?: string | null, tariffSchedule?: { __typename?: 'TariffSchedule2View', contractType: ContractType, status: TariffScheduleStatus, tariffScheduleCid: string, hotelSetCid: string, baseSettings: { __typename?: 'TariffScheduleBaseSettings2', completed: boolean, ageSettings: { __typename?: 'AgeSettings', determineAgeMethod: DetermineAgeMethod, initialAge: any, noSeatAge?: any | null, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } }, roomCategories: Array<{ __typename?: 'RoomCategoryQuota', roomCategoryCid: string, quotaStatus: QuotaStatus }> }, commonInformation: { __typename?: 'TariffScheduleCommonInformation', visitTimetableCount: number, hotelSetHasRemote: boolean, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, applyingRules: { __typename?: 'ApplyingRulesView', stopSalePeriodHours: any, penaltyScheme: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string }, supplierPayRule: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string } }, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean }, taxScheme: { __typename?: 'TaxSchemeSuggestion', cid: string, name: string } }, operations: { __typename?: 'TariffScheduleOperations', sendInWork: OperationStatus, startPVM: OperationStatus, update: OperationStatus, canEditPlacingVariants: OperationStatus }, remoteInteraction?: { __typename?: 'TariffScheduleRemoteInteraction', activeRemoting: boolean, channelManagerCode: ChannelManagerCode, interactionId: any, remoteIntegrationUrl?: string | null } | null } | null, errors?: Array<{ __typename: 'ContractNotFoundError', message: string } | { __typename: 'PenaltySchemeNotFoundError', message: string } | { __typename: 'SupplierPayRuleNotFoundError', message: string } | { __typename: 'TariffScheduleOutOfContractPeriodError', message: string } | { __typename: 'TaxSchemeNotFoundError', message: string }> | null } };

export type GetTariffScheduleQueryVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type GetTariffScheduleQuery = { __typename?: 'Query', tariffSchedule2?: { __typename?: 'TariffSchedule2View', contractType: ContractType, status: TariffScheduleStatus, tariffScheduleCid: string, hotelSetCid: string, baseSettings: { __typename?: 'TariffScheduleBaseSettings2', completed: boolean, ageSettings: { __typename?: 'AgeSettings', determineAgeMethod: DetermineAgeMethod, initialAge: any, noSeatAge?: any | null, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } }, roomCategories: Array<{ __typename?: 'RoomCategoryQuota', roomCategoryCid: string, quotaStatus: QuotaStatus }> }, commonInformation: { __typename?: 'TariffScheduleCommonInformation', visitTimetableCount: number, hotelSetHasRemote: boolean, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, applyingRules: { __typename?: 'ApplyingRulesView', stopSalePeriodHours: any, penaltyScheme: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string }, supplierPayRule: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string } }, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean }, taxScheme: { __typename?: 'TaxSchemeSuggestion', cid: string, name: string } }, operations: { __typename?: 'TariffScheduleOperations', sendInWork: OperationStatus, startPVM: OperationStatus, update: OperationStatus, canEditPlacingVariants: OperationStatus }, remoteInteraction?: { __typename?: 'TariffScheduleRemoteInteraction', activeRemoting: boolean, channelManagerCode: ChannelManagerCode, interactionId: any, remoteIntegrationUrl?: string | null } | null } | null };

export type EditTariffScheduleStartMutationVariables = Exact<{
  input: EditTariffScheduleInput;
}>;


export type EditTariffScheduleStartMutation = { __typename?: 'Mutation', editTariffSchedule: { __typename?: 'EditTariffSchedulePayload', TariffSchedule?: { __typename?: 'TariffScheduleCommonInformation', visitTimetableCount: number, hotelSetHasRemote: boolean, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, applyingRules: { __typename?: 'ApplyingRulesView', stopSalePeriodHours: any, penaltyScheme: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string }, supplierPayRule: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string } }, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean }, taxScheme: { __typename?: 'TaxSchemeSuggestion', cid: string, name: string } } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'OperationForbiddenError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type EditTariffScheduleKeepAliveMutationVariables = Exact<{
  input: KeepAliveTariffScheduleInput;
}>;


export type EditTariffScheduleKeepAliveMutation = { __typename?: 'Mutation', keepAliveTariffSchedule: { __typename?: 'KeepAliveTariffSchedulePayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type EditTariffScheduleCancelMutationVariables = Exact<{
  input: CancelEditTariffScheduleInput;
}>;


export type EditTariffScheduleCancelMutation = { __typename?: 'Mutation', cancelEditTariffSchedule: { __typename?: 'CancelEditTariffSchedulePayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type EditTariffScheduleUpdateMutationVariables = Exact<{
  input: UpdateTariffScheduleInput;
}>;


export type EditTariffScheduleUpdateMutation = { __typename?: 'Mutation', updateTariffSchedule: { __typename?: 'UpdateTariffSchedulePayload', TariffSchedule?: { __typename?: 'TariffScheduleCommonInformationUpdated', visitTimetableCount: number, hotelSetHasRemote: boolean, hasServiceSequenceChanged: boolean, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, applyingRules: { __typename?: 'ApplyingRulesView', stopSalePeriodHours: any, penaltyScheme: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string }, supplierPayRule: { __typename?: 'RuleView', description?: string | null, name: string, shortName: string } }, checkInOutSettings: { __typename?: 'CheckInOutSettings', checkInTime: any, checkOutTime: any, nextDayCheckout: boolean }, taxScheme: { __typename?: 'TaxSchemeSuggestion', cid: string, name: string } } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'OperationForbiddenError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string } | { __typename: 'TariffScheduleOutOfContractPeriodError', message: string }> | null } };

export type PlacingVariantTarificationFragment = { __typename?: 'PlacingVariantTarificationView', name: string, isChecked: boolean, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', roomPlacingCid: string, pricePerRoom: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, defaultAvailable: boolean } | null };

export type PlacingVariantTarificationFragmentFragment = { __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null };

export type RoomCategoryPlacingsFragmentFragment = { __typename?: 'RoomCategoryPlacingsView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, type: { __typename?: 'RoomType', cid: string, name: string } }, suggestedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }>, conflictedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }> };

export type GetPlacingVariantsQueryVariables = Exact<{
  hotelSetCid: Scalars['String']['input'];
}>;


export type GetPlacingVariantsQuery = { __typename?: 'Query', placingVariants: { __typename?: 'PlacingVariantsView', placingVariants: Array<{ __typename?: 'RoomCategoryPlacingsView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, type: { __typename?: 'RoomType', cid: string, name: string } }, suggestedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }>, conflictedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }> }> } };

export type PvmStartMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type PvmStartMutation = { __typename?: 'Mutation', placingVariantsMasterStart: { __typename?: 'PlacingVariantsMasterStartPayload', settings?: { __typename?: 'PlacingVariantsMasterStartSettings', roomCategories: Array<{ __typename?: 'RoomCategoryQuota', roomCategoryCid: string, quotaStatus: QuotaStatus }>, ageSettings: { __typename?: 'AgeSettings', initialAge: any, noSeatAge?: any | null, determineAgeMethod: DetermineAgeMethod, categories: { __typename?: 'AgeCategories', values: Array<{ __typename?: 'AgeCategory', from: any, to: any }> } } } | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type PvmKeepAliveMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type PvmKeepAliveMutation = { __typename?: 'Mutation', placingVariantsMasterKeepAlive: { __typename?: 'PlacingVariantsMasterKeepAlivePayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type PvmCancelEditMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type PvmCancelEditMutation = { __typename?: 'Mutation', placingVariantsMasterCancel: { __typename?: 'PlacingVariantsMasterCancelPayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type PvmCompleteMutationVariables = Exact<{
  input: PlacingVariantsMasterCompleteInput;
}>;


export type PvmCompleteMutation = { __typename?: 'Mutation', placingVariantsMasterComplete: { __typename?: 'PlacingVariantsMasterCompletePayload', errors?: Array<{ __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'RoomCategoriesCannotDeleteError', message: string } | { __typename: 'RoomCategoriesEmptyError', message: string } | { __typename: 'RoomCategoryListNotFoundError', message: string } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'RoomPlacingListNotFoundError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type PvmGenerateMutationVariables = Exact<{
  input: PlacingVariantsMasterGenerateInput;
}>;


export type PvmGenerateMutation = { __typename?: 'Mutation', placingVariantsMasterGenerate: { __typename?: 'PlacingVariantsMasterGeneratePayload', invalidRoomCategoryCids?: Array<string> | null, placingVariantsTarification?: Array<{ __typename?: 'RoomCategoryPlacingsView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, type: { __typename?: 'RoomType', cid: string, name: string } }, suggestedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }>, conflictedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }> }> | null, errors?: Array<{ __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type StartPlacingVariantsEditMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type StartPlacingVariantsEditMutation = { __typename?: 'Mutation', placingVariantsEdit: { __typename?: 'PlacingVariantsEditPayload', placingVariantsTarification?: Array<{ __typename?: 'RoomCategoryPlacingsView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, type: { __typename?: 'RoomType', cid: string, name: string } }, suggestedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }>, conflictedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }> }> | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'LockResourceFailedError', message: string, blockedInfo: { __typename?: 'BlockedInfo', blockers: Array<{ __typename?: 'Blocker', userAlias: string, lockTime: any }> } } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type KeepAlivePlacingVariantsEditMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type KeepAlivePlacingVariantsEditMutation = { __typename?: 'Mutation', placingVariantsKeepAlive: { __typename?: 'PlacingVariantsKeepAlivePayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type UpdatePlacingVariantsMutationVariables = Exact<{
  variants: PlacingVariantsUpdateInput;
}>;


export type UpdatePlacingVariantsMutation = { __typename?: 'Mutation', placingVariantsUpdate: { __typename?: 'PlacingVariantsUpdatePayload', placingVariantsTarification?: Array<{ __typename?: 'RoomCategoryPlacingsView', roomCategory: { __typename?: 'RoomCategoryView', cid: string, shortName: string, description: Array<{ __typename?: 'LangString', langCode: string, value: string }>, name: Array<{ __typename?: 'LangString', langCode: string, value: string }>, type: { __typename?: 'RoomType', cid: string, name: string } }, suggestedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }>, conflictedPlacingVariants: Array<{ __typename?: 'PlacingVariantTarificationView', isChecked: boolean, name: string, placingVariant: { __typename?: 'PlacingVariantView', baseSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }>, extSeats: Array<{ __typename?: 'TouristSeatsView', seats: any, touristType: { __typename?: 'TouristTypeView', isAdult: boolean, ageCategory?: { __typename?: 'AgeCategoryView', from: any, to?: any | null } | null } }> }, tarification?: { __typename?: 'PlacingVariantTarification', defaultAvailable: boolean, isNeedConfirm: boolean, maxNoSeatQuantity: any, pricePerRoom: boolean, roomPlacingCid: string } | null }> }> | null, errors?: Array<{ __typename: 'HotelSetHasRemoteIntegrationForbiddenError', message: string } | { __typename: 'HotelSetNotFoundError', message: string } | { __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string } | { __typename: 'RoomCategoriesCannotDeleteError', message: string } | { __typename: 'RoomCategoriesEmptyError', message: string } | { __typename: 'RoomCategoryListNotFoundError', message: string } | { __typename: 'RoomCategoryNotFoundError', message: string } | { __typename: 'RoomPlacingListNotFoundError', message: string } | { __typename: 'TariffScheduleMultipleVisitTimetableForbiddenError', message: string } | { __typename: 'TariffScheduleNotFoundError', message: string }> | null } };

export type CancelPlacingVariantsEditMutationVariables = Exact<{
  tariffScheduleCid: Scalars['String']['input'];
}>;


export type CancelPlacingVariantsEditMutation = { __typename?: 'Mutation', placingVariantsCancelEdit: { __typename?: 'PlacingVariantsCancelEditPayload', status?: string | null, errors?: Array<{ __typename: 'OperationOnUnlockedResourceIsInvalidError', message: string }> | null } };

export type UserFragment = { __typename?: 'SupplierUserView', email: string, id: any, isOwner: boolean, role?: Role | null, operations: { __typename?: 'UserOperations', delete: OperationStatus }, profile: { __typename?: 'UserProfileView', lastName: string, middleName?: string | null, name: string, phoneNumber: string, userAvatar: { __typename?: 'UserAvatar', url?: string | null, canNotLoad: boolean } } };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'SupplierUserView', email: string, id: any, isOwner: boolean, role?: Role | null, operations: { __typename?: 'UserOperations', delete: OperationStatus }, profile: { __typename?: 'UserProfileView', lastName: string, middleName?: string | null, name: string, phoneNumber: string, userAvatar: { __typename?: 'UserAvatar', url?: string | null, canNotLoad: boolean } } }> };

export type InvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvitationsQuery = { __typename?: 'Query', invitations: Array<{ __typename?: 'InvitationView', email: string, id: any, role?: Role | null }> };

export type InviteUserToSupplierMutationVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InviteUserToSupplierMutation = { __typename?: 'Mutation', inviteUserToSupplier: { __typename?: 'InviteUserToSupplierPayload', status: string } };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'DeleteUserPayload', status?: string | null } };

export type SetUserRoleMutationVariables = Exact<{
  input: SetUserRoleInput;
}>;


export type SetUserRoleMutation = { __typename?: 'Mutation', setUserRole: { __typename?: 'SetUserRolePayload', status?: string | null, errors?: Array<{ __typename: 'ChangeUserRoleToSupportForbiddenError', message: string } | { __typename: 'SelfSetRoleError', message: string } | { __typename: 'SetRoleOwnerError', message: string } | { __typename: 'SupportRoleChangeForbiddenError', message: string } | { __typename: 'UserNotFoundError', message: string }> | null } };

export type SetInvitationRoleMutationVariables = Exact<{
  input: SetInvitationRoleInput;
}>;


export type SetInvitationRoleMutation = { __typename?: 'Mutation', setInvitationRole: { __typename?: 'SetInvitationRolePayload', status?: string | null, errors?: Array<{ __typename: 'InvitationNotFoundError', message: string }> | null } };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user: { __typename?: 'SupplierUserView', email: string, id: any, isOwner: boolean, role?: Role | null, operations: { __typename?: 'UserOperations', delete: OperationStatus }, profile: { __typename?: 'UserProfileView', lastName: string, middleName?: string | null, name: string, phoneNumber: string, userAvatar: { __typename?: 'UserAvatar', url?: string | null, canNotLoad: boolean } } } };

export type GetActiveAccessRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveAccessRequestsQuery = { __typename?: 'Query', activeAccessRequests: Array<{ __typename?: 'AccessRequestView', id: any, userName: string, userFullName: string }> };

export type AccessRequestDeclineMutationVariables = Exact<{
  input: AccessRequestDeclineInput;
}>;


export type AccessRequestDeclineMutation = { __typename?: 'Mutation', accessRequestDecline: { __typename?: 'AccessRequestDeclinePayload', status?: string | null, errors?: Array<{ __typename: 'AccessRequestInvalidStatusError', message: string } | { __typename: 'AccessRequestNotFoundError', message: string }> | null } };

export type AccessRequestAcceptMutationVariables = Exact<{
  input: AccessRequestAcceptInput;
}>;


export type AccessRequestAcceptMutation = { __typename?: 'Mutation', accessRequestAccept: { __typename?: 'AccessRequestAcceptPayload', status?: string | null, errors?: Array<{ __typename: 'AccessRequestInvalidStatusError', message: string } | { __typename: 'AccessRequestNotFoundError', message: string }> | null } };

export const Error = gql`
    fragment Error on Error {
  ... on Error {
    message
  }
  __typename
}
    `;
export const LockResourceError = gql`
    fragment LockResourceError on LockResourceFailedError {
  message
  blockedInfo {
    blockers {
      userAlias
      lockTime
    }
  }
  __typename
}
    `;
export const OrderInfo = gql`
    fragment OrderInfo on OrderView {
  accommodation {
    cost
    currencyISOCode
    daysCount
    hasAccommodationWithoutPacket
    hasUnavoidedInvoice
    accommodationHasBegun
    roomCount
    period {
      from
      to
    }
    specConditions
    orderWishes
  }
  commonInfo {
    contractNumber
    hotelName
    orderDate
    quotaShortName
    remoteInteract
    roomCategoryName
  }
  operations {
    avoid
    confirm
    sendToSupplier
  }
  orderInfo {
    id
    number
    status
    subNumber
    sentToSupplier
    hasNonStandard
  }
  rooms {
    nonStandard
    places {
      cost
      packets {
        cost
        packetName
        period {
          from
          to
        }
        status
      }
      period {
        from
        to
      }
      placeType
      status
      touristName
      touristType
    }
    pricePerRoom
    roomPlacingCid
    roomPlacingName
    services {
      amount
      cost
      period {
        from
        to
      }
      serviceMethod
      serviceName
      status
      touristName
    }
    status
    summaryAccommodationCost
    summaryServiceCost
  }
}
    `;
export const LangField = gql`
    fragment LangField on LangString {
  langCode
  value
}
    `;
export const AttachmentFragment = gql`
    fragment AttachmentFragment on Attachment {
  id
  name
  size
  questionnaireId
}
    `;
export const ContentServiceQuestionnaireAnswersFragment = gql`
    fragment ContentServiceQuestionnaireAnswersFragment on QuestionnaireAnswers {
  step
  isFinished
  generalInfo {
    name {
      ...LangField
    }
    hotelChain
    address
    buildYear
    renovationYear
    totalArea
    nearestAeroport
    nearestTrainStation
    nearestSubwayStation
    checkIn
    checkOut
    petsAllowed
    petWeightLimitKg
    requiredDocumentsAdult
    isAcceptChildren
    requiredDocumentsChildren
    requiredDocumentsForeigner
    description
    webSite
    contactFullName
    contactEmail
    photobankUrl
    attachments {
      ...AttachmentFragment
    }
  }
  roomCategories {
    roomCategoryCid
    roomCategoryName
    roomCategoryTypeName
    roomCategoryBasePlaces
    roomCategoryExtPlaces
    roomsCount
    roomArea
    typeOfExtendedPlace
    kitchenIsInRoom
    balcony
    roomEquipment
    furniture
    bathroom
    bathroomEquipment
    roomService
    roomView
    attachments {
      ...AttachmentFragment
    }
    photobankUrl
  }
  infrastructureInfo {
    beaches {
      beachId
      beachType
      beachEquipment
      paidBeachEquipment
      beachEntertainment
      questionnaireId
      beachDistanceMeters
    }
    pools {
      poolId
      poolName
      poolType
      poolCharacteristics
      poolSeason
      attachments {
        ...AttachmentFragment
      }
      photobankUrl
      questionnaireId
    }
    saunas {
      saunaId
      saunaType
      payment
      attachments {
        ...AttachmentFragment
      }
      photobankUrl
      questionnaireId
    }
    anotherInfrastructure
    beautyInfrastructure
    childrenInfrastructure
    childrenPool
    disabilityCheck
    disabilityInfrastructure
    indoorAreas
    outdoorAreas
    parkingType
    skiResorts
    waterComplexDescription
    winterPlaygrounds
    photobankUrl
    attachments {
      ...AttachmentFragment
    }
    waterDistanceMeters
  }
  nutritionInfo {
    nutritionDelivery
    childrenNutrition
    foodObjects {
      foodObjectId
      foodObjectName
      foodObjectOpeningHours
      foodObjectOpeningHoursFrom
      foodObjectOpeningHoursTo
      foodObjectType
      cuisine
      attachments {
        ...AttachmentFragment
      }
      photobankUrl
      questionnaireId
    }
  }
  servicesAndEntertainment {
    household
    reception
    rent
    internet
    other
    waterSports
    equipmentRental
    skiResortService
    animation
    entertainmentTypes
    leisure
    childrenEntertainment
    childrenService
    childrenEquipment
    spaServices
    medicalCosmetology
  }
  treatment {
    enabled
    treatmentCategories {
      name
      groups {
        name
        items {
          name
          options
        }
      }
    }
  }
  conferenceServices {
    conferenceRooms {
      conferenceRoomId
      conferenceRoomName
      placesCount
      area
      conferenceRoomEquipment
      conferenceRoomSeatingOptions
      conferenceRoomFurniture
      photobankUrl
      attachments {
        ...AttachmentFragment
      }
      questionnaireId
    }
    congressServices
  }
}
    ${LangField}
${AttachmentFragment}`;
export const ContentServiceQuestionnaireStepsValidationsFragment = gql`
    fragment ContentServiceQuestionnaireStepsValidationsFragment on QuestionnaireStepsValidations {
  validations {
    step
    isValid
  }
}
    `;
export const DocumentFragment = gql`
    fragment DocumentFragment on DocumentResponseModel {
  documentId
  documentName
  documentDate
  documentType
  downloadId
  fileName
  juridicalPerson
  ediType
  signatureStatus
  reportPeriod {
    month
    year
  }
}
    `;
export const LegalListItemFragment = gql`
    fragment LegalListItemFragment on LegalListItemView {
  approveStatus
  cid
  legalDetails {
    kpp
    ogrn
    tin
  }
  name {
    langCode
    value
  }
  operations {
    delete
  }
}
    `;
export const LegalFragment = gql`
    fragment LegalFragment on LegalView {
  cid
  data {
    address
    addressML {
      ...LangField
    }
    details {
      kpp
      ogrn
      tin
    }
    isIndividual
    isNotTaxPayer
    name
    nameML {
      ...LangField
    }
    ediType
  }
  status
  operations {
    canUpdateEDI
  }
}
    ${LangField}`;
export const LegalDetails = gql`
    fragment LegalDetails on LegalDetails {
  tin
  kpp
  ogrn
}
    `;
export const LegalListItem = gql`
    fragment LegalListItem on LegalListItemView {
  operations {
    delete
  }
  cid
  name {
    ...LangField
  }
  legalDetails {
    ...LegalDetails
  }
  approveStatus
}
    ${LangField}
${LegalDetails}`;
export const Contract = gql`
    fragment Contract on ContractView {
  hasOffer
  contractNumber
  contractType
  legal {
    cid
    name {
      ...LangField
    }
  }
  status
  currencyISOCode
}
    ${LangField}`;
export const RoomCategoryFragment = gql`
    fragment RoomCategoryFragment on RoomCategoryView {
  cid
  description {
    langCode
    value
  }
  shortName
  isActive
  name {
    langCode
    value
  }
  operations {
    delete
    edit
    fullEdit
  }
  seat {
    baseQuantity
    extQuantity
  }
  type {
    name
    cid
  }
}
    `;
export const ReverseIntegrationFragment = gql`
    fragment ReverseIntegrationFragment on ReverseIntegrationView {
  channelManagerCode
  master {
    hotelSetCid
    masterStep
    isRestarting
    steps {
      integrationSettings {
        connectionName {
          ...LangField
        }
        penaltySchemeCode
        supplierPayRuleCode
        checkInOutSettings {
          checkInTime
          checkOutTime
          nextDayCheckout
        }
      }
      roomCategoriesSettings {
        roomCategories {
          ...RoomCategoryFragment
        }
        selectedRoomCategoryCIDs
      }
      serviceGroupsSettings {
        serviceGroups {
          cid
          name {
            ...LangField
          }
          services {
            cid
            shortName
          }
        }
        selectedServiceGroupeCIDs
      }
      touristTypesSettings {
        ageSettings {
          initialAge
          determineAgeMethod
          categories {
            values {
              from
              to
            }
          }
        }
      }
    }
  }
}
    ${LangField}
${RoomCategoryFragment}`;
export const UncompletedReverseIntegrationFragment = gql`
    fragment UncompletedReverseIntegrationFragment on UncompletedReverseInteractionView {
  interactionId
  uncompletedInteraction {
    channelManagerCode
    isNotStarted
  }
}
    `;
export const RoomType = gql`
    fragment RoomType on RoomType {
  cid
  name
}
    `;
export const RoomCategoryView = gql`
    fragment RoomCategoryView on RoomCategoryView {
  cid
  type {
    ...RoomType
  }
  shortName
  name {
    ...LangField
  }
  description {
    ...LangField
  }
  seat {
    baseQuantity
    extQuantity
  }
  isActive
  operations {
    delete
    edit
    fullEdit
  }
}
    ${RoomType}
${LangField}`;
export const TravelLineIntegrationMasterStepsView = gql`
    fragment TravelLineIntegrationMasterStepsView on TravelLineMasterStepsView {
  integrationSettings {
    connectionName {
      ...LangField
    }
    penaltySchemeCode
    supplierPayRuleCode
    checkInOutSettings {
      checkInTime
      checkOutTime
      nextDayCheckout
    }
  }
  roomCategoriesMapping {
    roomCategories {
      ...RoomCategoryView
    }
    translationTable {
      cid
      externalObject {
        id
        name
      }
    }
  }
  touristTypesMapping {
    touristTypesRefreshRequired
    ageSettings {
      initialAge
      noSeatAge
      categories {
        values {
          from
          to
        }
      }
      determineAgeMethod
    }
  }
  placingVariantsMapping {
    requiredPlacingVariants {
      roomCategoryCid
      placingVariantName
    }
  }
  serviceGroupsMapping {
    serviceGroups {
      name {
        ...LangField
      }
      canChange
      cid
    }
    translationTable {
      cid
      externalObject {
        id
        name
      }
    }
  }
}
    ${LangField}
${RoomCategoryView}`;
export const TravelLineIntegrationView = gql`
    fragment TravelLineIntegrationView on TravelLineIntegrationView {
  master {
    masterStep
    steps {
      ...TravelLineIntegrationMasterStepsView
    }
    hotelSetCid
  }
  hasExternalIntegrationIssue
  channelManagerCode
  externalIntegration {
    externalId
    integrationUrl
    externalHotel {
      hotelId
      hotelName
    }
  }
}
    ${TravelLineIntegrationMasterStepsView}`;
export const TravelLineRestartIntegrationView = gql`
    fragment TravelLineRestartIntegrationView on TravelLineRestartIntegrationView {
  master {
    masterStep
    steps {
      ...TravelLineIntegrationMasterStepsView
    }
    hotelSetCid
  }
  hasExternalIntegrationIssue
  channelManagerCode
}
    ${TravelLineIntegrationMasterStepsView}`;
export const TravelLineUncompletedIntegrationView = gql`
    fragment TravelLineUncompletedIntegrationView on TravelLineUncompletedIntegrationView {
  channelManagerCode
  externalIntegration {
    externalId
    integrationUrl
    externalHotel {
      hotelId
      hotelName
    }
  }
  integrationId
}
    `;
export const TlPlacingVariant = gql`
    fragment TLPlacingVariant on PlacingVariantTarificationView {
  name
  isChecked
  tarification {
    maxNoSeatQuantity
    roomPlacingCid
    pricePerRoom
    isNeedConfirm
    defaultAvailable
  }
  placingVariant {
    baseSeats {
      seats
      touristType {
        isAdult
        ageCategory {
          from
          to
        }
      }
    }
    extSeats {
      seats
      touristType {
        isAdult
        ageCategory {
          from
          to
        }
      }
    }
  }
  mandatory
}
    `;
export const SeatsFragment = gql`
    fragment SeatsFragment on TouristSeatsView {
  seats
  touristType {
    isAdult
    ageCategory {
      from
      to
    }
  }
}
    `;
export const RoomPlacingPlacingVariant = gql`
    fragment RoomPlacingPlacingVariant on PlacingVariantView {
  name
  baseSeats {
    ...SeatsFragment
  }
  extSeats {
    ...SeatsFragment
  }
}
    ${SeatsFragment}`;
export const Tabs = gql`
    fragment Tabs on TabsView {
  grid {
    services {
      roomCategories {
        placingFactors {
          placingFactor {
            roomPlacing {
              cid
              placingVariant {
                ...RoomPlacingPlacingVariant
              }
            }
            touristPlace {
              relatedRoomPlacings
              touristPlace {
                isAdditional
                touristTypeCID
              }
              touristType {
                ageCategory {
                  from
                  to
                }
                isAdult
              }
            }
          }
          rates {
            period {
              from
              to
            }
            price {
              nominal
              sale
            }
          }
        }
        roomCategory {
          cid
          description {
            langCode
            value
          }
          isActive
          name {
            langCode
            value
          }
          seat {
            baseQuantity
            extQuantity
          }
          operations {
            delete
            edit
          }
          shortName
          type {
            cid
            name
          }
        }
      }
      serviceGroup {
        cid
        description {
          langCode
          value
        }
        isActive
        operations {
          edit
        }
        name {
          langCode
          value
        }
        services {
          applyMethod
          calculationMethod
          cid
          operations {
            delete
          }
          name {
            langCode
            value
          }
          serviceType {
            cid
            name
            shortName
          }
          shortName
        }
        shortName
      }
    }
  }
  comissions {
    comissions {
      period {
        from
        to
      }
      rate
    }
  }
}
    ${RoomPlacingPlacingVariant}`;
export const Grid = gql`
    fragment Grid on TariffScheduleGridView {
  invalidCommissions
  baseSettings {
    currencyIsoCode
    period {
      from
      to
    }
  }
  operations {
    edit
  }
  tabs {
    ...Tabs
  }
}
    ${Tabs}`;
export const QuotaFragment = gql`
    fragment QuotaFragment on QuotaView {
  contractNumber
  operations {
    addRooms
    removeRooms
    updateReserves
  }
  roomQuotas {
    quotas {
      isClosed
      ordered
      period {
        from
        to
      }
      reserve {
        byRequest
        free
        reserved
      }
    }
    room {
      cid
      description {
        ...LangField
      }
      isActive
      name {
        ...LangField
      }
      operations {
        edit
        delete
      }
      shortName
      seat {
        baseQuantity
        extQuantity
      }
      type {
        cid
        name
      }
    }
  }
  shortName
}
    ${LangField}`;
export const QuotaRoomCategoryFragment = gql`
    fragment QuotaRoomCategoryFragment on RoomCategoryView {
  cid
  description {
    langCode
    value
  }
  isActive
  name {
    langCode
    value
  }
  operations {
    edit
    delete
  }
  seat {
    baseQuantity
    extQuantity
  }
  type {
    name
    cid
  }
}
    `;
export const IncorrectQuotaChangeError = gql`
    fragment IncorrectQuotaChangeError on IncorrectQuotaChangeOperationError {
  roomCategoryCid
  roomCategoryName
  from
  to
  requiredReserve
  booked
}
    `;
export const CheckInOutRestrictionsFragment = gql`
    fragment CheckInOutRestrictionsFragment on RestrictionsCheckInOutSettingsView {
  operations {
    add
    edit
    remove
  }
  defaults {
    defaultOptions {
      nextDayCheckout
      checkIn
      checkOut
    }
  }
  grid {
    period {
      from
      to
    }
    restrictionId
  }
  table {
    restriction {
      hasConflict
      number
      options {
        checkIn
        checkOut
        nextDayCheckout
      }
      period {
        from
        to
      }
      restrictionId
    }
  }
}
    `;
export const PlacingVariantsRestrictionsOptionsFragment = gql`
    fragment PlacingVariantsRestrictionsOptionsFragment on RestrictionsPlacingVariantsOptions {
  isOpened
  options {
    isNeedConfirm
  }
}
    `;
export const PlacingVariantsRestrictionsRoomCategoryFragment = gql`
    fragment PlacingVariantsRestrictionsRoomCategoryFragment on RoomCategoryView {
  cid
  name {
    value
  }
  type {
    name
  }
}
    `;
export const PlacingVariantsRestrictionsFragment = gql`
    fragment PlacingVariantsRestrictionsFragment on RestrictionsPlacingVariantsView {
  operations {
    add
    edit
    remove
  }
  defaults {
    defaultOptions {
      ...PlacingVariantsRestrictionsOptionsFragment
    }
    restrictionFactorKey {
      roomCategoryCid
      roomPlacingCid
    }
  }
  grid {
    roomCategory {
      ...PlacingVariantsRestrictionsRoomCategoryFragment
    }
    roomPlacings {
      restrictionFactor {
        cid
        placingVariant {
          ...RoomPlacingPlacingVariant
        }
      }
      restrictionPeriods {
        period {
          from
          to
        }
        restrictionId
      }
    }
  }
  gridPeriod {
    from
    to
  }
  table {
    restriction {
      hasConflict
      number
      options {
        ...PlacingVariantsRestrictionsOptionsFragment
      }
      period {
        from
        to
      }
      restrictionId
    }
    restrictionFactor {
      roomCategory {
        ...PlacingVariantsRestrictionsRoomCategoryFragment
      }
      roomPlacing {
        cid
        placingVariant {
          name
        }
      }
    }
  }
}
    ${PlacingVariantsRestrictionsOptionsFragment}
${PlacingVariantsRestrictionsRoomCategoryFragment}
${RoomPlacingPlacingVariant}`;
export const ServiceGroupsRestrictionsOptionsFragment = gql`
    fragment ServiceGroupsRestrictionsOptionsFragment on RestrictionsServiceGroupsOptions {
  isOpened
  options {
    isNeedConfirm
    orderPeriod {
      maxOrderPeriod
      minOrderPeriod
    }
  }
}
    `;
export const ServiceGroupsRestrictionsFragment = gql`
    fragment ServiceGroupsRestrictionsFragment on RestrictionsServiceGroupsView {
  operations {
    add
    edit
    remove
  }
  defaults {
    defaultOptions {
      ...ServiceGroupsRestrictionsOptionsFragment
    }
    restrictionFactorKey {
      serviceGroupCid
    }
  }
  grid {
    restrictionFactor {
      cid
      name
      shortName
    }
    restrictionPeriods {
      period {
        from
        to
      }
      restrictionId
    }
  }
  gridPeriod {
    from
    to
  }
  table {
    restriction {
      hasConflict
      number
      options {
        ...ServiceGroupsRestrictionsOptionsFragment
      }
      period {
        from
        to
      }
      restrictionId
    }
    restrictionFactor {
      cid
      name
      shortName
    }
  }
}
    ${ServiceGroupsRestrictionsOptionsFragment}`;
export const ServiceGroups = gql`
    fragment ServiceGroups on TariffScheduleServiceGroupListItemView {
  isActive
  defaultAvailable
  description {
    langCode
    value
  }
  isNeedConfirm
  orderPeriod {
    maxOrderPeriod
    minOrderPeriod
  }
  name {
    langCode
    value
  }
  serviceGroupCid
  services {
    shortName
    cid
    isFirst
    isLast
    sortNumber
  }
  shortName
}
    `;
export const ServiceGroupsList = gql`
    fragment serviceGroupsList on TariffScheduleServiceGroupsListView {
  operations {
    add
    edit
    hasMaximumServiceGroups
  }
  serviceGroups {
    ...ServiceGroups
  }
}
    ${ServiceGroups}`;
export const TariffScheduleServiceGroup = gql`
    fragment TariffScheduleServiceGroup on TariffScheduleServiceGroupView {
  cid
  name {
    ...LangField
  }
  description {
    ...LangField
  }
  isActive
  shortName
  operations {
    edit
  }
  services {
    shortName
    name {
      ...LangField
    }
    cid
    isFirst
    isLast
    sortNumber
  }
}
    ${LangField}`;
export const RoomCategoryPlacingsView = gql`
    fragment RoomCategoryPlacingsView on RoomCategoryPlacingsView {
  conflictedPlacingVariants {
    isChecked
    name
    placingVariant {
      baseSeats {
        seats
        touristType {
          ageCategory {
            from
            to
          }
        }
      }
      extSeats {
        seats
        touristType {
          ageCategory {
            from
            to
          }
        }
      }
    }
    tarification {
      defaultAvailable
      isNeedConfirm
      maxNoSeatQuantity
      pricePerRoom
      roomPlacingCid
    }
  }
  roomCategory {
    cid
    description {
      langCode
      value
    }
    name {
      langCode
      value
    }
    shortName
    type {
      cid
      name
    }
  }
  suggestedPlacingVariants {
    isChecked
    name
    placingVariant {
      baseSeats {
        seats
        touristType {
          ageCategory {
            from
            to
          }
        }
      }
      extSeats {
        seats
        touristType {
          ageCategory {
            from
            to
          }
        }
      }
    }
    tarification {
      defaultAvailable
      isNeedConfirm
      maxNoSeatQuantity
      pricePerRoom
      roomPlacingCid
    }
  }
}
    `;
export const PlacingVariantsView = gql`
    fragment PlacingVariantsView on PlacingVariantsView {
  placingVariants {
    ...RoomCategoryPlacingsView
  }
}
    ${RoomCategoryPlacingsView}`;
export const Table = gql`
    fragment Table on RestrictionTableRowViewOfRestrictionsPlacingVariantsFactorViewAndRestrictionsPlacingVariantsOptions {
  restriction {
    hasConflict
    number
    options {
      isOpened
      options {
        isNeedConfirm
      }
    }
    period {
      from
      to
    }
    restrictionId
  }
  restrictionFactor {
    roomPlacing {
      cid
      placingVariant {
        ...RoomPlacingPlacingVariant
      }
    }
  }
}
    ${RoomPlacingPlacingVariant}`;
export const TariffScheduleCommonInformationUpdatedFragment = gql`
    fragment TariffScheduleCommonInformationUpdatedFragment on TariffScheduleCommonInformationUpdated {
  name {
    ...LangField
  }
  visitTimetableCount
  hotelSetHasRemote
  applyingRules {
    penaltyScheme {
      description
      name
      shortName
    }
    stopSalePeriodHours
    supplierPayRule {
      description
      name
      shortName
    }
  }
  checkInOutSettings {
    checkInTime
    checkOutTime
    nextDayCheckout
  }
  taxScheme {
    cid
    name
  }
  hasServiceSequenceChanged
}
    ${LangField}`;
export const TariffScheduleCommonInformationFragment = gql`
    fragment TariffScheduleCommonInformationFragment on TariffScheduleCommonInformation {
  name {
    ...LangField
  }
  visitTimetableCount
  hotelSetHasRemote
  applyingRules {
    penaltyScheme {
      description
      name
      shortName
    }
    stopSalePeriodHours
    supplierPayRule {
      description
      name
      shortName
    }
  }
  checkInOutSettings {
    checkInTime
    checkOutTime
    nextDayCheckout
  }
  taxScheme {
    cid
    name
  }
}
    ${LangField}`;
export const TariffScheduleFragment = gql`
    fragment TariffScheduleFragment on TariffSchedule2View {
  baseSettings {
    ageSettings {
      categories {
        values {
          from
          to
        }
      }
      determineAgeMethod
      initialAge
      noSeatAge
    }
    completed
    roomCategories {
      roomCategoryCid
      quotaStatus
    }
  }
  contractType
  status
  commonInformation {
    ...TariffScheduleCommonInformationFragment
  }
  tariffScheduleCid
  hotelSetCid
  operations {
    sendInWork
    startPVM
    update
    canEditPlacingVariants
  }
  remoteInteraction {
    activeRemoting
    channelManagerCode
    interactionId
    remoteIntegrationUrl
  }
}
    ${TariffScheduleCommonInformationFragment}`;
export const TariffScheduleGridView = gql`
    fragment TariffScheduleGridView on TariffScheduleGridView {
  operations {
    edit
  }
  invalidCommissions
  baseSettings {
    currencyIsoCode
    period {
      from
      to
    }
  }
  tabs {
    ...Tabs
  }
}
    ${Tabs}`;
export const PlacingVariantTarification = gql`
    fragment PlacingVariantTarification on PlacingVariantTarificationView {
  name
  placingVariant {
    baseSeats {
      touristType {
        ageCategory {
          from
          to
        }
        isAdult
      }
      seats
    }
    extSeats {
      touristType {
        ageCategory {
          from
          to
        }
        isAdult
      }
      seats
    }
  }
  tarification {
    roomPlacingCid
    pricePerRoom
    isNeedConfirm
    maxNoSeatQuantity
    defaultAvailable
  }
  isChecked
}
    `;
export const PlacingVariantTarificationFragment = gql`
    fragment PlacingVariantTarificationFragment on PlacingVariantTarificationView {
  isChecked
  name
  placingVariant {
    baseSeats {
      seats
      touristType {
        isAdult
        ageCategory {
          from
          to
        }
      }
    }
    extSeats {
      seats
      touristType {
        isAdult
        ageCategory {
          from
          to
        }
      }
    }
  }
  tarification {
    defaultAvailable
    isNeedConfirm
    maxNoSeatQuantity
    pricePerRoom
    roomPlacingCid
  }
}
    `;
export const RoomCategoryPlacingsFragment = gql`
    fragment RoomCategoryPlacingsFragment on RoomCategoryPlacingsView {
  roomCategory {
    cid
    description {
      langCode
      value
    }
    name {
      langCode
      value
    }
    shortName
    type {
      cid
      name
    }
  }
  suggestedPlacingVariants {
    ...PlacingVariantTarificationFragment
  }
  conflictedPlacingVariants {
    ...PlacingVariantTarificationFragment
  }
}
    ${PlacingVariantTarificationFragment}`;
export const User = gql`
    fragment User on SupplierUserView {
  email
  id
  isOwner
  operations {
    delete
  }
  profile {
    lastName
    middleName
    name
    phoneNumber
    userAvatar {
      url
      canNotLoad
    }
  }
  role
}
    `;
export const TownSuggestion = gql`
    query TownSuggestion($key: String!, $maxResults: Int!) {
  townSuggestions(suggestion: {key: $key, maxResults: $maxResults}) {
    cid
    toponymsPath
  }
}
    `;
export const CurrencyList = gql`
    query CurrencyList {
  currencyList {
    currencyISOCode
    isActive
    name
  }
}
    `;
export const Me = gql`
    query Me {
  me {
    id
    hasSupplier
    hasProfile
    hasKsbAccount
    email
    role
    isOwner
    supplierCode
    userRegistration {
      status
      questionnaire {
        legalOrigin
        legal {
          name
          nameML {
            langCode
            value
          }
          details {
            tin
            kpp
            ogrn
          }
          address
          addressML {
            langCode
            value
          }
          townName
          isNotTaxPayer
        }
        accommodationObject {
          name
          nameML {
            langCode
            value
          }
          type {
            cid
            name
          }
          addressData {
            townName
            address
            addressML {
              langCode
              value
            }
          }
        }
        contact {
          phone
          email
          webSite
        }
      }
    }
    permissions
    profile {
      lastName
      middleName
      name
      phoneNumber
      userAvatar {
        url
        canNotLoad
      }
    }
  }
}
    `;
export const UpdateUserProfile = gql`
    mutation UpdateUserProfile($middleName: String, $lastName: String!, $name: String!, $phoneNumber: String!) {
  updateUserProfile(
    updateUserProfileInput: {userProfile: {lastName: $lastName, middleName: $middleName, name: $name, phoneNumber: $phoneNumber}}
  ) {
    user {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const IsLegalFree = gql`
    query IsLegalFree($tin: String!) {
  isLegalFree(input: {tin: $tin})
}
    `;
export const JoinToSupplier = gql`
    mutation JoinToSupplier($inviteCode: String!) {
  joinToSupplier(input: {inviteCode: $inviteCode}) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const SendSupplierQuestionnaire = gql`
    mutation SendSupplierQuestionnaire($legalName: String, $legalNameML: [LangStringInput!], $kpp: String, $ogrn: String, $tin: String!, $legalAddress: String, $legalAddressML: [LangStringInput!], $legalTownName: String, $objectName: String, $objectNameML: [LangStringInput!], $objectTypeName: String!, $objectTypeCid: String!, $objectAddress: String, $objectAddressML: [LangStringInput!], $objectTownName: String, $phone: String!, $email: String!, $webSite: String, $version: Int!, $isNew: Boolean!, $isNotTaxPayer: Boolean!, $legalOrigin: LegalOrigin!) {
  sendSupplierQuestionnaire(
    input: {legal: {name: $legalName, nameML: $legalNameML, legalDetails: {kpp: $kpp, tin: $tin, ogrn: $ogrn}, address: {address: $legalAddress, addressML: $legalAddressML, townName: $legalTownName}, isNotTaxPayer: $isNotTaxPayer, legalOrigin: $legalOrigin}, accommodationObject: {name: $objectName, nameML: $objectNameML, type: {name: $objectTypeName, cid: $objectTypeCid}, addressData: {address: $objectAddress, addressML: $objectAddressML, townName: $objectTownName}}, contact: {phone: $phone, email: $email, webSite: $webSite}, version: $version, isNew: $isNew}
  ) {
    SupplierCode
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const UpdateSupplierQuestionnaire = gql`
    mutation UpdateSupplierQuestionnaire($legalName: String, $legalNameML: [LangStringInput!], $kpp: String, $ogrn: String, $tin: String!, $legalAddress: String, $legalAddressML: [LangStringInput!], $legalTownName: String, $objectName: String, $objectNameML: [LangStringInput!], $objectTypeName: String!, $objectTypeCid: String!, $objectAddress: String, $objectAddressML: [LangStringInput!], $objectTownName: String, $phone: String!, $email: String!, $webSite: String, $version: Int!, $isNew: Boolean!, $isNotTaxPayer: Boolean!, $legalOrigin: LegalOrigin!) {
  updateSupplierQuestionnaire(
    input: {legal: {name: $legalName, nameML: $legalNameML, legalDetails: {kpp: $kpp, tin: $tin, ogrn: $ogrn}, address: {address: $legalAddress, addressML: $legalAddressML, townName: $legalTownName}, isNotTaxPayer: $isNotTaxPayer, legalOrigin: $legalOrigin}, accommodationObject: {name: $objectName, nameML: $objectNameML, type: {name: $objectTypeName, cid: $objectTypeCid}, addressData: {address: $objectAddress, addressML: $objectAddressML, townName: $objectTownName}}, contact: {phone: $phone, email: $email, webSite: $webSite}, version: $version, isNew: $isNew}
  ) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const CreateSupplier = gql`
    mutation CreateSupplier {
  createSupplier {
    SupplierCode
  }
}
    `;
export const RegisterKsbAccount = gql`
    mutation RegisterKsbAccount {
  registerKsbAccount {
    status
  }
}
    `;
export const QuotaOrder = gql`
    query QuotaOrder($orderId: Int!) {
  quotaOrder(orderId: $orderId) {
    ...OrderInfo
  }
}
    ${OrderInfo}`;
export const QuotaOrders = gql`
    query QuotaOrders($accommodationObjectCid: String, $dateFrom: Date!, $dateTo: Date, $contractNumber: Int, $tariffScheduleCid: String) {
  quotaOrders(
    getQuotaOrdersInput: {accommodationObjectCid: $accommodationObjectCid, contractNumber: $contractNumber, tariffScheduleCid: $tariffScheduleCid, dateFrom: $dateFrom, dateTo: $dateTo}
  ) {
    orderId
    orderNumber
    subOrderNumber
    orderDate
    status
    sentToSupplier
    roomCategory {
      cid
      name {
        ...LangField
      }
      shortName
    }
    period {
      from
      to
    }
    tourists {
      name
      touristType
      placeType
    }
  }
}
    ${LangField}`;
export const AvoidOrder = gql`
    mutation AvoidOrder($orderId: Int!) {
  avoidOrder(input: {orderId: $orderId}) {
    order {
      ...OrderInfo
    }
    errors {
      ...Error
    }
  }
}
    ${OrderInfo}
${Error}`;
export const ConfirmOrder = gql`
    mutation ConfirmOrder($orderId: Int!) {
  confirmOrder(input: {orderId: $orderId}) {
    order {
      ...OrderInfo
    }
    errors {
      ...Error
    }
  }
}
    ${OrderInfo}
${Error}`;
export const SendOrderToSupplier = gql`
    mutation SendOrderToSupplier($orderId: Int!) {
  sendOrderToSupplier(input: {orderId: $orderId}) {
    order {
      ...OrderInfo
    }
    errors {
      ...Error
    }
  }
}
    ${OrderInfo}
${Error}`;
export const ContentServiceDictionaries = gql`
    query ContentServiceDictionaries {
  contentServiceDictionaries {
    commonInformation {
      hotelChains
      resortTypes
      checkinDocuments {
        adultDocuments {
          groupName
          documents
        }
        childrenDocuments {
          groupName
          documents
        }
        foreignerDocuments {
          groupName
          documents
        }
      }
    }
    rooms {
      roomNumbers
      extrabedTypes
      balconyTypes
      equipment
      furniture
      bathroomTypes
      bathroomEquipment
      services
      views
    }
    equipment {
      anotherInfrastructure
      beachEntertainments
      beachEquipment
      beachTypes
      beautyInfrastructure
      childrenInfrastructure
      childrenPools
      disabilityInfrastructure
      indoorAreas
      openWinterPlaygrounds
      outdoorAreas
      paidBeachEquipment
      parkingTypes
      poolCharacteristics
      saunaPay
      saunaTypes
      skiResorts
    }
    nutrition {
      childrenNutrition
      cuisine
      foodObjectType
    }
    servicesAndEntertainment {
      animations
      childrenEntertainments
      childrenEquipmentRental
      childrenServices
      equipmentRental
      household
      internet
      leisure
      medicalCosmetology
      other
      reception
      rental
      skiResortServices
      spaServices
      sportAndEntertainmentTypes
      waterSports
    }
    treatment {
      categories {
        name
        groups {
          name
          items {
            name
            options
          }
        }
      }
    }
    conferenceServices {
      equipment
      seatingOptions
      furniture
      congressServices
    }
  }
}
    `;
export const ContentServiceQuestionnaireAnswers = gql`
    query ContentServiceQuestionnaireAnswers($questionnaireId: UUID!) {
  contentServiceQuestionnaireAnswersById(questionnaireId: $questionnaireId) {
    ...ContentServiceQuestionnaireAnswersFragment
  }
}
    ${ContentServiceQuestionnaireAnswersFragment}`;
export const ContentServiceQuestionnaireAnswersValidationsById = gql`
    query ContentServiceQuestionnaireAnswersValidationsById($questionnaireId: UUID!) {
  contentServiceQuestionnaireAnswersValidationsById(
    questionnaireId: $questionnaireId
  ) {
    ...ContentServiceQuestionnaireStepsValidationsFragment
  }
}
    ${ContentServiceQuestionnaireStepsValidationsFragment}`;
export const ContentServiceQuestionnaire = gql`
    query ContentServiceQuestionnaire($accommodationObjectCid: String!) {
  contentServiceQuestionnaire(accommodationObjectCid: $accommodationObjectCid) {
    id
    hasParent
    status
  }
}
    `;
export const ContentServiceQuestionnaireSave = gql`
    mutation ContentServiceQuestionnaireSave($input: ContentServiceQuestionnaireSaveAnswersInput!) {
  contentServiceQuestionnaireSaveAnswers(input: $input) {
    questionnaireAnswers {
      ...ContentServiceQuestionnaireAnswersFragment
    }
    errors {
      ...Error
    }
  }
}
    ${ContentServiceQuestionnaireAnswersFragment}
${Error}`;
export const ContentServiceQuestionnaireCreate = gql`
    mutation ContentServiceQuestionnaireCreate($input: ContentServiceQuestionnaireCreateInput!) {
  contentServiceQuestionnaireCreate(input: $input) {
    questionnaireAnswers {
      ...ContentServiceQuestionnaireAnswersFragment
    }
    errors {
      ...Error
    }
  }
}
    ${ContentServiceQuestionnaireAnswersFragment}
${Error}`;
export const ContentServiceQuestionnaireMoveToNextStep = gql`
    mutation ContentServiceQuestionnaireMoveToNextStep($accommodationObjectCid: String!, $answers: QuestionnaireAnswersInput!, $finishedStep: QuestionnaireMasterStep!) {
  contentServiceQuestionnaireMoveToNextStep(
    input: {accommodationObjectCid: $accommodationObjectCid, answers: $answers, finishedStep: $finishedStep}
  ) {
    questionnaireAnswers {
      ...ContentServiceQuestionnaireAnswersFragment
    }
    errors {
      ...Error
    }
  }
}
    ${ContentServiceQuestionnaireAnswersFragment}
${Error}`;
export const ContentServiceQuestionnaireFinalize = gql`
    mutation ContentServiceQuestionnaireFinalize($accommodationObjectCid: String!, $answers: QuestionnaireAnswersInput!) {
  contentServiceQuestionnaireFinalize(
    input: {input: {accommodationObjectCid: $accommodationObjectCid, answers: $answers}}
  ) {
    mutationResult
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const ContentServiceQuestionnaireEdit = gql`
    mutation ContentServiceQuestionnaireEdit($accommodationObjectCid: String!) {
  contentServiceQuestionnaireEdit(
    input: {accommodationObjectCid: $accommodationObjectCid}
  ) {
    questionnaireAnswers {
      ...ContentServiceQuestionnaireAnswersFragment
    }
    errors {
      ...Error
    }
  }
}
    ${ContentServiceQuestionnaireAnswersFragment}
${Error}`;
export const ContentServiceQuestionnaireCancelEdit = gql`
    mutation ContentServiceQuestionnaireCancelEdit($questionnaireId: UUID!) {
  contentServiceQuestionnaireCancelEdit(
    input: {questionnaireId: $questionnaireId}
  ) {
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const GetDocuments = gql`
    query GetDocuments {
  documents {
    ...DocumentFragment
  }
}
    ${DocumentFragment}`;
export const GetDocumentToSign = gql`
    query GetDocumentToSign($documentId: UUID!) {
  documentToSign(documentId: $documentId) {
    documentDate
    documentId
    documentName
    fileUri
    previewFileUri
  }
}
    `;
export const SaveDocumentSignature = gql`
    mutation SaveDocumentSignature($documentId: UUID!, $signature: String!) {
  saveDocumentSignature(input: {documentId: $documentId, signature: $signature}) {
    errors {
      ...Error
    }
    mutationResult
  }
}
    ${Error}`;
export const GetLegals = gql`
    query GetLegals {
  legals {
    operations {
      canAdd
      onApprovalLimitExceeded {
        limit
      }
    }
    legals {
      ...LegalListItemFragment
    }
  }
}
    ${LegalListItemFragment}`;
export const GetLegal = gql`
    query GetLegal($legalCid: String!) {
  legal(legalCid: $legalCid) {
    ...LegalFragment
  }
}
    ${LegalFragment}`;
export const GetIsLegalFree = gql`
    query GetIsLegalFree($input: IsLegalFreeInput!) {
  isLegalFree(input: $input)
}
    `;
export const FindFreeLegal = gql`
    query FindFreeLegal($input: FindFreeLegalInput!) {
  findFreeLegal(input: $input) {
    ...LegalFragment
  }
}
    ${LegalFragment}`;
export const AddLegal = gql`
    mutation AddLegal($input: LegalDataInput!) {
  addLegal(legal: $input) {
    legal {
      ...LegalListItemFragment
    }
    errors {
      ...Error
    }
  }
}
    ${LegalListItemFragment}
${Error}`;
export const AddLegalExisting = gql`
    mutation AddLegalExisting($input: AddLegalExistingInput!) {
  addLegalExisting(input: $input) {
    legal {
      ...LegalListItemFragment
    }
    errors {
      ...Error
    }
  }
}
    ${LegalListItemFragment}
${Error}`;
export const RemoveLegal = gql`
    mutation RemoveLegal($cid: String!) {
  removeLegal(input: {cid: $cid}) {
    status
    errors {
      ...LockResourceError
      __typename
    }
  }
}
    ${LockResourceError}`;
export const SaveLegalEdiType = gql`
    mutation SaveLegalEdiType($legalCID: String!, $ediType: EDIType!) {
  saveLegalEDIType(input: {legalCID: $legalCID, ediType: $ediType}) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const AccommodationObjects2 = gql`
    query AccommodationObjects2 {
  accommodationObjects2 {
    operations {
      canAdd
      onApprovalLimitExceeded {
        limit
      }
    }
    accommodationObjects {
      cid
      commonInformation {
        name {
          ...LangField
        }
        type
        category
        town
        status
      }
      contracts {
        ...Contract
      }
    }
  }
}
    ${LangField}
${Contract}`;
export const AccomodationObjectDashboardInfo = gql`
    query AccomodationObjectDashboardInfo($accommodationObjectCid: String!) {
  accomodationObjectDashboardInfo(
    accomodationObjectDashboardInfoInput: {accommodationObjectCid: $accommodationObjectCid}
  ) {
    status
    supersetDomain
    guestToken
    dashboards {
      key
      value
    }
  }
}
    `;
export const AccommodationObject2 = gql`
    query AccommodationObject2($accommodationObjectCid: String!) {
  accommodationObject2(accommodationObjectCid: $accommodationObjectCid) {
    cid
    commonInformation {
      name {
        ...LangField
      }
      type
      category
      town
      status
    }
    contacts {
      phone
      email
      webSite
      postalAddress {
        ...LangField
      }
    }
    contracts {
      ...Contract
    }
    operations {
      canAddContract
    }
    timeZoneOffsetMin
  }
}
    ${LangField}
${Contract}`;
export const HotelCategorySuggestions = gql`
    query HotelCategorySuggestions($key: String, $maxResults: Int!) {
  hotelCategorySuggestions(suggestion: {key: $key, maxResults: $maxResults}) {
    cid
    name
  }
}
    `;
export const HotelTypeSuggestions = gql`
    query HotelTypeSuggestions($key: String, $maxResults: Int!) {
  hotelTypeSuggestions(suggestion: {key: $key, maxResults: $maxResults}) {
    cid
    name
  }
}
    `;
export const RoomTypeSuggestions = gql`
    query RoomTypeSuggestions($key: String!, $maxResults: Int!) {
  roomTypeSuggestions(suggestion: {key: $key, maxResults: $maxResults}) {
    cid
    name
  }
}
    `;
export const AddAccommodationObjectRoomCategory = gql`
    mutation AddAccommodationObjectRoomCategory($baseQuantity: UnsignedShort!, $extQuantity: UnsignedShort!, $name: [LangStringInput!]!, $description: [LangStringInput!]!, $accommodationObjectCid: String!, $roomTypeCid: String!) {
  addAccommodationObjectRoomCategory(
    addAccommodationObjectRoomCategoryInput: {accommodationObjectCid: $accommodationObjectCid, roomCategory: {roomTypeCid: $roomTypeCid, name: $name, description: $description, seat: {baseQuantity: $baseQuantity, extQuantity: $extQuantity}}}
  ) {
    roomCategory {
      ...RoomCategoryView
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${RoomCategoryView}
${Error}
${LockResourceError}`;
export const EditAccommodationObjectRoomCategory = gql`
    mutation EditAccommodationObjectRoomCategory($accommodationObjectRoomCategoryCid: String!) {
  editAccommodationObjectRoomCategory(
    editAccommodationObjectRoomCategoryInput: {accommodationObjectRoomCategoryCid: $accommodationObjectRoomCategoryCid}
  ) {
    roomCategory {
      cid
      operations {
        delete
        edit
        fullEdit
      }
      isActive
    }
    errors {
      ...LockResourceError
    }
  }
}
    ${LockResourceError}`;
export const CancelEditAccommodationObjectRoomCategory = gql`
    mutation CancelEditAccommodationObjectRoomCategory($accommodationObjectRoomCategoryCid: String!) {
  cancelEditAccommodationObjectRoomCategory(
    cancelEditAccommodationObjectRoomCategoryInput: {accommodationObjectRoomCategoryCid: $accommodationObjectRoomCategoryCid}
  ) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const AddAccommodationObjectService = gql`
    mutation AddAccommodationObjectService($applyMethod: ApplyMethod!, $calculationMethod: CalculationMethodInput!, $name: [LangStringInput!]!, $shortName: String!, $accommodationObjectCid: String!, $serviceTypeCid: String!) {
  addAccommodationObjectService(
    addAccommodationObjectServiceInput: {accommodationObjectCid: $accommodationObjectCid, accommodationObjectService: {applyMethod: $applyMethod, calculationMethod: $calculationMethod, name: $name, shortName: $shortName, serviceTypeCid: $serviceTypeCid}}
  ) {
    serviceView {
      applyMethod
      calculationMethod
      cid
      operations {
        delete
      }
      name {
        langCode
        value
      }
      serviceType {
        cid
        name
        shortName
      }
      shortName
    }
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const UpdateAccommodationObjectRoomCategory = gql`
    mutation UpdateAccommodationObjectRoomCategory($accommodationObjectRoomCategoryCid: String!, $roomTypeCid: String!, $baseQuantity: UnsignedShort!, $extQuantity: UnsignedShort!, $description: [LangStringInput!]!, $name: [LangStringInput!]!) {
  updateAccommodationObjectRoomCategory(
    updateAccommodationObjectRoomCategoryInput: {accommodationObjectRoomCategoryCid: $accommodationObjectRoomCategoryCid, roomCategory: {description: $description, name: $name, roomTypeCid: $roomTypeCid, seat: {baseQuantity: $baseQuantity, extQuantity: $extQuantity}}}
  ) {
    roomCategory {
      ...RoomCategoryView
    }
    errors {
      ...Error
    }
  }
}
    ${RoomCategoryView}
${Error}`;
export const RemoveAccommodationObjectRoomCategory = gql`
    mutation RemoveAccommodationObjectRoomCategory($accommodationObjectRoomCategoryCid: String!) {
  removeAccommodationObjectRoomCategory(
    input: {accommodationObjectRoomCategoryCid: $accommodationObjectRoomCategoryCid}
  ) {
    status
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${Error}
${LockResourceError}`;
export const AddContract = gql`
    mutation AddContract($contractType: ContractType!, $accommodationObjectCID: String!, $legalCid: String!, $currencyIsoCode: String!, $legalOrigin: LegalOrigin!) {
  addContract(
    addContractInput: {contractType: $contractType, accommodationObjectCID: $accommodationObjectCID, legalCid: $legalCid, currencyIsoCode: $currencyIsoCode, legalOrigin: $legalOrigin}
  ) {
    Contract {
      ...Contract
    }
    errors {
      ...Error
    }
  }
}
    ${Contract}
${Error}`;
export const AddAccommodationObject = gql`
    mutation AddAccommodationObject($commonInformation: CommonInformationInput!, $commonContact: CommonContactInput!) {
  addAccommodationObject(
    addAccommodationObjectInput: {commonInformation: $commonInformation, commonContact: $commonContact}
  ) {
    accommodationObject {
      cid
    }
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const GetOrdersReconciliation = gql`
    query GetOrdersReconciliation($input: OrdersReconciliationInput!) {
  ordersReconciliation(input: $input) {
    ordersReconciliation {
      commonInfo {
        orderId
        orderBookNumber
        orderNumber
        orderReconciliationStatus
        orderAvoidanceStatus
        period {
          from
          to
        }
        reconciliationItemSubTitle
        reconciliationItemTitle
        supplierOrderNumber
        tourists {
          name
        }
        amountsInfo {
          payable
          payout
        }
        orderReconciliationId
        orderReconciliationPeriodId
      }
    }
    operations {
      edit
    }
    totalAmountsInfo {
      payable
      payout
    }
    count
  }
}
    `;
export const GetOrdersReconciliationFilters = gql`
    query GetOrdersReconciliationFilters($input: OrdersReconciliationFiltersInput!) {
  ordersReconciliationFilters(input: $input) {
    reportDates {
      reportDate
    }
  }
}
    `;
export const ReconcileContractForPeriod = gql`
    mutation ReconcileContractForPeriod($input: ReconcileContractForPeriodInput!) {
  reconcileContractForPeriod(input: $input) {
    contractReconciliation {
      contractReconciliationState
    }
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const ReconcileOrdersReconciliation = gql`
    mutation ReconcileOrdersReconciliation($input: ReconcileOrdersReconciliationInput!) {
  reconcileOrdersReconciliation(input: $input) {
    ordersReconciliation {
      commonInfo {
        orderId
        orderNumber
        orderReconciliationStatus
      }
    }
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const MismatchOrderReconciliation = gql`
    mutation MismatchOrderReconciliation($input: MismatchOrderReconciliationInput!) {
  mismatchOrderReconciliation(input: $input) {
    errors {
      ...Error
    }
    orderReconciliation {
      commonInfo {
        orderId
        orderNumber
        orderReconciliationStatus
        reconciliationItemSubTitle
        reconciliationItemTitle
        supplierOrderNumber
        amountsInfo {
          payable
          payout
        }
        period {
          from
          to
        }
        tourists {
          name
        }
      }
      mismatch {
        description
        reason
      }
    }
  }
}
    ${Error}`;
export const GetOrderReconciliation = gql`
    query GetOrderReconciliation($orderId: Int!) {
  orderReconciliation(orderId: $orderId) {
    commonInfo {
      orderId
      orderBookNumber
      orderNumber
      orderReconciliationStatus
      orderAvoidanceStatus
      reconciliationItemSubTitle
      reconciliationItemTitle
      supplierOrderNumber
      amountsInfo {
        payable
        payout
      }
      period {
        from
        to
      }
      tourists {
        name
      }
      orderReconciliationId
      orderReconciliationPeriodId
    }
    mismatch {
      description
      reason
    }
    operations {
      edit
    }
  }
}
    `;
export const GetContractReconciliationAvailableForPeriod = gql`
    query GetContractReconciliationAvailableForPeriod($input: ContractReconciliationStatusForPeriodInput!) {
  contractReconciliationAvailableForPeriod(input: $input) {
    contractReconciliationState
  }
}
    `;
export const GetRoomCategories = gql`
    query GetRoomCategories($accommodationObjectCid: String!) {
  roomCategories(accommodationObjectCid: $accommodationObjectCid) {
    operations {
      canAdd
    }
    roomCategories {
      ...RoomCategoryFragment
    }
  }
}
    ${RoomCategoryFragment}`;
export const AddRoomCategory = gql`
    mutation AddRoomCategory($addAccommodationObjectRoomCategoryInput: AddAccommodationObjectRoomCategoryInput!) {
  addAccommodationObjectRoomCategory(
    addAccommodationObjectRoomCategoryInput: $addAccommodationObjectRoomCategoryInput
  ) {
    roomCategory {
      ...RoomCategoryFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${RoomCategoryFragment}
${Error}
${LockResourceError}`;
export const EditRoomCategoryStart = gql`
    mutation EditRoomCategoryStart($editAccommodationObjectRoomCategoryInput: EditAccommodationObjectRoomCategoryInput!) {
  editAccommodationObjectRoomCategory(
    editAccommodationObjectRoomCategoryInput: $editAccommodationObjectRoomCategoryInput
  ) {
    roomCategory {
      ...RoomCategoryFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${RoomCategoryFragment}
${Error}
${LockResourceError}`;
export const EditRoomCategoryKeepAlive = gql`
    mutation EditRoomCategoryKeepAlive($keepAliveAccommodationObjectRoomCategoryInput: KeepAliveAccommodationObjectRoomCategoryInput!) {
  keepAliveAccommodationObjectRoomCategory(
    keepAliveAccommodationObjectRoomCategoryInput: $keepAliveAccommodationObjectRoomCategoryInput
  ) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const EditRoomCategoryCancel = gql`
    mutation EditRoomCategoryCancel($cancelEditAccommodationObjectRoomCategoryInput: CancelEditAccommodationObjectRoomCategoryInput!) {
  cancelEditAccommodationObjectRoomCategory(
    cancelEditAccommodationObjectRoomCategoryInput: $cancelEditAccommodationObjectRoomCategoryInput
  ) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const EditRoomCategoryUpdate = gql`
    mutation EditRoomCategoryUpdate($updateAccommodationObjectRoomCategoryInput: UpdateAccommodationObjectRoomCategoryInput!) {
  updateAccommodationObjectRoomCategory(
    updateAccommodationObjectRoomCategoryInput: $updateAccommodationObjectRoomCategoryInput
  ) {
    roomCategory {
      ...RoomCategoryFragment
    }
    errors {
      ...Error
    }
  }
}
    ${RoomCategoryFragment}
${Error}`;
export const RemoveRoomCategory = gql`
    mutation RemoveRoomCategory($input: RemoveAccommodationObjectRoomCategoryInput!) {
  removeAccommodationObjectRoomCategory(input: $input) {
    status
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${Error}
${LockResourceError}`;
export const ReverseStartIntegration = gql`
    mutation ReverseStartIntegration($input: ReverseStartIntegrationInput!) {
  reverseStartIntegration(input: $input) {
    InteractionId
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const ReverseIntegration = gql`
    query ReverseIntegration($interactionId: UUID!, $contractNumber: UnsignedInt!) {
  reverseIntegration(
    input: {query: {interactionId: $interactionId, contractNumber: $contractNumber}}
  ) {
    ...ReverseIntegrationFragment
  }
}
    ${ReverseIntegrationFragment}`;
export const UncompletedReverseInteraction = gql`
    query UncompletedReverseInteraction($channelManagerCode: ChannelManagerCode!, $contractNumber: UnsignedInt!) {
  uncompletedReverseInteraction(
    input: {channelManagerCode: $channelManagerCode, contractNumber: $contractNumber}
  ) {
    ...UncompletedReverseIntegrationFragment
  }
}
    ${UncompletedReverseIntegrationFragment}`;
export const CheckIsNotStartedReverseInteraction = gql`
    query CheckIsNotStartedReverseInteraction($interactionId: UUID!, $contractNumber: UnsignedInt!) {
  checkIsNotStartedReverseInteraction(
    input: {query: {interactionId: $interactionId, contractNumber: $contractNumber}}
  ) {
    interactionId
    isNotStarted
  }
}
    `;
export const UpdateReverseRoomCategories = gql`
    mutation UpdateReverseRoomCategories($input: ReverseUpdateRoomCategoriesInput!) {
  reverseUpdateRoomCategories(input: $input) {
    View {
      ...ReverseIntegrationFragment
    }
    errors {
      ...Error
    }
  }
}
    ${ReverseIntegrationFragment}
${Error}`;
export const UpdateReverseServiceGroups = gql`
    mutation UpdateReverseServiceGroups($input: ReverseUpdateServiceGroupsInput!) {
  reverseUpdateServiceGroups(input: $input) {
    View {
      ...ReverseIntegrationFragment
    }
    errors {
      ...Error
    }
  }
}
    ${ReverseIntegrationFragment}
${Error}`;
export const UpdateReverseTouristTypes = gql`
    mutation UpdateReverseTouristTypes($input: ReverseUpdateTouristTypesInput!) {
  reverseUpdateTouristTypes(input: $input) {
    View {
      ...ReverseIntegrationFragment
    }
    errors {
      ...Error
    }
  }
}
    ${ReverseIntegrationFragment}
${Error}`;
export const GetReversePlacingVariants = gql`
    query GetReversePlacingVariants($interactionQuery: InteractionQueryInput!) {
  reversePlacingVariants(interactionQuery: $interactionQuery) {
    placingVariantsTarification {
      ...RoomCategoryPlacingsFragment
    }
  }
}
    ${RoomCategoryPlacingsFragment}`;
export const UpdateReversePlacingVariants = gql`
    mutation UpdateReversePlacingVariants($input: ReverseUpdatePlacingVariantsInput!) {
  reverseUpdatePlacingVariants(input: $input) {
    View {
      tariffScheduleCID
      remoteInteractionUrl
    }
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const ReverseRestartIntegration = gql`
    mutation ReverseRestartIntegration($input: ReverseRestartIntegrationInput!) {
  reverseRestartIntegration(input: $input) {
    View {
      interaction {
        ...ReverseIntegrationFragment
      }
      roomCategories {
        roomCategoryCid
        quotaStatus
      }
    }
    errors {
      ...Error
    }
  }
}
    ${ReverseIntegrationFragment}
${Error}`;
export const TravelLineExternalHotelSuggestions = gql`
    query TravelLineExternalHotelSuggestions($contractNumber: UnsignedInt!) {
  travelLineExternalHotelSuggestions(contractNumber: $contractNumber) {
    externalHotelQuery {
      hotelId
      hotelName
    }
    uncompletedInteractionId
    channelManagerCode
  }
}
    `;
export const TravelLineRefreshTouristTypes = gql`
    mutation TravelLineRefreshTouristTypes($interactionId: UUID!, $contractNumber: UnsignedInt!) {
  travelLineRefreshTouristTypes(
    input: {interactionQuery: {interactionId: $interactionId, contractNumber: $contractNumber}}
  ) {
    status
  }
}
    `;
export const GetTravelLineRestartIntegration = gql`
    mutation GetTravelLineRestartIntegration($interactionId: UUID!, $contractNumber: UnsignedInt!) {
  travelLineRestartIntegration(
    input: {interactionQuery: {interactionId: $interactionId, contractNumber: $contractNumber}}
  ) {
    View {
      ...TravelLineRestartIntegrationView
    }
    errors {
      ...Error
    }
  }
}
    ${TravelLineRestartIntegrationView}
${Error}`;
export const TravelLineIntegration = gql`
    query TravelLineIntegration($contractNumber: UnsignedInt!, $interactionId: UUID!) {
  travelLineIntegration(
    input: {query: {contractNumber: $contractNumber, interactionId: $interactionId}}
  ) {
    ...TravelLineIntegrationView
  }
}
    ${TravelLineIntegrationView}`;
export const UncompletedIntegrationInfo = gql`
    query UncompletedIntegrationInfo($hotelId: UnsignedInt!, $hotelName: String!, $contractNumber: UnsignedInt!, $channelManagerCode: ChannelManagerCode!) {
  uncompletedIntegrationInfo(
    input: {query: {externalHotel: {hotelName: $hotelName, hotelId: $hotelId}, contractNumber: $contractNumber}, channelManagerCode: $channelManagerCode}
  ) {
    ...TravelLineUncompletedIntegrationView
  }
}
    ${TravelLineUncompletedIntegrationView}`;
export const GetTravelLinePlacingVariants = gql`
    query GetTravelLinePlacingVariants($interactionId: UUID!, $contractNumber: UnsignedInt!) {
  travelLinePlacingVariants(
    interactionQuery: {interactionId: $interactionId, contractNumber: $contractNumber}
  ) {
    placingVariantsTarification {
      roomCategory {
        cid
        name {
          langCode
          value
        }
      }
      suggestedPlacingVariants {
        ...TLPlacingVariant
      }
      conflictedPlacingVariants {
        ...TLPlacingVariant
      }
    }
    invalidRoomCategoryCids
  }
}
    ${TlPlacingVariant}`;
export const TravelLineStartIntegration = gql`
    mutation TravelLineStartIntegration($hotelId: UnsignedInt!, $hotelName: String!, $contractNumber: UnsignedInt!, $channelManagerCode: ChannelManagerCode!) {
  travelLineStartIntegration(
    input: {query: {externalHotel: {hotelName: $hotelName, hotelId: $hotelId}, contractNumber: $contractNumber}, channelManagerCode: $channelManagerCode}
  ) {
    InteractionId
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const TravelLineUpdateIntegrationSettings = gql`
    mutation TravelLineUpdateIntegrationSettings($interactionId: UUID!, $contractNumber: UnsignedInt!, $connectionName: [LangStringInput!]!, $penaltySchemeCode: String!, $supplierPayRuleCode: String!, $checkInTime: TimeSpan!, $checkOutTime: TimeSpan!, $nextDayCheckout: Boolean!) {
  travelLineUpdateIntegrationSettings(
    input: {interactionQuery: {interactionId: $interactionId, contractNumber: $contractNumber}, integrationSettings: {connectionName: $connectionName, penaltySchemeCode: $penaltySchemeCode, supplierPayRuleCode: $supplierPayRuleCode, checkInOutSettings: {checkInTime: $checkInTime, checkOutTime: $checkOutTime, nextDayCheckout: $nextDayCheckout}}}
  ) {
    View {
      ...TravelLineIntegrationMasterStepsView
    }
    errors {
      ...Error
    }
  }
}
    ${TravelLineIntegrationMasterStepsView}
${Error}`;
export const TravelLineSaveRoomCategoriesMapping = gql`
    mutation TravelLineSaveRoomCategoriesMapping($interactionId: UUID!, $contractNumber: UnsignedInt!, $roomCategories: [ExternalObjectTranslationInput!]!) {
  travelLineSaveRoomCategoriesMapping(
    input: {interactionQuery: {contractNumber: $contractNumber, interactionId: $interactionId}, roomCategories: $roomCategories}
  ) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const TravelLineSaveServiceGroupsMapping = gql`
    mutation TravelLineSaveServiceGroupsMapping($interactionId: UUID!, $contractNumber: UnsignedInt!, $serviceGroups: [ExternalObjectTranslationInput!]!) {
  travelLineSaveServiceGroupsMapping(
    input: {interactionQuery: {contractNumber: $contractNumber, interactionId: $interactionId}, serviceGroups: $serviceGroups}
  ) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const TravelLineUpdateServiceGroups = gql`
    mutation TravelLineUpdateServiceGroups($interactionId: UUID!, $contractNumber: UnsignedInt!, $serviceGroups: [ExternalObjectTranslationInput!]!) {
  travelLineUpdateServiceGroups(
    input: {interactionQuery: {contractNumber: $contractNumber, interactionId: $interactionId}, serviceGroups: $serviceGroups}
  ) {
    View {
      ...TravelLineIntegrationMasterStepsView
    }
    errors {
      ...Error
    }
  }
}
    ${TravelLineIntegrationMasterStepsView}
${Error}`;
export const TravelLineUpdateRoomCategories = gql`
    mutation TravelLineUpdateRoomCategories($interactionId: UUID!, $contractNumber: UnsignedInt!, $roomCategories: [ExternalObjectTranslationInput!]!) {
  travelLineUpdateRoomCategories(
    input: {interactionQuery: {interactionId: $interactionId, contractNumber: $contractNumber}, roomCategories: $roomCategories}
  ) {
    View {
      ...TravelLineIntegrationMasterStepsView
    }
    errors {
      ...Error
    }
  }
}
    ${TravelLineIntegrationMasterStepsView}
${Error}`;
export const TravelLineUpdateTouristTypes = gql`
    mutation TravelLineUpdateTouristTypes($interactionId: UUID!, $contractNumber: UnsignedInt!, $determineAgeMethod: DetermineAgeMethod!) {
  travelLineUpdateTouristTypes(
    input: {interactionQuery: {interactionId: $interactionId, contractNumber: $contractNumber}, determineAgeMethod: $determineAgeMethod}
  ) {
    View {
      ...TravelLineIntegrationMasterStepsView
    }
    errors {
      ...Error
    }
  }
}
    ${TravelLineIntegrationMasterStepsView}
${Error}`;
export const TravelLineUpdatePlacingVariants = gql`
    mutation TravelLineUpdatePlacingVariants($interactionId: UUID!, $contractNumber: UnsignedInt!, $roomPlacingVariants: [TariffScheduleRoomPlacingVariantInput!]!) {
  travelLineUpdatePlacingVariants(
    input: {interactionQuery: {interactionId: $interactionId, contractNumber: $contractNumber}, roomPlacingVariants: $roomPlacingVariants}
  ) {
    View {
      tariffScheduleCID
    }
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const StartTariffGridEdit = gql`
    mutation StartTariffGridEdit($tariffScheduleCid: String!) {
  tariffGridEdit(input: {tariffScheduleCid: $tariffScheduleCid}) {
    Grid {
      ...Grid
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${Grid}
${Error}
${LockResourceError}`;
export const KeepAliveTariffGridEdit = gql`
    mutation KeepAliveTariffGridEdit($tariffScheduleCid: String!) {
  tariffGridKeepAlive(input: {tariffScheduleCid: $tariffScheduleCid}) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const CancelTariffGridEdit = gql`
    mutation CancelTariffGridEdit($tariffScheduleCid: String!) {
  tariffGridCancelEdit(input: {tariffScheduleCid: $tariffScheduleCid}) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const UpdateTariffGrid = gql`
    mutation UpdateTariffGrid($input: TariffGridUpdateInput!) {
  tariffGridUpdate(input: $input) {
    Grid {
      ...Grid
    }
    errors {
      ...Error
    }
  }
}
    ${Grid}
${Error}`;
export const GetQuota = gql`
    query GetQuota($tariffScheduleCid: String!) {
  quota(tariffScheduleCid: $tariffScheduleCid) {
    ...QuotaFragment
  }
}
    ${QuotaFragment}`;
export const EditQuotaInitialValuesStart = gql`
    mutation EditQuotaInitialValuesStart($input: EditQuotaAddRoomsInput!) {
  editQuotaAddRooms(input: $input) {
    roomQuotas {
      ...QuotaRoomCategoryFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${QuotaRoomCategoryFragment}
${Error}
${LockResourceError}`;
export const EditQuotaInitialValuesKeepAlive = gql`
    mutation EditQuotaInitialValuesKeepAlive($input: KeepAliveQuotaAddRoomsInput!) {
  keepAliveQuotaAddRooms(input: $input) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const EditQuotaInitialValuesCancel = gql`
    mutation EditQuotaInitialValuesCancel($input: CancelEditQuotaAddRoomsInput!) {
  cancelEditQuotaAddRooms(input: $input) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const EditQuotaInitialValuesUpdate = gql`
    mutation EditQuotaInitialValuesUpdate($input: UpdateQuotaAddRoomsInput!) {
  updateQuotaAddRooms(input: $input) {
    quotaView {
      ...QuotaFragment
    }
    errors {
      ...Error
    }
  }
}
    ${QuotaFragment}
${Error}`;
export const EditQuotaReservesStart = gql`
    mutation EditQuotaReservesStart($input: EditQuotaReservesUpdateInput!) {
  editQuotaReservesUpdate(input: $input) {
    Quota {
      ...QuotaFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${QuotaFragment}
${Error}
${LockResourceError}`;
export const EditQuotaReservesKeepAlive = gql`
    mutation EditQuotaReservesKeepAlive($input: KeepAliveQuotaReservesUpdateInput!) {
  keepAliveQuotaReservesUpdate(input: $input) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const EditQuotaReservesCancel = gql`
    mutation EditQuotaReservesCancel($input: CancelEditQuotaReservesUpdateInput!) {
  cancelEditQuotaReservesUpdate(input: $input) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const EditQuotaReservesUpdate = gql`
    mutation EditQuotaReservesUpdate($input: UpdateQuotaReservesUpdateInput!) {
  updateQuotaReservesUpdate(input: $input) {
    Quota {
      ...QuotaFragment
    }
    errors {
      ...Error
      ...IncorrectQuotaChangeError
    }
  }
}
    ${QuotaFragment}
${Error}
${IncorrectQuotaChangeError}`;
export const GetCheckInOutRestrictions = gql`
    query GetCheckInOutRestrictions($tariffScheduleCid: String!) {
  restrictionsCheckInOutSettings(tariffScheduleCid: $tariffScheduleCid) {
    ...CheckInOutRestrictionsFragment
  }
}
    ${CheckInOutRestrictionsFragment}`;
export const AddCheckInOutRestriction = gql`
    mutation AddCheckInOutRestriction($input: AddRestrictionsCheckInOutSettingInput!) {
  addRestrictionsCheckInOutSetting(input: $input) {
    Grid {
      ...CheckInOutRestrictionsFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${CheckInOutRestrictionsFragment}
${Error}
${LockResourceError}`;
export const UpdateCheckInOutRestriction = gql`
    mutation UpdateCheckInOutRestriction($input: UpdateRestrictionsCheckInOutSettingInput!) {
  updateRestrictionsCheckInOutSetting(input: $input) {
    Grid {
      ...CheckInOutRestrictionsFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${CheckInOutRestrictionsFragment}
${Error}
${LockResourceError}`;
export const RemoveCheckInOutRestriction = gql`
    mutation RemoveCheckInOutRestriction($input: RemoveRestrictionsCheckInOutSettingInput!) {
  removeRestrictionsCheckInOutSetting(input: $input) {
    Grid {
      ...CheckInOutRestrictionsFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${CheckInOutRestrictionsFragment}
${Error}
${LockResourceError}`;
export const GetPlacingVariantsRestrictions = gql`
    query GetPlacingVariantsRestrictions($tariffScheduleCid: String!) {
  restrictionsPlacingVariants(tariffScheduleCid: $tariffScheduleCid) {
    ...PlacingVariantsRestrictionsFragment
  }
}
    ${PlacingVariantsRestrictionsFragment}`;
export const AddPlacingVariantsRestriction = gql`
    mutation AddPlacingVariantsRestriction($input: AddRestrictionsPlacingVariantsInput!) {
  addRestrictionsPlacingVariants(input: $input) {
    Grid {
      ...PlacingVariantsRestrictionsFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${PlacingVariantsRestrictionsFragment}
${Error}
${LockResourceError}`;
export const UpdatePlacingVariantsRestriction = gql`
    mutation UpdatePlacingVariantsRestriction($input: UpdateRestrictionsPlacingVariantInput!) {
  updateRestrictionsPlacingVariant(input: $input) {
    Grid {
      ...PlacingVariantsRestrictionsFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${PlacingVariantsRestrictionsFragment}
${Error}
${LockResourceError}`;
export const RemovePlacingVariantsRestriction = gql`
    mutation RemovePlacingVariantsRestriction($input: RemoveRestrictionsPlacingVariantInput!) {
  removeRestrictionsPlacingVariant(input: $input) {
    Grid {
      ...PlacingVariantsRestrictionsFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${PlacingVariantsRestrictionsFragment}
${Error}
${LockResourceError}`;
export const GetServiceGroupsRestrictions = gql`
    query GetServiceGroupsRestrictions($tariffScheduleCid: String!) {
  restrictionsServiceGroups(tariffScheduleCid: $tariffScheduleCid) {
    ...ServiceGroupsRestrictionsFragment
  }
}
    ${ServiceGroupsRestrictionsFragment}`;
export const AddServiceGroupsRestriction = gql`
    mutation AddServiceGroupsRestriction($input: AddRestrictionsServiceGroupInput!) {
  addRestrictionsServiceGroup(input: $input) {
    Grid {
      ...ServiceGroupsRestrictionsFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${ServiceGroupsRestrictionsFragment}
${Error}
${LockResourceError}`;
export const UpdateServiceGroupsRestriction = gql`
    mutation UpdateServiceGroupsRestriction($input: UpdateRestrictionsServiceGroupInput!) {
  updateRestrictionsServiceGroup(input: $input) {
    Grid {
      ...ServiceGroupsRestrictionsFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${ServiceGroupsRestrictionsFragment}
${Error}
${LockResourceError}`;
export const RemoveServiceGroupsRestriction = gql`
    mutation RemoveServiceGroupsRestriction($input: RemoveRestrictionsServiceGroupInput!) {
  removeRestrictionsServiceGroup(input: $input) {
    Grid {
      ...ServiceGroupsRestrictionsFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${ServiceGroupsRestrictionsFragment}
${Error}
${LockResourceError}`;
export const TariffScheduleServiceGroups = gql`
    query TariffScheduleServiceGroups($tariffScheduleCid: String!) {
  tariffScheduleServiceGroups(tariffScheduleCid: $tariffScheduleCid) {
    ...serviceGroupsList
  }
}
    ${ServiceGroupsList}`;
export const GetServiceGroupSuggestedServices = gql`
    query GetServiceGroupSuggestedServices {
  serviceGroupSuggestedServices {
    services {
      cid
      shortName
      isFirst
      isLast
      sortNumber
    }
  }
}
    `;
export const GetContractServiceGroups = gql`
    query GetContractServiceGroups($contractNumber: Int!) {
  contractServiceGroups(contractNumber: $contractNumber) {
    tariffSchedule {
      name
      cid
    }
    serviceGroups {
      cid
      name {
        ...LangField
      }
      description {
        ...LangField
      }
      services {
        shortName
        cid
        isFirst
        isLast
        sortNumber
      }
    }
  }
}
    ${LangField}`;
export const CalculateServiceSequence = gql`
    query CalculateServiceSequence($tariffScheduleCid: String, $serviceCids: [String!]!, $hotelSetCid: String!) {
  calculateServiceSequence(
    tariffScheduleCid: $tariffScheduleCid
    serviceCids: $serviceCids
    hotelSetCid: $hotelSetCid
  ) {
    cid
    shortName
    parentCid
    isFirst
    isLast
    sequenceNumber
  }
}
    `;
export const GetTariffScheduleServiceGroupsForRestriction = gql`
    query GetTariffScheduleServiceGroupsForRestriction($tariffScheduleCid: String!, $checkInOutRestrictionId: Int!) {
  tariffScheduleServiceGroupsForRestriction(
    tariffScheduleCid: $tariffScheduleCid
    checkInOutRestrictionId: $checkInOutRestrictionId
  ) {
    ...serviceGroupsList
  }
}
    ${ServiceGroupsList}`;
export const CalculateTariffScheduleServiceGroups = gql`
    query CalculateTariffScheduleServiceGroups($tariffScheduleCid: String!, $checkInOutSettings: CheckInOutSettingsInput!) {
  calculateTariffScheduleServiceGroups(
    tariffScheduleCid: $tariffScheduleCid
    checkInOutSettings: $checkInOutSettings
  ) {
    ...serviceGroupsList
  }
}
    ${ServiceGroupsList}`;
export const AddTariffScheduleServiceGroup = gql`
    mutation AddTariffScheduleServiceGroup($tariffScheduleCid: String, $hotelSetCid: String!, $serviceGroup: ServiceGroupInput!) {
  addTariffScheduleServiceGroup(
    input: {serviceGroup: $serviceGroup, tariffScheduleCid: $tariffScheduleCid, hotelSetCid: $hotelSetCid}
  ) {
    serviceGroups {
      operations {
        add
        edit
        hasMaximumServiceGroups
      }
      serviceGroups {
        ...ServiceGroups
      }
    }
    addedServiceGroup {
      serviceGroupCid
      services {
        cid
        shortName
        name {
          ...LangField
        }
      }
      name {
        ...LangField
      }
    }
    errors {
      ...LockResourceError
      __typename
    }
  }
}
    ${ServiceGroups}
${LangField}
${LockResourceError}`;
export const GetTariffScheduleServiceGroup = gql`
    query GetTariffScheduleServiceGroup($tariffScheduleCid: String, $serviceGroupCid: String!, $hotelSetCid: String!) {
  tariffScheduleServiceGroup(
    tariffScheduleCid: $tariffScheduleCid
    serviceGroupCid: $serviceGroupCid
    hotelSetCid: $hotelSetCid
  ) {
    ...TariffScheduleServiceGroup
  }
}
    ${TariffScheduleServiceGroup}`;
export const EditTariffScheduleServiceGroup = gql`
    mutation EditTariffScheduleServiceGroup($tariffScheduleCid: String, $serviceGroupCid: String!, $hotelSetCid: String!) {
  editTariffScheduleServiceGroup(
    input: {tariffScheduleCid: $tariffScheduleCid, serviceGroupCid: $serviceGroupCid, hotelSetCid: $hotelSetCid}
  ) {
    serviceGroup {
      ...TariffScheduleServiceGroup
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${TariffScheduleServiceGroup}
${Error}
${LockResourceError}`;
export const KeepAliveTariffScheduleServiceGroup = gql`
    mutation KeepAliveTariffScheduleServiceGroup($serviceGroupCid: String!, $hotelSetCid: String!) {
  keepAliveTariffScheduleServiceGroup(
    input: {serviceGroupCid: $serviceGroupCid, hotelSetCid: $hotelSetCid}
  ) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const CancelTariffScheduleServiceGroup = gql`
    mutation CancelTariffScheduleServiceGroup($serviceGroupCid: String!, $hotelSetCid: String!) {
  cancelEditTariffScheduleServiceGroup(
    input: {serviceGroupCid: $serviceGroupCid, hotelSetCid: $hotelSetCid}
  ) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const UpdateTariffScheduleServiceGroup = gql`
    mutation UpdateTariffScheduleServiceGroup($hotelSetCid: String!, $tariffScheduleCid: String, $serviceGroupCid: String!, $serviceGroup: ServiceGroupInput!) {
  updateTariffScheduleServiceGroup(
    input: {hotelSetCid: $hotelSetCid, tariffScheduleCid: $tariffScheduleCid, serviceGroupCid: $serviceGroupCid, serviceGroup: $serviceGroup}
  ) {
    serviceGroup {
      ...TariffScheduleServiceGroup
    }
    errors {
      ...Error
    }
  }
}
    ${TariffScheduleServiceGroup}
${Error}`;
export const EditTariffScheduleServiceGroupList = gql`
    mutation EditTariffScheduleServiceGroupList($tariffScheduleCid: String!) {
  editTariffScheduleServiceGroupList(
    input: {tariffScheduleCid: $tariffScheduleCid}
  ) {
    serviceGroups {
      ...serviceGroupsList
    }
    errors {
      ...LockResourceError
      __typename
    }
  }
}
    ${ServiceGroupsList}
${LockResourceError}`;
export const KeepAliveTariffScheduleServiceGroupList = gql`
    mutation KeepAliveTariffScheduleServiceGroupList($tariffScheduleCid: String!) {
  keepAliveTariffScheduleServiceGroupList(
    input: {tariffScheduleCid: $tariffScheduleCid}
  ) {
    status
    errors {
      __typename
    }
  }
}
    `;
export const CancelEditTariffScheduleServiceGroupList = gql`
    mutation CancelEditTariffScheduleServiceGroupList($tariffScheduleCid: String!) {
  cancelEditTariffScheduleServiceGroupList(
    input: {tariffScheduleCid: $tariffScheduleCid}
  ) {
    status
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const UpdateTariffScheduleServiceGroupList = gql`
    mutation UpdateTariffScheduleServiceGroupList($tariffScheduleCid: String!, $serviceGroups: [ServiceGroupListInput!]!) {
  updateTariffScheduleServiceGroupList(
    input: {serviceGroups: $serviceGroups, tariffScheduleCid: $tariffScheduleCid}
  ) {
    serviceGroups {
      ...serviceGroupsList
    }
    errors {
      ...Error
    }
  }
}
    ${ServiceGroupsList}
${Error}`;
export const EditTariffSchedule = gql`
    mutation EditTariffSchedule($tariffScheduleCid: String!) {
  editTariffSchedule(input: {tariffScheduleCid: $tariffScheduleCid}) {
    errors {
      ...LockResourceError
    }
  }
}
    ${LockResourceError}`;
export const CancelEditTariffSchedule = gql`
    mutation CancelEditTariffSchedule($tariffScheduleCid: String!) {
  cancelEditTariffSchedule(input: {tariffScheduleCid: $tariffScheduleCid}) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const SendTariffScheduleInWork = gql`
    mutation SendTariffScheduleInWork($tariffScheduleCid: String!) {
  sendTariffScheduleInWork(input: {tariffScheduleCid: $tariffScheduleCid}) {
    tariffSchedule2View {
      ...TariffScheduleFragment
    }
    errors {
      ...LockResourceError
      ...Error
    }
  }
}
    ${TariffScheduleFragment}
${LockResourceError}
${Error}`;
export const TariffSchedules = gql`
    query TariffSchedules($contractNumber: Int!) {
  tariffSchedules2(contractNumber: $contractNumber) {
    operations {
      canAddExtranetTariffSchedule
      canAddRemoteTariffSchedule
    }
    extranet {
      tariffScheduleCid
      name {
        ...LangField
      }
      stopSalePeriodHours
      status
    }
    remote {
      channelManagerCode
      interactionId
      name {
        value
        langCode
      }
      tariffSchedule {
        activeRemoting
        tariffScheduleCid
        contractClosed
      }
    }
  }
}
    ${LangField}`;
export const SupplierPayRuleList = gql`
    query SupplierPayRuleList {
  supplierPayRuleList {
    shortName
    name
  }
}
    `;
export const PenaltySchemeList = gql`
    query PenaltySchemeList {
  penaltySchemeList {
    shortName
    name
  }
}
    `;
export const GetTaxSchemeList = gql`
    query GetTaxSchemeList {
  taxSchemeList {
    cid
    name
  }
}
    `;
export const GetTariffScheduleGrid = gql`
    query GetTariffScheduleGrid($tariffScheduleCid: String!) {
  tariffScheduleGrid(tariffScheduleCid: $tariffScheduleCid) {
    ...TariffScheduleGridView
  }
}
    ${TariffScheduleGridView}`;
export const AddTariffSchedule = gql`
    mutation AddTariffSchedule($addTariffScheduleInput: AddTariffScheduleInput!) {
  addTariffSchedule(addTariffScheduleInput: $addTariffScheduleInput) {
    tariffScheduleCid
    tariffSchedule {
      ...TariffScheduleFragment
    }
    errors {
      ...Error
    }
  }
}
    ${TariffScheduleFragment}
${Error}`;
export const GetTariffSchedule = gql`
    query GetTariffSchedule($tariffScheduleCid: String!) {
  tariffSchedule2(tariffScheduleCid: $tariffScheduleCid) {
    ...TariffScheduleFragment
  }
}
    ${TariffScheduleFragment}`;
export const EditTariffScheduleStart = gql`
    mutation EditTariffScheduleStart($input: EditTariffScheduleInput!) {
  editTariffSchedule(input: $input) {
    TariffSchedule {
      ...TariffScheduleCommonInformationFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${TariffScheduleCommonInformationFragment}
${Error}
${LockResourceError}`;
export const EditTariffScheduleKeepAlive = gql`
    mutation EditTariffScheduleKeepAlive($input: KeepAliveTariffScheduleInput!) {
  keepAliveTariffSchedule(input: $input) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const EditTariffScheduleCancel = gql`
    mutation EditTariffScheduleCancel($input: CancelEditTariffScheduleInput!) {
  cancelEditTariffSchedule(input: $input) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const EditTariffScheduleUpdate = gql`
    mutation EditTariffScheduleUpdate($input: UpdateTariffScheduleInput!) {
  updateTariffSchedule(input: $input) {
    TariffSchedule {
      ...TariffScheduleCommonInformationUpdatedFragment
    }
    errors {
      ...Error
    }
  }
}
    ${TariffScheduleCommonInformationUpdatedFragment}
${Error}`;
export const GetPlacingVariants = gql`
    query GetPlacingVariants($hotelSetCid: String!) {
  placingVariants(hotelSetCid: $hotelSetCid) {
    placingVariants {
      ...RoomCategoryPlacingsFragment
    }
  }
}
    ${RoomCategoryPlacingsFragment}`;
export const PvmStart = gql`
    mutation PvmStart($tariffScheduleCid: String!) {
  placingVariantsMasterStart(input: {tariffScheduleCid: $tariffScheduleCid}) {
    settings {
      roomCategories {
        roomCategoryCid
        quotaStatus
      }
      ageSettings {
        initialAge
        noSeatAge
        determineAgeMethod
        categories {
          values {
            from
            to
          }
        }
      }
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${Error}
${LockResourceError}`;
export const PvmKeepAlive = gql`
    mutation PvmKeepAlive($tariffScheduleCid: String!) {
  placingVariantsMasterKeepAlive(input: {tariffScheduleCid: $tariffScheduleCid}) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const PvmCancelEdit = gql`
    mutation PvmCancelEdit($tariffScheduleCid: String!) {
  placingVariantsMasterCancel(input: {tariffScheduleCid: $tariffScheduleCid}) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const PvmComplete = gql`
    mutation PvmComplete($input: PlacingVariantsMasterCompleteInput!) {
  placingVariantsMasterComplete(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const PvmGenerate = gql`
    mutation PvmGenerate($input: PlacingVariantsMasterGenerateInput!) {
  placingVariantsMasterGenerate(input: $input) {
    placingVariantsTarification {
      ...RoomCategoryPlacingsFragment
    }
    invalidRoomCategoryCids
    errors {
      ...Error
    }
  }
}
    ${RoomCategoryPlacingsFragment}
${Error}`;
export const StartPlacingVariantsEdit = gql`
    mutation StartPlacingVariantsEdit($tariffScheduleCid: String!) {
  placingVariantsEdit(input: {tariffScheduleCid: $tariffScheduleCid}) {
    placingVariantsTarification {
      ...RoomCategoryPlacingsFragment
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}
    ${RoomCategoryPlacingsFragment}
${Error}
${LockResourceError}`;
export const KeepAlivePlacingVariantsEdit = gql`
    mutation KeepAlivePlacingVariantsEdit($tariffScheduleCid: String!) {
  placingVariantsKeepAlive(input: {tariffScheduleCid: $tariffScheduleCid}) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const UpdatePlacingVariants = gql`
    mutation UpdatePlacingVariants($variants: PlacingVariantsUpdateInput!) {
  placingVariantsUpdate(input: $variants) {
    placingVariantsTarification {
      ...RoomCategoryPlacingsFragment
    }
    errors {
      ...Error
    }
  }
}
    ${RoomCategoryPlacingsFragment}
${Error}`;
export const CancelPlacingVariantsEdit = gql`
    mutation CancelPlacingVariantsEdit($tariffScheduleCid: String!) {
  placingVariantsCancelEdit(input: {tariffScheduleCid: $tariffScheduleCid}) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const Users = gql`
    query Users {
  users {
    ...User
  }
}
    ${User}`;
export const Invitations = gql`
    query Invitations {
  invitations {
    email
    id
    role
  }
}
    `;
export const InviteUserToSupplier = gql`
    mutation InviteUserToSupplier($emails: [String!]!) {
  inviteUserToSupplier(input: {emails: $emails}) {
    status
  }
}
    `;
export const DeleteUser = gql`
    mutation DeleteUser($userId: UUID!) {
  deleteUser(deleteUserInput: {userId: $userId}) {
    status
  }
}
    `;
export const SetUserRole = gql`
    mutation SetUserRole($input: SetUserRoleInput!) {
  setUserRole(input: $input) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const SetInvitationRole = gql`
    mutation SetInvitationRole($input: SetInvitationRoleInput!) {
  setInvitationRole(input: $input) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const GetUser = gql`
    query GetUser($userId: UUID!) {
  user(userId: $userId) {
    ...User
  }
}
    ${User}`;
export const GetActiveAccessRequests = gql`
    query GetActiveAccessRequests {
  activeAccessRequests {
    id
    userName
    userFullName
  }
}
    `;
export const AccessRequestDecline = gql`
    mutation AccessRequestDecline($input: AccessRequestDeclineInput!) {
  accessRequestDecline(input: $input) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;
export const AccessRequestAccept = gql`
    mutation AccessRequestAccept($input: AccessRequestAcceptInput!) {
  accessRequestAccept(input: $input) {
    status
    errors {
      ...Error
    }
  }
}
    ${Error}`;